//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class Client {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "/api";
    }

    /**
     * Login a user
     * @param body Login credentials
     * @return OK
     */
    authLogin(body: Body): Observable<AuthToken> {
        let url_ = this.baseUrl + "/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthToken>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthToken>;
        }));
    }

    protected processAuthLogin(response: HttpResponseBase): Observable<AuthToken> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthToken.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = LoginError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * sendSms
     * @param body sendSms credentials
     * @return OK
     */
    authSendSms(body: SendSmsRequest): Observable<Message> {
        let url_ = this.baseUrl + "/auth/sendSms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthSendSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthSendSms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Message>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Message>;
        }));
    }

    protected processAuthSendSms(response: HttpResponseBase): Observable<Message> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Message.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 429) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result429: any = null;
            let resultData429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result429 = Message.fromJS(resultData429);
            return throwException("Too many attempts", status, _responseText, _headers, result429);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = SendSmsError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * loginSms a user
     * @param body loginSms credentials
     * @return OK
     */
    authLoginSms(body: LoginSmsRequest): Observable<AuthToken> {
        let url_ = this.baseUrl + "/auth/loginSms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthLoginSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthLoginSms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthToken>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthToken>;
        }));
    }

    protected processAuthLoginSms(response: HttpResponseBase): Observable<AuthToken> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthToken.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = LoginSmsError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * changePhoneSendSms
     * @return OK
     */
    authChangePhoneSendSms(): Observable<Message> {
        let url_ = this.baseUrl + "/auth/changePhoneSendSms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthChangePhoneSendSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthChangePhoneSendSms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Message>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Message>;
        }));
    }

    protected processAuthChangePhoneSendSms(response: HttpResponseBase): Observable<Message> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Message.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * changePhone a user
     * @param body changePhone credentials
     * @return OK
     */
    authChangePhone(body: ChangePhoneRequest): Observable<UserDataResponse> {
        let url_ = this.baseUrl + "/auth/changePhone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthChangePhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthChangePhone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDataResponse>;
        }));
    }

    protected processAuthChangePhone(response: HttpResponseBase): Observable<UserDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = LoginSmsError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * User info
     * @return OK
     */
    authMe(): Observable<UserDataResponse> {
        let url_ = this.baseUrl + "/auth/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthMe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthMe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDataResponse>;
        }));
    }

    protected processAuthMe(response: HttpResponseBase): Observable<UserDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Logout the current user
     * @return OK
     */
    authLogout(): Observable<Message> {
        let url_ = this.baseUrl + "/auth/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Message>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Message>;
        }));
    }

    protected processAuthLogout(response: HttpResponseBase): Observable<Message> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Message.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Refresh the user token
     * @param body Refreshy token
     * @return OK
     */
    authRefresh(body: Body2): Observable<AuthToken> {
        let url_ = this.baseUrl + "/auth/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthRefresh(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthRefresh(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthToken>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthToken>;
        }));
    }

    protected processAuthRefresh(response: HttpResponseBase): Observable<AuthToken> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthToken.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = RefreshError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * smsStatus
     * @param body smsStatus
     * @return OK
     */
    authSmsStatus(body: Body3): Observable<Message> {
        let url_ = this.baseUrl + "/auth/smsStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthSmsStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthSmsStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Message>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Message>;
        }));
    }

    protected processAuthSmsStatus(response: HttpResponseBase): Observable<Message> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Message.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ErrorDto.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get logoutAll
     * @return OK
     */
    authLogoutAll(): Observable<Message> {
        let url_ = this.baseUrl + "/auth/logoutAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthLogoutAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthLogoutAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Message>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Message>;
        }));
    }

    protected processAuthLogoutAll(response: HttpResponseBase): Observable<Message> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Message.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get CountryPhoneCodes
     * @return OK
     */
    authGetCountryPhoneCodes(): Observable<CountryPhoneCodes[]> {
        let url_ = this.baseUrl + "/auth/getCountryPhoneCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthGetCountryPhoneCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthGetCountryPhoneCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryPhoneCodes[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryPhoneCodes[]>;
        }));
    }

    protected processAuthGetCountryPhoneCodes(response: HttpResponseBase): Observable<CountryPhoneCodes[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryPhoneCodes.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of AvatarOrder
     * @return OK
     */
    avatarOrderIndex(): Observable<AvatarOrdersDataResponse> {
        let url_ = this.baseUrl + "/avatarOrder/index";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAvatarOrderIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvatarOrderIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvatarOrdersDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvatarOrdersDataResponse>;
        }));
    }

    protected processAvatarOrderIndex(response: HttpResponseBase): Observable<AvatarOrdersDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvatarOrdersDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new AvatarOrder
     * @param body (optional) Add AvatarOrder
     * @return AvatarOrder response
     */
    avatarOrderPost(body: AvatarOrderRequest | undefined): Observable<AvatarOrderDataResponse> {
        let url_ = this.baseUrl + "/avatarOrder/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAvatarOrderPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvatarOrderPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvatarOrderDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvatarOrderDataResponse>;
        }));
    }

    protected processAvatarOrderPost(response: HttpResponseBase): Observable<AvatarOrderDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AvatarOrderDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = AvatarOrderError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified AvatarOrder
     * @param id AvatarOrder ID
     * @return OK
     */
    avatarOrderGet(id: number): Observable<AvatarOrderDataResponse> {
        let url_ = this.baseUrl + "/avatarOrder/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAvatarOrderGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvatarOrderGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvatarOrderDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvatarOrderDataResponse>;
        }));
    }

    protected processAvatarOrderGet(response: HttpResponseBase): Observable<AvatarOrderDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvatarOrderDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing AvatarOrder
     * @param id AvatarOrder ID
     * @param body Update avatarOrder.
     * @return OK
     */
    avatarOrderPut(id: number, body: AvatarOrderUpdateRequest): Observable<AvatarOrderDataResponse> {
        let url_ = this.baseUrl + "/avatarOrder/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAvatarOrderPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvatarOrderPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvatarOrderDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvatarOrderDataResponse>;
        }));
    }

    protected processAvatarOrderPut(response: HttpResponseBase): Observable<AvatarOrderDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvatarOrderDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = AvatarOrderUpdateError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a AvatarOrder
     * @param id AvatarOrder ID
     * @return No Content
     */
    avatarOrderDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/avatarOrder/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAvatarOrderDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvatarOrderDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAvatarOrderDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Change status and set coordinates for AvatarOrder
     * @param id AvatarOrder ID
     * @param longitude AvatarOrder to_id user longitude
     * @param latitude AvatarOrder to_id user latitude
     * @return OK
     */
    avatarOrderAccept(id: number, longitude: number, latitude: number): Observable<AvatarOrderResponse> {
        let url_ = this.baseUrl + "/avatarOrder/accept/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (longitude === undefined || longitude === null)
            throw new Error("The parameter 'longitude' must be defined and cannot be null.");
        else
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (latitude === undefined || latitude === null)
            throw new Error("The parameter 'latitude' must be defined and cannot be null.");
        else
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAvatarOrderAccept(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvatarOrderAccept(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvatarOrderResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvatarOrderResponse>;
        }));
    }

    protected processAvatarOrderAccept(response: HttpResponseBase): Observable<AvatarOrderResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvatarOrderResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified AvatarOrder
     * @param id AvatarOrder ID
     * @return OK
     */
    avatarOrderReject(id: number): Observable<AvatarOrderDataResponse> {
        let url_ = this.baseUrl + "/avatarOrder/reject/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAvatarOrderReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvatarOrderReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvatarOrderDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvatarOrderDataResponse>;
        }));
    }

    protected processAvatarOrderReject(response: HttpResponseBase): Observable<AvatarOrderDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvatarOrderDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified AvatarOrder
     * @param id AvatarOrder ID
     * @return OK
     */
    avatarOrderBroadcastStart(id: number): Observable<AvatarOrderDataResponse> {
        let url_ = this.baseUrl + "/avatarOrder/broadcastStart/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAvatarOrderBroadcastStart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvatarOrderBroadcastStart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvatarOrderDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvatarOrderDataResponse>;
        }));
    }

    protected processAvatarOrderBroadcastStart(response: HttpResponseBase): Observable<AvatarOrderDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvatarOrderDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = AvatarOrderUpdateError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified AvatarOrder
     * @param id AvatarOrder ID
     * @return OK
     */
    avatarOrderBroadcastEnd(id: number): Observable<AvatarOrderDataResponse> {
        let url_ = this.baseUrl + "/avatarOrder/broadcastEnd/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAvatarOrderBroadcastEnd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvatarOrderBroadcastEnd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvatarOrderDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvatarOrderDataResponse>;
        }));
    }

    protected processAvatarOrderBroadcastEnd(response: HttpResponseBase): Observable<AvatarOrderDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvatarOrderDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = AvatarOrderUpdateError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified AvatarOrder
     * @param id AvatarOrder ID
     * @return OK
     */
    avatarOrderDone(id: number): Observable<AvatarOrderDataResponse> {
        let url_ = this.baseUrl + "/avatarOrder/done/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAvatarOrderDone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvatarOrderDone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvatarOrderDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvatarOrderDataResponse>;
        }));
    }

    protected processAvatarOrderDone(response: HttpResponseBase): Observable<AvatarOrderDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvatarOrderDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified AvatarOrder
     * @param id AvatarOrder ID
     * @return OK
     */
    avatarOrderCancel(id: number): Observable<AvatarOrderDataResponse> {
        let url_ = this.baseUrl + "/avatarOrder/cancel/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAvatarOrderCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvatarOrderCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvatarOrderDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvatarOrderDataResponse>;
        }));
    }

    protected processAvatarOrderCancel(response: HttpResponseBase): Observable<AvatarOrderDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvatarOrderDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Video record
     * @param id AvatarOrder ID
     * @return OK
     */
    avatarOrderConnected(id: number): Observable<void> {
        let url_ = this.baseUrl + "/avatarOrder/connected/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAvatarOrderConnected(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvatarOrderConnected(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAvatarOrderConnected(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Ban
     * @param sort (optional) Sorting column.
     * @param order (optional) Sorting order. Use 'asc' or 'desc'. 'asc' by default.
     * @param countOnPage (optional) Rows count on the page. 10 rows by default.
     * @param page (optional) Page number. 1 by default.
     * @return OK
     */
    banIndex(sort: string | undefined, order: string | undefined, countOnPage: number | undefined, page: number | undefined): Observable<BansDataResponse> {
        let url_ = this.baseUrl + "/ban/index?";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (countOnPage === null)
            throw new Error("The parameter 'countOnPage' cannot be null.");
        else if (countOnPage !== undefined)
            url_ += "countOnPage=" + encodeURIComponent("" + countOnPage) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBanIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBanIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BansDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BansDataResponse>;
        }));
    }

    protected processBanIndex(response: HttpResponseBase): Observable<BansDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BansDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new Ban
     * @param body (optional) Add Ban
     * @return OK
     */
    banPost(body: BanRequest | undefined): Observable<BanDataResponse> {
        let url_ = this.baseUrl + "/ban/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBanPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBanPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BanDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BanDataResponse>;
        }));
    }

    protected processBanPost(response: HttpResponseBase): Observable<BanDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = BanDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = BanError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified Ban
     * @param id Ban ID
     * @return OK
     */
    banGet(id: number): Observable<BanDataResponse> {
        let url_ = this.baseUrl + "/ban/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBanGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBanGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BanDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BanDataResponse>;
        }));
    }

    protected processBanGet(response: HttpResponseBase): Observable<BanDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BanDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing Ban
     * @param id Ban ID
     * @param body Update ban.
     * @return OK
     */
    banPut(id: number, body: BanUpdateRequest): Observable<BanDataResponse> {
        let url_ = this.baseUrl + "/ban/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBanPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBanPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BanDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BanDataResponse>;
        }));
    }

    protected processBanPut(response: HttpResponseBase): Observable<BanDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BanDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = BanUpdateError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a Ban
     * @param id Ban ID
     * @return No Content
     */
    banDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/ban/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBanDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBanDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBanDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a Ban Types
     * @return OK
     */
    banGetTypes(): Observable<any> {
        let url_ = this.baseUrl + "/ban/getTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBanGetTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBanGetTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processBanGetTypes(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Ban
     * @param id User ID
     * @return OK
     */
    banGetBanForeverByUserId(id: number): Observable<BanDataResponse> {
        let url_ = this.baseUrl + "/ban/getBanForeverByUserId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBanGetBanForeverByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBanGetBanForeverByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BanDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BanDataResponse>;
        }));
    }

    protected processBanGetBanForeverByUserId(response: HttpResponseBase): Observable<BanDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BanDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Blacklist
     * @return OK
     */
    blacklistIndex(): Observable<BlacklistsDataResponse> {
        let url_ = this.baseUrl + "/blacklist/index";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBlacklistIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBlacklistIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlacklistsDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlacklistsDataResponse>;
        }));
    }

    protected processBlacklistIndex(response: HttpResponseBase): Observable<BlacklistsDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BlacklistsDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new Blacklist
     * @param body (optional) Add Blacklist
     * @return OK
     */
    blacklistPost(body: BlacklistRequest | undefined): Observable<BlacklistDataResponse> {
        let url_ = this.baseUrl + "/blacklist/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBlacklistPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBlacklistPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlacklistDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlacklistDataResponse>;
        }));
    }

    protected processBlacklistPost(response: HttpResponseBase): Observable<BlacklistDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = BlacklistDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = BlacklistError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified Blacklist
     * @param id Blacklist ID
     * @return OK
     */
    blacklistGet(id: number): Observable<BlacklistDataResponse> {
        let url_ = this.baseUrl + "/blacklist/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBlacklistGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBlacklistGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlacklistDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlacklistDataResponse>;
        }));
    }

    protected processBlacklistGet(response: HttpResponseBase): Observable<BlacklistDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BlacklistDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a Blacklist
     * @param id Blacklist ID
     * @return No Content
     */
    blacklistDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/blacklist/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBlacklistDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBlacklistDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBlacklistDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Captcha
     * @return OK
     */
    captcha(): Observable<CaptchaResource> {
        let url_ = this.baseUrl + "/captcha";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCaptcha(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCaptcha(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaptchaResource>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaptchaResource>;
        }));
    }

    protected processCaptcha(response: HttpResponseBase): Observable<CaptchaResource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaptchaResource.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Category
     * @param isActive (optional) isActiveCategory
     * @param locale (optional) locale
     * @return OK
     */
    categoryIndex(isActive: boolean | null | undefined, locale: string | null | undefined): Observable<CategoriesDataResponse> {
        let url_ = this.baseUrl + "/category/index?";
        if (isActive !== undefined && isActive !== null)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        if (locale !== undefined && locale !== null)
            url_ += "locale=" + encodeURIComponent("" + locale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategoryIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategoryIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoriesDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoriesDataResponse>;
        }));
    }

    protected processCategoryIndex(response: HttpResponseBase): Observable<CategoriesDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoriesDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Category
     * @param isFinal (optional) isFinalCategory
     * @param isActive (optional) isActiveCategory
     * @return OK
     */
    categoryAllCategory(isFinal: boolean | null | undefined, isActive: boolean | null | undefined): Observable<CategoriesShortDataResponse> {
        let url_ = this.baseUrl + "/category/allCategory?";
        if (isFinal !== undefined && isFinal !== null)
            url_ += "isFinal=" + encodeURIComponent("" + isFinal) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategoryAllCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategoryAllCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoriesShortDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoriesShortDataResponse>;
        }));
    }

    protected processCategoryAllCategory(response: HttpResponseBase): Observable<CategoriesShortDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoriesShortDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new Category
     * @param body (optional) Add category
     * @return OK
     */
    categoryPost(body: CategoryRequest | undefined): Observable<CategoryDataResponse> {
        let url_ = this.baseUrl + "/category/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategoryPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategoryPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDataResponse>;
        }));
    }

    protected processCategoryPost(response: HttpResponseBase): Observable<CategoryDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CategoryDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = CategoryError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified category
     * @param id Category ID
     * @return OK
     */
    categoryGet(id: number): Observable<CategoryDataResponse> {
        let url_ = this.baseUrl + "/category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategoryGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategoryGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDataResponse>;
        }));
    }

    protected processCategoryGet(response: HttpResponseBase): Observable<CategoryDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing category
     * @param id Category ID
     * @param body (optional) Add category
     * @return OK
     */
    categoryPut(id: number, body: CategoryRequest | undefined): Observable<CategoryDataResponse> {
        let url_ = this.baseUrl + "/category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategoryPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategoryPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDataResponse>;
        }));
    }

    protected processCategoryPut(response: HttpResponseBase): Observable<CategoryDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = CategoryError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a category
     * @param id Category ID
     * @return No Content
     */
    categoryDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategoryDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategoryDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCategoryDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified Category
     * @return OK
     */
    categoryGetJson(): Observable<any> {
        let url_ = this.baseUrl + "/category/getJson";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategoryGetJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategoryGetJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processCategoryGetJson(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * updateCategoriesJson
     * @param file (optional) 
     * @return OK
     */
    categoryUpdateJson(file: FileParameter | undefined): Observable<CategoriesDataResponse2> {
        let url_ = this.baseUrl + "/category/updateJson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategoryUpdateJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategoryUpdateJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoriesDataResponse2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoriesDataResponse2>;
        }));
    }

    protected processCategoryUpdateJson(response: HttpResponseBase): Observable<CategoriesDataResponse2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoriesDataResponse2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Chat
     * @param type (optional) Use 'all', 'reply' or 'offer' or 'user' or 'freelance'. 'all' by default.
     * @param status (optional) Use all, 1, 2 or 3. 2 by default.
     * @param sort (optional) Sorting column.
     * @param order (optional) Sorting order. Use 'asc' or 'desc'. 'asc' by default.
     * @param countOnPage (optional) Rows count on the page. 10 rows by default.
     * @param page (optional) Page number. 1 by default.
     * @param name (optional) Name, surname, or middlename or all together with variations
     * @return OK
     */
    chatIndex(type: string | undefined, status: string | undefined, sort: string | undefined, order: string | undefined, countOnPage: number | undefined, page: number | undefined, name: string | undefined): Observable<ChatsDataResponse> {
        let url_ = this.baseUrl + "/chat/index?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (countOnPage === null)
            throw new Error("The parameter 'countOnPage' cannot be null.");
        else if (countOnPage !== undefined)
            url_ += "countOnPage=" + encodeURIComponent("" + countOnPage) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatsDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatsDataResponse>;
        }));
    }

    protected processChatIndex(response: HttpResponseBase): Observable<ChatsDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatsDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Chat
     * @return OK
     */
    chatChats(): Observable<ChatsDataResponse> {
        let url_ = this.baseUrl + "/chat/chats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatChats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatChats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatsDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatsDataResponse>;
        }));
    }

    protected processChatChats(response: HttpResponseBase): Observable<ChatsDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatsDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get chats with participant details for socket presence
     * @return OK
     */
    chatChatsWithParticipants(): Observable<ChatPresenceChatsResponse> {
        let url_ = this.baseUrl + "/chat/chatsWithParticipants";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatChatsWithParticipants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatChatsWithParticipants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatPresenceChatsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatPresenceChatsResponse>;
        }));
    }

    protected processChatChatsWithParticipants(response: HttpResponseBase): Observable<ChatPresenceChatsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatPresenceChatsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resolve a chat by chat ID or direct user ID
     * @param chat_id (optional) Chat ID
     * @param user_id (optional) Direct chat target user ID
     * @param includeMembers (optional) Include group chat members
     * @return OK
     */
    chatResolve(chat_id: number | undefined, user_id: number | undefined, includeMembers: boolean | undefined): Observable<ChatDataResponse> {
        let url_ = this.baseUrl + "/chat/resolve?";
        if (chat_id === null)
            throw new Error("The parameter 'chat_id' cannot be null.");
        else if (chat_id !== undefined)
            url_ += "chat_id=" + encodeURIComponent("" + chat_id) + "&";
        if (user_id === null)
            throw new Error("The parameter 'user_id' cannot be null.");
        else if (user_id !== undefined)
            url_ += "user_id=" + encodeURIComponent("" + user_id) + "&";
        if (includeMembers === null)
            throw new Error("The parameter 'includeMembers' cannot be null.");
        else if (includeMembers !== undefined)
            url_ += "includeMembers=" + encodeURIComponent("" + includeMembers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatResolve(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatResolve(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatDataResponse>;
        }));
    }

    protected processChatResolve(response: HttpResponseBase): Observable<ChatDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Direct chat does not exist yet", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new Chat
     * @param body (optional) Add Chat
     * @return OK
     */
    chatPost(body: ChatRequest | undefined): Observable<ChatDataResponse> {
        let url_ = this.baseUrl + "/chat/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatDataResponse>;
        }));
    }

    protected processChatPost(response: HttpResponseBase): Observable<ChatDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ChatDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ChatError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new group chat
     * @param body Create Group Chat
     * @return Group chat created successfully
     */
    chatGroup(body: Body4): Observable<ChatDataResponse> {
        let url_ = this.baseUrl + "/chat/group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatDataResponse>;
        }));
    }

    protected processChatGroup(response: HttpResponseBase): Observable<ChatDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ChatDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ChatError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add members to a group chat
     * @param id Chat ID
     * @param body Add Members
     * @return Members added successfully
     */
    chatMembersPost(id: number, body: Body5): Observable<Anonymous> {
        let url_ = this.baseUrl + "/chat/{id}/members";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatMembersPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatMembersPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous>;
        }));
    }

    protected processChatMembersPost(response: HttpResponseBase): Observable<Anonymous> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Chat is not a group", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Remove a member from a group chat
     * @param id Chat ID
     * @param userId User ID to remove
     * @return Member removed successfully
     */
    chatMembersDelete(id: number, userId: number): Observable<any> {
        let url_ = this.baseUrl + "/chat/{id}/members/{userId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatMembersDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatMembersDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processChatMembersDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("User is not a member", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Validation error (not a group, cannot remove owner, use leave endpoint)", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update member role in a group chat
     * @param id Chat ID
     * @param userId User ID
     * @param body Update Member Role
     * @return Role updated successfully
     */
    chatMembersRole(id: number, userId: number, body: Body6): Observable<ChatMemberResource> {
        let url_ = this.baseUrl + "/chat/{id}/members/{userId}/role";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatMembersRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatMembersRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatMemberResource>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatMemberResource>;
        }));
    }

    protected processChatMembersRole(response: HttpResponseBase): Observable<ChatMemberResource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatMemberResource.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden - Only owner can change roles", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("User is not a member", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Validation error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Leave a group chat
     * @param id Chat ID
     * @return Successfully left the group
     */
    chatLeave(id: number): Observable<any> {
        let url_ = this.baseUrl + "/chat/{id}/leave";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatLeave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatLeave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processChatLeave(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("User is not a member", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Validation error (not a group or owner cannot leave)", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get notification settings for a group chat
     * @param id Chat ID
     * @return Notification settings retrieved successfully
     */
    chatNotificationSettingsGet(id: number): Observable<ChatNotificationSettingsResource> {
        let url_ = this.baseUrl + "/chat/{id}/notification-settings";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatNotificationSettingsGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatNotificationSettingsGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatNotificationSettingsResource>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatNotificationSettingsResource>;
        }));
    }

    protected processChatNotificationSettingsGet(response: HttpResponseBase): Observable<ChatNotificationSettingsResource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatNotificationSettingsResource.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Chat is not a group", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update notification settings for a group chat
     * @param id Chat ID
     * @param body Update Notification Settings
     * @return Notification settings updated successfully
     */
    chatNotificationSettingsPatch(id: number, body: UpdateChatNotificationSettingsRequest): Observable<ChatNotificationSettingsResource> {
        let url_ = this.baseUrl + "/chat/{id}/notification-settings";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatNotificationSettingsPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatNotificationSettingsPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatNotificationSettingsResource>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatNotificationSettingsResource>;
        }));
    }

    protected processChatNotificationSettingsPatch(response: HttpResponseBase): Observable<ChatNotificationSettingsResource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatNotificationSettingsResource.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Validation error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get active invite info for a group chat
     * @param id Chat ID
     * @return Invite retrieved successfully
     */
    chatInviteGet(id: number): Observable<ChatInviteResource> {
        let url_ = this.baseUrl + "/chat/{id}/invite";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatInviteGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatInviteGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatInviteResource>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatInviteResource>;
        }));
    }

    protected processChatInviteGet(response: HttpResponseBase): Observable<ChatInviteResource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatInviteResource.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Chat is not a group", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create or rotate invite link for a group chat
     * @param id Chat ID
     * @return Invite created successfully
     */
    chatInvitePost(id: number): Observable<ChatInviteResource> {
        let url_ = this.baseUrl + "/chat/{id}/invite";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatInvitePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatInvitePost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatInviteResource>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatInviteResource>;
        }));
    }

    protected processChatInvitePost(response: HttpResponseBase): Observable<ChatInviteResource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ChatInviteResource.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Chat is not a group", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Revoke an invite link
     * @param token Invite token
     * @return Invite revoked successfully
     */
    chatInviteRevoke(token: string): Observable<ChatInviteResource> {
        let url_ = this.baseUrl + "/chat/invite/{token}/revoke";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatInviteRevoke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatInviteRevoke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatInviteResource>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatInviteResource>;
        }));
    }

    protected processChatInviteRevoke(response: HttpResponseBase): Observable<ChatInviteResource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatInviteResource.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Invite not found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Chat is not a group", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Public preview for an invite link (no auth required)
     * @param token Invite token
     * @return Invite preview
     */
    chatInviteByToken(token: string): Observable<ChatInvitePreviewResource> {
        let url_ = this.baseUrl + "/chat/inviteByToken/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatInviteByToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatInviteByToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatInvitePreviewResource>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatInvitePreviewResource>;
        }));
    }

    protected processChatInviteByToken(response: HttpResponseBase): Observable<ChatInvitePreviewResource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatInvitePreviewResource.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Invite not found or expired", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Join a group chat using an invite link
     * @param token Invite token
     * @return Successfully joined the group
     */
    chatInviteJoin(token: string): Observable<ChatDataResponse> {
        let url_ = this.baseUrl + "/chat/invite/{token}/join";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatInviteJoin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatInviteJoin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatDataResponse>;
        }));
    }

    protected processChatInviteJoin(response: HttpResponseBase): Observable<ChatDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Invite not found or expired", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Validation error (chat is not a group)", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update group chat details (title, description, avatar)
     * @param id Chat ID
     * @param body (optional) Update Group
     * @return Group updated successfully
     */
    chatUpdateGroup(id: number, body: Body7 | undefined): Observable<ChatDataResponse> {
        let url_ = this.baseUrl + "/chat/{id}/updateGroup";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatUpdateGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatUpdateGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatDataResponse>;
        }));
    }

    protected processChatUpdateGroup(response: HttpResponseBase): Observable<ChatDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Chat is not a group", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified Chat
     * @param id Chat ID
     * @param includeMembers (optional) 
     * @return OK
     */
    chatGet(id: number, includeMembers: boolean | undefined): Observable<ChatDataResponse> {
        let url_ = this.baseUrl + "/chat/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeMembers === null)
            throw new Error("The parameter 'includeMembers' cannot be null.");
        else if (includeMembers !== undefined)
            url_ += "includeMembers=" + encodeURIComponent("" + includeMembers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatDataResponse>;
        }));
    }

    protected processChatGet(response: HttpResponseBase): Observable<ChatDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a Chat
     * @param id Chat ID
     * @return No Content
     */
    chatDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/chat/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChatDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search text messages in chat
     * @param id Chat ID
     * @param q Search word or exact phrase
     * @param limit (optional) Result limit
     * @param before_id (optional) Load matches older than this message ID
     * @return OK
     */
    chatMessagesSearch(id: number, q: string, limit: number | undefined, before_id: string | undefined): Observable<ChatMessageSearchResponse> {
        let url_ = this.baseUrl + "/chat/{id}/messages/search?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (q === undefined || q === null)
            throw new Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (before_id === null)
            throw new Error("The parameter 'before_id' cannot be null.");
        else if (before_id !== undefined)
            url_ += "before_id=" + encodeURIComponent("" + before_id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatMessagesSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatMessagesSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatMessageSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatMessageSearchResponse>;
        }));
    }

    protected processChatMessagesSearch(response: HttpResponseBase): Observable<ChatMessageSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatMessageSearchResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get reaction navigation state for current user
     * @param id Chat ID
     * @return OK
     */
    chatReactionNavigation(id: number): Observable<ReactionNavigationDataResponse> {
        let url_ = this.baseUrl + "/chat/{id}/reaction-navigation";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatReactionNavigation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatReactionNavigation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReactionNavigationDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReactionNavigationDataResponse>;
        }));
    }

    protected processChatReactionNavigation(response: HttpResponseBase): Observable<ReactionNavigationDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReactionNavigationDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Acknowledge unread reactions for one of my messages
     * @param id Chat ID
     * @return OK
     */
    chatReactionNavigationAck(id: number, body: ReactionNavigationAckRequest): Observable<ReactionNavigationAckResponse> {
        let url_ = this.baseUrl + "/chat/{id}/reaction-navigation/ack";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatReactionNavigationAck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatReactionNavigationAck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReactionNavigationAckResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReactionNavigationAckResponse>;
        }));
    }

    protected processChatReactionNavigationAck(response: HttpResponseBase): Observable<ReactionNavigationAckResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReactionNavigationAckResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Message not found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing Chat
     * @param id Chat ID
     * @param title (optional) 
     * @param files (optional) 
     * @return OK
     */
    chatUpdate(id: number, title: string | undefined, files: FileParameter[] | undefined): Observable<ChatDataResponse> {
        let url_ = this.baseUrl + "/chat/update/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (title === null || title === undefined)
            throw new Error("The parameter 'title' cannot be null.");
        else
            content_.append("title", title.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files[]", item_.data, item_.fileName ? item_.fileName : "files[]") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatDataResponse>;
        }));
    }

    protected processChatUpdate(response: HttpResponseBase): Observable<ChatDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ChatUpdateError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing Chat
     * @param id Chat ID
     * @param body Update Chat.
     * @return OK
     */
    chatUpdateAsJson(id: number, body: ChatUpdateRequest): Observable<ChatDataResponse> {
        let url_ = this.baseUrl + "/chat/updateAsJson/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatUpdateAsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatUpdateAsJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatDataResponse>;
        }));
    }

    protected processChatUpdateAsJson(response: HttpResponseBase): Observable<ChatDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ChatUpdateError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get qtyUnreadMessages
     * @return OK
     */
    chatQtyUnreadMessages(): Observable<QtyUnreadMessages> {
        let url_ = this.baseUrl + "/chat/qtyUnreadMessages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatQtyUnreadMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatQtyUnreadMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QtyUnreadMessages>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QtyUnreadMessages>;
        }));
    }

    protected processChatQtyUnreadMessages(response: HttpResponseBase): Observable<QtyUnreadMessages> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QtyUnreadMessages.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * updateQtyUnreadMessages
     * @param id Chat ID
     * @param body Update Chat.
     * @return OK
     */
    chatUpdateQtyUnreadMessages(id: number, body: Body8): Observable<any> {
        let url_ = this.baseUrl + "/chat/updateQtyUnreadMessages/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatUpdateQtyUnreadMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatUpdateQtyUnreadMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processChatUpdateQtyUnreadMessages(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified chat
     * @param id Chat ID
     * @param fileName fileName
     * @param fileType fileType
     * @param client_guid (optional) Client upload GUID for tracking
     * @return OK
     */
    chatAddAvatarBySignUrl(id: number, fileName: string, fileType: string, client_guid: string | undefined): Observable<ChatAvatarS3FormFieldsResponse> {
        let url_ = this.baseUrl + "/chat/addAvatarBySignUrl/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (fileType === undefined || fileType === null)
            throw new Error("The parameter 'fileType' must be defined and cannot be null.");
        else
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (client_guid === null)
            throw new Error("The parameter 'client_guid' cannot be null.");
        else if (client_guid !== undefined)
            url_ += "client_guid=" + encodeURIComponent("" + client_guid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatAddAvatarBySignUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatAddAvatarBySignUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatAvatarS3FormFieldsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatAvatarS3FormFieldsResponse>;
        }));
    }

    protected processChatAddAvatarBySignUrl(response: HttpResponseBase): Observable<ChatAvatarS3FormFieldsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatAvatarS3FormFieldsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Confirm group avatar upload by S3 key
     * @param id Chat ID
     * @param body Confirm Avatar Upload
     * @return Avatar confirmed and set successfully
     */
    chatAvatarConfirm(id: number, body: Body9): Observable<ChatDataResponse> {
        let url_ = this.baseUrl + "/chat/{id}/avatar/confirm";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatAvatarConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatAvatarConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatDataResponse>;
        }));
    }

    protected processChatAvatarConfirm(response: HttpResponseBase): Observable<ChatDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("File not found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Validation error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified chat
     * @param id Chat ID
     * @param fileName fileName
     * @param fileType fileType
     * @param client_guid (optional) Client upload GUID for tracking
     * @return OK
     */
    chatAddFileBySignUrl(id: number, fileName: string, fileType: string, client_guid: string | undefined): Observable<ChatFileS3FormFieldsResponse> {
        let url_ = this.baseUrl + "/chat/addFileBySignUrl/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (fileType === undefined || fileType === null)
            throw new Error("The parameter 'fileType' must be defined and cannot be null.");
        else
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (client_guid === null)
            throw new Error("The parameter 'client_guid' cannot be null.");
        else if (client_guid !== undefined)
            url_ += "client_guid=" + encodeURIComponent("" + client_guid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatAddFileBySignUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatAddFileBySignUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatFileS3FormFieldsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatFileS3FormFieldsResponse>;
        }));
    }

    protected processChatAddFileBySignUrl(response: HttpResponseBase): Observable<ChatFileS3FormFieldsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatFileS3FormFieldsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Forward messages to chat
     * @param id Target chat ID
     * @return OK
     */
    chatForwardMessages(id: number, body: ChatForwardMessagesRequest): Observable<ChatForwardMessagesResponse> {
        let url_ = this.baseUrl + "/chat/{id}/forward_messages";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatForwardMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatForwardMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatForwardMessagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatForwardMessagesResponse>;
        }));
    }

    protected processChatForwardMessages(response: HttpResponseBase): Observable<ChatForwardMessagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatForwardMessagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 406) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result406: any = null;
            let resultData406 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result406 = Message.fromJS(resultData406);
            return throwException("Chat blocked", status, _responseText, _headers, result406);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Validation error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Edit message in chat
     * @param id Chat ID
     * @return OK
     */
    chatEditMessage(id: number, body: ChatEditMessageRequest): Observable<ChatEditMessageResponse> {
        let url_ = this.baseUrl + "/chat/{id}/edit_message";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatEditMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatEditMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatEditMessageResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatEditMessageResponse>;
        }));
    }

    protected processChatEditMessage(response: HttpResponseBase): Observable<ChatEditMessageResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatEditMessageResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 406) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result406: any = null;
            let resultData406 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result406 = Message.fromJS(resultData406);
            return throwException("Chat blocked", status, _responseText, _headers, result406);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Validation error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Toggle reaction for message in chat
     * @param id Chat ID
     * @return OK
     */
    chatReactionMessage(id: number, body: ChatReactionMessageRequest): Observable<ChatReactionMessageResponse> {
        let url_ = this.baseUrl + "/chat/{id}/reaction_message";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatReactionMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatReactionMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatReactionMessageResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatReactionMessageResponse>;
        }));
    }

    protected processChatReactionMessage(response: HttpResponseBase): Observable<ChatReactionMessageResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatReactionMessageResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Message not found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Validation error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete messages in chat
     * @param id Chat ID
     * @return OK
     */
    chatDeleteMessages(id: number, body: ChatDeleteMessagesRequest): Observable<void> {
        let url_ = this.baseUrl + "/chat/{id}/delete_messages";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatDeleteMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatDeleteMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChatDeleteMessages(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 406) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result406: any = null;
            let resultData406 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result406 = Message.fromJS(resultData406);
            return throwException("Chat blocked", status, _responseText, _headers, result406);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Validation error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete message in chat
     * @param id Chat ID
     * @param message_id Message ID
     * @param scope (optional) Delete scope. Use 'me' to hide message only for current user. Use 'everyone' to delete own messages in any ordinary chat, or any message in a direct chat.
     * @return OK
     */
    chatDeleteMessage(id: number, message_id: string, scope: Scope | undefined): Observable<void> {
        let url_ = this.baseUrl + "/chat/{id}/delete_message?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (message_id === undefined || message_id === null)
            throw new Error("The parameter 'message_id' must be defined and cannot be null.");
        else
            url_ += "message_id=" + encodeURIComponent("" + message_id) + "&";
        if (scope === null)
            throw new Error("The parameter 'scope' cannot be null.");
        else if (scope !== undefined)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChatDeleteMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChatDeleteMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChatDeleteMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 406) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result406: any = null;
            let resultData406 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result406 = Message.fromJS(resultData406);
            return throwException("Chat blocked", status, _responseText, _headers, result406);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Validation error", status, _responseText, _headers, result422);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Comment
     * @param id Task ID
     * @return OK
     */
    commentIndex(id: number): Observable<CommentsDataResponse> {
        let url_ = this.baseUrl + "/comment/index/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommentIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommentIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentsDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentsDataResponse>;
        }));
    }

    protected processCommentIndex(response: HttpResponseBase): Observable<CommentsDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommentsDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new Comment
     * @param body (optional) Add Comment
     * @return OK
     */
    commentPost(body: CommentRequest | undefined): Observable<CommentDataResponse> {
        let url_ = this.baseUrl + "/comment/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommentPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommentPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentDataResponse>;
        }));
    }

    protected processCommentPost(response: HttpResponseBase): Observable<CommentDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CommentDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = CommentError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified Comment
     * @param id Comment ID
     * @return OK
     */
    commentGet(id: number): Observable<CommentDataResponse> {
        let url_ = this.baseUrl + "/comment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommentGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommentGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentDataResponse>;
        }));
    }

    protected processCommentGet(response: HttpResponseBase): Observable<CommentDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommentDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing Comment
     * @param id Comment ID
     * @param body Update comment.
     * @return OK
     */
    commentPut(id: number, body: CommentUpdateRequest): Observable<CommentDataResponse> {
        let url_ = this.baseUrl + "/comment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommentPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommentPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentDataResponse>;
        }));
    }

    protected processCommentPut(response: HttpResponseBase): Observable<CommentDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommentDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = CommentUpdateError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a Comment
     * @param id Comment ID
     * @return No Content
     */
    commentDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/comment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommentDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommentDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCommentDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of content_subscriptions
     * @return OK
     */
    userContentSubscriptions(): Observable<UserContentSubscriptionResource[]> {
        let url_ = this.baseUrl + "/user/content_subscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserContentSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserContentSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserContentSubscriptionResource[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserContentSubscriptionResource[]>;
        }));
    }

    protected processUserContentSubscriptions(response: HttpResponseBase): Observable<UserContentSubscriptionResource[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserContentSubscriptionResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Manage content subscriptions
     * @param id Subscriber User ID
     * @return OK
     */
    userContentSubscription(id: number, body: UserContentSubscriptionRequest): Observable<UserContentSubscriptionResource[]> {
        let url_ = this.baseUrl + "/user/content_subscription/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserContentSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserContentSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserContentSubscriptionResource[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserContentSubscriptionResource[]>;
        }));
    }

    protected processUserContentSubscription(response: HttpResponseBase): Observable<UserContentSubscriptionResource[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserContentSubscriptionResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Coordinate
     * @param long Longitude.
     * @param lat Latitude.
     * @param maxDistance (optional) Max distance. Default 50.
     * @param count (optional) Rows count of Avatar. Default 10.
     * @param offset (optional) Records to skip for load
     * @param minRate (optional) minRate
     * @param maxRate (optional) maxRate
     * @param statuses (optional) statuses array. use 1 - ONLINE, 2 - BUSY, 3 - OFFLINE
     * @param isShared (optional) isShared
     * @return OK
     */
    coordinateIndex(long: number, lat: number, maxDistance: number | undefined, count: number | undefined, offset: number | undefined, minRate: number | undefined, maxRate: number | undefined, statuses: number[] | undefined, isShared: boolean | null | undefined): Observable<CoordinatesDataResponse> {
        let url_ = this.baseUrl + "/coordinate/index?";
        if (long === undefined || long === null)
            throw new Error("The parameter 'long' must be defined and cannot be null.");
        else
            url_ += "long=" + encodeURIComponent("" + long) + "&";
        if (lat === undefined || lat === null)
            throw new Error("The parameter 'lat' must be defined and cannot be null.");
        else
            url_ += "lat=" + encodeURIComponent("" + lat) + "&";
        if (maxDistance === null)
            throw new Error("The parameter 'maxDistance' cannot be null.");
        else if (maxDistance !== undefined)
            url_ += "maxDistance=" + encodeURIComponent("" + maxDistance) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (minRate === null)
            throw new Error("The parameter 'minRate' cannot be null.");
        else if (minRate !== undefined)
            url_ += "minRate=" + encodeURIComponent("" + minRate) + "&";
        if (maxRate === null)
            throw new Error("The parameter 'maxRate' cannot be null.");
        else if (maxRate !== undefined)
            url_ += "maxRate=" + encodeURIComponent("" + maxRate) + "&";
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses[]=" + encodeURIComponent("" + item) + "&"; });
        if (isShared !== undefined && isShared !== null)
            url_ += "isShared=" + encodeURIComponent("" + isShared) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCoordinateIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCoordinateIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoordinatesDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoordinatesDataResponse>;
        }));
    }

    protected processCoordinateIndex(response: HttpResponseBase): Observable<CoordinatesDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoordinatesDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Coordinate (short)
     * @param long Longitude.
     * @param lat Latitude.
     * @param maxDistance (optional) Max distance. Default 50.
     * @param count (optional) Rows count of Avatar. Default 10.
     * @param minRate (optional) minRate
     * @param maxRate (optional) maxRate
     * @param statuses (optional) statuses array. use 1 - ONLINE, 2 - BUSY, 3 - OFFLINE
     * @param isShared (optional) isShared
     * @return OK
     */
    coordinateIndex2(long: number, lat: number, maxDistance: number | undefined, count: number | undefined, minRate: number | undefined, maxRate: number | undefined, statuses: number[] | undefined, isShared: boolean | null | undefined): Observable<CoordinatesMarkerShortResponse> {
        let url_ = this.baseUrl + "/coordinate/index2?";
        if (long === undefined || long === null)
            throw new Error("The parameter 'long' must be defined and cannot be null.");
        else
            url_ += "long=" + encodeURIComponent("" + long) + "&";
        if (lat === undefined || lat === null)
            throw new Error("The parameter 'lat' must be defined and cannot be null.");
        else
            url_ += "lat=" + encodeURIComponent("" + lat) + "&";
        if (maxDistance === null)
            throw new Error("The parameter 'maxDistance' cannot be null.");
        else if (maxDistance !== undefined)
            url_ += "maxDistance=" + encodeURIComponent("" + maxDistance) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (minRate === null)
            throw new Error("The parameter 'minRate' cannot be null.");
        else if (minRate !== undefined)
            url_ += "minRate=" + encodeURIComponent("" + minRate) + "&";
        if (maxRate === null)
            throw new Error("The parameter 'maxRate' cannot be null.");
        else if (maxRate !== undefined)
            url_ += "maxRate=" + encodeURIComponent("" + maxRate) + "&";
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses[]=" + encodeURIComponent("" + item) + "&"; });
        if (isShared !== undefined && isShared !== null)
            url_ += "isShared=" + encodeURIComponent("" + isShared) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCoordinateIndex2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCoordinateIndex2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoordinatesMarkerShortResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoordinatesMarkerShortResponse>;
        }));
    }

    protected processCoordinateIndex2(response: HttpResponseBase): Observable<CoordinatesMarkerShortResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoordinatesMarkerShortResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new Coordinate
     * @param body (optional) Add Coordinate
     * @return OK
     */
    coordinatePost(body: CoordinateRequest | undefined): Observable<CoordinateShortResponse> {
        let url_ = this.baseUrl + "/coordinate/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCoordinatePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCoordinatePost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoordinateShortResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoordinateShortResponse>;
        }));
    }

    protected processCoordinatePost(response: HttpResponseBase): Observable<CoordinateShortResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CoordinateShortResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ReplyError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified Coordinate
     * @param id Coordinate ID
     * @return OK
     */
    coordinateGet(id: string): Observable<CoordinateDataResponse> {
        let url_ = this.baseUrl + "/coordinate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCoordinateGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCoordinateGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoordinateDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoordinateDataResponse>;
        }));
    }

    protected processCoordinateGet(response: HttpResponseBase): Observable<CoordinateDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoordinateDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a Coordinate
     * @param id Coordinate ID
     * @return No Content
     */
    coordinateDelete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/coordinate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCoordinateDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCoordinateDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCoordinateDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified Coordinate
     * @return OK
     */
    coordinateMe(): Observable<CoordinateDataResponse> {
        let url_ = this.baseUrl + "/coordinate/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCoordinateMe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCoordinateMe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoordinateDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoordinateDataResponse>;
        }));
    }

    protected processCoordinateMe(response: HttpResponseBase): Observable<CoordinateDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoordinateDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing Coordinate
     * @param body Update Coordinate.
     * @return OK
     */
    coordinatePut(body: CoordinateUpdateRequest): Observable<CoordinateDataResponse> {
        let url_ = this.baseUrl + "/coordinate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCoordinatePut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCoordinatePut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoordinateDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoordinateDataResponse>;
        }));
    }

    protected processCoordinatePut(response: HttpResponseBase): Observable<CoordinateDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoordinateDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified Coordinate
     * @return OK
     */
    coordinateGetPosition(): Observable<PositionResponse> {
        let url_ = this.baseUrl + "/coordinate/getPosition";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCoordinateGetPosition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCoordinateGetPosition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PositionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PositionResponse>;
        }));
    }

    protected processCoordinateGetPosition(response: HttpResponseBase): Observable<PositionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PositionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Coordinate
     * @return OK
     */
    coordinateGetRates(): Observable<CoordinateRatesDataResponse> {
        let url_ = this.baseUrl + "/coordinate/getRates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCoordinateGetRates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCoordinateGetRates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoordinateRatesDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoordinateRatesDataResponse>;
        }));
    }

    protected processCoordinateGetRates(response: HttpResponseBase): Observable<CoordinateRatesDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoordinateRatesDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified Coordinate
     * @return OK
     */
    coordinateCheckStatus(): Observable<CoordinateCheckStatusResponse> {
        let url_ = this.baseUrl + "/coordinate/checkStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCoordinateCheckStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCoordinateCheckStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoordinateCheckStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoordinateCheckStatusResponse>;
        }));
    }

    protected processCoordinateCheckStatus(response: HttpResponseBase): Observable<CoordinateCheckStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoordinateCheckStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Coordinate by user_id
     * @param user_id User ID
     * @return OK
     */
    coordinateShowByUserId(user_id: string): Observable<CoordinateDataResponse> {
        let url_ = this.baseUrl + "/coordinate/showByUserId?";
        if (user_id === undefined || user_id === null)
            throw new Error("The parameter 'user_id' must be defined and cannot be null.");
        else
            url_ += "user_id=" + encodeURIComponent("" + user_id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCoordinateShowByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCoordinateShowByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoordinateDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoordinateDataResponse>;
        }));
    }

    protected processCoordinateShowByUserId(response: HttpResponseBase): Observable<CoordinateDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoordinateDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Coordinate does not exist yet", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Draft
     * @return OK
     */
    draftIndex(): Observable<DraftsDataResponse> {
        let url_ = this.baseUrl + "/draft/index";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDraftIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDraftIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DraftsDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DraftsDataResponse>;
        }));
    }

    protected processDraftIndex(response: HttpResponseBase): Observable<DraftsDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DraftsDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new Draft
     * @param body (optional) Add Draft
     * @return OK
     */
    draftPost(body: DraftRequest | undefined): Observable<DraftDataResponse> {
        let url_ = this.baseUrl + "/draft/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDraftPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDraftPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DraftDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DraftDataResponse>;
        }));
    }

    protected processDraftPost(response: HttpResponseBase): Observable<DraftDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = DraftDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = DraftError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified Draft
     * @param id Draft ID
     * @return OK
     */
    draftGet(id: number): Observable<DraftDataResponse> {
        let url_ = this.baseUrl + "/draft/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDraftGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDraftGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DraftDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DraftDataResponse>;
        }));
    }

    protected processDraftGet(response: HttpResponseBase): Observable<DraftDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DraftDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing Draft
     * @param id Draft ID
     * @param body Update Draft.
     * @return OK
     */
    draftPut(id: number, body: DraftRequest): Observable<DraftDataResponse> {
        let url_ = this.baseUrl + "/draft/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDraftPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDraftPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DraftDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DraftDataResponse>;
        }));
    }

    protected processDraftPut(response: HttpResponseBase): Observable<DraftDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DraftDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = DraftError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a Draft
     * @param id Draft ID
     * @return No Content
     */
    draftDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/draft/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDraftDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDraftDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDraftDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified draft
     * @param id Draft ID
     * @param fileName fileName
     * @param fileType fileType
     * @param questionId (optional) questionId
     * @param client_guid (optional) Client upload GUID for tracking
     * @return OK
     */
    draftAddFileBySignUrl(id: number, fileName: string, fileType: string, questionId: number | undefined, client_guid: string | undefined): Observable<DraftFileS3FormFieldsResponse> {
        let url_ = this.baseUrl + "/draft/addFileBySignUrl/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (fileType === undefined || fileType === null)
            throw new Error("The parameter 'fileType' must be defined and cannot be null.");
        else
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (questionId === null)
            throw new Error("The parameter 'questionId' cannot be null.");
        else if (questionId !== undefined)
            url_ += "questionId=" + encodeURIComponent("" + questionId) + "&";
        if (client_guid === null)
            throw new Error("The parameter 'client_guid' cannot be null.");
        else if (client_guid !== undefined)
            url_ += "client_guid=" + encodeURIComponent("" + client_guid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDraftAddFileBySignUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDraftAddFileBySignUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DraftFileS3FormFieldsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DraftFileS3FormFieldsResponse>;
        }));
    }

    protected processDraftAddFileBySignUrl(response: HttpResponseBase): Observable<DraftFileS3FormFieldsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DraftFileS3FormFieldsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of ExtraWork
     * @param id Reply ID
     * @return OK
     */
    extraWorkIndex(id: number): Observable<ExtraWorksDataResponse> {
        let url_ = this.baseUrl + "/extraWork/index/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtraWorkIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtraWorkIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtraWorksDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtraWorksDataResponse>;
        }));
    }

    protected processExtraWorkIndex(response: HttpResponseBase): Observable<ExtraWorksDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtraWorksDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new ExtraWork
     * @param reply_id (optional) 
     * @param price (optional) 
     * @param description (optional) 
     * @param deadline_at (optional) 
     * @param files (optional) 
     * @return OK
     */
    extraWorkPost(reply_id: number | undefined, price: number | null | undefined, description: string | null | undefined, deadline_at: string | null | undefined, files: FileParameter[] | null | undefined): Observable<ExtraWorkDataResponse> {
        let url_ = this.baseUrl + "/extraWork/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (reply_id === null || reply_id === undefined)
            throw new Error("The parameter 'reply_id' cannot be null.");
        else
            content_.append("reply_id", reply_id.toString());
        if (price !== null && price !== undefined)
            content_.append("price", price.toString());
        if (description !== null && description !== undefined)
            content_.append("description", description.toString());
        if (deadline_at !== null && deadline_at !== undefined)
            content_.append("deadline_at", deadline_at.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files[]", item_.data, item_.fileName ? item_.fileName : "files[]") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtraWorkPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtraWorkPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtraWorkDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtraWorkDataResponse>;
        }));
    }

    protected processExtraWorkPost(response: HttpResponseBase): Observable<ExtraWorkDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ExtraWorkDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ExtraWorkError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new ExtraWork
     * @param body Add ExtraWork
     * @return OK
     */
    extraWorkStoreAsJson(body: ExtraWorkRequest): Observable<ExtraWorkDataResponse> {
        let url_ = this.baseUrl + "/extraWork/storeAsJson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtraWorkStoreAsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtraWorkStoreAsJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtraWorkDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtraWorkDataResponse>;
        }));
    }

    protected processExtraWorkStoreAsJson(response: HttpResponseBase): Observable<ExtraWorkDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ExtraWorkDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ExtraWorkError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified ExtraWork
     * @param id ExtraWork ID
     * @return OK
     */
    extraWorkGet(id: number): Observable<ExtraWorkDataResponse> {
        let url_ = this.baseUrl + "/extraWork/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtraWorkGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtraWorkGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtraWorkDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtraWorkDataResponse>;
        }));
    }

    protected processExtraWorkGet(response: HttpResponseBase): Observable<ExtraWorkDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtraWorkDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing ExtraWork
     * @param id ExtraWork ID
     * @param body Update extraWork.
     * @return OK
     */
    extraWorkPut(id: number, body: ExtraWorkUpdateRequest): Observable<ExtraWorkDataResponse> {
        let url_ = this.baseUrl + "/extraWork/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtraWorkPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtraWorkPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtraWorkDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtraWorkDataResponse>;
        }));
    }

    protected processExtraWorkPut(response: HttpResponseBase): Observable<ExtraWorkDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtraWorkDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ExtraWorkUpdateError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a ExtraWork
     * @param id ExtraWork ID
     * @return No Content
     */
    extraWorkDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/extraWork/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtraWorkDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtraWorkDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExtraWorkDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing ExtraWork
     * @param id ExtraWork ID
     * @param body Update extraWork.
     * @return OK
     */
    extraWorkReject(id: number, body: ExtraWorkRejectRequest): Observable<ExtraWorkDataResponse> {
        let url_ = this.baseUrl + "/extraWork/reject/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtraWorkReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtraWorkReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtraWorkDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtraWorkDataResponse>;
        }));
    }

    protected processExtraWorkReject(response: HttpResponseBase): Observable<ExtraWorkDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtraWorkDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ExtraWorkRejectError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing ExtraWork
     * @param id ExtraWork ID
     * @param body Update extraWork.
     * @return OK
     */
    extraWorkOfferExtraPay(id: number, body: ExtraWorkOfferExtraPayRequest): Observable<ExtraWorkDataResponse> {
        let url_ = this.baseUrl + "/extraWork/offerExtraPay/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtraWorkOfferExtraPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtraWorkOfferExtraPay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtraWorkDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtraWorkDataResponse>;
        }));
    }

    protected processExtraWorkOfferExtraPay(response: HttpResponseBase): Observable<ExtraWorkDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtraWorkDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ExtraWorkUpdateError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing ExtraWork
     * @param id ExtraWork ID
     * @return OK
     */
    extraWorkOwnerApprove(id: number): Observable<ExtraWorkDataResponse> {
        let url_ = this.baseUrl + "/extraWork/ownerApprove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtraWorkOwnerApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtraWorkOwnerApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtraWorkDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtraWorkDataResponse>;
        }));
    }

    protected processExtraWorkOwnerApprove(response: HttpResponseBase): Observable<ExtraWorkDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtraWorkDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing ExtraWork
     * @param id ExtraWork ID
     * @return OK
     */
    extraWorkWorkerApprove(id: number): Observable<ExtraWorkDataResponse> {
        let url_ = this.baseUrl + "/extraWork/workerApprove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtraWorkWorkerApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtraWorkWorkerApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtraWorkDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtraWorkDataResponse>;
        }));
    }

    protected processExtraWorkWorkerApprove(response: HttpResponseBase): Observable<ExtraWorkDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtraWorkDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add results an existing ExtraWork
     * @param id ExtraWork ID
     * @param result_description (optional) 
     * @param files (optional) 
     * @return OK
     */
    extraWorkAddResults(id: number, result_description: string | null | undefined, files: FileParameter[] | null | undefined): Observable<ExtraWorkDataResponse> {
        let url_ = this.baseUrl + "/extraWork/addResults/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (result_description !== null && result_description !== undefined)
            content_.append("result_description", result_description.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files[]", item_.data, item_.fileName ? item_.fileName : "files[]") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtraWorkAddResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtraWorkAddResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtraWorkDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtraWorkDataResponse>;
        }));
    }

    protected processExtraWorkAddResults(response: HttpResponseBase): Observable<ExtraWorkDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtraWorkDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ExtraWorkAddResultsError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add results an existing ExtraWork
     * @param id ExtraWork ID
     * @param body Add results ExtraWork
     * @return OK
     */
    extraWorkAddResultsAsJson(id: number, body: ExtraWorkAddResultsRequest): Observable<ExtraWorkDataResponse> {
        let url_ = this.baseUrl + "/extraWork/addResultsAsJson/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtraWorkAddResultsAsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtraWorkAddResultsAsJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtraWorkDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtraWorkDataResponse>;
        }));
    }

    protected processExtraWorkAddResultsAsJson(response: HttpResponseBase): Observable<ExtraWorkDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtraWorkDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ExtraWorkAddResultsError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing ExtraWork
     * @param id ExtraWork ID
     * @return OK
     */
    extraWorkOwnerApproveResults(id: number): Observable<ExtraWorkDataResponse> {
        let url_ = this.baseUrl + "/extraWork/ownerApproveResults/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtraWorkOwnerApproveResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtraWorkOwnerApproveResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtraWorkDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtraWorkDataResponse>;
        }));
    }

    protected processExtraWorkOwnerApproveResults(response: HttpResponseBase): Observable<ExtraWorkDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtraWorkDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified extraWork
     * @param id ExtraWork ID
     * @param fileName fileName
     * @param fileType fileType
     * @param client_guid (optional) Client upload GUID for tracking
     * @return OK
     */
    extraWorkAddFileBySignUrl(id: number, fileName: string, fileType: string, client_guid: string | undefined): Observable<ExtraWorkFileS3FormFieldsResponse> {
        let url_ = this.baseUrl + "/extraWork/addFileBySignUrl/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (fileType === undefined || fileType === null)
            throw new Error("The parameter 'fileType' must be defined and cannot be null.");
        else
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (client_guid === null)
            throw new Error("The parameter 'client_guid' cannot be null.");
        else if (client_guid !== undefined)
            url_ += "client_guid=" + encodeURIComponent("" + client_guid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtraWorkAddFileBySignUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtraWorkAddFileBySignUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtraWorkFileS3FormFieldsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtraWorkFileS3FormFieldsResponse>;
        }));
    }

    protected processExtraWorkAddFileBySignUrl(response: HttpResponseBase): Observable<ExtraWorkFileS3FormFieldsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtraWorkFileS3FormFieldsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of files
     * @param body List files from db
     * @return OK
     */
    fileListOnBase(body: FilesListFromDbRequest): Observable<FilesDataResponse> {
        let url_ = this.baseUrl + "/file/listOnBase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileListOnBase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileListOnBase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilesDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilesDataResponse>;
        }));
    }

    protected processFileListOnBase(response: HttpResponseBase): Observable<FilesDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilesDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of files from s3
     * @param body List files from s3
     * @return OK
     */
    fileListOnServer(body: FilesListFromDbRequest): Observable<FilesStringDataResponse> {
        let url_ = this.baseUrl + "/file/listOnServer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileListOnServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileListOnServer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilesStringDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilesStringDataResponse>;
        }));
    }

    protected processFileListOnServer(response: HttpResponseBase): Observable<FilesStringDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilesStringDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add file to s3
     * @param files (optional) 
     * @return OK
     */
    fileStore(files: FileFormdataRequest[] | undefined): Observable<FileDataResponse> {
        let url_ = this.baseUrl + "/file/store";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files[]", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileStore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDataResponse>;
        }));
    }

    protected processFileStore(response: HttpResponseBase): Observable<FileDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = FileDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = FileError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add file to s3
     * @param body Base64. Type of file: pdf, avatar, image, audio, video.
     * @return OK
     */
    fileStoreAsBase64(body: FileRequestBody): Observable<FileDataResponse> {
        let url_ = this.baseUrl + "/file/storeAsBase64";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileStoreAsBase64(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileStoreAsBase64(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDataResponse>;
        }));
    }

    protected processFileStoreAsBase64(response: HttpResponseBase): Observable<FileDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = FileDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = FileError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancel pending file upload by client guid
     * @return OK
     */
    fileCancelUpload(body: Body10): Observable<Anonymous2> {
        let url_ = this.baseUrl + "/file/cancelUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileCancelUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileCancelUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous2>;
        }));
    }

    protected processFileCancelUpload(response: HttpResponseBase): Observable<Anonymous2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get upload status by client guid or s3 name
     * @return OK
     */
    fileUploadStatus(body: Body11): Observable<Anonymous3> {
        let url_ = this.baseUrl + "/file/uploadStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileUploadStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileUploadStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous3>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous3>;
        }));
    }

    protected processFileUploadStatus(response: HttpResponseBase): Observable<Anonymous3> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous3.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Destroy file by Id
     * @param id File ID
     * @return OK
     */
    fileDestroy(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/file/destroy/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileDestroy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileDestroy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processFileDestroy(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download file by Id
     * @param id File ID
     * @param token (optional) Bearer token
     * @return OK
     */
    fileDownload(id: number, token: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/file/download/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFileDownload(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * get URL file by Id
     * @param id File ID
     * @return OK
     */
    fileGetURL(id: number): Observable<string> {
        let url_ = this.baseUrl + "/file/getURL/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileGetURL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileGetURL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFileGetURL(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of files for user
     * @return OK
     */
    fileList(): Observable<FilesDataResponse> {
        let url_ = this.baseUrl + "/file/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilesDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilesDataResponse>;
        }));
    }

    protected processFileList(response: HttpResponseBase): Observable<FilesDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilesDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get file for user
     * @param file File ID
     * @return OK
     */
    fileGetFile(file: number): Observable<FileDataResponse> {
        let url_ = this.baseUrl + "/file/getFile/{file}";
        if (file === undefined || file === null)
            throw new Error("The parameter 'file' must be defined.");
        url_ = url_.replace("{file}", encodeURIComponent("" + file));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDataResponse>;
        }));
    }

    protected processFileGetFile(response: HttpResponseBase): Observable<FileDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of type
     * @return OK
     */
    fileListOfType(): Observable<FileTypeDataResponse> {
        let url_ = this.baseUrl + "/file/listOfType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileListOfType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileListOfType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileTypeDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileTypeDataResponse>;
        }));
    }

    protected processFileListOfType(response: HttpResponseBase): Observable<FileTypeDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileTypeDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Filter
     * @param id Category ID
     * @return OK
     */
    filterIndex(id: number): Observable<FiltersShortDataResponse> {
        let url_ = this.baseUrl + "/filter/index/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilterIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FiltersShortDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FiltersShortDataResponse>;
        }));
    }

    protected processFilterIndex(response: HttpResponseBase): Observable<FiltersShortDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FiltersShortDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new Filter
     * @param body (optional) Add filter
     * @return OK
     */
    filterPost(body: FilterRequest | undefined): Observable<FilterDataResponse> {
        let url_ = this.baseUrl + "/filter/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilterPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilterDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilterDataResponse>;
        }));
    }

    protected processFilterPost(response: HttpResponseBase): Observable<FilterDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = FilterDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = FilterError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified filter
     * @param id Filter ID
     * @return OK
     */
    filterGet(id: number): Observable<FilterDataResponse> {
        let url_ = this.baseUrl + "/filter/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilterGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilterDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilterDataResponse>;
        }));
    }

    protected processFilterGet(response: HttpResponseBase): Observable<FilterDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilterDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing filter
     * @param id Filter ID
     * @param body (optional) Update filter
     * @return OK
     */
    filterPut(id: number, body: FilterRequest | undefined): Observable<FilterDataResponse> {
        let url_ = this.baseUrl + "/filter/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilterPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilterDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilterDataResponse>;
        }));
    }

    protected processFilterPut(response: HttpResponseBase): Observable<FilterDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilterDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = FilterError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a filter
     * @param id Filter ID
     * @return No Content
     */
    filterDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/filter/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilterDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFilterDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ErrorDto.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified Filter
     * @return OK
     */
    filterGetJson(): Observable<any> {
        let url_ = this.baseUrl + "/filter/getJson";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilterGetJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterGetJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processFilterGetJson(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * updateFilterJson
     * @param file (optional) 
     * @return OK
     */
    filterUpdateJson(file: FileParameter | undefined): Observable<any> {
        let url_ = this.baseUrl + "/filter/updateJson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilterUpdateJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterUpdateJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processFilterUpdateJson(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a Flag
     * @param filename filename
     * @return OK
     */
    flag(filename: string): Observable<string> {
        let url_ = this.baseUrl + "/flag/{filename}";
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFlag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFlag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFlag(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recovery the user password
     * @param body User phone
     * @return OK
     */
    authRecovery(body: SendSmsRequest): Observable<Message> {
        let url_ = this.baseUrl + "/auth/recovery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthRecovery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthRecovery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Message>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Message>;
        }));
    }

    protected processAuthRecovery(response: HttpResponseBase): Observable<Message> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Message.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = RecoveryError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result502: any = null;
            let resultData502 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result502 = Message.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Lang
     * @return OK
     */
    lang(): Observable<LangResponse[]> {
        let url_ = this.baseUrl + "/lang";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLang(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLang(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LangResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LangResponse[]>;
        }));
    }

    protected processLang(response: HttpResponseBase): Observable<LangResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LangResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Mail
     * @param type (optional) Use 'all', '1', '2' or '3'. 'all' by default.
     * @param sort (optional) Sorting column.
     * @param order (optional) Sorting order. Use 'asc' or 'desc'. 'asc' by default.
     * @param countOnPage (optional) Rows count on the page. 10 rows by default.
     * @param page (optional) Page number. 1 by default.
     * @return OK
     */
    mailIndex(type: string | undefined, sort: string | undefined, order: string | undefined, countOnPage: number | undefined, page: number | undefined): Observable<MailsDataResponse> {
        let url_ = this.baseUrl + "/mail/index?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (countOnPage === null)
            throw new Error("The parameter 'countOnPage' cannot be null.");
        else if (countOnPage !== undefined)
            url_ += "countOnPage=" + encodeURIComponent("" + countOnPage) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMailIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMailIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailsDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailsDataResponse>;
        }));
    }

    protected processMailIndex(response: HttpResponseBase): Observable<MailsDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MailsDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new Mail
     * @param type (optional) Use type 1 for a support request or type 2 for a user removal request
     * @param message (optional) 
     * @param topic (optional) 
     * @param email (optional) 
     * @param files (optional) 
     * @return OK
     */
    mailPost(type: number | undefined, message: string | undefined, topic: string | undefined, email: string | undefined, files: FileParameter[] | undefined): Observable<MailDataResponse> {
        let url_ = this.baseUrl + "/mail/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (type === null || type === undefined)
            throw new Error("The parameter 'type' cannot be null.");
        else
            content_.append("type", type.toString());
        if (message === null || message === undefined)
            throw new Error("The parameter 'message' cannot be null.");
        else
            content_.append("message", message.toString());
        if (topic === null || topic === undefined)
            throw new Error("The parameter 'topic' cannot be null.");
        else
            content_.append("topic", topic.toString());
        if (email === null || email === undefined)
            throw new Error("The parameter 'email' cannot be null.");
        else
            content_.append("email", email.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files[]", item_.data, item_.fileName ? item_.fileName : "files[]") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMailPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMailPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailDataResponse>;
        }));
    }

    protected processMailPost(response: HttpResponseBase): Observable<MailDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = MailDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = MailError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new Mail
     * @return OK
     */
    mailStoreAsJson(body: MailRequest): Observable<MailDataResponse> {
        let url_ = this.baseUrl + "/mail/storeAsJson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMailStoreAsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMailStoreAsJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailDataResponse>;
        }));
    }

    protected processMailStoreAsJson(response: HttpResponseBase): Observable<MailDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = MailDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = MailError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified Mail
     * @param id Mail ID
     * @return OK
     */
    mailGet(id: number): Observable<MailDataResponse> {
        let url_ = this.baseUrl + "/mail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMailGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMailGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailDataResponse>;
        }));
    }

    protected processMailGet(response: HttpResponseBase): Observable<MailDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MailDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing Mail
     * @param id Mail ID
     * @param body Update mail.
     * @return OK
     */
    mailPut(id: number, body: MailUpdateRequest): Observable<MailDataResponse> {
        let url_ = this.baseUrl + "/mail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMailPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMailPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailDataResponse>;
        }));
    }

    protected processMailPut(response: HttpResponseBase): Observable<MailDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MailDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = MailUpdateError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a Mail
     * @param id Mail ID
     * @return No Content
     */
    mailDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/mail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMailDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMailDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMailDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a Mail Types
     * @return OK
     */
    mailGetTypes(): Observable<any> {
        let url_ = this.baseUrl + "/mail/getTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMailGetTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMailGetTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processMailGetTypes(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new Mail
     * @param topic (optional) 
     * @param message (optional) 
     * @param email (optional) 
     * @param files (optional) 
     * @return OK
     */
    mailCreateUnauth(topic: string | undefined, message: string | undefined, email: string | undefined, files: FileParameter[] | undefined): Observable<MailDataResponse> {
        let url_ = this.baseUrl + "/mail/createUnauth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (topic === null || topic === undefined)
            throw new Error("The parameter 'topic' cannot be null.");
        else
            content_.append("topic", topic.toString());
        if (message === null || message === undefined)
            throw new Error("The parameter 'message' cannot be null.");
        else
            content_.append("message", message.toString());
        if (email === null || email === undefined)
            throw new Error("The parameter 'email' cannot be null.");
        else
            content_.append("email", email.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files[]", item_.data, item_.fileName ? item_.fileName : "files[]") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMailCreateUnauth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMailCreateUnauth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailDataResponse>;
        }));
    }

    protected processMailCreateUnauth(response: HttpResponseBase): Observable<MailDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = MailDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = MailError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new Mail
     * @return OK
     */
    mailCreateUnauthAsJson(body: MailUnauthRequest): Observable<MailDataResponse> {
        let url_ = this.baseUrl + "/mail/createUnauthAsJson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMailCreateUnauthAsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMailCreateUnauthAsJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailDataResponse>;
        }));
    }

    protected processMailCreateUnauthAsJson(response: HttpResponseBase): Observable<MailDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = MailDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = MailError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Notification
     * @param page (optional) Page number. 1 by default.
     * @param countOnPage (optional) how many elements on page
     * @return OK
     */
    notificationIndex(page: number | undefined, countOnPage: number | undefined): Observable<NotificationsDataResponse> {
        let url_ = this.baseUrl + "/notification/index?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (countOnPage === null)
            throw new Error("The parameter 'countOnPage' cannot be null.");
        else if (countOnPage !== undefined)
            url_ += "countOnPage=" + encodeURIComponent("" + countOnPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationsDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationsDataResponse>;
        }));
    }

    protected processNotificationIndex(response: HttpResponseBase): Observable<NotificationsDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationsDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new message Notification
     * @param body (optional) Add message Notification
     * @return OK
     */
    notificationPost(body: NotificationRequest | undefined): Observable<any> {
        let url_ = this.baseUrl + "/notification/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processNotificationPost(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = NotificationError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified Notification
     * @param id Notification ID
     * @return OK
     */
    notificationGet(id: number): Observable<NotificationDataResponse> {
        let url_ = this.baseUrl + "/notification/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationDataResponse>;
        }));
    }

    protected processNotificationGet(response: HttpResponseBase): Observable<NotificationDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing Notification
     * @param id Notification ID
     * @param body Update notification.
     * @return OK
     */
    notificationPut(id: number, body: NotificationUpdateRequest): Observable<NotificationDataResponse> {
        let url_ = this.baseUrl + "/notification/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationDataResponse>;
        }));
    }

    protected processNotificationPut(response: HttpResponseBase): Observable<NotificationDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = NotificationUpdateError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a Notification
     * @param id Notification ID
     * @return No Content
     */
    notificationDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/notification/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotificationDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Read an existing Notifications
     * @param body Read notifications.
     * @return OK
     */
    notificationRead(body: number[]): Observable<NotificationsDataResponse> {
        let url_ = this.baseUrl + "/notification/read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationsDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationsDataResponse>;
        }));
    }

    protected processNotificationRead(response: HttpResponseBase): Observable<NotificationsDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationsDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = NotificationUpdateError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send universal notifications to multiple users
     * @param body Send notifications to specified users
     * @return OK - Notifications sent successfully
     */
    notificationSend(body: SendNotificationRequest): Observable<any> {
        let url_ = this.baseUrl + "/notification/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationSend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationSend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processNotificationSend(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = SendNotificationError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Offers
     * @return OK
     */
    offerIndex(): Observable<OffersDataResponse> {
        let url_ = this.baseUrl + "/offer/index/{id}";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfferIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfferIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OffersDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OffersDataResponse>;
        }));
    }

    protected processOfferIndex(response: HttpResponseBase): Observable<OffersDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OffersDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new Offer
     * @param body Add Offer
     * @return OK
     */
    offerPost(body: OfferRequest): Observable<OfferDataResponse> {
        let url_ = this.baseUrl + "/offer/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfferPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfferPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfferDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfferDataResponse>;
        }));
    }

    protected processOfferPost(response: HttpResponseBase): Observable<OfferDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = OfferDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = OfferError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified Offer
     * @param id Offer ID
     * @return OK
     */
    offerGet(id: number): Observable<OfferDataResponse> {
        let url_ = this.baseUrl + "/offer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfferGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfferGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfferDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfferDataResponse>;
        }));
    }

    protected processOfferGet(response: HttpResponseBase): Observable<OfferDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfferDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing Offer
     * @param id Offer ID
     * @param body Update Offer.
     * @return OK
     */
    offerPut(id: number, body: OfferUpdateRequest): Observable<OfferDataResponse> {
        let url_ = this.baseUrl + "/offer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfferPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfferPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfferDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfferDataResponse>;
        }));
    }

    protected processOfferPut(response: HttpResponseBase): Observable<OfferDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfferDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = OfferError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a Offer
     * @param id Offer ID
     * @return No Content
     */
    offerDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/offer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfferDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfferDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOfferDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Accept offer
     * @param id Offer ID
     * @return OK
     */
    offerAccept(id: number): Observable<OfferDataResponse> {
        let url_ = this.baseUrl + "/offer/accept/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfferAccept(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfferAccept(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfferDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfferDataResponse>;
        }));
    }

    protected processOfferAccept(response: HttpResponseBase): Observable<OfferDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfferDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reject offer
     * @param id Offer ID
     * @return OK
     */
    offerReject(id: number): Observable<OfferDataResponse> {
        let url_ = this.baseUrl + "/offer/reject/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfferReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfferReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfferDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfferDataResponse>;
        }));
    }

    protected processOfferReject(response: HttpResponseBase): Observable<OfferDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfferDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Payment intent
     * @param id id reply, extra work or avatar order
     * @param type type: reply, extra work or avatar order. 1 for reply, 2 for extra work, 3 for avatar order, 4 for reply tips, 5 for avatar order tips
     * @param amount (optional) amount for tips
     * @param setupFutureUsage (optional) setup future usage
     * @param paymentMethod (optional) payment method
     * @return OK
     */
    paymentIntent(id: number, type: number, amount: any | undefined, setupFutureUsage: boolean | undefined, paymentMethod: string | undefined): Observable<PaymentIntent> {
        let url_ = this.baseUrl + "/payment/intent?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (amount === null)
            throw new Error("The parameter 'amount' cannot be null.");
        else if (amount !== undefined)
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        if (setupFutureUsage === null)
            throw new Error("The parameter 'setupFutureUsage' cannot be null.");
        else if (setupFutureUsage !== undefined)
            url_ += "setupFutureUsage=" + encodeURIComponent("" + setupFutureUsage) + "&";
        if (paymentMethod === null)
            throw new Error("The parameter 'paymentMethod' cannot be null.");
        else if (paymentMethod !== undefined)
            url_ += "paymentMethod=" + encodeURIComponent("" + paymentMethod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentIntent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentIntent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentIntent>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentIntent>;
        }));
    }

    protected processPaymentIntent(response: HttpResponseBase): Observable<PaymentIntent> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentIntent.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Onboarding stripe
     * @param countyCode (optional) Country code is AL,AT,BE,BG,HR,CY,CZ,DK,EE,FI,FR,DE,GI,GR,HU,IE,IT,LV,LI,LT,LU,NL,NO,PL,PT,RO,SK,SI,ES,SE,CH,GB. Default 'DE'
     * @param gateway (optional) 
     * @return OK
     */
    paymentOnboardingGet(countyCode: string | undefined, gateway: string | undefined): Observable<StripeConnect> {
        let url_ = this.baseUrl + "/payment/onboarding?";
        if (countyCode === null)
            throw new Error("The parameter 'countyCode' cannot be null.");
        else if (countyCode !== undefined)
            url_ += "countyCode=" + encodeURIComponent("" + countyCode) + "&";
        if (gateway === null)
            throw new Error("The parameter 'gateway' cannot be null.");
        else if (gateway !== undefined)
            url_ += "gateway=" + encodeURIComponent("" + gateway) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentOnboardingGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentOnboardingGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StripeConnect>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StripeConnect>;
        }));
    }

    protected processPaymentOnboardingGet(response: HttpResponseBase): Observable<StripeConnect> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StripeConnect.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a Payment
     * @return No Content
     */
    paymentOnboardingDelete(): Observable<void> {
        let url_ = this.baseUrl + "/payment/onboarding";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentOnboardingDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentOnboardingDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPaymentOnboardingDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Balance
     * @return OK
     */
    paymentBalance(): Observable<string> {
        let url_ = this.baseUrl + "/payment/balance";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentBalance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processPaymentBalance(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get accLink
     * @return OK
     */
    paymentAccLink(): Observable<Anonymous4> {
        let url_ = this.baseUrl + "/payment/accLink";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentAccLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentAccLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous4>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous4>;
        }));
    }

    protected processPaymentAccLink(response: HttpResponseBase): Observable<Anonymous4> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous4.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get OnboardingCountyCodes
     * @return OK
     */
    paymentGetOnboardingCountyCodes(): Observable<OnboardingCountyCodes[]> {
        let url_ = this.baseUrl + "/payment/getOnboardingCountyCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentGetOnboardingCountyCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentGetOnboardingCountyCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingCountyCodes[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingCountyCodes[]>;
        }));
    }

    protected processPaymentGetOnboardingCountyCodes(response: HttpResponseBase): Observable<OnboardingCountyCodes[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnboardingCountyCodes.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Payment Methods
     * @return OK
     */
    paymentPaymentMethods(): Observable<PaymentMethodDataResponse> {
        let url_ = this.baseUrl + "/payment/paymentMethods";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentPaymentMethods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentPaymentMethods(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentMethodDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentMethodDataResponse>;
        }));
    }

    protected processPaymentPaymentMethods(response: HttpResponseBase): Observable<PaymentMethodDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentMethodDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get fee
     * @return OK
     */
    paymentFee(): Observable<Fee> {
        let url_ = this.baseUrl + "/payment/fee";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentFee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentFee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Fee>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Fee>;
        }));
    }

    protected processPaymentFee(response: HttpResponseBase): Observable<Fee> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Fee.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * paypalAuthorizeOrder
     * @param orderId orderId
     * @return OK
     */
    paypalAuthorizeOrder(orderId: number): Observable<any> {
        let url_ = this.baseUrl + "/paypal/authorizeOrder?";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined and cannot be null.");
        else
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaypalAuthorizeOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaypalAuthorizeOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processPaypalAuthorizeOrder(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * paypalCaptureOrder
     * @param orderId orderId
     * @return OK
     */
    paypalCaptureOrder(orderId: number): Observable<any> {
        let url_ = this.baseUrl + "/paypal/captureOrder?";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined and cannot be null.");
        else
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaypalCaptureOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaypalCaptureOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processPaypalCaptureOrder(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of profileFiles
     * @param type_id (optional) Type of Files. Use 'all' or '1', '3', '4', '5', '99'.  Default all.
     * @param user_id (optional) User id.  Default auth User.
     * @param sort (optional) Sorting column. Use 'id','name','type_id','size','created_at'. 'id' by default.
     * @param order (optional) Sorting order. Use 'asc' or 'desc'. 'asc' by default.
     * @param countOnPage (optional) Rows count on the page. 10 rows by default.
     * @param page (optional) Page number. 1 by default.
     * @return OK
     */
    profileFileIndex(type_id: string | undefined, user_id: number | undefined, sort: string | undefined, order: string | undefined, countOnPage: number | undefined, page: number | undefined): Observable<FilesDataResponse> {
        let url_ = this.baseUrl + "/profileFile/index?";
        if (type_id === null)
            throw new Error("The parameter 'type_id' cannot be null.");
        else if (type_id !== undefined)
            url_ += "type_id=" + encodeURIComponent("" + type_id) + "&";
        if (user_id === null)
            throw new Error("The parameter 'user_id' cannot be null.");
        else if (user_id !== undefined)
            url_ += "user_id=" + encodeURIComponent("" + user_id) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (countOnPage === null)
            throw new Error("The parameter 'countOnPage' cannot be null.");
        else if (countOnPage !== undefined)
            url_ += "countOnPage=" + encodeURIComponent("" + countOnPage) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfileFileIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfileFileIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilesDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilesDataResponse>;
        }));
    }

    protected processProfileFileIndex(response: HttpResponseBase): Observable<FilesDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilesDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProfileFileError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add file to s3
     * @param files (optional) 
     * @return OK
     */
    profileFilePost(files: ProfileFileFormdataRequest[] | undefined): Observable<FilesDataResponse> {
        let url_ = this.baseUrl + "/profileFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files[]", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfileFilePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfileFilePost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilesDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilesDataResponse>;
        }));
    }

    protected processProfileFilePost(response: HttpResponseBase): Observable<FilesDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = FilesDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProfileFileError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add file to s3
     * @return OK
     */
    profileFileStoreAsBase64(body: ProfileFileRequestBody): Observable<FilesDataResponse> {
        let url_ = this.baseUrl + "/profileFile/storeAsBase64";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfileFileStoreAsBase64(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfileFileStoreAsBase64(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilesDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilesDataResponse>;
        }));
    }

    protected processProfileFileStoreAsBase64(response: HttpResponseBase): Observable<FilesDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = FilesDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProfileFileError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified profileFile
     * @param id File ID
     * @return OK
     */
    profileFileGet(id: number): Observable<FileDataResponse> {
        let url_ = this.baseUrl + "/profileFile/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfileFileGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfileFileGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDataResponse>;
        }));
    }

    protected processProfileFileGet(response: HttpResponseBase): Observable<FileDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing profileFile
     * @param id File ID
     * @param body (optional) Update profileFile
     * @return OK
     */
    profileFilePut(id: number, body: ProfileFileUpdateRequest | undefined): Observable<FileDataResponse> {
        let url_ = this.baseUrl + "/profileFile/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfileFilePut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfileFilePut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDataResponse>;
        }));
    }

    protected processProfileFilePut(response: HttpResponseBase): Observable<FileDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProfileFileUpdateError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Destroy file by Id
     * @param id File ID
     * @return OK
     */
    profileFileDelete(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/profileFile/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfileFileDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfileFileDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processProfileFileDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified profileFile
     * @param fileName fileName
     * @param fileType fileType
     * @param description (optional) description
     * @param title (optional) title
     * @param client_guid (optional) Client upload GUID for tracking
     * @return OK
     */
    profileFileAddFileBySignUrl(fileName: string, fileType: string, description: string | undefined, title: string | undefined, client_guid: string | undefined): Observable<ProfileFileS3FormFieldsResponse> {
        let url_ = this.baseUrl + "/profileFile/addFileBySignUrl?";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (fileType === undefined || fileType === null)
            throw new Error("The parameter 'fileType' must be defined and cannot be null.");
        else
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (description === null)
            throw new Error("The parameter 'description' cannot be null.");
        else if (description !== undefined)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (title === null)
            throw new Error("The parameter 'title' cannot be null.");
        else if (title !== undefined)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (client_guid === null)
            throw new Error("The parameter 'client_guid' cannot be null.");
        else if (client_guid !== undefined)
            url_ += "client_guid=" + encodeURIComponent("" + client_guid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfileFileAddFileBySignUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfileFileAddFileBySignUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileFileS3FormFieldsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileFileS3FormFieldsResponse>;
        }));
    }

    protected processProfileFileAddFileBySignUrl(response: HttpResponseBase): Observable<ProfileFileS3FormFieldsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileFileS3FormFieldsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Question
     * @param id Question ID
     * @param locale (optional) locale
     * @return OK
     */
    questionIndex(id: number, locale: string | null | undefined): Observable<QuestionsDataResponse> {
        let url_ = this.baseUrl + "/question/index/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (locale !== undefined && locale !== null)
            url_ += "locale=" + encodeURIComponent("" + locale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionsDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionsDataResponse>;
        }));
    }

    protected processQuestionIndex(response: HttpResponseBase): Observable<QuestionsDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionsDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Question
     * @param id (optional) Category ID
     * @return OK
     */
    questionCategoriesQuestions(id: number | undefined): Observable<CategoryQuestionsDataResponse> {
        let url_ = this.baseUrl + "/question/categoriesQuestions";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionCategoriesQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionCategoriesQuestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryQuestionsDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryQuestionsDataResponse>;
        }));
    }

    protected processQuestionCategoriesQuestions(response: HttpResponseBase): Observable<CategoryQuestionsDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryQuestionsDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new Question
     * @param category_id (optional) 
     * @param next_question_id (optional) 
     * @param is_skip_next_question_id (optional) 
     * @param text_question (optional) 
     * @param type_question (optional) 
     * @param is_start (optional) 
     * @param is_skip (optional) 
     * @param allow_my_answer (optional) 
     * @param type_my_answer (optional) 
     * @param can_add_files (optional) 
     * @param example_answers (optional) 
     * @param type_values (optional) 
     * @param answers (optional) 
     * @param files (optional) 
     * @return OK
     */
    questionPost(category_id: number | undefined, next_question_id: number | undefined, is_skip_next_question_id: number | undefined, text_question: string | undefined, type_question: string | undefined, is_start: boolean | undefined, is_skip: boolean | undefined, allow_my_answer: boolean | undefined, type_my_answer: number | undefined, can_add_files: boolean | undefined, example_answers: any[] | undefined, type_values: any[] | undefined, answers: AnswersRequest[] | undefined, files: FileParameter[] | undefined): Observable<QuestionDataResponse> {
        let url_ = this.baseUrl + "/question/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (category_id === null || category_id === undefined)
            throw new Error("The parameter 'category_id' cannot be null.");
        else
            content_.append("category_id", category_id.toString());
        if (next_question_id === null || next_question_id === undefined)
            throw new Error("The parameter 'next_question_id' cannot be null.");
        else
            content_.append("next_question_id", next_question_id.toString());
        if (is_skip_next_question_id === null || is_skip_next_question_id === undefined)
            throw new Error("The parameter 'is_skip_next_question_id' cannot be null.");
        else
            content_.append("is_skip_next_question_id", is_skip_next_question_id.toString());
        if (text_question === null || text_question === undefined)
            throw new Error("The parameter 'text_question' cannot be null.");
        else
            content_.append("text_question", text_question.toString());
        if (type_question === null || type_question === undefined)
            throw new Error("The parameter 'type_question' cannot be null.");
        else
            content_.append("type_question", type_question.toString());
        if (is_start === null || is_start === undefined)
            throw new Error("The parameter 'is_start' cannot be null.");
        else
            content_.append("is_start", is_start.toString());
        if (is_skip === null || is_skip === undefined)
            throw new Error("The parameter 'is_skip' cannot be null.");
        else
            content_.append("is_skip", is_skip.toString());
        if (allow_my_answer === null || allow_my_answer === undefined)
            throw new Error("The parameter 'allow_my_answer' cannot be null.");
        else
            content_.append("allow_my_answer", allow_my_answer.toString());
        if (type_my_answer === null || type_my_answer === undefined)
            throw new Error("The parameter 'type_my_answer' cannot be null.");
        else
            content_.append("type_my_answer", type_my_answer.toString());
        if (can_add_files === null || can_add_files === undefined)
            throw new Error("The parameter 'can_add_files' cannot be null.");
        else
            content_.append("can_add_files", can_add_files.toString());
        if (example_answers === null || example_answers === undefined)
            throw new Error("The parameter 'example_answers' cannot be null.");
        else
            example_answers.forEach(item_ => content_.append("example_answers[]", item_.toString()));
        if (type_values === null || type_values === undefined)
            throw new Error("The parameter 'type_values' cannot be null.");
        else
            type_values.forEach(item_ => content_.append("type_values[]", item_.toString()));
        if (answers === null || answers === undefined)
            throw new Error("The parameter 'answers' cannot be null.");
        else
            answers.forEach(item_ => content_.append("answers[]", item_.toString()));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files[]", item_.data, item_.fileName ? item_.fileName : "files[]") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionDataResponse>;
        }));
    }

    protected processQuestionPost(response: HttpResponseBase): Observable<QuestionDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = QuestionDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = QuestionError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new Question
     * @param body (optional) Add question
     * @return OK
     */
    questionStoreAsJson(body: QuestionRequest | undefined): Observable<QuestionDataResponse> {
        let url_ = this.baseUrl + "/question/storeAsJson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionStoreAsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionStoreAsJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionDataResponse>;
        }));
    }

    protected processQuestionStoreAsJson(response: HttpResponseBase): Observable<QuestionDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = QuestionDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = QuestionError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified question
     * @param id Question ID
     * @param locale (optional) locale
     * @return OK
     */
    questionGet(id: number, locale: string | null | undefined): Observable<QuestionDataResponse> {
        let url_ = this.baseUrl + "/question/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (locale !== undefined && locale !== null)
            url_ += "locale=" + encodeURIComponent("" + locale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionDataResponse>;
        }));
    }

    protected processQuestionGet(response: HttpResponseBase): Observable<QuestionDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing question
     * @param id Question ID
     * @param category_id (optional) 
     * @param next_question_id (optional) 
     * @param is_skip_next_question_id (optional) 
     * @param text_question (optional) 
     * @param type_question (optional) 
     * @param is_start (optional) 
     * @param is_skip (optional) 
     * @param allow_my_answer (optional) 
     * @param type_my_answer (optional) 
     * @param can_add_files (optional) 
     * @param example_answers (optional) 
     * @param type_values (optional) 
     * @param answers (optional) 
     * @param files (optional) 
     * @param deleted (optional) 
     * @param deletedFiles (optional) 
     * @return OK
     */
    questionUpdate(id: number, category_id: number | undefined, next_question_id: number | undefined, is_skip_next_question_id: number | undefined, text_question: string | undefined, type_question: string | undefined, is_start: boolean | undefined, is_skip: boolean | undefined, allow_my_answer: boolean | undefined, type_my_answer: number | undefined, can_add_files: boolean | undefined, example_answers: any[] | undefined, type_values: any[] | undefined, answers: AnswersRequest[] | undefined, files: FileParameter[] | undefined, deleted: any[] | undefined, deletedFiles: any[] | undefined): Observable<QuestionDataResponse> {
        let url_ = this.baseUrl + "/question/update/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (category_id === null || category_id === undefined)
            throw new Error("The parameter 'category_id' cannot be null.");
        else
            content_.append("category_id", category_id.toString());
        if (next_question_id === null || next_question_id === undefined)
            throw new Error("The parameter 'next_question_id' cannot be null.");
        else
            content_.append("next_question_id", next_question_id.toString());
        if (is_skip_next_question_id === null || is_skip_next_question_id === undefined)
            throw new Error("The parameter 'is_skip_next_question_id' cannot be null.");
        else
            content_.append("is_skip_next_question_id", is_skip_next_question_id.toString());
        if (text_question === null || text_question === undefined)
            throw new Error("The parameter 'text_question' cannot be null.");
        else
            content_.append("text_question", text_question.toString());
        if (type_question === null || type_question === undefined)
            throw new Error("The parameter 'type_question' cannot be null.");
        else
            content_.append("type_question", type_question.toString());
        if (is_start === null || is_start === undefined)
            throw new Error("The parameter 'is_start' cannot be null.");
        else
            content_.append("is_start", is_start.toString());
        if (is_skip === null || is_skip === undefined)
            throw new Error("The parameter 'is_skip' cannot be null.");
        else
            content_.append("is_skip", is_skip.toString());
        if (allow_my_answer === null || allow_my_answer === undefined)
            throw new Error("The parameter 'allow_my_answer' cannot be null.");
        else
            content_.append("allow_my_answer", allow_my_answer.toString());
        if (type_my_answer === null || type_my_answer === undefined)
            throw new Error("The parameter 'type_my_answer' cannot be null.");
        else
            content_.append("type_my_answer", type_my_answer.toString());
        if (can_add_files === null || can_add_files === undefined)
            throw new Error("The parameter 'can_add_files' cannot be null.");
        else
            content_.append("can_add_files", can_add_files.toString());
        if (example_answers === null || example_answers === undefined)
            throw new Error("The parameter 'example_answers' cannot be null.");
        else
            example_answers.forEach(item_ => content_.append("example_answers[]", item_.toString()));
        if (type_values === null || type_values === undefined)
            throw new Error("The parameter 'type_values' cannot be null.");
        else
            type_values.forEach(item_ => content_.append("type_values[]", item_.toString()));
        if (answers === null || answers === undefined)
            throw new Error("The parameter 'answers' cannot be null.");
        else
            answers.forEach(item_ => content_.append("answers[]", item_.toString()));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files[]", item_.data, item_.fileName ? item_.fileName : "files[]") );
        if (deleted === null || deleted === undefined)
            throw new Error("The parameter 'deleted' cannot be null.");
        else
            deleted.forEach(item_ => content_.append("deleted[]", item_.toString()));
        if (deletedFiles === null || deletedFiles === undefined)
            throw new Error("The parameter 'deletedFiles' cannot be null.");
        else
            deletedFiles.forEach(item_ => content_.append("deletedFiles[]", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionDataResponse>;
        }));
    }

    protected processQuestionUpdate(response: HttpResponseBase): Observable<QuestionDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = QuestionError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing question
     * @param id Question ID
     * @param body (optional) Update question
     * @return OK
     */
    questionUpdateAsJson(id: number, body: QuestionUpdateRequest | undefined): Observable<QuestionDataResponse> {
        let url_ = this.baseUrl + "/question/updateAsJson/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionUpdateAsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionUpdateAsJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionDataResponse>;
        }));
    }

    protected processQuestionUpdateAsJson(response: HttpResponseBase): Observable<QuestionDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = QuestionError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a question
     * @param id Question ID
     * @return No Content
     */
    questionDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/question/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQuestionDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified question
     * @param id Question ID
     * @return OK
     */
    questionLinkedQuestions(id: number): Observable<QuestionDataResponse> {
        let url_ = this.baseUrl + "/question/linkedQuestions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionLinkedQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionLinkedQuestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionDataResponse>;
        }));
    }

    protected processQuestionLinkedQuestions(response: HttpResponseBase): Observable<QuestionDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified question
     * @return OK
     */
    questionGetBrifsCsv(): Observable<any> {
        let url_ = this.baseUrl + "/question/getBrifsCsv";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionGetBrifsCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionGetBrifsCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processQuestionGetBrifsCsv(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new Question
     * @param id Category ID
     * @param file (optional) 
     * @return OK
     */
    questionAddBrifs(id: number, file: FileParameter | undefined): Observable<any> {
        let url_ = this.baseUrl + "/question/addBrifs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionAddBrifs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionAddBrifs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processQuestionAddBrifs(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = QuestionError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified Question
     * @param locale (optional) Locale
     * @return OK
     */
    questionGetJson(locale: string | undefined): Observable<any> {
        let url_ = this.baseUrl + "/question/getJson";
        if (locale !== null && locale !== undefined)
        url_ = url_.replace("{locale}", encodeURIComponent("" + locale));
        else
            url_ = url_.replace("/{locale}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionGetJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionGetJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processQuestionGetJson(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * updateQuestionJson
     * @param locale (optional) 
     * @param file (optional) 
     * @return OK
     */
    questionUpdateJson(locale: Locale | undefined, file: FileParameter | undefined): Observable<any> {
        let url_ = this.baseUrl + "/question/updateJson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (locale === null || locale === undefined)
            throw new Error("The parameter 'locale' cannot be null.");
        else
            content_.append("locale", locale.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionUpdateJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionUpdateJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processQuestionUpdateJson(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Question
     * @param body Questions ids
     * @return OK
     */
    questionGetQuestionsByIds(body: QuestionsByIdsRequest): Observable<QuestionsDataResponse> {
        let url_ = this.baseUrl + "/question/getQuestionsByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionGetQuestionsByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionGetQuestionsByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionsDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionsDataResponse>;
        }));
    }

    protected processQuestionGetQuestionsByIds(response: HttpResponseBase): Observable<QuestionsDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionsDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Question
     * @return OK
     */
    questionGetLangs(): Observable<QuestionsDataResponse> {
        let url_ = this.baseUrl + "/question/getLangs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionGetLangs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionGetLangs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionsDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionsDataResponse>;
        }));
    }

    protected processQuestionGetLangs(response: HttpResponseBase): Observable<QuestionsDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionsDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Rating
     * @param id User ID
     * @return OK
     */
    ratingIndex(id: number): Observable<RatingsDataResponse> {
        let url_ = this.baseUrl + "/rating/index/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRatingIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRatingIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RatingsDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RatingsDataResponse>;
        }));
    }

    protected processRatingIndex(response: HttpResponseBase): Observable<RatingsDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RatingsDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new Rating
     * @param body Add Rating
     * @return OK
     */
    ratingPost(body: RatingRequest): Observable<RatingDataResponse> {
        let url_ = this.baseUrl + "/rating/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRatingPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRatingPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RatingDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RatingDataResponse>;
        }));
    }

    protected processRatingPost(response: HttpResponseBase): Observable<RatingDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = RatingDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = RatingError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified Rating
     * @param id Rating ID
     * @return OK
     */
    ratingGet(id: number): Observable<RatingDataResponse> {
        let url_ = this.baseUrl + "/rating/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRatingGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRatingGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RatingDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RatingDataResponse>;
        }));
    }

    protected processRatingGet(response: HttpResponseBase): Observable<RatingDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RatingDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing Rating
     * @param id Rating ID
     * @param body Update Rating.
     * @return OK
     */
    ratingPut(id: number, body: RatingUpdateRequest): Observable<RatingDataResponse> {
        let url_ = this.baseUrl + "/rating/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRatingPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRatingPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RatingDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RatingDataResponse>;
        }));
    }

    protected processRatingPut(response: HttpResponseBase): Observable<RatingDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RatingDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = RatingError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a Rating
     * @param id Rating ID
     * @return No Content
     */
    ratingDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/rating/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRatingDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRatingDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRatingDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Replies
     * @param id Task ID
     * @return OK
     */
    replyIndex(id: number): Observable<RepliesDataResponse> {
        let url_ = this.baseUrl + "/reply/index/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplyIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplyIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RepliesDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RepliesDataResponse>;
        }));
    }

    protected processReplyIndex(response: HttpResponseBase): Observable<RepliesDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RepliesDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of disputedTasks
     * @param sort (optional) Sorting column.
     * @param order (optional) Sorting order. Use 'asc' or 'desc'. 'asc' by default.
     * @param countOnPage (optional) Rows count on the page. 10 rows by default.
     * @param page (optional) Page number. 1 by default.
     * @return OK
     */
    replyDisputedTasks(sort: string | undefined, order: string | undefined, countOnPage: number | undefined, page: number | undefined): Observable<ReplyTaskShortDataResponse> {
        let url_ = this.baseUrl + "/reply/disputedTasks?";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (countOnPage === null)
            throw new Error("The parameter 'countOnPage' cannot be null.");
        else if (countOnPage !== undefined)
            url_ += "countOnPage=" + encodeURIComponent("" + countOnPage) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplyDisputedTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplyDisputedTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReplyTaskShortDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReplyTaskShortDataResponse>;
        }));
    }

    protected processReplyDisputedTasks(response: HttpResponseBase): Observable<ReplyTaskShortDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReplyTaskShortDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new Reply
     * @param body Add reply
     * @return OK
     */
    replyPost(body: ReplyRequest): Observable<ReplyDataResponse> {
        let url_ = this.baseUrl + "/reply/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplyPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplyPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReplyDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReplyDataResponse>;
        }));
    }

    protected processReplyPost(response: HttpResponseBase): Observable<ReplyDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ReplyDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ReplyError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified reply
     * @param id Reply ID
     * @param withTask (optional) With Task.
     * @return OK
     */
    replyGet(id: number, withTask: boolean | undefined): Observable<ReplyOrReplyTaskDataResponse> {
        let url_ = this.baseUrl + "/reply/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (withTask === null)
            throw new Error("The parameter 'withTask' cannot be null.");
        else if (withTask !== undefined)
            url_ += "withTask=" + encodeURIComponent("" + withTask) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplyGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplyGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReplyOrReplyTaskDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReplyOrReplyTaskDataResponse>;
        }));
    }

    protected processReplyGet(response: HttpResponseBase): Observable<ReplyOrReplyTaskDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReplyOrReplyTaskDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing reply
     * @param id Reply ID
     * @param body Update reply.
     * @return OK
     */
    replyPut(id: number, body: ReplyUpdateRequest): Observable<ReplyDataResponse> {
        let url_ = this.baseUrl + "/reply/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplyPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplyPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReplyDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReplyDataResponse>;
        }));
    }

    protected processReplyPut(response: HttpResponseBase): Observable<ReplyDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReplyDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ReplyError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a Reply
     * @param id Reply ID
     * @return No Content
     */
    replyDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/reply/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplyDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplyDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReplyDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Approve reply
     * @param id Reply ID
     * @return OK
     */
    replyApprove(id: number): Observable<ReplyDataResponse> {
        let url_ = this.baseUrl + "/reply/approve/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplyApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplyApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReplyDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReplyDataResponse>;
        }));
    }

    protected processReplyApprove(response: HttpResponseBase): Observable<ReplyDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReplyDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reject reply
     * @param id Reply ID
     * @return OK
     */
    replyReject(id: number): Observable<ReplyDataResponse> {
        let url_ = this.baseUrl + "/reply/reject/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplyReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplyReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReplyDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReplyDataResponse>;
        }));
    }

    protected processReplyReject(response: HttpResponseBase): Observable<ReplyDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReplyDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ReplyError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Accept reply
     * @param id Reply ID
     * @return OK
     */
    replyAccept(id: number): Observable<ReplyDataResponse> {
        let url_ = this.baseUrl + "/reply/accept/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplyAccept(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplyAccept(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReplyDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReplyDataResponse>;
        }));
    }

    protected processReplyAccept(response: HttpResponseBase): Observable<ReplyDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReplyDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ReplyError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * closeToOwner reply
     * @param id Reply ID
     * @return OK
     */
    replyCloseToOwner(id: number): Observable<ReplyDataResponse> {
        let url_ = this.baseUrl + "/reply/closeToOwner/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplyCloseToOwner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplyCloseToOwner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReplyDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReplyDataResponse>;
        }));
    }

    protected processReplyCloseToOwner(response: HttpResponseBase): Observable<ReplyDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReplyDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Dispute reply
     * @param id Reply ID
     * @param body Dispute description reply.
     * @return OK
     */
    replyDispute(id: number, body: DisputeDescriptionRequest): Observable<ReplyDataResponse> {
        let url_ = this.baseUrl + "/reply/dispute/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplyDispute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplyDispute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReplyDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReplyDataResponse>;
        }));
    }

    protected processReplyDispute(response: HttpResponseBase): Observable<ReplyDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReplyDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Dispute reply
     * @param id Reply ID
     * @return OK
     */
    replyCancelDispute(id: number): Observable<ReplyDataResponse> {
        let url_ = this.baseUrl + "/reply/cancelDispute/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplyCancelDispute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplyCancelDispute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReplyDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReplyDataResponse>;
        }));
    }

    protected processReplyCancelDispute(response: HttpResponseBase): Observable<ReplyDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReplyDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing reply
     * @param id Reply ID
     * @return OK
     */
    replyResolve(id: number): Observable<ReplyDataResponse> {
        let url_ = this.baseUrl + "/reply/resolve/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplyResolve(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplyResolve(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReplyDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReplyDataResponse>;
        }));
    }

    protected processReplyResolve(response: HttpResponseBase): Observable<ReplyDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReplyDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ReplyError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing reply
     * @param id Reply ID
     * @param contractorPercent Percent of reply price to be sent to the contractor
     * @return OK
     */
    replySolveDispute(id: number, contractorPercent: number): Observable<ReplyDataResponse> {
        let url_ = this.baseUrl + "/reply/solveDispute/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (contractorPercent === undefined || contractorPercent === null)
            throw new Error("The parameter 'contractorPercent' must be defined and cannot be null.");
        else
            url_ += "contractorPercent=" + encodeURIComponent("" + contractorPercent) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplySolveDispute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplySolveDispute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReplyDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReplyDataResponse>;
        }));
    }

    protected processReplySolveDispute(response: HttpResponseBase): Observable<ReplyDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReplyDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ReplyError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Dispute reply
     * @param id Reply ID
     * @return OK
     */
    replyCancelResolve(id: number): Observable<ReplyDataResponse> {
        let url_ = this.baseUrl + "/reply/cancelResolve/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplyCancelResolve(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplyCancelResolve(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReplyDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReplyDataResponse>;
        }));
    }

    protected processReplyCancelResolve(response: HttpResponseBase): Observable<ReplyDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReplyDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new offer Reply
     * @param body Add offer reply
     * @return OK
     */
    replyOffer(body: ReplyOfferRequest): Observable<ReplyDataResponse> {
        let url_ = this.baseUrl + "/reply/offer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplyOffer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplyOffer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReplyDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReplyDataResponse>;
        }));
    }

    protected processReplyOffer(response: HttpResponseBase): Observable<ReplyDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ReplyDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ReplyError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Accept offer
     * @param id Reply ID
     * @param body Add offer reply
     * @return OK
     */
    replyAcceptOffer(id: number, body: ReplyAcceptOfferRequest): Observable<ReplyDataResponse> {
        let url_ = this.baseUrl + "/reply/acceptOffer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplyAcceptOffer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplyAcceptOffer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReplyDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReplyDataResponse>;
        }));
    }

    protected processReplyAcceptOffer(response: HttpResponseBase): Observable<ReplyDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReplyDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reject offer
     * @param id Reply ID
     * @return OK
     */
    replyRejectOffer(id: number): Observable<ReplyDataResponse> {
        let url_ = this.baseUrl + "/reply/rejectOffer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplyRejectOffer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplyRejectOffer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReplyDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReplyDataResponse>;
        }));
    }

    protected processReplyRejectOffer(response: HttpResponseBase): Observable<ReplyDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReplyDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Report
     * @param sort (optional) Sorting column.
     * @param order (optional) Sorting order. Use 'asc' or 'desc'. 'asc' by default.
     * @param countOnPage (optional) Rows count on the page. 10 rows by default.
     * @param page (optional) Page number. 1 by default.
     * @return OK
     */
    reportIndex(sort: string | undefined, order: string | undefined, countOnPage: number | undefined, page: number | undefined): Observable<ReportsDataResponse> {
        let url_ = this.baseUrl + "/report/index?";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (countOnPage === null)
            throw new Error("The parameter 'countOnPage' cannot be null.");
        else if (countOnPage !== undefined)
            url_ += "countOnPage=" + encodeURIComponent("" + countOnPage) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportsDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportsDataResponse>;
        }));
    }

    protected processReportIndex(response: HttpResponseBase): Observable<ReportsDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportsDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new Report
     * @param body (optional) Add Report
     * @return OK
     */
    reportPost(body: ReportRequest | undefined): Observable<ReportDataResponse> {
        let url_ = this.baseUrl + "/report/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportDataResponse>;
        }));
    }

    protected processReportPost(response: HttpResponseBase): Observable<ReportDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ReportDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ReportError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified Report
     * @param id Report ID
     * @return OK
     */
    reportGet(id: number): Observable<ReportDataResponse> {
        let url_ = this.baseUrl + "/report/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportDataResponse>;
        }));
    }

    protected processReportGet(response: HttpResponseBase): Observable<ReportDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing Report
     * @param id Report ID
     * @param body Update report.
     * @return OK
     */
    reportPut(id: number, body: ReportUpdateRequest): Observable<ReportDataResponse> {
        let url_ = this.baseUrl + "/report/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportDataResponse>;
        }));
    }

    protected processReportPut(response: HttpResponseBase): Observable<ReportDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ReportUpdateError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a Report
     * @param id Report ID
     * @return No Content
     */
    reportDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/report/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReportDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a Report Types
     * @return OK
     */
    reportGetTypes(): Observable<any> {
        let url_ = this.baseUrl + "/report/getTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportGetTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportGetTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processReportGetTypes(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a Report Reasons
     * @return OK
     */
    reportGetReasons(): Observable<any> {
        let url_ = this.baseUrl + "/report/getReasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportGetReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportGetReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processReportGetReasons(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reset the user password
     * @param body Reset password data
     * @return OK
     */
    authReset(body: Body12): Observable<AuthToken> {
        let url_ = this.baseUrl + "/auth/reset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthReset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthToken>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthToken>;
        }));
    }

    protected processAuthReset(response: HttpResponseBase): Observable<AuthToken> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthToken.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ResetError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result502: any = null;
            let resultData502 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result502 = Message.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search for schools using Google Places API
     * @param text Search text for school name (min 3, max 50 characters)
     * @param sessionToken Session token for Google Places API autocomplete session
     * @return OK
     */
    schools(text: string, sessionToken: string): Observable<Anonymous5> {
        let url_ = this.baseUrl + "/schools?";
        if (text === undefined || text === null)
            throw new Error("The parameter 'text' must be defined and cannot be null.");
        else
            url_ += "text=" + encodeURIComponent("" + text) + "&";
        if (sessionToken === undefined || sessionToken === null)
            throw new Error("The parameter 'sessionToken' must be defined and cannot be null.");
        else
            url_ += "sessionToken=" + encodeURIComponent("" + sessionToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchools(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchools(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous5>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous5>;
        }));
    }

    protected processSchools(response: HttpResponseBase): Observable<Anonymous5> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous5.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of Skills
     * @param id Category ID
     * @return OK
     */
    skillIndex(id: number): Observable<SkillsDataResponse> {
        let url_ = this.baseUrl + "/skill/index/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSkillIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSkillIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SkillsDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SkillsDataResponse>;
        }));
    }

    protected processSkillIndex(response: HttpResponseBase): Observable<SkillsDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SkillsDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get version
     * @return OK
     */
    systemGetVersion(): Observable<VersionResponse> {
        let url_ = this.baseUrl + "/system/getVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSystemGetVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSystemGetVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VersionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VersionResponse>;
        }));
    }

    protected processSystemGetVersion(response: HttpResponseBase): Observable<VersionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VersionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of tasks
     * @param body Filters tasks.
     * @return OK
     */
    taskIndex(body: IndexTasksFiltersRequest): Observable<TasksDataResponse> {
        let url_ = this.baseUrl + "/task/index";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaskIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TasksDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TasksDataResponse>;
        }));
    }

    protected processTaskIndex(response: HttpResponseBase): Observable<TasksDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TasksDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ErrorDto.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of tasks
     * @param body Filters tasks.
     * @return OK
     */
    taskGetCategoryTasks(body: TasksFiltersRequest): Observable<TasksDataResponse> {
        let url_ = this.baseUrl + "/task/getCategoryTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaskGetCategoryTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskGetCategoryTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TasksDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TasksDataResponse>;
        }));
    }

    protected processTaskGetCategoryTasks(response: HttpResponseBase): Observable<TasksDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TasksDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ErrorDto.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of tasks
     * @param status (optional) Sorting status_id column. 'all' by default.
     * @param sort (optional) Sorting column. 'id' by default.
     * @param order (optional) Sorting order. Use 'asc' or 'desc'. 'asc' by default.
     * @param countOnPage (optional) Rows count on the page. 10 rows by default.
     * @param page (optional) Page number. 1 by default.
     * @return OK
     */
    taskHistory(status: number | undefined, sort: number | undefined, order: string | undefined, countOnPage: number | undefined, page: number | undefined): Observable<TasksDataResponse> {
        let url_ = this.baseUrl + "/task/history?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (countOnPage === null)
            throw new Error("The parameter 'countOnPage' cannot be null.");
        else if (countOnPage !== undefined)
            url_ += "countOnPage=" + encodeURIComponent("" + countOnPage) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaskHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TasksDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TasksDataResponse>;
        }));
    }

    protected processTaskHistory(response: HttpResponseBase): Observable<TasksDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TasksDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ErrorDto.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new task
     * @param category_id (optional) 
     * @param name (optional) 
     * @param description (optional) 
     * @param price (optional) 
     * @param deadline (optional) 
     * @param deadline_at (optional) 
     * @param answers (optional) 
     * @param files (optional) 
     * @return OK
     */
    taskPost(category_id: number | undefined, name: string | undefined, description: string | undefined, price: number | undefined, deadline: boolean | undefined, deadline_at: string | undefined, answers: TaskAnswerRequest[] | undefined, files: TaskFileFormdataRequest[] | undefined): Observable<TaskDataResponse> {
        let url_ = this.baseUrl + "/task/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (category_id === null || category_id === undefined)
            throw new Error("The parameter 'category_id' cannot be null.");
        else
            content_.append("category_id", category_id.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("name", name.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("description", description.toString());
        if (price === null || price === undefined)
            throw new Error("The parameter 'price' cannot be null.");
        else
            content_.append("price", price.toString());
        if (deadline === null || deadline === undefined)
            throw new Error("The parameter 'deadline' cannot be null.");
        else
            content_.append("deadline", deadline.toString());
        if (deadline_at === null || deadline_at === undefined)
            throw new Error("The parameter 'deadline_at' cannot be null.");
        else
            content_.append("deadline_at", deadline_at.toString());
        if (answers === null || answers === undefined)
            throw new Error("The parameter 'answers' cannot be null.");
        else
            answers.forEach(item_ => content_.append("answers[]", item_.toString()));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files[]", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaskPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskDataResponse>;
        }));
    }

    protected processTaskPost(response: HttpResponseBase): Observable<TaskDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = TaskDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = TaskError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new task
     * @param body Create new task
     * @return OK
     */
    taskStoreAsJson(body: TaskRequest): Observable<TaskDataResponse> {
        let url_ = this.baseUrl + "/task/storeAsJson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaskStoreAsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskStoreAsJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskDataResponse>;
        }));
    }

    protected processTaskStoreAsJson(response: HttpResponseBase): Observable<TaskDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = TaskDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = TaskError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified task
     * @param id Task ID
     * @return OK
     */
    taskGet(id: number): Observable<TaskDataResponse> {
        let url_ = this.baseUrl + "/task/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaskGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskDataResponse>;
        }));
    }

    protected processTaskGet(response: HttpResponseBase): Observable<TaskDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a Task
     * @param id Task ID
     * @return No Content
     */
    taskDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/task/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaskDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTaskDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing task
     * @param id Task ID
     * @param status_id (optional) 
     * @param name (optional) 
     * @param description (optional) 
     * @param price (optional) 
     * @param deadline (optional) 
     * @param deadline_at (optional) 
     * @param answers (optional) 
     * @param files (optional) 
     * @param deletedFiles (optional) 
     * @param deletedAnswers (optional) 
     * @param updateTaskFilesQuestion (optional) 
     * @return OK
     */
    taskUpdate(id: number, status_id: number | undefined, name: string | undefined, description: string | undefined, price: number | undefined, deadline: boolean | undefined, deadline_at: string | undefined, answers: TaskAnswerUpdateRequest[] | undefined, files: TaskFileFormdataRequest[] | undefined, deletedFiles: any[] | undefined, deletedAnswers: any[] | undefined, updateTaskFilesQuestion: UpdateTaskFilesQuestionRequest[] | undefined): Observable<TaskDataResponse> {
        let url_ = this.baseUrl + "/task/update/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (status_id === null || status_id === undefined)
            throw new Error("The parameter 'status_id' cannot be null.");
        else
            content_.append("status_id", status_id.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("name", name.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("description", description.toString());
        if (price === null || price === undefined)
            throw new Error("The parameter 'price' cannot be null.");
        else
            content_.append("price", price.toString());
        if (deadline === null || deadline === undefined)
            throw new Error("The parameter 'deadline' cannot be null.");
        else
            content_.append("deadline", deadline.toString());
        if (deadline_at === null || deadline_at === undefined)
            throw new Error("The parameter 'deadline_at' cannot be null.");
        else
            content_.append("deadline_at", deadline_at.toString());
        if (answers === null || answers === undefined)
            throw new Error("The parameter 'answers' cannot be null.");
        else
            answers.forEach(item_ => content_.append("answers[]", item_.toString()));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files[]", item_.toString()));
        if (deletedFiles === null || deletedFiles === undefined)
            throw new Error("The parameter 'deletedFiles' cannot be null.");
        else
            deletedFiles.forEach(item_ => content_.append("deletedFiles[]", item_.toString()));
        if (deletedAnswers === null || deletedAnswers === undefined)
            throw new Error("The parameter 'deletedAnswers' cannot be null.");
        else
            deletedAnswers.forEach(item_ => content_.append("deletedAnswers[]", item_.toString()));
        if (updateTaskFilesQuestion === null || updateTaskFilesQuestion === undefined)
            throw new Error("The parameter 'updateTaskFilesQuestion' cannot be null.");
        else
            updateTaskFilesQuestion.forEach(item_ => content_.append("updateTaskFilesQuestion[]", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaskUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskDataResponse>;
        }));
    }

    protected processTaskUpdate(response: HttpResponseBase): Observable<TaskDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = TaskError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing task
     * @param id Task ID
     * @param body Update task.
     * @return OK
     */
    taskUpdateAsJson(id: number, body: TaskUpdateRequest): Observable<TaskDataResponse> {
        let url_ = this.baseUrl + "/task/updateAsJson/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaskUpdateAsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskUpdateAsJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskDataResponse>;
        }));
    }

    protected processTaskUpdateAsJson(response: HttpResponseBase): Observable<TaskDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = TaskError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified task
     * @param id Task ID
     * @param fileName fileName
     * @param fileType fileType
     * @param questionId (optional) questionId
     * @param client_guid (optional) Client upload GUID for tracking
     * @return OK
     */
    taskAddFileBySignUrl(id: number, fileName: string, fileType: string, questionId: number | undefined, client_guid: string | undefined): Observable<TaskFileS3FormFieldsResponse> {
        let url_ = this.baseUrl + "/task/addFileBySignUrl/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (fileType === undefined || fileType === null)
            throw new Error("The parameter 'fileType' must be defined and cannot be null.");
        else
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (questionId === null)
            throw new Error("The parameter 'questionId' cannot be null.");
        else if (questionId !== undefined)
            url_ += "questionId=" + encodeURIComponent("" + questionId) + "&";
        if (client_guid === null)
            throw new Error("The parameter 'client_guid' cannot be null.");
        else if (client_guid !== undefined)
            url_ += "client_guid=" + encodeURIComponent("" + client_guid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaskAddFileBySignUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskAddFileBySignUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskFileS3FormFieldsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskFileS3FormFieldsResponse>;
        }));
    }

    protected processTaskAddFileBySignUrl(response: HttpResponseBase): Observable<TaskFileS3FormFieldsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskFileS3FormFieldsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of TaskResults
     * @param id Task ID
     * @return OK
     */
    taskResultIndex(id: number): Observable<TaskResultsDataResponse> {
        let url_ = this.baseUrl + "/taskResult/index/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaskResultIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskResultIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskResultsDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskResultsDataResponse>;
        }));
    }

    protected processTaskResultIndex(response: HttpResponseBase): Observable<TaskResultsDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskResultsDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new TaskResults
     * @param task_id (optional) 
     * @param reply_id (optional) 
     * @param description (optional) 
     * @param files (optional) 
     * @return OK
     */
    taskResultPost(task_id: number | undefined, reply_id: number | undefined, description: string | undefined, files: FileParameter[] | undefined): Observable<TaskResultDataResponse> {
        let url_ = this.baseUrl + "/taskResult/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (task_id === null || task_id === undefined)
            throw new Error("The parameter 'task_id' cannot be null.");
        else
            content_.append("task_id", task_id.toString());
        if (reply_id === null || reply_id === undefined)
            throw new Error("The parameter 'reply_id' cannot be null.");
        else
            content_.append("reply_id", reply_id.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("description", description.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files[]", item_.data, item_.fileName ? item_.fileName : "files[]") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaskResultPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskResultPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskResultDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskResultDataResponse>;
        }));
    }

    protected processTaskResultPost(response: HttpResponseBase): Observable<TaskResultDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = TaskResultDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = TaskResultError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new TaskResults
     * @param body Add taskResults
     * @return OK
     */
    taskResultStoreAsJson(body: TaskResultRequest): Observable<TaskResultDataResponse> {
        let url_ = this.baseUrl + "/taskResult/storeAsJson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaskResultStoreAsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskResultStoreAsJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskResultDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskResultDataResponse>;
        }));
    }

    protected processTaskResultStoreAsJson(response: HttpResponseBase): Observable<TaskResultDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = TaskResultDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = TaskResultError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified TaskResult
     * @param id TaskResult ID
     * @return OK
     */
    taskResultGet(id: number): Observable<TaskResultDataResponse> {
        let url_ = this.baseUrl + "/taskResult/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaskResultGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskResultGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskResultDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskResultDataResponse>;
        }));
    }

    protected processTaskResultGet(response: HttpResponseBase): Observable<TaskResultDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskResultDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a TaskResult
     * @param id TaskResult ID
     * @return No Content
     */
    taskResultDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/taskResult/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaskResultDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskResultDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTaskResultDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified TaskResult by Task ID
     * @param id Task ID
     * @return OK
     */
    taskResultShowByTaskId(id: number): Observable<TaskResultDataResponse> {
        let url_ = this.baseUrl + "/taskResult/showByTaskId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaskResultShowByTaskId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskResultShowByTaskId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskResultDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskResultDataResponse>;
        }));
    }

    protected processTaskResultShowByTaskId(response: HttpResponseBase): Observable<TaskResultDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskResultDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing TaskResult
     * @param id Task ID
     * @param text (optional) 
     * @param description (optional) 
     * @param files (optional) 
     * @return OK
     */
    taskResultUpdate(id: number, text: string | undefined, description: string | undefined, files: FileParameter[] | undefined): Observable<TaskResultDataResponse> {
        let url_ = this.baseUrl + "/taskResult/update/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (text === null || text === undefined)
            throw new Error("The parameter 'text' cannot be null.");
        else
            content_.append("text", text.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("description", description.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files[]", item_.data, item_.fileName ? item_.fileName : "files[]") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaskResultUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskResultUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskResultDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskResultDataResponse>;
        }));
    }

    protected processTaskResultUpdate(response: HttpResponseBase): Observable<TaskResultDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskResultDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = TaskResultError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing TaskResult
     * @param id Task ID
     * @param body Update taskResult.
     * @return OK
     */
    taskResultUpdateAsJson(id: number, body: TaskResultUpdateRequest): Observable<TaskResultDataResponse> {
        let url_ = this.baseUrl + "/taskResult/updateAsJson/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaskResultUpdateAsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskResultUpdateAsJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskResultDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskResultDataResponse>;
        }));
    }

    protected processTaskResultUpdateAsJson(response: HttpResponseBase): Observable<TaskResultDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskResultDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = TaskResultError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified taskResult
     * @param id TaskResult ID
     * @param fileName fileName
     * @param fileType fileType
     * @param client_guid (optional) Client upload GUID for tracking
     * @return OK
     */
    taskResultAddFileBySignUrl(id: number, fileName: string, fileType: string, client_guid: string | undefined): Observable<TaskResultFileS3FormFieldsResponse> {
        let url_ = this.baseUrl + "/taskResult/addFileBySignUrl/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (fileType === undefined || fileType === null)
            throw new Error("The parameter 'fileType' must be defined and cannot be null.");
        else
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (client_guid === null)
            throw new Error("The parameter 'client_guid' cannot be null.");
        else if (client_guid !== undefined)
            url_ += "client_guid=" + encodeURIComponent("" + client_guid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaskResultAddFileBySignUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskResultAddFileBySignUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskResultFileS3FormFieldsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskResultFileS3FormFieldsResponse>;
        }));
    }

    protected processTaskResultAddFileBySignUrl(response: HttpResponseBase): Observable<TaskResultFileS3FormFieldsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskResultFileS3FormFieldsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add action to content
     * @return OK
     */
    userActionsAction(body: ContentActionRequest): Observable<void> {
        let url_ = this.baseUrl + "/user_actions/action";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserActionsAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserActionsAction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserActionsAction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add comment to content
     * @return OK
     */
    userActionsComment(body: ContentCommentRequest): Observable<Anonymous6> {
        let url_ = this.baseUrl + "/user_actions/comment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserActionsComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserActionsComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous6>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous6>;
        }));
    }

    protected processUserActionsComment(response: HttpResponseBase): Observable<Anonymous6> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Anonymous6.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get comments of content
     * @param offset (optional) 
     * @param limit (optional) 
     * @return OK
     */
    userActionsComments(content_type: string, content_id: number, offset: number | undefined, limit: number | undefined): Observable<CommentsCollection> {
        let url_ = this.baseUrl + "/user_actions/comments?";
        if (content_type === undefined || content_type === null)
            throw new Error("The parameter 'content_type' must be defined and cannot be null.");
        else
            url_ += "content_type=" + encodeURIComponent("" + content_type) + "&";
        if (content_id === undefined || content_id === null)
            throw new Error("The parameter 'content_id' must be defined and cannot be null.");
        else
            url_ += "content_id=" + encodeURIComponent("" + content_id) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserActionsComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserActionsComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentsCollection>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentsCollection>;
        }));
    }

    protected processUserActionsComments(response: HttpResponseBase): Observable<CommentsCollection> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommentsCollection.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of users
     * @param taskId (optional) Task ID
     * @param categoryIds (optional) categoryIds
     * @param taskAnswers (optional) taskAnswers
     * @param highRating (optional) High rating
     * @param countOnPage (optional) Rows count on the page. 10 rows by default.
     * @param page (optional) Page number. 1 by default.
     * @param isWorkByPrice (optional) Work by price
     * @param isOpenForProposals (optional) is Open For Proposals
     * @param name (optional) Name, Surname, both
     * @return OK
     */
    userIndex(taskId: number | undefined, categoryIds: number[] | undefined, taskAnswers: SkillsRequest[] | undefined, highRating: boolean | undefined, countOnPage: number | undefined, page: number | undefined, isWorkByPrice: boolean | undefined, isOpenForProposals: boolean | undefined, name: string | undefined): Observable<UserFilesDataResponse> {
        let url_ = this.baseUrl + "/user/index?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (categoryIds === null)
            throw new Error("The parameter 'categoryIds' cannot be null.");
        else if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "categoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (taskAnswers === null)
            throw new Error("The parameter 'taskAnswers' cannot be null.");
        else if (taskAnswers !== undefined)
            taskAnswers && taskAnswers.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "taskAnswers[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (highRating === null)
            throw new Error("The parameter 'highRating' cannot be null.");
        else if (highRating !== undefined)
            url_ += "highRating=" + encodeURIComponent("" + highRating) + "&";
        if (countOnPage === null)
            throw new Error("The parameter 'countOnPage' cannot be null.");
        else if (countOnPage !== undefined)
            url_ += "countOnPage=" + encodeURIComponent("" + countOnPage) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (isWorkByPrice === null)
            throw new Error("The parameter 'isWorkByPrice' cannot be null.");
        else if (isWorkByPrice !== undefined)
            url_ += "isWorkByPrice=" + encodeURIComponent("" + isWorkByPrice) + "&";
        if (isOpenForProposals === null)
            throw new Error("The parameter 'isOpenForProposals' cannot be null.");
        else if (isOpenForProposals !== undefined)
            url_ += "isOpenForProposals=" + encodeURIComponent("" + isOpenForProposals) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserFilesDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserFilesDataResponse>;
        }));
    }

    protected processUserIndex(response: HttpResponseBase): Observable<UserFilesDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserFilesDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new user
     * @param body Register new user
     * @return OK
     */
    userPost(body: UserCreateRequest): Observable<UserDataResponse> {
        let url_ = this.baseUrl + "/user/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDataResponse>;
        }));
    }

    protected processUserPost(response: HttpResponseBase): Observable<UserDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = UserDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = UserCreateError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified user by ID or nickname
     * @param user User ID or nickname
     * @return OK
     */
    userGet(user: string): Observable<UserDataResponse> {
        let url_ = this.baseUrl + "/user/{user}";
        if (user === undefined || user === null)
            throw new Error("The parameter 'user' must be defined.");
        url_ = url_.replace("{user}", encodeURIComponent("" + user));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDataResponse>;
        }));
    }

    protected processUserGet(response: HttpResponseBase): Observable<UserDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 206) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result206: any = null;
            let resultData206 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result206 = Anonymous7.fromJS(resultData206);
            return throwException("OK", status, _responseText, _headers, result206);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing user
     * @param id User ID
     * @param is_trusted (optional) 
     * @param is_open_for_proposals (optional) 
     * @param lang (optional) 
     * @param work_status (optional) 
     * @param name (optional) 
     * @param surname (optional) 
     * @param middlename (optional) 
     * @param birthday (optional) 
     * @param email (optional) 
     * @param description (optional) 
     * @param price (optional) 
     * @param rate (optional) 
     * @param avatar (optional) 
     * @param skills (optional) 
     * @return OK
     */
    userUpdate(id: number, is_trusted: boolean | undefined, is_open_for_proposals: boolean | undefined, lang: number | undefined, work_status: string | undefined, name: string | undefined, surname: string | undefined, middlename: string | undefined, birthday: string | undefined, email: string | undefined, description: string | undefined, price: number | undefined, rate: number | undefined, avatar: FileParameter | undefined, skills: SkillsRequest[] | undefined): Observable<UserDataResponse> {
        let url_ = this.baseUrl + "/user/update/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (is_trusted === null || is_trusted === undefined)
            throw new Error("The parameter 'is_trusted' cannot be null.");
        else
            content_.append("is_trusted", is_trusted.toString());
        if (is_open_for_proposals === null || is_open_for_proposals === undefined)
            throw new Error("The parameter 'is_open_for_proposals' cannot be null.");
        else
            content_.append("is_open_for_proposals", is_open_for_proposals.toString());
        if (lang === null || lang === undefined)
            throw new Error("The parameter 'lang' cannot be null.");
        else
            content_.append("lang", lang.toString());
        if (work_status === null || work_status === undefined)
            throw new Error("The parameter 'work_status' cannot be null.");
        else
            content_.append("work_status", work_status.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("name", name.toString());
        if (surname === null || surname === undefined)
            throw new Error("The parameter 'surname' cannot be null.");
        else
            content_.append("surname", surname.toString());
        if (middlename === null || middlename === undefined)
            throw new Error("The parameter 'middlename' cannot be null.");
        else
            content_.append("middlename", middlename.toString());
        if (birthday === null || birthday === undefined)
            throw new Error("The parameter 'birthday' cannot be null.");
        else
            content_.append("birthday", birthday.toString());
        if (email === null || email === undefined)
            throw new Error("The parameter 'email' cannot be null.");
        else
            content_.append("email", email.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("description", description.toString());
        if (price === null || price === undefined)
            throw new Error("The parameter 'price' cannot be null.");
        else
            content_.append("price", price.toString());
        if (rate === null || rate === undefined)
            throw new Error("The parameter 'rate' cannot be null.");
        else
            content_.append("rate", rate.toString());
        if (avatar === null || avatar === undefined)
            throw new Error("The parameter 'avatar' cannot be null.");
        else
            content_.append("avatar", avatar.data, avatar.fileName ? avatar.fileName : "avatar");
        if (skills === null || skills === undefined)
            throw new Error("The parameter 'skills' cannot be null.");
        else
            skills.forEach(item_ => content_.append("skills", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDataResponse>;
        }));
    }

    protected processUserUpdate(response: HttpResponseBase): Observable<UserDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = UserUpdateError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing user
     * @param id User ID
     * @param body Update user
     * @return OK
     */
    userUpdateAsJson(id: number, body: UserUpdateRequest): Observable<UserDataResponse> {
        let url_ = this.baseUrl + "/user/updateAsJson/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserUpdateAsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserUpdateAsJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDataResponse>;
        }));
    }

    protected processUserUpdateAsJson(response: HttpResponseBase): Observable<UserDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = UserUpdateError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a User
     * @param id User ID
     * @return No Content
     */
    userDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/user/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Change user password
     * @param body Update password
     * @return OK
     */
    userChangePassword(body: Body13): Observable<Message> {
        let url_ = this.baseUrl + "/user/changePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Message>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Message>;
        }));
    }

    protected processUserChangePassword(response: HttpResponseBase): Observable<Message> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Message.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ErrorDto.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get profileFullness
     * @param id User ID
     * @return OK
     */
    userProfileFullness(id: number): Observable<ProfileFullnessDataResponse> {
        let url_ = this.baseUrl + "/user/profileFullness/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserProfileFullness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserProfileFullness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileFullnessDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileFullnessDataResponse>;
        }));
    }

    protected processUserProfileFullness(response: HttpResponseBase): Observable<ProfileFullnessDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileFullnessDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing user
     * @param id User ID
     * @param body updateIsOnline
     */
    userUpdateIsOnline(id: number, body: Body14): Observable<void> {
        let url_ = this.baseUrl + "/user/updateIsOnline/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserUpdateIsOnline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserUpdateIsOnline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserUpdateIsOnline(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = UserUpdateError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update user chat presence state
     * @param id User ID
     * @return OK
     */
    userUpdateChatPresence(id: number, body: Body15): Observable<void> {
        let url_ = this.baseUrl + "/user/updateChatPresence/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserUpdateChatPresence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserUpdateChatPresence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserUpdateChatPresence(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified profileFile
     * @param fileName fileName
     * @param fileType fileType
     * @param client_guid (optional) Client upload GUID for tracking
     * @return OK
     */
    userAddAvatarBySignUrl(fileName: string, fileType: string, client_guid: string | undefined): Observable<AvatarS3FormFieldsResponse> {
        let url_ = this.baseUrl + "/user/addAvatarBySignUrl?";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (fileType === undefined || fileType === null)
            throw new Error("The parameter 'fileType' must be defined and cannot be null.");
        else
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (client_guid === null)
            throw new Error("The parameter 'client_guid' cannot be null.");
        else if (client_guid !== undefined)
            url_ += "client_guid=" + encodeURIComponent("" + client_guid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserAddAvatarBySignUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserAddAvatarBySignUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvatarS3FormFieldsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvatarS3FormFieldsResponse>;
        }));
    }

    protected processUserAddAvatarBySignUrl(response: HttpResponseBase): Observable<AvatarS3FormFieldsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvatarS3FormFieldsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Post visit data of user
     * @param body (optional) Visit data posting
     * @return OK
     */
    userVisitData(body: VisitDataRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/user/visit_data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserVisitData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserVisitData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserVisitData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get minimal user profiles by IDs for chat rendering
     * @param body User IDs
     * @return OK
     */
    userBulk(body: UserBulkRequest): Observable<UserChatProfileCollection> {
        let url_ = this.baseUrl + "/user/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserBulk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserBulk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserChatProfileCollection>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserChatProfileCollection>;
        }));
    }

    protected processUserBulk(response: HttpResponseBase): Observable<UserChatProfileCollection> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserChatProfileCollection.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Message.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search user by name or surname
     * @param name name and(or) surname
     * @return OK
     */
    userSearch(name: string): Observable<UserMinimalCollection> {
        let url_ = this.baseUrl + "/user/search?";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined and cannot be null.");
        else
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserMinimalCollection>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserMinimalCollection>;
        }));
    }

    protected processUserSearch(response: HttpResponseBase): Observable<UserMinimalCollection> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserMinimalCollection.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of user subscribers
     * @return OK
     */
    userSubscribers(): Observable<UserMinimalResource[]> {
        let url_ = this.baseUrl + "/user/subscribers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserSubscribers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserSubscribers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserMinimalResource[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserMinimalResource[]>;
        }));
    }

    protected processUserSubscribers(response: HttpResponseBase): Observable<UserMinimalResource[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserMinimalResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Check if a nickname is available
     * @param nickname Nickname to check
     * @return OK
     */
    userCheckNickname(nickname: string): Observable<Anonymous8> {
        let url_ = this.baseUrl + "/user/check-nickname?";
        if (nickname === undefined || nickname === null)
            throw new Error("The parameter 'nickname' must be defined and cannot be null.");
        else
            url_ += "nickname=" + encodeURIComponent("" + nickname) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserCheckNickname(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserCheckNickname(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous8>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous8>;
        }));
    }

    protected processUserCheckNickname(response: HttpResponseBase): Observable<Anonymous8> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous8.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ErrorDto.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update user nickname
     * @param id User ID
     * @return Nickname updated successfully
     */
    userNickname(id: number, body: Body16): Observable<Anonymous9> {
        let url_ = this.baseUrl + "/user/{id}/nickname";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserNickname(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserNickname(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous9>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous9>;
        }));
    }

    protected processUserNickname(response: HttpResponseBase): Observable<Anonymous9> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous9.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Anonymous10.fromJS(resultData401);
            return throwException("Unauthorized - User can only update their own nickname", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Anonymous11.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of UserDevice
     * @return OK
     */
    userDeviceIndex(): Observable<UserDevicesDataResponse> {
        let url_ = this.baseUrl + "/userDevice/index";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserDeviceIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserDeviceIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDevicesDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDevicesDataResponse>;
        }));
    }

    protected processUserDeviceIndex(response: HttpResponseBase): Observable<UserDevicesDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDevicesDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new UserDevice
     * @param body (optional) Add UserDevice
     * @return OK
     */
    userDevicePost(body: UserDeviceRequest | undefined): Observable<UserDeviceDataResponse> {
        let url_ = this.baseUrl + "/userDevice/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserDevicePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserDevicePost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDeviceDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDeviceDataResponse>;
        }));
    }

    protected processUserDevicePost(response: HttpResponseBase): Observable<UserDeviceDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDeviceDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = UserDeviceDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = UserDeviceError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specified UserDevice
     * @param id UserDevice ID
     * @return OK
     */
    userDeviceGet(id: number): Observable<UserDeviceDataResponse> {
        let url_ = this.baseUrl + "/userDevice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserDeviceGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserDeviceGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDeviceDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDeviceDataResponse>;
        }));
    }

    protected processUserDeviceGet(response: HttpResponseBase): Observable<UserDeviceDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDeviceDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing UserDevice
     * @param id UserDevice ID
     * @param body Update userDevice.
     * @return OK
     */
    userDevicePut(id: number, body: UserDeviceUpdateRequest): Observable<UserDeviceDataResponse> {
        let url_ = this.baseUrl + "/userDevice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserDevicePut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserDevicePut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDeviceDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDeviceDataResponse>;
        }));
    }

    protected processUserDevicePut(response: HttpResponseBase): Observable<UserDeviceDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDeviceDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = UserDeviceUpdateError.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a UserDevice
     * @param id UserDevice ID
     * @return No Content
     */
    userDeviceDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/userDevice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserDeviceDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserDeviceDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserDeviceDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update UserLocation
     * @param body Add UserLocation
     * @return OK
     */
    userLocation(body: StoreUserLocationRequest): Observable<void> {
        let url_ = this.baseUrl + "/user/location";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserLocation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get user push settings
     * @return OK
     */
    userSettingsPushGet(): Observable<UserPushSettingsResource> {
        let url_ = this.baseUrl + "/user/settings/push";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserSettingsPushGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserSettingsPushGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPushSettingsResource>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPushSettingsResource>;
        }));
    }

    protected processUserSettingsPushGet(response: HttpResponseBase): Observable<UserPushSettingsResource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPushSettingsResource.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = UserPushSettingsResource.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Set user push settings
     * @param body Parameters of settings
     * @return OK
     */
    userSettingsPushPatch(body: SetUserPushSettingsRequest): Observable<UserPushSettingsResource> {
        let url_ = this.baseUrl + "/user/settings/push";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserSettingsPushPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserSettingsPushPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPushSettingsResource>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPushSettingsResource>;
        }));
    }

    protected processUserSettingsPushPatch(response: HttpResponseBase): Observable<UserPushSettingsResource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPushSettingsResource.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = UserPushSettingsResource.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get user settings
     * @return OK
     */
    userSettingsGet(): Observable<UserSettingsResource> {
        let url_ = this.baseUrl + "/user/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserSettingsGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserSettingsGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSettingsResource>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSettingsResource>;
        }));
    }

    protected processUserSettingsGet(response: HttpResponseBase): Observable<UserSettingsResource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSettingsResource.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Set user settings
     * @param body Parameters of settings
     * @return OK
     */
    userSettingsPatch(body: SetUserSettingsRequest): Observable<UserSettingsResource> {
        let url_ = this.baseUrl + "/user/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserSettingsPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserSettingsPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSettingsResource>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSettingsResource>;
        }));
    }

    protected processUserSettingsPatch(response: HttpResponseBase): Observable<UserSettingsResource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSettingsResource.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Videos for location
     * @param long Longitude.
     * @param lat Latitude.
     * @param maxDistance (optional) Max distance. Default 50.
     * @param count (optional) Rows count. Default 10.
     * @param offset (optional) Records to skip for loading
     * @param live (optional) Only live streams
     * @param period (optional) Period of stream created_at
     * @param user_coordinate (optional) Way videos filter (video coordinate or user coordinate)
     * @param group (optional) Group videos by user_id
     * @param date_from (optional) Start date filter (UTC, YYYY-MM-DD)
     * @param date_to (optional) End date filter (UTC, YYYY-MM-DD)
     * @return OK
     */
    videosIndex(long: number, lat: number, maxDistance: number | undefined, count: number | undefined, offset: number | undefined, live: boolean | undefined, period: string | undefined, user_coordinate: boolean | undefined, group: boolean | undefined, date_from: string | undefined, date_to: string | undefined): Observable<VideosIndexResponse> {
        let url_ = this.baseUrl + "/videos/index?";
        if (long === undefined || long === null)
            throw new Error("The parameter 'long' must be defined and cannot be null.");
        else
            url_ += "long=" + encodeURIComponent("" + long) + "&";
        if (lat === undefined || lat === null)
            throw new Error("The parameter 'lat' must be defined and cannot be null.");
        else
            url_ += "lat=" + encodeURIComponent("" + lat) + "&";
        if (maxDistance === null)
            throw new Error("The parameter 'maxDistance' cannot be null.");
        else if (maxDistance !== undefined)
            url_ += "maxDistance=" + encodeURIComponent("" + maxDistance) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (live === null)
            throw new Error("The parameter 'live' cannot be null.");
        else if (live !== undefined)
            url_ += "live=" + encodeURIComponent("" + live) + "&";
        if (period === null)
            throw new Error("The parameter 'period' cannot be null.");
        else if (period !== undefined)
            url_ += "period=" + encodeURIComponent("" + period) + "&";
        if (user_coordinate === null)
            throw new Error("The parameter 'user_coordinate' cannot be null.");
        else if (user_coordinate !== undefined)
            url_ += "user_coordinate=" + encodeURIComponent("" + user_coordinate) + "&";
        if (group === null)
            throw new Error("The parameter 'group' cannot be null.");
        else if (group !== undefined)
            url_ += "group=" + encodeURIComponent("" + group) + "&";
        if (date_from === null)
            throw new Error("The parameter 'date_from' cannot be null.");
        else if (date_from !== undefined)
            url_ += "date_from=" + encodeURIComponent("" + date_from) + "&";
        if (date_to === null)
            throw new Error("The parameter 'date_to' cannot be null.");
        else if (date_to !== undefined)
            url_ += "date_to=" + encodeURIComponent("" + date_to) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVideosIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVideosIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VideosIndexResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VideosIndexResponse>;
        }));
    }

    protected processVideosIndex(response: HttpResponseBase): Observable<VideosIndexResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VideosIndexResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Videos for world
     * @param long (optional) Longitude.
     * @param lat (optional) Latitude.
     * @param count (optional) Rows count. Default 10.
     * @param offset (optional) Records to skip for loading
     * @param video_id (optional) ID of video to prioritize in results
     * @param excluded_ids (optional) Array of video IDs to exclude from results (already seen videos)
     * @return OK
     */
    videosWorldIndex(long: number | undefined, lat: number | undefined, count: number | undefined, offset: number | undefined, video_id: number | undefined, excluded_ids: number[] | undefined): Observable<WorldStreamCollection> {
        let url_ = this.baseUrl + "/videos/world_index?";
        if (long === null)
            throw new Error("The parameter 'long' cannot be null.");
        else if (long !== undefined)
            url_ += "long=" + encodeURIComponent("" + long) + "&";
        if (lat === null)
            throw new Error("The parameter 'lat' cannot be null.");
        else if (lat !== undefined)
            url_ += "lat=" + encodeURIComponent("" + lat) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (video_id === null)
            throw new Error("The parameter 'video_id' cannot be null.");
        else if (video_id !== undefined)
            url_ += "video_id=" + encodeURIComponent("" + video_id) + "&";
        if (excluded_ids === null)
            throw new Error("The parameter 'excluded_ids' cannot be null.");
        else if (excluded_ids !== undefined)
            excluded_ids && excluded_ids.forEach(item => { url_ += "excluded_ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVideosWorldIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVideosWorldIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorldStreamCollection>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorldStreamCollection>;
        }));
    }

    protected processVideosWorldIndex(response: HttpResponseBase): Observable<WorldStreamCollection> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorldStreamCollection.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get video by id
     * @param id Get Video by ID
     * @return OK
     */
    videosGet(id: number): Observable<StreamExtendedResource> {
        let url_ = this.baseUrl + "/videos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVideosGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVideosGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StreamExtendedResource>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StreamExtendedResource>;
        }));
    }

    protected processVideosGet(response: HttpResponseBase): Observable<StreamExtendedResource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StreamExtendedResource.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete video
     * @param id Video ID
     * @return OK
     */
    videosDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/videos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVideosDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVideosDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVideosDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update live stream name and description
     * @param id (optional) Video ID
     * @param name (optional) Stream name
     * @param description (optional) Stream description
     * @return Successful response
     */
    videosPatch(id: number | undefined, name: string | undefined, description: string | undefined): Observable<Anonymous12> {
        let url_ = this.baseUrl + "/videos/{id}?";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (description === null)
            throw new Error("The parameter 'description' cannot be null.");
        else if (description !== undefined)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVideosPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVideosPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous12>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous12>;
        }));
    }

    protected processVideosPatch(response: HttpResponseBase): Observable<Anonymous12> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous12.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get video comments by video id
     * @param offset (optional) 
     * @param limit (optional) 
     * @return OK
     */
    videosComments(id: number, offset: number | undefined, limit: number | undefined): Observable<CommentsCollection> {
        let url_ = this.baseUrl + "/videos/{id}/comments?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVideosComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVideosComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentsCollection>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentsCollection>;
        }));
    }

    protected processVideosComments(response: HttpResponseBase): Observable<CommentsCollection> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommentsCollection.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add comment to video
     * @param id ID of Video
     * @param body Comment text
     * @return OK
     */
    videosComment(id: number, body: Body17): Observable<Anonymous13> {
        let url_ = this.baseUrl + "/videos/comment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVideosComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVideosComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous13>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous13>;
        }));
    }

    protected processVideosComment(response: HttpResponseBase): Observable<Anonymous13> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Anonymous13.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add like to video
     * @param id Video ID
     * @return OK
     */
    videosLike(id: number): Observable<void> {
        let url_ = this.baseUrl + "/videos/like/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVideosLike(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVideosLike(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVideosLike(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Remove added like from video
     * @param id Video ID
     * @return OK
     */
    videosRemoveLike(id: number): Observable<void> {
        let url_ = this.baseUrl + "/videos/remove_like/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVideosRemoveLike(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVideosRemoveLike(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVideosRemoveLike(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add dislike to video
     * @param id Video ID
     * @return OK
     */
    videosDislike(id: number): Observable<void> {
        let url_ = this.baseUrl + "/videos/dislike/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVideosDislike(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVideosDislike(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVideosDislike(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Remove added dislike from video
     * @param id Video ID
     * @return OK
     */
    videosRemoveDislike(id: number): Observable<void> {
        let url_ = this.baseUrl + "/videos/remove_dislike/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVideosRemoveDislike(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVideosRemoveDislike(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVideosRemoveDislike(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add watch to video
     * @param id Video ID
     * @return OK
     */
    videosWatch(id: number): Observable<void> {
        let url_ = this.baseUrl + "/videos/watch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVideosWatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVideosWatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVideosWatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Start live stream
     * @param long (optional) Longitude.
     * @param lat (optional) Latitude.
     * @param name (optional) Stream name
     * @param description (optional) Stream description
     * @return Successful response
     */
    videosStartStream(long: number | undefined, lat: number | undefined, name: string | undefined, description: string | undefined): Observable<Anonymous14> {
        let url_ = this.baseUrl + "/videos/startStream?";
        if (long === null)
            throw new Error("The parameter 'long' cannot be null.");
        else if (long !== undefined)
            url_ += "long=" + encodeURIComponent("" + long) + "&";
        if (lat === null)
            throw new Error("The parameter 'lat' cannot be null.");
        else if (lat !== undefined)
            url_ += "lat=" + encodeURIComponent("" + lat) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (description === null)
            throw new Error("The parameter 'description' cannot be null.");
        else if (description !== undefined)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVideosStartStream(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVideosStartStream(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous14>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous14>;
        }));
    }

    protected processVideosStartStream(response: HttpResponseBase): Observable<Anonymous14> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous14.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Set video confirmed = true
     * @param id Video ID
     * @return OK
     */
    videosConfirm(id: number): Observable<void> {
        let url_ = this.baseUrl + "/videos/confirm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVideosConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVideosConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVideosConfirm(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Confirm streamer connected to media server
     * @param id Video ID
     * @return OK
     */
    videosConnected(id: number): Observable<void> {
        let url_ = this.baseUrl + "/videos/connected/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVideosConnected(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVideosConnected(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVideosConnected(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * End live stream
     * @param id Video ID
     * @param reason (optional) Reason of end
     * @return Successful response
     */
    videosEndStream(id: number, reason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/videos/endStream/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVideosEndStream(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVideosEndStream(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVideosEndStream(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update video location coordinates
     * @param id Video ID
     * @return Location updated successfully
     */
    videosUpdateLocation(id: number, body: UpdateVideoLocationRequest): Observable<Anonymous15> {
        let url_ = this.baseUrl + "/videos/updateLocation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVideosUpdateLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVideosUpdateLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous15>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous15>;
        }));
    }

    protected processVideosUpdateLocation(response: HttpResponseBase): Observable<Anonymous15> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous15.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Message.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Video or location not found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get videos of user by id
     * @param id User ID
     * @param long (optional) Longitude.
     * @param lat (optional) Latitude.
     * @param maxDistance (optional) Max distance. Default 50.
     * @param count (optional) Rows count. Default 10.
     * @param offset (optional) Records to skip for loading
     * @param live (optional) Only live streams
     * @param period (optional) Period of stream created_at
     * @param date_from (optional) Start date filter (UTC, YYYY-MM-DD)
     * @param date_to (optional) End date filter (UTC, YYYY-MM-DD)
     * @return OK
     */
    videosUser(id: number, long: number | undefined, lat: number | undefined, maxDistance: number | undefined, count: number | undefined, offset: number | undefined, live: boolean | undefined, period: string | undefined, date_from: string | undefined, date_to: string | undefined): Observable<StreamsCollection> {
        let url_ = this.baseUrl + "/videos/user/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (long === null)
            throw new Error("The parameter 'long' cannot be null.");
        else if (long !== undefined)
            url_ += "long=" + encodeURIComponent("" + long) + "&";
        if (lat === null)
            throw new Error("The parameter 'lat' cannot be null.");
        else if (lat !== undefined)
            url_ += "lat=" + encodeURIComponent("" + lat) + "&";
        if (maxDistance === null)
            throw new Error("The parameter 'maxDistance' cannot be null.");
        else if (maxDistance !== undefined)
            url_ += "maxDistance=" + encodeURIComponent("" + maxDistance) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (live === null)
            throw new Error("The parameter 'live' cannot be null.");
        else if (live !== undefined)
            url_ += "live=" + encodeURIComponent("" + live) + "&";
        if (period === null)
            throw new Error("The parameter 'period' cannot be null.");
        else if (period !== undefined)
            url_ += "period=" + encodeURIComponent("" + period) + "&";
        if (date_from === null)
            throw new Error("The parameter 'date_from' cannot be null.");
        else if (date_from !== undefined)
            url_ += "date_from=" + encodeURIComponent("" + date_from) + "&";
        if (date_to === null)
            throw new Error("The parameter 'date_to' cannot be null.");
        else if (date_to !== undefined)
            url_ += "date_to=" + encodeURIComponent("" + date_to) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVideosUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVideosUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StreamsCollection>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StreamsCollection>;
        }));
    }

    protected processVideosUser(response: HttpResponseBase): Observable<StreamsCollection> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StreamsCollection.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Notify streamer of video with id
     * @param id Video ID
     * @return OK
     */
    videosNotifyStreamer(id: number, body: NotifyStreamerRequest): Observable<void> {
        let url_ = this.baseUrl + "/videos/notifyStreamer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVideosNotifyStreamer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVideosNotifyStreamer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVideosNotifyStreamer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get current user's linked Solana wallet
     * @return OK
     */
    wallet(): Observable<SolanaWalletDataResponse> {
        let url_ = this.baseUrl + "/wallet";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWallet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWallet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SolanaWalletDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SolanaWalletDataResponse>;
        }));
    }

    protected processWallet(response: HttpResponseBase): Observable<SolanaWalletDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SolanaWalletDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Solana wallet ownership challenge for current user
     * @return Created
     */
    walletLinkChallenge(body: SolanaWalletLinkChallengeRequest): Observable<SolanaWalletOwnershipChallengeDataResponse> {
        let url_ = this.baseUrl + "/wallet/link/challenge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWalletLinkChallenge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWalletLinkChallenge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SolanaWalletOwnershipChallengeDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SolanaWalletOwnershipChallengeDataResponse>;
        }));
    }

    protected processWalletLinkChallenge(response: HttpResponseBase): Observable<SolanaWalletOwnershipChallengeDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = SolanaWalletOwnershipChallengeDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = Message.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Validation error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Verify Solana wallet ownership and link wallet to current user
     * @return OK
     */
    walletLinkVerify(body: SolanaWalletLinkVerifyRequest): Observable<SolanaWalletDataResponse> {
        let url_ = this.baseUrl + "/wallet/link/verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWalletLinkVerify(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWalletLinkVerify(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SolanaWalletDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SolanaWalletDataResponse>;
        }));
    }

    protected processWalletLinkVerify(response: HttpResponseBase): Observable<SolanaWalletDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SolanaWalletDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = Message.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Validation error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get current user's PJM balance
     * @return OK
     */
    walletBalance(): Observable<PjmBalanceDataResponse> {
        let url_ = this.baseUrl + "/wallet/balance";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWalletBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWalletBalance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PjmBalanceDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PjmBalanceDataResponse>;
        }));
    }

    protected processWalletBalance(response: HttpResponseBase): Observable<PjmBalanceDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PjmBalanceDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Wallet is not linked", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get current user's PJM wallet transactions
     * @param limit (optional) Maximum number of transactions to return
     * @param cursor (optional) Opaque pagination cursor from the previous page
     * @return OK
     */
    walletTransactions(limit: number | undefined, cursor: string | undefined): Observable<WalletTransactionPageDataResponse> {
        let url_ = this.baseUrl + "/wallet/transactions?";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (cursor === null)
            throw new Error("The parameter 'cursor' cannot be null.");
        else if (cursor !== undefined)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWalletTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWalletTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WalletTransactionPageDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WalletTransactionPageDataResponse>;
        }));
    }

    protected processWalletTransactions(response: HttpResponseBase): Observable<WalletTransactionPageDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletTransactionPageDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Wallet is not linked", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Validation error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search users for PJM wallet transfer
     * @param query Name, surname, or nickname prefix. Prefix with @ to search by nickname only.
     * @param count (optional) Maximum number of users to return
     * @return OK
     */
    walletTransferRecipients(query: string, count: number | undefined): Observable<WalletTransferRecipientCollection> {
        let url_ = this.baseUrl + "/wallet/transfer/recipients?";
        if (query === undefined || query === null)
            throw new Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWalletTransferRecipients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWalletTransferRecipients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WalletTransferRecipientCollection>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WalletTransferRecipientCollection>;
        }));
    }

    protected processWalletTransferRecipients(response: HttpResponseBase): Observable<WalletTransferRecipientCollection> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletTransferRecipientCollection.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Validation error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a PJM transfer recipient by user ID
     * @return OK
     */
    walletTransferRecipient(recipientUserId: number): Observable<WalletTransferRecipientDataResponse> {
        let url_ = this.baseUrl + "/wallet/transfer/recipient/{recipientUserId}";
        if (recipientUserId === undefined || recipientUserId === null)
            throw new Error("The parameter 'recipientUserId' must be defined.");
        url_ = url_.replace("{recipientUserId}", encodeURIComponent("" + recipientUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWalletTransferRecipient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWalletTransferRecipient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WalletTransferRecipientDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WalletTransferRecipientDataResponse>;
        }));
    }

    protected processWalletTransferRecipient(response: HttpResponseBase): Observable<WalletTransferRecipientDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletTransferRecipientDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Recipient not found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = Message.fromJS(resultData409);
            return throwException("Cannot transfer to the current user", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Invite a user to create a wallet through direct chat
     * @return Invitation queued
     */
    walletTransferRecipientInvite(recipientUserId: number): Observable<void> {
        let url_ = this.baseUrl + "/wallet/transfer/recipient/{recipientUserId}/invite";
        if (recipientUserId === undefined || recipientUserId === null)
            throw new Error("The parameter 'recipientUserId' must be defined.");
        url_ = url_.replace("{recipientUserId}", encodeURIComponent("" + recipientUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWalletTransferRecipientInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWalletTransferRecipientInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWalletTransferRecipientInvite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Message.fromJS(resultData403);
            return throwException("Direct chat is not allowed", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Recipient not found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = Message.fromJS(resultData409);
            return throwException("Invitation is not applicable", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create PJM transfer payment intent for a recipient user
     * @return Existing idempotent intent
     */
    walletTransferPaymentIntentsPost(body: WalletTransferPaymentIntentCreateRequest): Observable<WalletTransferPaymentIntentDataResponse> {
        let url_ = this.baseUrl + "/wallet/transfer/payment-intents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWalletTransferPaymentIntentsPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWalletTransferPaymentIntentsPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WalletTransferPaymentIntentDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WalletTransferPaymentIntentDataResponse>;
        }));
    }

    protected processWalletTransferPaymentIntentsPost(response: HttpResponseBase): Observable<WalletTransferPaymentIntentDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = WalletTransferPaymentIntentDataResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletTransferPaymentIntentDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Wallet or recipient not found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = Message.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Validation error", status, _responseText, _headers);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Message.fromJS(resultData503);
            return throwException("Wallet service unavailable", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Submit sender-signed PJM transfer payment intent
     * @return OK
     */
    walletTransferPaymentIntentsSubmit(paymentIntentId: string, body: WalletTransferPaymentIntentSubmitRequest): Observable<WalletTransferPaymentIntentDataResponse> {
        let url_ = this.baseUrl + "/wallet/transfer/payment-intents/{paymentIntentId}/submit";
        if (paymentIntentId === undefined || paymentIntentId === null)
            throw new Error("The parameter 'paymentIntentId' must be defined.");
        url_ = url_.replace("{paymentIntentId}", encodeURIComponent("" + paymentIntentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWalletTransferPaymentIntentsSubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWalletTransferPaymentIntentsSubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WalletTransferPaymentIntentDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WalletTransferPaymentIntentDataResponse>;
        }));
    }

    protected processWalletTransferPaymentIntentsSubmit(response: HttpResponseBase): Observable<WalletTransferPaymentIntentDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletTransferPaymentIntentDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Payment intent not found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = Message.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Validation error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Abandon a prepared PJM transfer payment intent
     * @return Current payment intent
     */
    walletTransferPaymentIntentsAbandon(paymentIntentId: string): Observable<WalletTransferPaymentIntentDataResponse> {
        let url_ = this.baseUrl + "/wallet/transfer/payment-intents/{paymentIntentId}/abandon";
        if (paymentIntentId === undefined || paymentIntentId === null)
            throw new Error("The parameter 'paymentIntentId' must be defined.");
        url_ = url_.replace("{paymentIntentId}", encodeURIComponent("" + paymentIntentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWalletTransferPaymentIntentsAbandon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWalletTransferPaymentIntentsAbandon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WalletTransferPaymentIntentDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WalletTransferPaymentIntentDataResponse>;
        }));
    }

    protected processWalletTransferPaymentIntentsAbandon(response: HttpResponseBase): Observable<WalletTransferPaymentIntentDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletTransferPaymentIntentDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Payment intent not found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = Message.fromJS(resultData409);
            return throwException("Submission is already in progress", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get current user's PJM transfer payment intent
     * @return OK
     */
    walletTransferPaymentIntentsGet(paymentIntentId: string): Observable<WalletTransferPaymentIntentDataResponse> {
        let url_ = this.baseUrl + "/wallet/transfer/payment-intents/{paymentIntentId}";
        if (paymentIntentId === undefined || paymentIntentId === null)
            throw new Error("The parameter 'paymentIntentId' must be defined.");
        url_ = url_.replace("{paymentIntentId}", encodeURIComponent("" + paymentIntentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWalletTransferPaymentIntentsGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWalletTransferPaymentIntentsGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WalletTransferPaymentIntentDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WalletTransferPaymentIntentDataResponse>;
        }));
    }

    protected processWalletTransferPaymentIntentsGet(response: HttpResponseBase): Observable<WalletTransferPaymentIntentDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletTransferPaymentIntentDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Payment intent not found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = Message.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Test
     * @return OK
     */
    yoomoney(): Observable<YoomoneyResponse> {
        let url_ = this.baseUrl + "/yoomoney";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processYoomoney(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processYoomoney(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<YoomoneyResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<YoomoneyResponse>;
        }));
    }

    protected processYoomoney(response: HttpResponseBase): Observable<YoomoneyResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = YoomoneyResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Message.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Message.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class SubscriptionsInfo implements ISubscriptionsInfo {
    subscribersCount?: number;
    i_subscribed?: boolean;

    [key: string]: any;

    constructor(data?: ISubscriptionsInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.subscribersCount = _data["subscribersCount"];
            this.i_subscribed = _data["i_subscribed"];
        }
    }

    static fromJS(data: any): SubscriptionsInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionsInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["subscribersCount"] = this.subscribersCount;
        data["i_subscribed"] = this.i_subscribed;
        return data;
    }
}

export interface ISubscriptionsInfo {
    subscribersCount?: number;
    i_subscribed?: boolean;

    [key: string]: any;
}

export class AvatarS3FormFieldsResponse implements IAvatarS3FormFieldsResponse {
    action?: string;
    method?: string;
    enctype?: string;
    key?: string;
    contentType?: string;
    policy?: string;
    xAmzCredential?: string;
    xAmzAlgorithm?: string;
    xAmzDate?: string;
    xAmzSignature?: string;
    xAmzMetaObjectType?: string;
    xAmzMetaClientGuid?: string;

    [key: string]: any;

    constructor(data?: IAvatarS3FormFieldsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.action = _data["action"];
            this.method = _data["method"];
            this.enctype = _data["enctype"];
            this.key = _data["key"];
            this.contentType = _data["Content-Type"];
            this.policy = _data["Policy"];
            this.xAmzCredential = _data["X-Amz-Credential"];
            this.xAmzAlgorithm = _data["X-Amz-Algorithm"];
            this.xAmzDate = _data["X-Amz-Date"];
            this.xAmzSignature = _data["X-Amz-Signature"];
            this.xAmzMetaObjectType = _data["X-Amz-Meta-object-type"];
            this.xAmzMetaClientGuid = _data["X-Amz-Meta-client-guid"];
        }
    }

    static fromJS(data: any): AvatarS3FormFieldsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AvatarS3FormFieldsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["action"] = this.action;
        data["method"] = this.method;
        data["enctype"] = this.enctype;
        data["key"] = this.key;
        data["Content-Type"] = this.contentType;
        data["Policy"] = this.policy;
        data["X-Amz-Credential"] = this.xAmzCredential;
        data["X-Amz-Algorithm"] = this.xAmzAlgorithm;
        data["X-Amz-Date"] = this.xAmzDate;
        data["X-Amz-Signature"] = this.xAmzSignature;
        data["X-Amz-Meta-object-type"] = this.xAmzMetaObjectType;
        data["X-Amz-Meta-client-guid"] = this.xAmzMetaClientGuid;
        return data;
    }
}

export interface IAvatarS3FormFieldsResponse {
    action?: string;
    method?: string;
    enctype?: string;
    key?: string;
    contentType?: string;
    policy?: string;
    xAmzCredential?: string;
    xAmzAlgorithm?: string;
    xAmzDate?: string;
    xAmzSignature?: string;
    xAmzMetaObjectType?: string;
    xAmzMetaClientGuid?: string;

    [key: string]: any;
}

export class ProfileFileS3FormFieldsResponse implements IProfileFileS3FormFieldsResponse {
    action?: string;
    method?: string;
    enctype?: string;
    key?: string;
    contentType?: string;
    policy?: string;
    xAmzCredential?: string;
    xAmzAlgorithm?: string;
    xAmzDate?: string;
    xAmzSignature?: string;
    xAmzMetaObjectType?: string;
    xAmzMetaClientGuid?: string;
    xAmzMetaDescription?: string;
    xAmzMetaTitle?: string;

    [key: string]: any;

    constructor(data?: IProfileFileS3FormFieldsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.action = _data["action"];
            this.method = _data["method"];
            this.enctype = _data["enctype"];
            this.key = _data["key"];
            this.contentType = _data["Content-Type"];
            this.policy = _data["Policy"];
            this.xAmzCredential = _data["X-Amz-Credential"];
            this.xAmzAlgorithm = _data["X-Amz-Algorithm"];
            this.xAmzDate = _data["X-Amz-Date"];
            this.xAmzSignature = _data["X-Amz-Signature"];
            this.xAmzMetaObjectType = _data["X-Amz-Meta-object-type"];
            this.xAmzMetaClientGuid = _data["X-Amz-Meta-client-guid"];
            this.xAmzMetaDescription = _data["X-Amz-Meta-description"];
            this.xAmzMetaTitle = _data["X-Amz-Meta-title"];
        }
    }

    static fromJS(data: any): ProfileFileS3FormFieldsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileFileS3FormFieldsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["action"] = this.action;
        data["method"] = this.method;
        data["enctype"] = this.enctype;
        data["key"] = this.key;
        data["Content-Type"] = this.contentType;
        data["Policy"] = this.policy;
        data["X-Amz-Credential"] = this.xAmzCredential;
        data["X-Amz-Algorithm"] = this.xAmzAlgorithm;
        data["X-Amz-Date"] = this.xAmzDate;
        data["X-Amz-Signature"] = this.xAmzSignature;
        data["X-Amz-Meta-object-type"] = this.xAmzMetaObjectType;
        data["X-Amz-Meta-client-guid"] = this.xAmzMetaClientGuid;
        data["X-Amz-Meta-description"] = this.xAmzMetaDescription;
        data["X-Amz-Meta-title"] = this.xAmzMetaTitle;
        return data;
    }
}

export interface IProfileFileS3FormFieldsResponse {
    action?: string;
    method?: string;
    enctype?: string;
    key?: string;
    contentType?: string;
    policy?: string;
    xAmzCredential?: string;
    xAmzAlgorithm?: string;
    xAmzDate?: string;
    xAmzSignature?: string;
    xAmzMetaObjectType?: string;
    xAmzMetaClientGuid?: string;
    xAmzMetaDescription?: string;
    xAmzMetaTitle?: string;

    [key: string]: any;
}

export class TaskFileS3FormFieldsResponse implements ITaskFileS3FormFieldsResponse {
    action?: string;
    method?: string;
    enctype?: string;
    key?: string;
    contentType?: string;
    policy?: string;
    xAmzCredential?: string;
    xAmzAlgorithm?: string;
    xAmzDate?: string;
    xAmzSignature?: string;
    xAmzMetaObjectType?: string;
    xAmzMetaClientGuid?: string;
    xAmzMetaTaskId?: string;
    xAmzMetaQuestionId?: string;

    [key: string]: any;

    constructor(data?: ITaskFileS3FormFieldsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.action = _data["action"];
            this.method = _data["method"];
            this.enctype = _data["enctype"];
            this.key = _data["key"];
            this.contentType = _data["Content-Type"];
            this.policy = _data["Policy"];
            this.xAmzCredential = _data["X-Amz-Credential"];
            this.xAmzAlgorithm = _data["X-Amz-Algorithm"];
            this.xAmzDate = _data["X-Amz-Date"];
            this.xAmzSignature = _data["X-Amz-Signature"];
            this.xAmzMetaObjectType = _data["X-Amz-Meta-object-type"];
            this.xAmzMetaClientGuid = _data["X-Amz-Meta-client-guid"];
            this.xAmzMetaTaskId = _data["X-Amz-Meta-task-id"];
            this.xAmzMetaQuestionId = _data["X-Amz-Meta-question-id"];
        }
    }

    static fromJS(data: any): TaskFileS3FormFieldsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskFileS3FormFieldsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["action"] = this.action;
        data["method"] = this.method;
        data["enctype"] = this.enctype;
        data["key"] = this.key;
        data["Content-Type"] = this.contentType;
        data["Policy"] = this.policy;
        data["X-Amz-Credential"] = this.xAmzCredential;
        data["X-Amz-Algorithm"] = this.xAmzAlgorithm;
        data["X-Amz-Date"] = this.xAmzDate;
        data["X-Amz-Signature"] = this.xAmzSignature;
        data["X-Amz-Meta-object-type"] = this.xAmzMetaObjectType;
        data["X-Amz-Meta-client-guid"] = this.xAmzMetaClientGuid;
        data["X-Amz-Meta-task-id"] = this.xAmzMetaTaskId;
        data["X-Amz-Meta-question-id"] = this.xAmzMetaQuestionId;
        return data;
    }
}

export interface ITaskFileS3FormFieldsResponse {
    action?: string;
    method?: string;
    enctype?: string;
    key?: string;
    contentType?: string;
    policy?: string;
    xAmzCredential?: string;
    xAmzAlgorithm?: string;
    xAmzDate?: string;
    xAmzSignature?: string;
    xAmzMetaObjectType?: string;
    xAmzMetaClientGuid?: string;
    xAmzMetaTaskId?: string;
    xAmzMetaQuestionId?: string;

    [key: string]: any;
}

export class TaskResultFileS3FormFieldsResponse implements ITaskResultFileS3FormFieldsResponse {
    action?: string;
    method?: string;
    enctype?: string;
    key?: string;
    contentType?: string;
    policy?: string;
    xAmzCredential?: string;
    xAmzAlgorithm?: string;
    xAmzDate?: string;
    xAmzSignature?: string;
    xAmzMetaObjectType?: string;
    xAmzMetaClientGuid?: string;
    xAmzMetaTaskResultId?: string;

    [key: string]: any;

    constructor(data?: ITaskResultFileS3FormFieldsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.action = _data["action"];
            this.method = _data["method"];
            this.enctype = _data["enctype"];
            this.key = _data["key"];
            this.contentType = _data["Content-Type"];
            this.policy = _data["Policy"];
            this.xAmzCredential = _data["X-Amz-Credential"];
            this.xAmzAlgorithm = _data["X-Amz-Algorithm"];
            this.xAmzDate = _data["X-Amz-Date"];
            this.xAmzSignature = _data["X-Amz-Signature"];
            this.xAmzMetaObjectType = _data["X-Amz-Meta-object-type"];
            this.xAmzMetaClientGuid = _data["X-Amz-Meta-client-guid"];
            this.xAmzMetaTaskResultId = _data["X-Amz-Meta-task-result-id"];
        }
    }

    static fromJS(data: any): TaskResultFileS3FormFieldsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskResultFileS3FormFieldsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["action"] = this.action;
        data["method"] = this.method;
        data["enctype"] = this.enctype;
        data["key"] = this.key;
        data["Content-Type"] = this.contentType;
        data["Policy"] = this.policy;
        data["X-Amz-Credential"] = this.xAmzCredential;
        data["X-Amz-Algorithm"] = this.xAmzAlgorithm;
        data["X-Amz-Date"] = this.xAmzDate;
        data["X-Amz-Signature"] = this.xAmzSignature;
        data["X-Amz-Meta-object-type"] = this.xAmzMetaObjectType;
        data["X-Amz-Meta-client-guid"] = this.xAmzMetaClientGuid;
        data["X-Amz-Meta-task-result-id"] = this.xAmzMetaTaskResultId;
        return data;
    }
}

export interface ITaskResultFileS3FormFieldsResponse {
    action?: string;
    method?: string;
    enctype?: string;
    key?: string;
    contentType?: string;
    policy?: string;
    xAmzCredential?: string;
    xAmzAlgorithm?: string;
    xAmzDate?: string;
    xAmzSignature?: string;
    xAmzMetaObjectType?: string;
    xAmzMetaClientGuid?: string;
    xAmzMetaTaskResultId?: string;

    [key: string]: any;
}

export class ChatFileS3FormFieldsResponse implements IChatFileS3FormFieldsResponse {
    action?: string;
    method?: string;
    enctype?: string;
    key?: string;
    contentType?: string;
    policy?: string;
    xAmzCredential?: string;
    xAmzAlgorithm?: string;
    xAmzDate?: string;
    xAmzSignature?: string;
    xAmzMetaObjectType?: string;
    xAmzMetaClientGuid?: string;
    xAmzMetaChatId?: string;

    [key: string]: any;

    constructor(data?: IChatFileS3FormFieldsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.action = _data["action"];
            this.method = _data["method"];
            this.enctype = _data["enctype"];
            this.key = _data["key"];
            this.contentType = _data["Content-Type"];
            this.policy = _data["Policy"];
            this.xAmzCredential = _data["X-Amz-Credential"];
            this.xAmzAlgorithm = _data["X-Amz-Algorithm"];
            this.xAmzDate = _data["X-Amz-Date"];
            this.xAmzSignature = _data["X-Amz-Signature"];
            this.xAmzMetaObjectType = _data["X-Amz-Meta-object-type"];
            this.xAmzMetaClientGuid = _data["X-Amz-Meta-client-guid"];
            this.xAmzMetaChatId = _data["X-Amz-Meta-chat-id"];
        }
    }

    static fromJS(data: any): ChatFileS3FormFieldsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChatFileS3FormFieldsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["action"] = this.action;
        data["method"] = this.method;
        data["enctype"] = this.enctype;
        data["key"] = this.key;
        data["Content-Type"] = this.contentType;
        data["Policy"] = this.policy;
        data["X-Amz-Credential"] = this.xAmzCredential;
        data["X-Amz-Algorithm"] = this.xAmzAlgorithm;
        data["X-Amz-Date"] = this.xAmzDate;
        data["X-Amz-Signature"] = this.xAmzSignature;
        data["X-Amz-Meta-object-type"] = this.xAmzMetaObjectType;
        data["X-Amz-Meta-client-guid"] = this.xAmzMetaClientGuid;
        data["X-Amz-Meta-chat-id"] = this.xAmzMetaChatId;
        return data;
    }
}

export interface IChatFileS3FormFieldsResponse {
    action?: string;
    method?: string;
    enctype?: string;
    key?: string;
    contentType?: string;
    policy?: string;
    xAmzCredential?: string;
    xAmzAlgorithm?: string;
    xAmzDate?: string;
    xAmzSignature?: string;
    xAmzMetaObjectType?: string;
    xAmzMetaClientGuid?: string;
    xAmzMetaChatId?: string;

    [key: string]: any;
}

export class ChatAvatarS3FormFieldsResponse implements IChatAvatarS3FormFieldsResponse {
    action?: string;
    method?: string;
    enctype?: string;
    key?: string;
    contentType?: string;
    policy?: string;
    xAmzCredential?: string;
    xAmzAlgorithm?: string;
    xAmzDate?: string;
    xAmzSignature?: string;
    xAmzMetaObjectType?: string;
    xAmzMetaClientGuid?: string;
    xAmzMetaChatId?: string;

    [key: string]: any;

    constructor(data?: IChatAvatarS3FormFieldsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.action = _data["action"];
            this.method = _data["method"];
            this.enctype = _data["enctype"];
            this.key = _data["key"];
            this.contentType = _data["Content-Type"];
            this.policy = _data["Policy"];
            this.xAmzCredential = _data["X-Amz-Credential"];
            this.xAmzAlgorithm = _data["X-Amz-Algorithm"];
            this.xAmzDate = _data["X-Amz-Date"];
            this.xAmzSignature = _data["X-Amz-Signature"];
            this.xAmzMetaObjectType = _data["X-Amz-Meta-object-type"];
            this.xAmzMetaClientGuid = _data["X-Amz-Meta-client-guid"];
            this.xAmzMetaChatId = _data["X-Amz-Meta-chat-id"];
        }
    }

    static fromJS(data: any): ChatAvatarS3FormFieldsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChatAvatarS3FormFieldsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["action"] = this.action;
        data["method"] = this.method;
        data["enctype"] = this.enctype;
        data["key"] = this.key;
        data["Content-Type"] = this.contentType;
        data["Policy"] = this.policy;
        data["X-Amz-Credential"] = this.xAmzCredential;
        data["X-Amz-Algorithm"] = this.xAmzAlgorithm;
        data["X-Amz-Date"] = this.xAmzDate;
        data["X-Amz-Signature"] = this.xAmzSignature;
        data["X-Amz-Meta-object-type"] = this.xAmzMetaObjectType;
        data["X-Amz-Meta-client-guid"] = this.xAmzMetaClientGuid;
        data["X-Amz-Meta-chat-id"] = this.xAmzMetaChatId;
        return data;
    }
}

export interface IChatAvatarS3FormFieldsResponse {
    action?: string;
    method?: string;
    enctype?: string;
    key?: string;
    contentType?: string;
    policy?: string;
    xAmzCredential?: string;
    xAmzAlgorithm?: string;
    xAmzDate?: string;
    xAmzSignature?: string;
    xAmzMetaObjectType?: string;
    xAmzMetaClientGuid?: string;
    xAmzMetaChatId?: string;

    [key: string]: any;
}

export class DraftFileS3FormFieldsResponse implements IDraftFileS3FormFieldsResponse {
    action?: string;
    method?: string;
    enctype?: string;
    key?: string;
    contentType?: string;
    policy?: string;
    xAmzCredential?: string;
    xAmzAlgorithm?: string;
    xAmzDate?: string;
    xAmzSignature?: string;
    xAmzMetaObjectType?: string;
    xAmzMetaClientGuid?: string;
    xAmzMetaDraftId?: string;
    xAmzMetaQuestionId?: string;

    [key: string]: any;

    constructor(data?: IDraftFileS3FormFieldsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.action = _data["action"];
            this.method = _data["method"];
            this.enctype = _data["enctype"];
            this.key = _data["key"];
            this.contentType = _data["Content-Type"];
            this.policy = _data["Policy"];
            this.xAmzCredential = _data["X-Amz-Credential"];
            this.xAmzAlgorithm = _data["X-Amz-Algorithm"];
            this.xAmzDate = _data["X-Amz-Date"];
            this.xAmzSignature = _data["X-Amz-Signature"];
            this.xAmzMetaObjectType = _data["X-Amz-Meta-object-type"];
            this.xAmzMetaClientGuid = _data["X-Amz-Meta-client-guid"];
            this.xAmzMetaDraftId = _data["X-Amz-Meta-draft-id"];
            this.xAmzMetaQuestionId = _data["X-Amz-Meta-question-id"];
        }
    }

    static fromJS(data: any): DraftFileS3FormFieldsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DraftFileS3FormFieldsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["action"] = this.action;
        data["method"] = this.method;
        data["enctype"] = this.enctype;
        data["key"] = this.key;
        data["Content-Type"] = this.contentType;
        data["Policy"] = this.policy;
        data["X-Amz-Credential"] = this.xAmzCredential;
        data["X-Amz-Algorithm"] = this.xAmzAlgorithm;
        data["X-Amz-Date"] = this.xAmzDate;
        data["X-Amz-Signature"] = this.xAmzSignature;
        data["X-Amz-Meta-object-type"] = this.xAmzMetaObjectType;
        data["X-Amz-Meta-client-guid"] = this.xAmzMetaClientGuid;
        data["X-Amz-Meta-draft-id"] = this.xAmzMetaDraftId;
        data["X-Amz-Meta-question-id"] = this.xAmzMetaQuestionId;
        return data;
    }
}

export interface IDraftFileS3FormFieldsResponse {
    action?: string;
    method?: string;
    enctype?: string;
    key?: string;
    contentType?: string;
    policy?: string;
    xAmzCredential?: string;
    xAmzAlgorithm?: string;
    xAmzDate?: string;
    xAmzSignature?: string;
    xAmzMetaObjectType?: string;
    xAmzMetaClientGuid?: string;
    xAmzMetaDraftId?: string;
    xAmzMetaQuestionId?: string;

    [key: string]: any;
}

/** S3Helper */
export class ExtraWorkFileS3FormFieldsResponse implements IExtraWorkFileS3FormFieldsResponse {
    action?: string;
    method?: string;
    enctype?: string;
    key?: string;
    contentType?: string;
    policy?: string;
    xAmzCredential?: string;
    xAmzAlgorithm?: string;
    xAmzDate?: string;
    xAmzSignature?: string;
    xAmzMetaObjectType?: string;
    xAmzMetaClientGuid?: string;
    xAmzMetaExtraWorkId?: string;

    [key: string]: any;

    constructor(data?: IExtraWorkFileS3FormFieldsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.action = _data["action"];
            this.method = _data["method"];
            this.enctype = _data["enctype"];
            this.key = _data["key"];
            this.contentType = _data["Content-Type"];
            this.policy = _data["Policy"];
            this.xAmzCredential = _data["X-Amz-Credential"];
            this.xAmzAlgorithm = _data["X-Amz-Algorithm"];
            this.xAmzDate = _data["X-Amz-Date"];
            this.xAmzSignature = _data["X-Amz-Signature"];
            this.xAmzMetaObjectType = _data["X-Amz-Meta-object-type"];
            this.xAmzMetaClientGuid = _data["X-Amz-Meta-client-guid"];
            this.xAmzMetaExtraWorkId = _data["X-Amz-Meta-extra-work-id"];
        }
    }

    static fromJS(data: any): ExtraWorkFileS3FormFieldsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraWorkFileS3FormFieldsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["action"] = this.action;
        data["method"] = this.method;
        data["enctype"] = this.enctype;
        data["key"] = this.key;
        data["Content-Type"] = this.contentType;
        data["Policy"] = this.policy;
        data["X-Amz-Credential"] = this.xAmzCredential;
        data["X-Amz-Algorithm"] = this.xAmzAlgorithm;
        data["X-Amz-Date"] = this.xAmzDate;
        data["X-Amz-Signature"] = this.xAmzSignature;
        data["X-Amz-Meta-object-type"] = this.xAmzMetaObjectType;
        data["X-Amz-Meta-client-guid"] = this.xAmzMetaClientGuid;
        data["X-Amz-Meta-extra-work-id"] = this.xAmzMetaExtraWorkId;
        return data;
    }
}

/** S3Helper */
export interface IExtraWorkFileS3FormFieldsResponse {
    action?: string;
    method?: string;
    enctype?: string;
    key?: string;
    contentType?: string;
    policy?: string;
    xAmzCredential?: string;
    xAmzAlgorithm?: string;
    xAmzDate?: string;
    xAmzSignature?: string;
    xAmzMetaObjectType?: string;
    xAmzMetaClientGuid?: string;
    xAmzMetaExtraWorkId?: string;

    [key: string]: any;
}

export class AuthToken implements IAuthToken {
    access_token?: string;
    refresh_token?: string;
    token_type?: string;
    expires_in?: number;
    user?: UserResponse;

    [key: string]: any;

    constructor(data?: IAuthToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.access_token = _data["access_token"];
            this.refresh_token = _data["refresh_token"];
            this.token_type = _data["token_type"];
            this.expires_in = _data["expires_in"];
            this.user = _data["user"] ? UserResponse.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthToken {
        data = typeof data === 'object' ? data : {};
        let result = new AuthToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["access_token"] = this.access_token;
        data["refresh_token"] = this.refresh_token;
        data["token_type"] = this.token_type;
        data["expires_in"] = this.expires_in;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAuthToken {
    access_token?: string;
    refresh_token?: string;
    token_type?: string;
    expires_in?: number;
    user?: UserResponse;

    [key: string]: any;
}

export class CountryPhoneCodes implements ICountryPhoneCodes {
    default?: boolean;
    value?: string;
    name?: string;
    phone_code?: string;
    phone_length?: string;
    min_digits?: number;
    max_digits?: number;
    img?: string;

    [key: string]: any;

    constructor(data?: ICountryPhoneCodes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.default = _data["default"];
            this.value = _data["value"];
            this.name = _data["name"];
            this.phone_code = _data["phone_code"];
            this.phone_length = _data["phone_length"];
            this.min_digits = _data["min_digits"];
            this.max_digits = _data["max_digits"];
            this.img = _data["img"];
        }
    }

    static fromJS(data: any): CountryPhoneCodes {
        data = typeof data === 'object' ? data : {};
        let result = new CountryPhoneCodes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["default"] = this.default;
        data["value"] = this.value;
        data["name"] = this.name;
        data["phone_code"] = this.phone_code;
        data["phone_length"] = this.phone_length;
        data["min_digits"] = this.min_digits;
        data["max_digits"] = this.max_digits;
        data["img"] = this.img;
        return data;
    }
}

export interface ICountryPhoneCodes {
    default?: boolean;
    value?: string;
    name?: string;
    phone_code?: string;
    phone_length?: string;
    min_digits?: number;
    max_digits?: number;
    img?: string;

    [key: string]: any;
}

export class ChatForwardMessagesRequest implements IChatForwardMessagesRequest {
    source_chat_id!: number;
    message_ids!: string[];
    request_id!: string;

    [key: string]: any;

    constructor(data?: IChatForwardMessagesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.message_ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.source_chat_id = _data["source_chat_id"];
            if (Array.isArray(_data["message_ids"])) {
                this.message_ids = [] as any;
                for (let item of _data["message_ids"])
                    this.message_ids!.push(item);
            }
            this.request_id = _data["request_id"];
        }
    }

    static fromJS(data: any): ChatForwardMessagesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChatForwardMessagesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["source_chat_id"] = this.source_chat_id;
        if (Array.isArray(this.message_ids)) {
            data["message_ids"] = [];
            for (let item of this.message_ids)
                data["message_ids"].push(item);
        }
        data["request_id"] = this.request_id;
        return data;
    }
}

export interface IChatForwardMessagesRequest {
    source_chat_id: number;
    message_ids: string[];
    request_id: string;

    [key: string]: any;
}

export class ChatForwardedFromUserInfo implements IChatForwardedFromUserInfo {
    id?: number | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    nickname?: string | undefined;
    avatar?: any | undefined;
    role?: string | undefined;
    official?: boolean | undefined;

    [key: string]: any;

    constructor(data?: IChatForwardedFromUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.nickname = _data["nickname"];
            this.avatar = _data["avatar"];
            this.role = _data["role"];
            this.official = _data["official"];
        }
    }

    static fromJS(data: any): ChatForwardedFromUserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ChatForwardedFromUserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["nickname"] = this.nickname;
        data["avatar"] = this.avatar;
        data["role"] = this.role;
        data["official"] = this.official;
        return data;
    }
}

export interface IChatForwardedFromUserInfo {
    id?: number | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    nickname?: string | undefined;
    avatar?: any | undefined;
    role?: string | undefined;
    official?: boolean | undefined;

    [key: string]: any;
}

export class ChatForwardedFrom implements IChatForwardedFrom {
    from_id?: number | undefined;
    user_info?: ChatForwardedFromUserInfo | undefined;
    created_at?: Date | undefined;

    [key: string]: any;

    constructor(data?: IChatForwardedFrom) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.from_id = _data["from_id"];
            this.user_info = _data["user_info"] ? ChatForwardedFromUserInfo.fromJS(_data["user_info"]) : <any>undefined;
            this.created_at = _data["created_at"] ? new Date(_data["created_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatForwardedFrom {
        data = typeof data === 'object' ? data : {};
        let result = new ChatForwardedFrom();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["from_id"] = this.from_id;
        data["user_info"] = this.user_info ? this.user_info.toJSON() : <any>undefined;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        return data;
    }
}

export interface IChatForwardedFrom {
    from_id?: number | undefined;
    user_info?: ChatForwardedFromUserInfo | undefined;
    created_at?: Date | undefined;

    [key: string]: any;
}

export class ChatForwardedMessageData implements IChatForwardedMessageData {
    voice?: boolean | undefined;
    durationMs?: number | undefined;
    waveform?: number[] | undefined;
    quote?: any | undefined;
    mentions?: any[] | undefined;
    has_files?: boolean | undefined;
    forwarded_from?: ChatForwardedFrom;

    [key: string]: any;

    constructor(data?: IChatForwardedMessageData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.voice = _data["voice"];
            this.durationMs = _data["durationMs"];
            if (Array.isArray(_data["waveform"])) {
                this.waveform = [] as any;
                for (let item of _data["waveform"])
                    this.waveform!.push(item);
            }
            this.quote = _data["quote"];
            if (Array.isArray(_data["mentions"])) {
                this.mentions = [] as any;
                for (let item of _data["mentions"])
                    this.mentions!.push(item);
            }
            this.has_files = _data["has_files"];
            this.forwarded_from = _data["forwarded_from"] ? ChatForwardedFrom.fromJS(_data["forwarded_from"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatForwardedMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new ChatForwardedMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["voice"] = this.voice;
        data["durationMs"] = this.durationMs;
        if (Array.isArray(this.waveform)) {
            data["waveform"] = [];
            for (let item of this.waveform)
                data["waveform"].push(item);
        }
        data["quote"] = this.quote;
        if (Array.isArray(this.mentions)) {
            data["mentions"] = [];
            for (let item of this.mentions)
                data["mentions"].push(item);
        }
        data["has_files"] = this.has_files;
        data["forwarded_from"] = this.forwarded_from ? this.forwarded_from.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChatForwardedMessageData {
    voice?: boolean | undefined;
    durationMs?: number | undefined;
    waveform?: number[] | undefined;
    quote?: any | undefined;
    mentions?: any[] | undefined;
    has_files?: boolean | undefined;
    forwarded_from?: ChatForwardedFrom;

    [key: string]: any;
}

export class ChatForwardedMessage implements IChatForwardedMessage {
    _id?: string;
    chat_id?: number;
    from_id?: number | undefined;
    to_id?: number | undefined;
    reply_message_id?: string | undefined;
    type?: number;
    message?: string | undefined;
    guid?: string | undefined;
    room?: string | undefined;
    user_info?: any | undefined;
    readBy?: number[];
    readByAt?: any | undefined;
    data?: ChatForwardedMessageData | undefined;
    created_at?: Date | undefined;
    updated_at?: Date | undefined;
    files?: any[];
    filesLength?: number;

    [key: string]: any;

    constructor(data?: IChatForwardedMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this._id = _data["_id"];
            this.chat_id = _data["chat_id"];
            this.from_id = _data["from_id"];
            this.to_id = _data["to_id"];
            this.reply_message_id = _data["reply_message_id"];
            this.type = _data["type"];
            this.message = _data["message"];
            this.guid = _data["guid"];
            this.room = _data["room"];
            this.user_info = _data["user_info"];
            if (Array.isArray(_data["readBy"])) {
                this.readBy = [] as any;
                for (let item of _data["readBy"])
                    this.readBy!.push(item);
            }
            this.readByAt = _data["readByAt"];
            this.data = _data["data"] ? ChatForwardedMessageData.fromJS(_data["data"]) : <any>undefined;
            this.created_at = _data["created_at"] ? new Date(_data["created_at"].toString()) : <any>undefined;
            this.updated_at = _data["updated_at"] ? new Date(_data["updated_at"].toString()) : <any>undefined;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(item);
            }
            this.filesLength = _data["filesLength"];
        }
    }

    static fromJS(data: any): ChatForwardedMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ChatForwardedMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["_id"] = this._id;
        data["chat_id"] = this.chat_id;
        data["from_id"] = this.from_id;
        data["to_id"] = this.to_id;
        data["reply_message_id"] = this.reply_message_id;
        data["type"] = this.type;
        data["message"] = this.message;
        data["guid"] = this.guid;
        data["room"] = this.room;
        data["user_info"] = this.user_info;
        if (Array.isArray(this.readBy)) {
            data["readBy"] = [];
            for (let item of this.readBy)
                data["readBy"].push(item);
        }
        data["readByAt"] = this.readByAt;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        data["updated_at"] = this.updated_at ? this.updated_at.toISOString() : <any>undefined;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item);
        }
        data["filesLength"] = this.filesLength;
        return data;
    }
}

export interface IChatForwardedMessage {
    _id?: string;
    chat_id?: number;
    from_id?: number | undefined;
    to_id?: number | undefined;
    reply_message_id?: string | undefined;
    type?: number;
    message?: string | undefined;
    guid?: string | undefined;
    room?: string | undefined;
    user_info?: any | undefined;
    readBy?: number[];
    readByAt?: any | undefined;
    data?: ChatForwardedMessageData | undefined;
    created_at?: Date | undefined;
    updated_at?: Date | undefined;
    files?: any[];
    filesLength?: number;

    [key: string]: any;
}

export class ChatForwardMessagesResponse implements IChatForwardMessagesResponse {
    data?: Data;

    [key: string]: any;

    constructor(data?: IChatForwardMessagesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? Data.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatForwardMessagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChatForwardMessagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChatForwardMessagesResponse {
    data?: Data;

    [key: string]: any;
}

export class ChatEditMessageMention implements IChatEditMessageMention {
    id!: number;
    key!: string;
    name?: string | undefined;
    surname?: string | undefined;
    nickname?: string | undefined;

    [key: string]: any;

    constructor(data?: IChatEditMessageMention) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.key = _data["key"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.nickname = _data["nickname"];
        }
    }

    static fromJS(data: any): ChatEditMessageMention {
        data = typeof data === 'object' ? data : {};
        let result = new ChatEditMessageMention();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["key"] = this.key;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["nickname"] = this.nickname;
        return data;
    }
}

export interface IChatEditMessageMention {
    id: number;
    key: string;
    name?: string | undefined;
    surname?: string | undefined;
    nickname?: string | undefined;

    [key: string]: any;
}

export class ChatEditMessageRequestData implements IChatEditMessageRequestData {
    mentions?: ChatEditMessageMention[] | undefined;

    [key: string]: any;

    constructor(data?: IChatEditMessageRequestData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["mentions"])) {
                this.mentions = [] as any;
                for (let item of _data["mentions"])
                    this.mentions!.push(ChatEditMessageMention.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChatEditMessageRequestData {
        data = typeof data === 'object' ? data : {};
        let result = new ChatEditMessageRequestData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.mentions)) {
            data["mentions"] = [];
            for (let item of this.mentions)
                data["mentions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChatEditMessageRequestData {
    mentions?: ChatEditMessageMention[] | undefined;

    [key: string]: any;
}

export class ChatEditMessageRequest implements IChatEditMessageRequest {
    message_id!: string;
    message!: string;
    data?: ChatEditMessageRequestData | undefined;

    [key: string]: any;

    constructor(data?: IChatEditMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message_id = _data["message_id"];
            this.message = _data["message"];
            this.data = _data["data"] ? ChatEditMessageRequestData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatEditMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChatEditMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message_id"] = this.message_id;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChatEditMessageRequest {
    message_id: string;
    message: string;
    data?: ChatEditMessageRequestData | undefined;

    [key: string]: any;
}

export class ChatEditMessageData implements IChatEditMessageData {
    action?: string;
    chat_id?: number;
    message_id?: string;
    message?: string;
    data?: any | undefined;
    chat_preview?: Chat_preview | undefined;
    edited_at?: Date | undefined;
    updated_at?: Date | undefined;

    [key: string]: any;

    constructor(data?: IChatEditMessageData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.action = _data["action"];
            this.chat_id = _data["chat_id"];
            this.message_id = _data["message_id"];
            this.message = _data["message"];
            this.data = _data["data"];
            this.chat_preview = _data["chat_preview"] ? Chat_preview.fromJS(_data["chat_preview"]) : <any>undefined;
            this.edited_at = _data["edited_at"] ? new Date(_data["edited_at"].toString()) : <any>undefined;
            this.updated_at = _data["updated_at"] ? new Date(_data["updated_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatEditMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new ChatEditMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["action"] = this.action;
        data["chat_id"] = this.chat_id;
        data["message_id"] = this.message_id;
        data["message"] = this.message;
        data["data"] = this.data;
        data["chat_preview"] = this.chat_preview ? this.chat_preview.toJSON() : <any>undefined;
        data["edited_at"] = this.edited_at ? this.edited_at.toISOString() : <any>undefined;
        data["updated_at"] = this.updated_at ? this.updated_at.toISOString() : <any>undefined;
        return data;
    }
}

export interface IChatEditMessageData {
    action?: string;
    chat_id?: number;
    message_id?: string;
    message?: string;
    data?: any | undefined;
    chat_preview?: Chat_preview | undefined;
    edited_at?: Date | undefined;
    updated_at?: Date | undefined;

    [key: string]: any;
}

export class ChatEditMessageResponse implements IChatEditMessageResponse {
    data?: ChatEditMessageData;

    [key: string]: any;

    constructor(data?: IChatEditMessageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? ChatEditMessageData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatEditMessageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChatEditMessageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChatEditMessageResponse {
    data?: ChatEditMessageData;

    [key: string]: any;
}

export class MessageReactionUserEntry implements IMessageReactionUserEntry {
    user_id!: number;
    reacted_at?: Date | undefined;

    [key: string]: any;

    constructor(data?: IMessageReactionUserEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.user_id = _data["user_id"];
            this.reacted_at = _data["reacted_at"] ? new Date(_data["reacted_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MessageReactionUserEntry {
        data = typeof data === 'object' ? data : {};
        let result = new MessageReactionUserEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["user_id"] = this.user_id;
        data["reacted_at"] = this.reacted_at ? this.reacted_at.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMessageReactionUserEntry {
    user_id: number;
    reacted_at?: Date | undefined;

    [key: string]: any;
}

export class MessageReactionEntry implements IMessageReactionEntry {
    emoji!: string;
    user_ids!: number[];
    users?: MessageReactionUserEntry[] | undefined;

    [key: string]: any;

    constructor(data?: IMessageReactionEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user_ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.emoji = _data["emoji"];
            if (Array.isArray(_data["user_ids"])) {
                this.user_ids = [] as any;
                for (let item of _data["user_ids"])
                    this.user_ids!.push(item);
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(MessageReactionUserEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageReactionEntry {
        data = typeof data === 'object' ? data : {};
        let result = new MessageReactionEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["emoji"] = this.emoji;
        if (Array.isArray(this.user_ids)) {
            data["user_ids"] = [];
            for (let item of this.user_ids)
                data["user_ids"].push(item);
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMessageReactionEntry {
    emoji: string;
    user_ids: number[];
    users?: MessageReactionUserEntry[] | undefined;

    [key: string]: any;
}

export class ChatReactionMessageRequest implements IChatReactionMessageRequest {
    message_id!: string;
    reaction!: string;

    [key: string]: any;

    constructor(data?: IChatReactionMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message_id = _data["message_id"];
            this.reaction = _data["reaction"];
        }
    }

    static fromJS(data: any): ChatReactionMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChatReactionMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message_id"] = this.message_id;
        data["reaction"] = this.reaction;
        return data;
    }
}

export interface IChatReactionMessageRequest {
    message_id: string;
    reaction: string;

    [key: string]: any;
}

export class ChatReactionMessageDataBody implements IChatReactionMessageDataBody {

    [key: string]: any;

    constructor(data?: IChatReactionMessageDataBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): ChatReactionMessageDataBody {
        data = typeof data === 'object' ? data : {};
        let result = new ChatReactionMessageDataBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IChatReactionMessageDataBody {

    [key: string]: any;
}

export class ChatReactionMessageData implements IChatReactionMessageData {
    action?: string;
    chat_id?: number;
    message_id?: string;
    data?: ChatReactionMessageDataBody | undefined;
    updated_at?: Date | undefined;

    [key: string]: any;

    constructor(data?: IChatReactionMessageData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.action = _data["action"];
            this.chat_id = _data["chat_id"];
            this.message_id = _data["message_id"];
            this.data = _data["data"] ? ChatReactionMessageDataBody.fromJS(_data["data"]) : <any>undefined;
            this.updated_at = _data["updated_at"] ? new Date(_data["updated_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatReactionMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new ChatReactionMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["action"] = this.action;
        data["chat_id"] = this.chat_id;
        data["message_id"] = this.message_id;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["updated_at"] = this.updated_at ? this.updated_at.toISOString() : <any>undefined;
        return data;
    }
}

export interface IChatReactionMessageData {
    action?: string;
    chat_id?: number;
    message_id?: string;
    data?: ChatReactionMessageDataBody | undefined;
    updated_at?: Date | undefined;

    [key: string]: any;
}

export class ChatReactionMessageResponse implements IChatReactionMessageResponse {
    data?: ChatReactionMessageData;

    [key: string]: any;

    constructor(data?: IChatReactionMessageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? ChatReactionMessageData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatReactionMessageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChatReactionMessageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChatReactionMessageResponse {
    data?: ChatReactionMessageData;

    [key: string]: any;
}

export class ChatDeleteMessagesRequest implements IChatDeleteMessagesRequest {
    message_ids!: string[];
    /** Delete scope. Use 'me' to hide messages only for current user. Use 'everyone' only when every selected message can be deleted for everyone. */
    scope?: ChatDeleteMessagesRequestScope | undefined;

    [key: string]: any;

    constructor(data?: IChatDeleteMessagesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.message_ids = [];
            this.scope = ChatDeleteMessagesRequestScope.Everyone;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["message_ids"])) {
                this.message_ids = [] as any;
                for (let item of _data["message_ids"])
                    this.message_ids!.push(item);
            }
            this.scope = _data["scope"] !== undefined ? _data["scope"] : ChatDeleteMessagesRequestScope.Everyone;
        }
    }

    static fromJS(data: any): ChatDeleteMessagesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChatDeleteMessagesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.message_ids)) {
            data["message_ids"] = [];
            for (let item of this.message_ids)
                data["message_ids"].push(item);
        }
        data["scope"] = this.scope;
        return data;
    }
}

export interface IChatDeleteMessagesRequest {
    message_ids: string[];
    /** Delete scope. Use 'me' to hide messages only for current user. Use 'everyone' only when every selected message can be deleted for everyone. */
    scope?: ChatDeleteMessagesRequestScope | undefined;

    [key: string]: any;
}

export class ErrorDto implements IErrorDto {
    message?: string;
    errors?: Errors;

    [key: string]: any;

    constructor(data?: IErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface IErrorDto {
    message?: string;
    errors?: Errors;

    [key: string]: any;
}

export class Message implements IMessage {
    message?: string;

    [key: string]: any;

    constructor(data?: IMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): Message {
        data = typeof data === 'object' ? data : {};
        let result = new Message();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        return data;
    }
}

export interface IMessage {
    message?: string;

    [key: string]: any;
}

export class Validation implements IValidation {
    attribute?: string;
    key?: string;

    [key: string]: any;

    constructor(data?: IValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.attribute = _data["attribute"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): Validation {
        data = typeof data === 'object' ? data : {};
        let result = new Validation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["attribute"] = this.attribute;
        data["key"] = this.key;
        return data;
    }
}

export interface IValidation {
    attribute?: string;
    key?: string;

    [key: string]: any;
}

export class ValidationValues implements IValidationValues {
    attribute?: string;
    key?: string;
    values?: string;

    [key: string]: any;

    constructor(data?: IValidationValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.attribute = _data["attribute"];
            this.key = _data["key"];
            this.values = _data["values"];
        }
    }

    static fromJS(data: any): ValidationValues {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["attribute"] = this.attribute;
        data["key"] = this.key;
        data["values"] = this.values;
        return data;
    }
}

export interface IValidationValues {
    attribute?: string;
    key?: string;
    values?: string;

    [key: string]: any;
}

export class ValidationMax implements IValidationMax {
    attribute?: string;
    key?: string;
    max?: string;

    [key: string]: any;

    constructor(data?: IValidationMax) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.attribute = _data["attribute"];
            this.key = _data["key"];
            this.max = _data["max"];
        }
    }

    static fromJS(data: any): ValidationMax {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationMax();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["attribute"] = this.attribute;
        data["key"] = this.key;
        data["max"] = this.max;
        return data;
    }
}

export interface IValidationMax {
    attribute?: string;
    key?: string;
    max?: string;

    [key: string]: any;
}

export class CoordinateCheckStatusResponse implements ICoordinateCheckStatusResponse {
    status?: number;
    deviceId?: number;

    [key: string]: any;

    constructor(data?: ICoordinateCheckStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.status = _data["status"];
            this.deviceId = _data["deviceId"];
        }
    }

    static fromJS(data: any): CoordinateCheckStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinateCheckStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["status"] = this.status;
        data["deviceId"] = this.deviceId;
        return data;
    }
}

export interface ICoordinateCheckStatusResponse {
    status?: number;
    deviceId?: number;

    [key: string]: any;
}

export class LangResponse implements ILangResponse {
    id?: number;
    name?: string;
    locale?: string;

    [key: string]: any;

    constructor(data?: ILangResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.locale = _data["locale"];
        }
    }

    static fromJS(data: any): LangResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LangResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["locale"] = this.locale;
        return data;
    }
}

export interface ILangResponse {
    id?: number;
    name?: string;
    locale?: string;

    [key: string]: any;
}

export class PaymentIntent implements IPaymentIntent {
    client_secret?: string;
    amount?: string;
    currency?: string;
    id?: string;
    gateway?: string;

    [key: string]: any;

    constructor(data?: IPaymentIntent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.client_secret = _data["client_secret"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.id = _data["id"];
            this.gateway = _data["gateway"];
        }
    }

    static fromJS(data: any): PaymentIntent {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentIntent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["client_secret"] = this.client_secret;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["id"] = this.id;
        data["gateway"] = this.gateway;
        return data;
    }
}

export interface IPaymentIntent {
    client_secret?: string;
    amount?: string;
    currency?: string;
    id?: string;
    gateway?: string;

    [key: string]: any;
}

export class StripeConnect implements IStripeConnect {
    account?: any;
    link?: Link;

    [key: string]: any;

    constructor(data?: IStripeConnect) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.account = _data["account"];
            this.link = _data["link"] ? Link.fromJS(_data["link"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StripeConnect {
        data = typeof data === 'object' ? data : {};
        let result = new StripeConnect();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["account"] = this.account;
        data["link"] = this.link ? this.link.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStripeConnect {
    account?: any;
    link?: Link;

    [key: string]: any;
}

export class OnboardingCountyCodes implements IOnboardingCountyCodes {
    default?: boolean;
    value?: string;
    name?: string;
    phone_code?: string;
    phone_length?: string;
    min_digits?: number;
    max_digits?: number;
    url?: string;

    [key: string]: any;

    constructor(data?: IOnboardingCountyCodes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.default = _data["default"];
            this.value = _data["value"];
            this.name = _data["name"];
            this.phone_code = _data["phone_code"];
            this.phone_length = _data["phone_length"];
            this.min_digits = _data["min_digits"];
            this.max_digits = _data["max_digits"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): OnboardingCountyCodes {
        data = typeof data === 'object' ? data : {};
        let result = new OnboardingCountyCodes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["default"] = this.default;
        data["value"] = this.value;
        data["name"] = this.name;
        data["phone_code"] = this.phone_code;
        data["phone_length"] = this.phone_length;
        data["min_digits"] = this.min_digits;
        data["max_digits"] = this.max_digits;
        data["url"] = this.url;
        return data;
    }
}

export interface IOnboardingCountyCodes {
    default?: boolean;
    value?: string;
    name?: string;
    phone_code?: string;
    phone_length?: string;
    min_digits?: number;
    max_digits?: number;
    url?: string;

    [key: string]: any;
}

export class PaymentMethodResponse implements IPaymentMethodResponse {
    id?: string;
    last4?: string;

    [key: string]: any;

    constructor(data?: IPaymentMethodResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.last4 = _data["last4"];
        }
    }

    static fromJS(data: any): PaymentMethodResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["last4"] = this.last4;
        return data;
    }
}

export interface IPaymentMethodResponse {
    id?: string;
    last4?: string;

    [key: string]: any;
}

export class PaymentMethodDataResponse implements IPaymentMethodDataResponse {
    data?: PaymentMethodResponse[];

    [key: string]: any;

    constructor(data?: IPaymentMethodDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PaymentMethodResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaymentMethodDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaymentMethodDataResponse {
    data?: PaymentMethodResponse[];

    [key: string]: any;
}

export class Fee implements IFee {
    fee?: string;

    [key: string]: any;

    constructor(data?: IFee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.fee = _data["fee"];
        }
    }

    static fromJS(data: any): Fee {
        data = typeof data === 'object' ? data : {};
        let result = new Fee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["fee"] = this.fee;
        return data;
    }
}

export interface IFee {
    fee?: string;

    [key: string]: any;
}

export class AuthorizeResponse implements IAuthorizeResponse {
    id?: string;
    last4?: string;

    [key: string]: any;

    constructor(data?: IAuthorizeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.last4 = _data["last4"];
        }
    }

    static fromJS(data: any): AuthorizeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["last4"] = this.last4;
        return data;
    }
}

export interface IAuthorizeResponse {
    id?: string;
    last4?: string;

    [key: string]: any;
}

export class CaptureResponse implements ICaptureResponse {
    id?: string;
    last4?: string;

    [key: string]: any;

    constructor(data?: ICaptureResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.last4 = _data["last4"];
        }
    }

    static fromJS(data: any): CaptureResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaptureResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["last4"] = this.last4;
        return data;
    }
}

export interface ICaptureResponse {
    id?: string;
    last4?: string;

    [key: string]: any;
}

export class VersionResponse implements IVersionResponse {
    version?: string;
    minimal_working_version?: string;

    [key: string]: any;

    constructor(data?: IVersionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.version = _data["version"];
            this.minimal_working_version = _data["minimal_working_version"];
        }
    }

    static fromJS(data: any): VersionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VersionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["version"] = this.version;
        data["minimal_working_version"] = this.minimal_working_version;
        return data;
    }
}

export interface IVersionResponse {
    version?: string;
    minimal_working_version?: string;

    [key: string]: any;
}

export class VideosIndexResponse implements IVideosIndexResponse {
    data?: StreamExtendedResource[];

    [key: string]: any;

    constructor(data?: IVideosIndexResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StreamExtendedResource.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VideosIndexResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VideosIndexResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVideosIndexResponse {
    data?: StreamExtendedResource[];

    [key: string]: any;
}

export class YoomoneyResponse implements IYoomoneyResponse {
    id?: number;
    filter_id?: number;
    text?: string;
    filter?: FilterShortResponse;

    [key: string]: any;

    constructor(data?: IYoomoneyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.filter_id = _data["filter_id"];
            this.text = _data["text"];
            this.filter = _data["filter"] ? FilterShortResponse.fromJS(_data["filter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): YoomoneyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new YoomoneyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["filter_id"] = this.filter_id;
        data["text"] = this.text;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IYoomoneyResponse {
    id?: number;
    filter_id?: number;
    text?: string;
    filter?: FilterShortResponse;

    [key: string]: any;
}

export class UpdateChatNotificationSettingsRequest implements IUpdateChatNotificationSettingsRequest {
    /** Mute notifications until this datetime. Set to null to unmute. */
    muted_until?: Date | undefined;

    [key: string]: any;

    constructor(data?: IUpdateChatNotificationSettingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.muted_until = _data["muted_until"] ? new Date(_data["muted_until"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateChatNotificationSettingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateChatNotificationSettingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["muted_until"] = this.muted_until ? this.muted_until.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateChatNotificationSettingsRequest {
    /** Mute notifications until this datetime. Set to null to unmute. */
    muted_until?: Date | undefined;

    [key: string]: any;
}

export class ContentActionRequest implements IContentActionRequest {
    temp_token?: string;
    content_id?: number;
    content_type?: ContentActionRequestContent_type;
    action?: ContentActionRequestAction;

    [key: string]: any;

    constructor(data?: IContentActionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.temp_token = _data["temp_token"];
            this.content_id = _data["content_id"];
            this.content_type = _data["content_type"];
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): ContentActionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContentActionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["temp_token"] = this.temp_token;
        data["content_id"] = this.content_id;
        data["content_type"] = this.content_type;
        data["action"] = this.action;
        return data;
    }
}

export interface IContentActionRequest {
    temp_token?: string;
    content_id?: number;
    content_type?: ContentActionRequestContent_type;
    action?: ContentActionRequestAction;

    [key: string]: any;
}

export class ContentCommentRequest implements IContentCommentRequest {
    content_id?: number;
    content_type?: ContentCommentRequestContent_type;
    comment?: string;
    parent_id?: number | undefined;

    [key: string]: any;

    constructor(data?: IContentCommentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.content_id = _data["content_id"];
            this.content_type = _data["content_type"];
            this.comment = _data["comment"];
            this.parent_id = _data["parent_id"];
        }
    }

    static fromJS(data: any): ContentCommentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContentCommentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["content_id"] = this.content_id;
        data["content_type"] = this.content_type;
        data["comment"] = this.comment;
        data["parent_id"] = this.parent_id;
        return data;
    }
}

export interface IContentCommentRequest {
    content_id?: number;
    content_type?: ContentCommentRequestContent_type;
    comment?: string;
    parent_id?: number | undefined;

    [key: string]: any;
}

export class NotifyStreamerRequest implements INotifyStreamerRequest {
    message?: string;

    [key: string]: any;

    constructor(data?: INotifyStreamerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): NotifyStreamerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NotifyStreamerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        return data;
    }
}

export interface INotifyStreamerRequest {
    message?: string;

    [key: string]: any;
}

export class SendNotificationRequest implements ISendNotificationRequest {
    /** Array of user IDs to send notifications to */
    user_ids!: number[];
    /** Translation key for notification body text */
    body_text_key!: string;
    /** Translation key for notification title text */
    title_text_key!: string;
    /** Optional URL to attach to the notification */
    url?: string;
    /** Optional metadata as key-value pairs */
    meta?: any;
    /** Optional icon identifier for the notification */
    icon?: string;
    /** Optional HTML content for the notification */
    html_data?: string;

    [key: string]: any;

    constructor(data?: ISendNotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user_ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["user_ids"])) {
                this.user_ids = [] as any;
                for (let item of _data["user_ids"])
                    this.user_ids!.push(item);
            }
            this.body_text_key = _data["body_text_key"];
            this.title_text_key = _data["title_text_key"];
            this.url = _data["url"];
            this.meta = _data["meta"];
            this.icon = _data["icon"];
            this.html_data = _data["html_data"];
        }
    }

    static fromJS(data: any): SendNotificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendNotificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.user_ids)) {
            data["user_ids"] = [];
            for (let item of this.user_ids)
                data["user_ids"].push(item);
        }
        data["body_text_key"] = this.body_text_key;
        data["title_text_key"] = this.title_text_key;
        data["url"] = this.url;
        data["meta"] = this.meta;
        data["icon"] = this.icon;
        data["html_data"] = this.html_data;
        return data;
    }
}

export interface ISendNotificationRequest {
    /** Array of user IDs to send notifications to */
    user_ids: number[];
    /** Translation key for notification body text */
    body_text_key: string;
    /** Translation key for notification title text */
    title_text_key: string;
    /** Optional URL to attach to the notification */
    url?: string;
    /** Optional metadata as key-value pairs */
    meta?: any;
    /** Optional icon identifier for the notification */
    icon?: string;
    /** Optional HTML content for the notification */
    html_data?: string;

    [key: string]: any;
}

export class SendNotificationError implements ISendNotificationError {
    message?: string;
    errors?: Errors2;

    [key: string]: any;

    constructor(data?: ISendNotificationError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors2.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SendNotificationError {
        data = typeof data === 'object' ? data : {};
        let result = new SendNotificationError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISendNotificationError {
    message?: string;
    errors?: Errors2;

    [key: string]: any;
}

export class SetUserPushSettingsRequest implements ISetUserPushSettingsRequest {
    pushType?: SetUserPushSettingsRequestPushType;
    active?: boolean;

    [key: string]: any;

    constructor(data?: ISetUserPushSettingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.pushType = _data["pushType"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): SetUserPushSettingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserPushSettingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["pushType"] = this.pushType;
        data["active"] = this.active;
        return data;
    }
}

export interface ISetUserPushSettingsRequest {
    pushType?: SetUserPushSettingsRequestPushType;
    active?: boolean;

    [key: string]: any;
}

export class SetUserSettingsRequest implements ISetUserSettingsRequest {
    only_followers?: boolean;

    [key: string]: any;

    constructor(data?: ISetUserSettingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.only_followers = _data["only_followers"];
        }
    }

    static fromJS(data: any): SetUserSettingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserSettingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["only_followers"] = this.only_followers;
        return data;
    }
}

export interface ISetUserSettingsRequest {
    only_followers?: boolean;

    [key: string]: any;
}

export class StoreUserLocationRequest implements IStoreUserLocationRequest {
    long?: number;
    lat?: number;
    source?: StoreUserLocationRequestSource;

    [key: string]: any;

    constructor(data?: IStoreUserLocationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.long = _data["long"];
            this.lat = _data["lat"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): StoreUserLocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StoreUserLocationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["long"] = this.long;
        data["lat"] = this.lat;
        data["source"] = this.source;
        return data;
    }
}

export interface IStoreUserLocationRequest {
    long?: number;
    lat?: number;
    source?: StoreUserLocationRequestSource;

    [key: string]: any;
}

export class UpdateVideoLocationRequest implements IUpdateVideoLocationRequest {
    /** Longitude */
    long!: number;
    /** Latitude */
    lat!: number;
    location_source?: UpdateVideoLocationRequestLocation_source;

    [key: string]: any;

    constructor(data?: IUpdateVideoLocationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.long = _data["long"];
            this.lat = _data["lat"];
            this.location_source = _data["location_source"];
        }
    }

    static fromJS(data: any): UpdateVideoLocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVideoLocationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["long"] = this.long;
        data["lat"] = this.lat;
        data["location_source"] = this.location_source;
        return data;
    }
}

export interface IUpdateVideoLocationRequest {
    /** Longitude */
    long: number;
    /** Latitude */
    lat: number;
    location_source?: UpdateVideoLocationRequestLocation_source;

    [key: string]: any;
}

export class UserBulkRequest implements IUserBulkRequest {
    /** User IDs */
    ids!: number[];

    [key: string]: any;

    constructor(data?: IUserBulkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): UserBulkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserBulkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IUserBulkRequest {
    /** User IDs */
    ids: number[];

    [key: string]: any;
}

export class UserContentSubscriptionRequest implements IUserContentSubscriptionRequest {
    subscription_type?: UserContentSubscriptionRequestSubscription_type;
    action?: UserContentSubscriptionRequestAction;
    author_user_id?: number;
    subscription_id?: number | undefined;

    [key: string]: any;

    constructor(data?: IUserContentSubscriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.subscription_type = _data["subscription_type"];
            this.action = _data["action"];
            this.author_user_id = _data["author_user_id"];
            this.subscription_id = _data["subscription_id"];
        }
    }

    static fromJS(data: any): UserContentSubscriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserContentSubscriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["subscription_type"] = this.subscription_type;
        data["action"] = this.action;
        data["author_user_id"] = this.author_user_id;
        data["subscription_id"] = this.subscription_id;
        return data;
    }
}

export interface IUserContentSubscriptionRequest {
    subscription_type?: UserContentSubscriptionRequestSubscription_type;
    action?: UserContentSubscriptionRequestAction;
    author_user_id?: number;
    subscription_id?: number | undefined;

    [key: string]: any;
}

export class VisitDataRequest implements IVisitDataRequest {
    temp_token?: string;
    device?: string;
    app_version?: string;
    resolution?: string;

    [key: string]: any;

    constructor(data?: IVisitDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.temp_token = _data["temp_token"];
            this.device = _data["device"];
            this.app_version = _data["app_version"];
            this.resolution = _data["resolution"];
        }
    }

    static fromJS(data: any): VisitDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VisitDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["temp_token"] = this.temp_token;
        data["device"] = this.device;
        data["app_version"] = this.app_version;
        data["resolution"] = this.resolution;
        return data;
    }
}

export interface IVisitDataRequest {
    temp_token?: string;
    device?: string;
    app_version?: string;
    resolution?: string;

    [key: string]: any;
}

export class WalletTransferPaymentIntentCreateRequest implements IWalletTransferPaymentIntentCreateRequest {
    recipient_user_id!: number;
    chat_id?: number | undefined;
    amount_base_units!: string;
    idempotency_key!: string;

    [key: string]: any;

    constructor(data?: IWalletTransferPaymentIntentCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.recipient_user_id = _data["recipient_user_id"];
            this.chat_id = _data["chat_id"];
            this.amount_base_units = _data["amount_base_units"];
            this.idempotency_key = _data["idempotency_key"];
        }
    }

    static fromJS(data: any): WalletTransferPaymentIntentCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WalletTransferPaymentIntentCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["recipient_user_id"] = this.recipient_user_id;
        data["chat_id"] = this.chat_id;
        data["amount_base_units"] = this.amount_base_units;
        data["idempotency_key"] = this.idempotency_key;
        return data;
    }
}

export interface IWalletTransferPaymentIntentCreateRequest {
    recipient_user_id: number;
    chat_id?: number | undefined;
    amount_base_units: string;
    idempotency_key: string;

    [key: string]: any;
}

export class WalletTransferPaymentIntentSubmitRequest implements IWalletTransferPaymentIntentSubmitRequest {
    signed_transaction_base64!: string;

    [key: string]: any;

    constructor(data?: IWalletTransferPaymentIntentSubmitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.signed_transaction_base64 = _data["signed_transaction_base64"];
        }
    }

    static fromJS(data: any): WalletTransferPaymentIntentSubmitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WalletTransferPaymentIntentSubmitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["signed_transaction_base64"] = this.signed_transaction_base64;
        return data;
    }
}

export interface IWalletTransferPaymentIntentSubmitRequest {
    signed_transaction_base64: string;

    [key: string]: any;
}

export class AvatarOrderResponse implements IAvatarOrderResponse {
    id?: number;
    from_id?: number;
    to_id?: number;
    type?: number;
    status?: number;
    is_allow_control_movement?: boolean;
    is_allow_front_camera?: boolean;
    front_camera_price?: number;
    rate?: number;
    time?: number;
    realTime?: number;
    price?: number;
    fee?: number;
    description?: string;
    date_from_at?: string;
    date_to_at?: string;
    dates?: AvatarOrderDateResponse[];
    from?: AvatarResponse;
    to?: AvatarResponse;
    coordinates?: AvatarOrderLocation;
    video_id?: number;

    [key: string]: any;

    constructor(data?: IAvatarOrderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.from_id = _data["from_id"];
            this.to_id = _data["to_id"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.is_allow_control_movement = _data["is_allow_control_movement"];
            this.is_allow_front_camera = _data["is_allow_front_camera"];
            this.front_camera_price = _data["front_camera_price"];
            this.rate = _data["rate"];
            this.time = _data["time"];
            this.realTime = _data["realTime"];
            this.price = _data["price"];
            this.fee = _data["fee"];
            this.description = _data["description"];
            this.date_from_at = _data["date_from_at"];
            this.date_to_at = _data["date_to_at"];
            if (Array.isArray(_data["dates"])) {
                this.dates = [] as any;
                for (let item of _data["dates"])
                    this.dates!.push(AvatarOrderDateResponse.fromJS(item));
            }
            this.from = _data["from"] ? AvatarResponse.fromJS(_data["from"]) : <any>undefined;
            this.to = _data["to"] ? AvatarResponse.fromJS(_data["to"]) : <any>undefined;
            this.coordinates = _data["coordinates"] ? AvatarOrderLocation.fromJS(_data["coordinates"]) : <any>undefined;
            this.video_id = _data["video_id"];
        }
    }

    static fromJS(data: any): AvatarOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AvatarOrderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["from_id"] = this.from_id;
        data["to_id"] = this.to_id;
        data["type"] = this.type;
        data["status"] = this.status;
        data["is_allow_control_movement"] = this.is_allow_control_movement;
        data["is_allow_front_camera"] = this.is_allow_front_camera;
        data["front_camera_price"] = this.front_camera_price;
        data["rate"] = this.rate;
        data["time"] = this.time;
        data["realTime"] = this.realTime;
        data["price"] = this.price;
        data["fee"] = this.fee;
        data["description"] = this.description;
        data["date_from_at"] = this.date_from_at;
        data["date_to_at"] = this.date_to_at;
        if (Array.isArray(this.dates)) {
            data["dates"] = [];
            for (let item of this.dates)
                data["dates"].push(item.toJSON());
        }
        data["from"] = this.from ? this.from.toJSON() : <any>undefined;
        data["to"] = this.to ? this.to.toJSON() : <any>undefined;
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : <any>undefined;
        data["video_id"] = this.video_id;
        return data;
    }
}

export interface IAvatarOrderResponse {
    id?: number;
    from_id?: number;
    to_id?: number;
    type?: number;
    status?: number;
    is_allow_control_movement?: boolean;
    is_allow_front_camera?: boolean;
    front_camera_price?: number;
    rate?: number;
    time?: number;
    realTime?: number;
    price?: number;
    fee?: number;
    description?: string;
    date_from_at?: string;
    date_to_at?: string;
    dates?: AvatarOrderDateResponse[];
    from?: AvatarResponse;
    to?: AvatarResponse;
    coordinates?: AvatarOrderLocation;
    video_id?: number;

    [key: string]: any;
}

export class CaptchaResource implements ICaptchaResource {
    sensitive?: boolean;
    key?: string;
    img?: string;

    [key: string]: any;

    constructor(data?: ICaptchaResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.sensitive = _data["sensitive"];
            this.key = _data["key"];
            this.img = _data["img"];
        }
    }

    static fromJS(data: any): CaptchaResource {
        data = typeof data === 'object' ? data : {};
        let result = new CaptchaResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["sensitive"] = this.sensitive;
        data["key"] = this.key;
        data["img"] = this.img;
        return data;
    }
}

export interface ICaptchaResource {
    sensitive?: boolean;
    key?: string;
    img?: string;

    [key: string]: any;
}

export class CommentsCollection implements ICommentsCollection {
    data?: ContentCommentResource[];
    meta?: Meta;

    [key: string]: any;

    constructor(data?: ICommentsCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ContentCommentResource.fromJS(item));
            }
            this.meta = _data["meta"] ? Meta.fromJS(_data["meta"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CommentsCollection {
        data = typeof data === 'object' ? data : {};
        let result = new CommentsCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICommentsCollection {
    data?: ContentCommentResource[];
    meta?: Meta;

    [key: string]: any;
}

export class ContentCommentResource implements IContentCommentResource {
    id?: number;
    text?: string;
    parent_id?: number | undefined;
    user?: UserMinimalResource;
    created_at?: string;

    [key: string]: any;

    constructor(data?: IContentCommentResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.text = _data["text"];
            this.parent_id = _data["parent_id"];
            this.user = _data["user"] ? UserMinimalResource.fromJS(_data["user"]) : <any>undefined;
            this.created_at = _data["created_at"];
        }
    }

    static fromJS(data: any): ContentCommentResource {
        data = typeof data === 'object' ? data : {};
        let result = new ContentCommentResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["text"] = this.text;
        data["parent_id"] = this.parent_id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["created_at"] = this.created_at;
        return data;
    }
}

export interface IContentCommentResource {
    id?: number;
    text?: string;
    parent_id?: number | undefined;
    user?: UserMinimalResource;
    created_at?: string;

    [key: string]: any;
}

export class CoordinateResponse implements ICoordinateResponse {
    _id?: string;
    location?: Location;
    status?: number;
    rate?: number;
    description?: string;
    front_camera_price?: number;
    is_allow_control_movement?: boolean;
    is_allow_front_camera?: boolean;
    is_allow_free_mode?: boolean;
    phone_model?: string;
    time?: number;
    user?: AvatarResponse;
    streams?: StreamResource[];
    user_videos_count?: number;

    [key: string]: any;

    constructor(data?: ICoordinateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this._id = _data["_id"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.status = _data["status"];
            this.rate = _data["rate"];
            this.description = _data["description"];
            this.front_camera_price = _data["front_camera_price"];
            this.is_allow_control_movement = _data["is_allow_control_movement"];
            this.is_allow_front_camera = _data["is_allow_front_camera"];
            this.is_allow_free_mode = _data["is_allow_free_mode"];
            this.phone_model = _data["phone_model"];
            this.time = _data["time"];
            this.user = _data["user"] ? AvatarResponse.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["streams"])) {
                this.streams = [] as any;
                for (let item of _data["streams"])
                    this.streams!.push(StreamResource.fromJS(item));
            }
            this.user_videos_count = _data["user_videos_count"];
        }
    }

    static fromJS(data: any): CoordinateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["_id"] = this._id;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["rate"] = this.rate;
        data["description"] = this.description;
        data["front_camera_price"] = this.front_camera_price;
        data["is_allow_control_movement"] = this.is_allow_control_movement;
        data["is_allow_front_camera"] = this.is_allow_front_camera;
        data["is_allow_free_mode"] = this.is_allow_free_mode;
        data["phone_model"] = this.phone_model;
        data["time"] = this.time;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.streams)) {
            data["streams"] = [];
            for (let item of this.streams)
                data["streams"].push(item.toJSON());
        }
        data["user_videos_count"] = this.user_videos_count;
        return data;
    }
}

export interface ICoordinateResponse {
    _id?: string;
    location?: Location;
    status?: number;
    rate?: number;
    description?: string;
    front_camera_price?: number;
    is_allow_control_movement?: boolean;
    is_allow_front_camera?: boolean;
    is_allow_free_mode?: boolean;
    phone_model?: string;
    time?: number;
    user?: AvatarResponse;
    streams?: StreamResource[];
    user_videos_count?: number;

    [key: string]: any;
}

export class MarkerShortResource implements IMarkerShortResource {
    id?: number;
    name?: string;
    surname?: string;
    status?: number;
    avatar?: string;
    location?: Location;
    official?: boolean;

    [key: string]: any;

    constructor(data?: IMarkerShortResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.status = _data["status"];
            this.avatar = _data["avatar"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.official = _data["official"];
        }
    }

    static fromJS(data: any): MarkerShortResource {
        data = typeof data === 'object' ? data : {};
        let result = new MarkerShortResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["status"] = this.status;
        data["avatar"] = this.avatar;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["official"] = this.official;
        return data;
    }
}

export interface IMarkerShortResource {
    id?: number;
    name?: string;
    surname?: string;
    status?: number;
    avatar?: string;
    location?: Location;
    official?: boolean;

    [key: string]: any;
}

/** Resource of Stream */
export class StreamExtendedResource implements IStreamExtendedResource {
    user?: UserMinimalResource;
    video_id?: number;
    live?: boolean;
    date?: Date;
    video?: VideoResource;
    location?: Location;
    my_reaction?: string;
    place?: string;
    /** Source of location: 'gps', 'ip' for IP-based (less accurate) */
    location_source?: StreamExtendedResourceLocation_source;
    i_watched?: boolean;
    i_subscribed?: boolean;
    user_videos_count?: number;
    name?: string;
    description?: string;
    comments_count?: number;
    is_avatar_order?: boolean;

    [key: string]: any;

    constructor(data?: IStreamExtendedResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.user = _data["user"] ? UserMinimalResource.fromJS(_data["user"]) : <any>undefined;
            this.video_id = _data["video_id"];
            this.live = _data["live"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.video = _data["video"] ? VideoResource.fromJS(_data["video"]) : <any>undefined;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.my_reaction = _data["my_reaction"];
            this.place = _data["place"];
            this.location_source = _data["location_source"];
            this.i_watched = _data["i_watched"];
            this.i_subscribed = _data["i_subscribed"];
            this.user_videos_count = _data["user_videos_count"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.comments_count = _data["comments_count"];
            this.is_avatar_order = _data["is_avatar_order"];
        }
    }

    static fromJS(data: any): StreamExtendedResource {
        data = typeof data === 'object' ? data : {};
        let result = new StreamExtendedResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["video_id"] = this.video_id;
        data["live"] = this.live;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["video"] = this.video ? this.video.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["my_reaction"] = this.my_reaction;
        data["place"] = this.place;
        data["location_source"] = this.location_source;
        data["i_watched"] = this.i_watched;
        data["i_subscribed"] = this.i_subscribed;
        data["user_videos_count"] = this.user_videos_count;
        data["name"] = this.name;
        data["description"] = this.description;
        data["comments_count"] = this.comments_count;
        data["is_avatar_order"] = this.is_avatar_order;
        return data;
    }
}

/** Resource of Stream */
export interface IStreamExtendedResource {
    user?: UserMinimalResource;
    video_id?: number;
    live?: boolean;
    date?: Date;
    video?: VideoResource;
    location?: Location;
    my_reaction?: string;
    place?: string;
    /** Source of location: 'gps', 'ip' for IP-based (less accurate) */
    location_source?: StreamExtendedResourceLocation_source;
    i_watched?: boolean;
    i_subscribed?: boolean;
    user_videos_count?: number;
    name?: string;
    description?: string;
    comments_count?: number;
    is_avatar_order?: boolean;

    [key: string]: any;
}

export class StreamResource implements IStreamResource {
    video_id?: number;
    date?: Date;
    location?: Location;
    live?: boolean;

    [key: string]: any;

    constructor(data?: IStreamResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.video_id = _data["video_id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.live = _data["live"];
        }
    }

    static fromJS(data: any): StreamResource {
        data = typeof data === 'object' ? data : {};
        let result = new StreamResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["video_id"] = this.video_id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["live"] = this.live;
        return data;
    }
}

export interface IStreamResource {
    video_id?: number;
    date?: Date;
    location?: Location;
    live?: boolean;

    [key: string]: any;
}

export class StreamsCollection implements IStreamsCollection {
    data?: StreamExtendedResource[];
    meta?: Meta2;

    [key: string]: any;

    constructor(data?: IStreamsCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StreamExtendedResource.fromJS(item));
            }
            this.meta = _data["meta"] ? Meta2.fromJS(_data["meta"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StreamsCollection {
        data = typeof data === 'object' ? data : {};
        let result = new StreamsCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStreamsCollection {
    data?: StreamExtendedResource[];
    meta?: Meta2;

    [key: string]: any;
}

export class UserChatProfileCollection implements IUserChatProfileCollection {
    data?: UserChatProfileResource[];

    [key: string]: any;

    constructor(data?: IUserChatProfileCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserChatProfileResource.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserChatProfileCollection {
        data = typeof data === 'object' ? data : {};
        let result = new UserChatProfileCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserChatProfileCollection {
    data?: UserChatProfileResource[];

    [key: string]: any;
}

export class UserChatProfileResource implements IUserChatProfileResource {
    id?: number;
    name?: string;
    surname?: string;
    avatar?: FileResponse;
    official?: boolean;

    [key: string]: any;

    constructor(data?: IUserChatProfileResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.avatar = _data["avatar"] ? FileResponse.fromJS(_data["avatar"]) : <any>undefined;
            this.official = _data["official"];
        }
    }

    static fromJS(data: any): UserChatProfileResource {
        data = typeof data === 'object' ? data : {};
        let result = new UserChatProfileResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["avatar"] = this.avatar ? this.avatar.toJSON() : <any>undefined;
        data["official"] = this.official;
        return data;
    }
}

export interface IUserChatProfileResource {
    id?: number;
    name?: string;
    surname?: string;
    avatar?: FileResponse;
    official?: boolean;

    [key: string]: any;
}

/** A resource representing a user's content subscription */
export class UserContentSubscriptionResource implements IUserContentSubscriptionResource {
    id?: number;
    type_id?: number;
    radius_meters?: number;
    created_at?: Date;
    subscriber_user_id?: number;
    author_user_id?: number;
    active?: boolean;
    authorResource?: UserResponse;

    [key: string]: any;

    constructor(data?: IUserContentSubscriptionResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.type_id = _data["type_id"];
            this.radius_meters = _data["radius_meters"];
            this.created_at = _data["created_at"] ? new Date(_data["created_at"].toString()) : <any>undefined;
            this.subscriber_user_id = _data["subscriber_user_id"];
            this.author_user_id = _data["author_user_id"];
            this.active = _data["active"];
            this.authorResource = _data["authorResource"] ? UserResponse.fromJS(_data["authorResource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserContentSubscriptionResource {
        data = typeof data === 'object' ? data : {};
        let result = new UserContentSubscriptionResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["type_id"] = this.type_id;
        data["radius_meters"] = this.radius_meters;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        data["subscriber_user_id"] = this.subscriber_user_id;
        data["author_user_id"] = this.author_user_id;
        data["active"] = this.active;
        data["authorResource"] = this.authorResource ? this.authorResource.toJSON() : <any>undefined;
        return data;
    }
}

/** A resource representing a user's content subscription */
export interface IUserContentSubscriptionResource {
    id?: number;
    type_id?: number;
    radius_meters?: number;
    created_at?: Date;
    subscriber_user_id?: number;
    author_user_id?: number;
    active?: boolean;
    authorResource?: UserResponse;

    [key: string]: any;
}

export class UserMinimalCollection implements IUserMinimalCollection {
    data?: UserMinimalResource[];

    [key: string]: any;

    constructor(data?: IUserMinimalCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserMinimalResource.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserMinimalCollection {
        data = typeof data === 'object' ? data : {};
        let result = new UserMinimalCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserMinimalCollection {
    data?: UserMinimalResource[];

    [key: string]: any;
}

export class UserMinimalResource implements IUserMinimalResource {
    id?: number;
    name?: string;
    surname?: string;
    nickname?: string | undefined;
    avatar?: FileResponse;
    is_subscribed_back?: boolean;
    only_followers?: boolean;
    official?: boolean;

    [key: string]: any;

    constructor(data?: IUserMinimalResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.nickname = _data["nickname"];
            this.avatar = _data["avatar"] ? FileResponse.fromJS(_data["avatar"]) : <any>undefined;
            this.is_subscribed_back = _data["is_subscribed_back"];
            this.only_followers = _data["only_followers"];
            this.official = _data["official"];
        }
    }

    static fromJS(data: any): UserMinimalResource {
        data = typeof data === 'object' ? data : {};
        let result = new UserMinimalResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["nickname"] = this.nickname;
        data["avatar"] = this.avatar ? this.avatar.toJSON() : <any>undefined;
        data["is_subscribed_back"] = this.is_subscribed_back;
        data["only_followers"] = this.only_followers;
        data["official"] = this.official;
        return data;
    }
}

export interface IUserMinimalResource {
    id?: number;
    name?: string;
    surname?: string;
    nickname?: string | undefined;
    avatar?: FileResponse;
    is_subscribed_back?: boolean;
    only_followers?: boolean;
    official?: boolean;

    [key: string]: any;
}

export class UserPushSettingItem implements IUserPushSettingItem {
    pushType?: string;
    active?: boolean;

    [key: string]: any;

    constructor(data?: IUserPushSettingItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.pushType = _data["pushType"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): UserPushSettingItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserPushSettingItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["pushType"] = this.pushType;
        data["active"] = this.active;
        return data;
    }
}

export interface IUserPushSettingItem {
    pushType?: string;
    active?: boolean;

    [key: string]: any;
}

export class UserPushSettingsResource implements IUserPushSettingsResource {
    data?: UserPushSettingItem[];

    [key: string]: any;

    constructor(data?: IUserPushSettingsResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserPushSettingItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserPushSettingsResource {
        data = typeof data === 'object' ? data : {};
        let result = new UserPushSettingsResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserPushSettingsResource {
    data?: UserPushSettingItem[];

    [key: string]: any;
}

export class UserSettingsResource implements IUserSettingsResource {
    only_followers?: boolean;

    [key: string]: any;

    constructor(data?: IUserSettingsResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.only_followers = _data["only_followers"];
        }
    }

    static fromJS(data: any): UserSettingsResource {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettingsResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["only_followers"] = this.only_followers;
        return data;
    }
}

export interface IUserSettingsResource {
    only_followers?: boolean;

    [key: string]: any;
}

export class UserTinyResource implements IUserTinyResource {
    name?: string;
    surname?: string;
    official?: boolean;
    avatar?: FileResponse;

    [key: string]: any;

    constructor(data?: IUserTinyResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.official = _data["official"];
            this.avatar = _data["avatar"] ? FileResponse.fromJS(_data["avatar"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserTinyResource {
        data = typeof data === 'object' ? data : {};
        let result = new UserTinyResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["official"] = this.official;
        data["avatar"] = this.avatar ? this.avatar.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserTinyResource {
    name?: string;
    surname?: string;
    official?: boolean;
    avatar?: FileResponse;

    [key: string]: any;
}

export class VideoResource implements IVideoResource {
    id?: number;
    likes?: number;
    dislikes?: number;
    watches?: number;
    comments_count?: number;

    [key: string]: any;

    constructor(data?: IVideoResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.likes = _data["likes"];
            this.dislikes = _data["dislikes"];
            this.watches = _data["watches"];
            this.comments_count = _data["comments_count"];
        }
    }

    static fromJS(data: any): VideoResource {
        data = typeof data === 'object' ? data : {};
        let result = new VideoResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["likes"] = this.likes;
        data["dislikes"] = this.dislikes;
        data["watches"] = this.watches;
        data["comments_count"] = this.comments_count;
        return data;
    }
}

export interface IVideoResource {
    id?: number;
    likes?: number;
    dislikes?: number;
    watches?: number;
    comments_count?: number;

    [key: string]: any;
}

export class WalletTransactionResponse implements IWalletTransactionResponse {
    id!: string;
    direction!: WalletTransactionResponseDirection;
    status!: WalletTransactionResponseStatus;
    sender_user_id!: number;
    recipient_user_id!: number;
    counterparty_user!: WalletTransferRecipientResponse | undefined;
    amount_base_units!: string;
    fee_amount_base_units!: string;
    fee_sponsored!: boolean;
    mint_address!: string;
    decimals!: number;
    signature!: string | undefined;
    created_at!: Date | undefined;
    updated_at!: Date | undefined;
    submitted_at!: Date | undefined;
    finalized_at!: Date | undefined;
    transaction_at!: Date | undefined;

    [key: string]: any;

    constructor(data?: IWalletTransactionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.direction = _data["direction"];
            this.status = _data["status"];
            this.sender_user_id = _data["sender_user_id"];
            this.recipient_user_id = _data["recipient_user_id"];
            this.counterparty_user = _data["counterparty_user"] ? WalletTransferRecipientResponse.fromJS(_data["counterparty_user"]) : <any>undefined;
            this.amount_base_units = _data["amount_base_units"];
            this.fee_amount_base_units = _data["fee_amount_base_units"];
            this.fee_sponsored = _data["fee_sponsored"];
            this.mint_address = _data["mint_address"];
            this.decimals = _data["decimals"];
            this.signature = _data["signature"];
            this.created_at = _data["created_at"] ? new Date(_data["created_at"].toString()) : <any>undefined;
            this.updated_at = _data["updated_at"] ? new Date(_data["updated_at"].toString()) : <any>undefined;
            this.submitted_at = _data["submitted_at"] ? new Date(_data["submitted_at"].toString()) : <any>undefined;
            this.finalized_at = _data["finalized_at"] ? new Date(_data["finalized_at"].toString()) : <any>undefined;
            this.transaction_at = _data["transaction_at"] ? new Date(_data["transaction_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WalletTransactionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WalletTransactionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["direction"] = this.direction;
        data["status"] = this.status;
        data["sender_user_id"] = this.sender_user_id;
        data["recipient_user_id"] = this.recipient_user_id;
        data["counterparty_user"] = this.counterparty_user ? this.counterparty_user.toJSON() : <any>undefined;
        data["amount_base_units"] = this.amount_base_units;
        data["fee_amount_base_units"] = this.fee_amount_base_units;
        data["fee_sponsored"] = this.fee_sponsored;
        data["mint_address"] = this.mint_address;
        data["decimals"] = this.decimals;
        data["signature"] = this.signature;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        data["updated_at"] = this.updated_at ? this.updated_at.toISOString() : <any>undefined;
        data["submitted_at"] = this.submitted_at ? this.submitted_at.toISOString() : <any>undefined;
        data["finalized_at"] = this.finalized_at ? this.finalized_at.toISOString() : <any>undefined;
        data["transaction_at"] = this.transaction_at ? this.transaction_at.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWalletTransactionResponse {
    id: string;
    direction: WalletTransactionResponseDirection;
    status: WalletTransactionResponseStatus;
    sender_user_id: number;
    recipient_user_id: number;
    counterparty_user: WalletTransferRecipientResponse | undefined;
    amount_base_units: string;
    fee_amount_base_units: string;
    fee_sponsored: boolean;
    mint_address: string;
    decimals: number;
    signature: string | undefined;
    created_at: Date | undefined;
    updated_at: Date | undefined;
    submitted_at: Date | undefined;
    finalized_at: Date | undefined;
    transaction_at: Date | undefined;

    [key: string]: any;
}

export class WalletTransactionPage implements IWalletTransactionPage {
    items!: WalletTransactionResponse[];
    next_cursor!: string | undefined;

    [key: string]: any;

    constructor(data?: IWalletTransactionPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WalletTransactionResponse.fromJS(item));
            }
            this.next_cursor = _data["next_cursor"];
        }
    }

    static fromJS(data: any): WalletTransactionPage {
        data = typeof data === 'object' ? data : {};
        let result = new WalletTransactionPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["next_cursor"] = this.next_cursor;
        return data;
    }
}

export interface IWalletTransactionPage {
    items: WalletTransactionResponse[];
    next_cursor: string | undefined;

    [key: string]: any;
}

export class WalletTransactionPageDataResponse implements IWalletTransactionPageDataResponse {
    data!: WalletTransactionPage;

    [key: string]: any;

    constructor(data?: IWalletTransactionPageDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = new WalletTransactionPage();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? WalletTransactionPage.fromJS(_data["data"]) : new WalletTransactionPage();
        }
    }

    static fromJS(data: any): WalletTransactionPageDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WalletTransactionPageDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWalletTransactionPageDataResponse {
    data: WalletTransactionPage;

    [key: string]: any;
}

export enum WalletTransferPaymentIntentStatus {
    Prepared = "prepared",
    Submitted = "submitted",
    Finalized = "finalized",
    Failed = "failed",
    Expired = "expired",
}

export class WalletTransferPaymentIntentResponse implements IWalletTransferPaymentIntentResponse {
    id!: string;
    status!: WalletTransferPaymentIntentStatus;
    solana_cluster!: WalletTransferPaymentIntentResponseSolana_cluster;
    token_program_address!: string;
    fee_payer_address!: string;
    sender_wallet_address!: string;
    recipient_wallet_address!: string;
    sender_user_id!: number;
    recipient_user_id!: number;
    amount_base_units!: string;
    fee_recipient_address!: string | undefined;
    fee_amount_base_units!: string;
    fee_sponsored!: boolean;
    network_fee_lamports!: string | undefined;
    pjm_usd_price!: string | undefined;
    sol_usd_price!: string | undefined;
    mint_address!: string;
    decimals!: number;
    memo!: string;
    unsigned_transaction_base64!: string;
    recent_blockhash!: string | undefined;
    last_valid_block_height!: string | undefined;
    message_hash!: string;
    signature!: string | undefined;
    failure_reason!: string | undefined;
    created_at!: Date | undefined;
    updated_at!: Date | undefined;
    submitted_at!: Date | undefined;
    finalized_at!: Date | undefined;
    recipient!: WalletTransferRecipientResponse | undefined;

    [key: string]: any;

    constructor(data?: IWalletTransferPaymentIntentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.status = _data["status"];
            this.solana_cluster = _data["solana_cluster"];
            this.token_program_address = _data["token_program_address"];
            this.fee_payer_address = _data["fee_payer_address"];
            this.sender_wallet_address = _data["sender_wallet_address"];
            this.recipient_wallet_address = _data["recipient_wallet_address"];
            this.sender_user_id = _data["sender_user_id"];
            this.recipient_user_id = _data["recipient_user_id"];
            this.amount_base_units = _data["amount_base_units"];
            this.fee_recipient_address = _data["fee_recipient_address"];
            this.fee_amount_base_units = _data["fee_amount_base_units"];
            this.fee_sponsored = _data["fee_sponsored"];
            this.network_fee_lamports = _data["network_fee_lamports"];
            this.pjm_usd_price = _data["pjm_usd_price"];
            this.sol_usd_price = _data["sol_usd_price"];
            this.mint_address = _data["mint_address"];
            this.decimals = _data["decimals"];
            this.memo = _data["memo"];
            this.unsigned_transaction_base64 = _data["unsigned_transaction_base64"];
            this.recent_blockhash = _data["recent_blockhash"];
            this.last_valid_block_height = _data["last_valid_block_height"];
            this.message_hash = _data["message_hash"];
            this.signature = _data["signature"];
            this.failure_reason = _data["failure_reason"];
            this.created_at = _data["created_at"] ? new Date(_data["created_at"].toString()) : <any>undefined;
            this.updated_at = _data["updated_at"] ? new Date(_data["updated_at"].toString()) : <any>undefined;
            this.submitted_at = _data["submitted_at"] ? new Date(_data["submitted_at"].toString()) : <any>undefined;
            this.finalized_at = _data["finalized_at"] ? new Date(_data["finalized_at"].toString()) : <any>undefined;
            this.recipient = _data["recipient"] ? WalletTransferRecipientResponse.fromJS(_data["recipient"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WalletTransferPaymentIntentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WalletTransferPaymentIntentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["status"] = this.status;
        data["solana_cluster"] = this.solana_cluster;
        data["token_program_address"] = this.token_program_address;
        data["fee_payer_address"] = this.fee_payer_address;
        data["sender_wallet_address"] = this.sender_wallet_address;
        data["recipient_wallet_address"] = this.recipient_wallet_address;
        data["sender_user_id"] = this.sender_user_id;
        data["recipient_user_id"] = this.recipient_user_id;
        data["amount_base_units"] = this.amount_base_units;
        data["fee_recipient_address"] = this.fee_recipient_address;
        data["fee_amount_base_units"] = this.fee_amount_base_units;
        data["fee_sponsored"] = this.fee_sponsored;
        data["network_fee_lamports"] = this.network_fee_lamports;
        data["pjm_usd_price"] = this.pjm_usd_price;
        data["sol_usd_price"] = this.sol_usd_price;
        data["mint_address"] = this.mint_address;
        data["decimals"] = this.decimals;
        data["memo"] = this.memo;
        data["unsigned_transaction_base64"] = this.unsigned_transaction_base64;
        data["recent_blockhash"] = this.recent_blockhash;
        data["last_valid_block_height"] = this.last_valid_block_height;
        data["message_hash"] = this.message_hash;
        data["signature"] = this.signature;
        data["failure_reason"] = this.failure_reason;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        data["updated_at"] = this.updated_at ? this.updated_at.toISOString() : <any>undefined;
        data["submitted_at"] = this.submitted_at ? this.submitted_at.toISOString() : <any>undefined;
        data["finalized_at"] = this.finalized_at ? this.finalized_at.toISOString() : <any>undefined;
        data["recipient"] = this.recipient ? this.recipient.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWalletTransferPaymentIntentResponse {
    id: string;
    status: WalletTransferPaymentIntentStatus;
    solana_cluster: WalletTransferPaymentIntentResponseSolana_cluster;
    token_program_address: string;
    fee_payer_address: string;
    sender_wallet_address: string;
    recipient_wallet_address: string;
    sender_user_id: number;
    recipient_user_id: number;
    amount_base_units: string;
    fee_recipient_address: string | undefined;
    fee_amount_base_units: string;
    fee_sponsored: boolean;
    network_fee_lamports: string | undefined;
    pjm_usd_price: string | undefined;
    sol_usd_price: string | undefined;
    mint_address: string;
    decimals: number;
    memo: string;
    unsigned_transaction_base64: string;
    recent_blockhash: string | undefined;
    last_valid_block_height: string | undefined;
    message_hash: string;
    signature: string | undefined;
    failure_reason: string | undefined;
    created_at: Date | undefined;
    updated_at: Date | undefined;
    submitted_at: Date | undefined;
    finalized_at: Date | undefined;
    recipient: WalletTransferRecipientResponse | undefined;

    [key: string]: any;
}

export class WalletTransferPaymentIntentDataResponse implements IWalletTransferPaymentIntentDataResponse {
    data!: WalletTransferPaymentIntentResponse;

    [key: string]: any;

    constructor(data?: IWalletTransferPaymentIntentDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = new WalletTransferPaymentIntentResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? WalletTransferPaymentIntentResponse.fromJS(_data["data"]) : new WalletTransferPaymentIntentResponse();
        }
    }

    static fromJS(data: any): WalletTransferPaymentIntentDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WalletTransferPaymentIntentDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWalletTransferPaymentIntentDataResponse {
    data: WalletTransferPaymentIntentResponse;

    [key: string]: any;
}

export class WalletTransferRecipientResponse implements IWalletTransferRecipientResponse {
    id!: number;
    name!: string;
    surname!: string;
    nickname!: string | undefined;
    avatar!: FileResponse;
    is_subscribed_back!: boolean;
    only_followers!: boolean;
    official!: boolean;
    has_wallet!: boolean;

    [key: string]: any;

    constructor(data?: IWalletTransferRecipientResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.avatar = new FileResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.nickname = _data["nickname"];
            this.avatar = _data["avatar"] ? FileResponse.fromJS(_data["avatar"]) : new FileResponse();
            this.is_subscribed_back = _data["is_subscribed_back"];
            this.only_followers = _data["only_followers"];
            this.official = _data["official"];
            this.has_wallet = _data["has_wallet"];
        }
    }

    static fromJS(data: any): WalletTransferRecipientResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WalletTransferRecipientResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["nickname"] = this.nickname;
        data["avatar"] = this.avatar ? this.avatar.toJSON() : <any>undefined;
        data["is_subscribed_back"] = this.is_subscribed_back;
        data["only_followers"] = this.only_followers;
        data["official"] = this.official;
        data["has_wallet"] = this.has_wallet;
        return data;
    }
}

export interface IWalletTransferRecipientResponse {
    id: number;
    name: string;
    surname: string;
    nickname: string | undefined;
    avatar: FileResponse;
    is_subscribed_back: boolean;
    only_followers: boolean;
    official: boolean;
    has_wallet: boolean;

    [key: string]: any;
}

export class WalletTransferRecipientCollection implements IWalletTransferRecipientCollection {
    data!: WalletTransferRecipientResponse[];

    [key: string]: any;

    constructor(data?: IWalletTransferRecipientCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(WalletTransferRecipientResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WalletTransferRecipientCollection {
        data = typeof data === 'object' ? data : {};
        let result = new WalletTransferRecipientCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWalletTransferRecipientCollection {
    data: WalletTransferRecipientResponse[];

    [key: string]: any;
}

export class WalletTransferRecipientDataResponse implements IWalletTransferRecipientDataResponse {
    data!: WalletTransferRecipientResponse;

    [key: string]: any;

    constructor(data?: IWalletTransferRecipientDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = new WalletTransferRecipientResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? WalletTransferRecipientResponse.fromJS(_data["data"]) : new WalletTransferRecipientResponse();
        }
    }

    static fromJS(data: any): WalletTransferRecipientDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WalletTransferRecipientDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWalletTransferRecipientDataResponse {
    data: WalletTransferRecipientResponse;

    [key: string]: any;
}

export class WorldStreamCollection implements IWorldStreamCollection {
    data?: WorldStreamResource[];

    [key: string]: any;

    constructor(data?: IWorldStreamCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(WorldStreamResource.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorldStreamCollection {
        data = typeof data === 'object' ? data : {};
        let result = new WorldStreamCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWorldStreamCollection {
    data?: WorldStreamResource[];

    [key: string]: any;
}

/** Resource of Stream */
export class WorldStreamResource implements IWorldStreamResource {
    user?: UserTinyResource;
    video_id?: number;
    author_id?: number;
    live?: boolean;
    live_viewers?: number | undefined;
    actions?: VideoResource;
    name?: string;
    description?: string;
    location?: string | undefined;
    location_coordinates?: Location;
    place?: string | undefined;
    /** Source of location: 'gps, 'ip' for IP-based (less accurate) */
    location_source?: WorldStreamResourceLocation_source;
    my_actions?: My_actions;

    [key: string]: any;

    constructor(data?: IWorldStreamResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.user = _data["user"] ? UserTinyResource.fromJS(_data["user"]) : <any>undefined;
            this.video_id = _data["video_id"];
            this.author_id = _data["author_id"];
            this.live = _data["live"];
            this.live_viewers = _data["live_viewers"];
            this.actions = _data["actions"] ? VideoResource.fromJS(_data["actions"]) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.location = _data["location"];
            this.location_coordinates = _data["location_coordinates"] ? Location.fromJS(_data["location_coordinates"]) : <any>undefined;
            this.place = _data["place"];
            this.location_source = _data["location_source"];
            this.my_actions = _data["my_actions"] ? My_actions.fromJS(_data["my_actions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorldStreamResource {
        data = typeof data === 'object' ? data : {};
        let result = new WorldStreamResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["video_id"] = this.video_id;
        data["author_id"] = this.author_id;
        data["live"] = this.live;
        data["live_viewers"] = this.live_viewers;
        data["actions"] = this.actions ? this.actions.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["location"] = this.location;
        data["location_coordinates"] = this.location_coordinates ? this.location_coordinates.toJSON() : <any>undefined;
        data["place"] = this.place;
        data["location_source"] = this.location_source;
        data["my_actions"] = this.my_actions ? this.my_actions.toJSON() : <any>undefined;
        return data;
    }
}

/** Resource of Stream */
export interface IWorldStreamResource {
    user?: UserTinyResource;
    video_id?: number;
    author_id?: number;
    live?: boolean;
    live_viewers?: number | undefined;
    actions?: VideoResource;
    name?: string;
    description?: string;
    location?: string | undefined;
    location_coordinates?: Location;
    place?: string | undefined;
    /** Source of location: 'gps, 'ip' for IP-based (less accurate) */
    location_source?: WorldStreamResourceLocation_source;
    my_actions?: My_actions;

    [key: string]: any;
}

export class AnswersRequest implements IAnswersRequest {
    next_question_id?: number;
    text_answer?: string;
    extra_message?: string;

    [key: string]: any;

    constructor(data?: IAnswersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.next_question_id = _data["next_question_id"];
            this.text_answer = _data["text_answer"];
            this.extra_message = _data["extra_message"];
        }
    }

    static fromJS(data: any): AnswersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AnswersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["next_question_id"] = this.next_question_id;
        data["text_answer"] = this.text_answer;
        data["extra_message"] = this.extra_message;
        return data;
    }
}

export interface IAnswersRequest {
    next_question_id?: number;
    text_answer?: string;
    extra_message?: string;

    [key: string]: any;
}

/** Answer model */
export class AnswersResponse implements IAnswersResponse {
    id?: number;
    question_id?: number;
    next_question_id?: number;
    text_answer?: string;
    extra_message?: string;
    frequency?: number;
    next_question?: QuestionShortResponse;

    [key: string]: any;

    constructor(data?: IAnswersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.question_id = _data["question_id"];
            this.next_question_id = _data["next_question_id"];
            this.text_answer = _data["text_answer"];
            this.extra_message = _data["extra_message"];
            this.frequency = _data["frequency"];
            this.next_question = _data["next_question"] ? QuestionShortResponse.fromJS(_data["next_question"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AnswersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AnswersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["question_id"] = this.question_id;
        data["next_question_id"] = this.next_question_id;
        data["text_answer"] = this.text_answer;
        data["extra_message"] = this.extra_message;
        data["frequency"] = this.frequency;
        data["next_question"] = this.next_question ? this.next_question.toJSON() : <any>undefined;
        return data;
    }
}

/** Answer model */
export interface IAnswersResponse {
    id?: number;
    question_id?: number;
    next_question_id?: number;
    text_answer?: string;
    extra_message?: string;
    frequency?: number;
    next_question?: QuestionShortResponse;

    [key: string]: any;
}

export class AvatarOrderRequest implements IAvatarOrderRequest {
    to_id?: number;
    type?: number;
    description?: string;
    is_shared?: boolean;
    date_from_at?: string;
    date_to_at?: string;

    [key: string]: any;

    constructor(data?: IAvatarOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.to_id = _data["to_id"];
            this.type = _data["type"];
            this.description = _data["description"];
            this.is_shared = _data["is_shared"];
            this.date_from_at = _data["date_from_at"];
            this.date_to_at = _data["date_to_at"];
        }
    }

    static fromJS(data: any): AvatarOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AvatarOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["to_id"] = this.to_id;
        data["type"] = this.type;
        data["description"] = this.description;
        data["is_shared"] = this.is_shared;
        data["date_from_at"] = this.date_from_at;
        data["date_to_at"] = this.date_to_at;
        return data;
    }
}

export interface IAvatarOrderRequest {
    to_id?: number;
    type?: number;
    description?: string;
    is_shared?: boolean;
    date_from_at?: string;
    date_to_at?: string;

    [key: string]: any;
}

export class AvatarOrderUpdateRequest implements IAvatarOrderUpdateRequest {
    description?: string;

    [key: string]: any;

    constructor(data?: IAvatarOrderUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AvatarOrderUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AvatarOrderUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["description"] = this.description;
        return data;
    }
}

export interface IAvatarOrderUpdateRequest {
    description?: string;

    [key: string]: any;
}

export class AvatarOrderDataResponse implements IAvatarOrderDataResponse {
    data?: AvatarOrderResponse;

    [key: string]: any;

    constructor(data?: IAvatarOrderDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? AvatarOrderResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AvatarOrderDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AvatarOrderDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAvatarOrderDataResponse {
    data?: AvatarOrderResponse;

    [key: string]: any;
}

export class AvatarOrdersDataResponse implements IAvatarOrdersDataResponse {
    data?: AvatarOrderResponse[];

    [key: string]: any;

    constructor(data?: IAvatarOrdersDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AvatarOrderResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AvatarOrdersDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AvatarOrdersDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAvatarOrdersDataResponse {
    data?: AvatarOrderResponse[];

    [key: string]: any;
}

export class AvatarOrderError implements IAvatarOrderError {
    message?: string;
    errors?: Errors3;

    [key: string]: any;

    constructor(data?: IAvatarOrderError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors3.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AvatarOrderError {
        data = typeof data === 'object' ? data : {};
        let result = new AvatarOrderError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAvatarOrderError {
    message?: string;
    errors?: Errors3;

    [key: string]: any;
}

/** AvatarOrder model */
export class AvatarOrderUpdateError implements IAvatarOrderUpdateError {
    message?: string;
    errors?: Errors4;

    [key: string]: any;

    constructor(data?: IAvatarOrderUpdateError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors4.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AvatarOrderUpdateError {
        data = typeof data === 'object' ? data : {};
        let result = new AvatarOrderUpdateError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

/** AvatarOrder model */
export interface IAvatarOrderUpdateError {
    message?: string;
    errors?: Errors4;

    [key: string]: any;
}

/** AvatarOrderDate model */
export class AvatarOrderDateResponse implements IAvatarOrderDateResponse {
    id?: number;
    real_date_from_at?: string;
    real_date_to_at?: string;

    [key: string]: any;

    constructor(data?: IAvatarOrderDateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.real_date_from_at = _data["real_date_from_at"];
            this.real_date_to_at = _data["real_date_to_at"];
        }
    }

    static fromJS(data: any): AvatarOrderDateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AvatarOrderDateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["real_date_from_at"] = this.real_date_from_at;
        data["real_date_to_at"] = this.real_date_to_at;
        return data;
    }
}

/** AvatarOrderDate model */
export interface IAvatarOrderDateResponse {
    id?: number;
    real_date_from_at?: string;
    real_date_to_at?: string;

    [key: string]: any;
}

export class AvatarOrderLocation implements IAvatarOrderLocation {
    lng?: number;
    lat?: number;

    [key: string]: any;

    constructor(data?: IAvatarOrderLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.lng = _data["lng"];
            this.lat = _data["lat"];
        }
    }

    static fromJS(data: any): AvatarOrderLocation {
        data = typeof data === 'object' ? data : {};
        let result = new AvatarOrderLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["lng"] = this.lng;
        data["lat"] = this.lat;
        return data;
    }
}

export interface IAvatarOrderLocation {
    lng?: number;
    lat?: number;

    [key: string]: any;
}

export class BanRequest implements IBanRequest {
    user_id?: number;
    type?: number;
    reason?: string;
    date?: string;

    [key: string]: any;

    constructor(data?: IBanRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.user_id = _data["user_id"];
            this.type = _data["type"];
            this.reason = _data["reason"];
            this.date = _data["date"];
        }
    }

    static fromJS(data: any): BanRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BanRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["user_id"] = this.user_id;
        data["type"] = this.type;
        data["reason"] = this.reason;
        data["date"] = this.date;
        return data;
    }
}

export interface IBanRequest {
    user_id?: number;
    type?: number;
    reason?: string;
    date?: string;

    [key: string]: any;
}

export class BanUpdateRequest implements IBanUpdateRequest {
    type?: number;
    reason?: string;
    date?: string;

    [key: string]: any;

    constructor(data?: IBanUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.reason = _data["reason"];
            this.date = _data["date"];
        }
    }

    static fromJS(data: any): BanUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BanUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["reason"] = this.reason;
        data["date"] = this.date;
        return data;
    }
}

export interface IBanUpdateRequest {
    type?: number;
    reason?: string;
    date?: string;

    [key: string]: any;
}

export class BanDataResponse implements IBanDataResponse {
    data?: BanResponse;

    [key: string]: any;

    constructor(data?: IBanDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? BanResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BanDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BanDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBanDataResponse {
    data?: BanResponse;

    [key: string]: any;
}

export class BansDataResponse implements IBansDataResponse {
    data?: BanResponse[];

    [key: string]: any;

    constructor(data?: IBansDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(BanResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BansDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BansDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBansDataResponse {
    data?: BanResponse[];

    [key: string]: any;
}

export class BanResponse implements IBanResponse {
    id?: number;
    user_id?: number;
    type?: number;
    reason?: string;
    date?: string;

    [key: string]: any;

    constructor(data?: IBanResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.user_id = _data["user_id"];
            this.type = _data["type"];
            this.reason = _data["reason"];
            this.date = _data["date"];
        }
    }

    static fromJS(data: any): BanResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BanResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["user_id"] = this.user_id;
        data["type"] = this.type;
        data["reason"] = this.reason;
        data["date"] = this.date;
        return data;
    }
}

export interface IBanResponse {
    id?: number;
    user_id?: number;
    type?: number;
    reason?: string;
    date?: string;

    [key: string]: any;
}

export class BanShortResponse implements IBanShortResponse {
    type?: number;
    reason?: string;
    date?: string;

    [key: string]: any;

    constructor(data?: IBanShortResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.reason = _data["reason"];
            this.date = _data["date"];
        }
    }

    static fromJS(data: any): BanShortResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BanShortResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["reason"] = this.reason;
        data["date"] = this.date;
        return data;
    }
}

export interface IBanShortResponse {
    type?: number;
    reason?: string;
    date?: string;

    [key: string]: any;
}

export class BanError implements IBanError {
    message?: string;
    errors?: Errors5;

    [key: string]: any;

    constructor(data?: IBanError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors5.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BanError {
        data = typeof data === 'object' ? data : {};
        let result = new BanError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBanError {
    message?: string;
    errors?: Errors5;

    [key: string]: any;
}

/** Ban model */
export class BanUpdateError implements IBanUpdateError {
    message?: string;
    errors?: Errors6;

    [key: string]: any;

    constructor(data?: IBanUpdateError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors6.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BanUpdateError {
        data = typeof data === 'object' ? data : {};
        let result = new BanUpdateError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

/** Ban model */
export interface IBanUpdateError {
    message?: string;
    errors?: Errors6;

    [key: string]: any;
}

export class BlacklistRequest implements IBlacklistRequest {
    to_id?: number;

    [key: string]: any;

    constructor(data?: IBlacklistRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.to_id = _data["to_id"];
        }
    }

    static fromJS(data: any): BlacklistRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BlacklistRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["to_id"] = this.to_id;
        return data;
    }
}

export interface IBlacklistRequest {
    to_id?: number;

    [key: string]: any;
}

export class BlacklistDataResponse implements IBlacklistDataResponse {
    data?: BlacklistResponse;

    [key: string]: any;

    constructor(data?: IBlacklistDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? BlacklistResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BlacklistDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BlacklistDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBlacklistDataResponse {
    data?: BlacklistResponse;

    [key: string]: any;
}

export class BlacklistsDataResponse implements IBlacklistsDataResponse {
    data?: BlacklistResponse[];

    [key: string]: any;

    constructor(data?: IBlacklistsDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(BlacklistResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BlacklistsDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BlacklistsDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBlacklistsDataResponse {
    data?: BlacklistResponse[];

    [key: string]: any;
}

export class BlacklistResponse implements IBlacklistResponse {
    id?: number;
    from_id?: number;
    to_id?: number;

    [key: string]: any;

    constructor(data?: IBlacklistResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.from_id = _data["from_id"];
            this.to_id = _data["to_id"];
        }
    }

    static fromJS(data: any): BlacklistResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BlacklistResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["from_id"] = this.from_id;
        data["to_id"] = this.to_id;
        return data;
    }
}

export interface IBlacklistResponse {
    id?: number;
    from_id?: number;
    to_id?: number;

    [key: string]: any;
}

/** Blacklist model */
export class BlacklistError implements IBlacklistError {
    message?: string;
    errors?: Errors7;

    [key: string]: any;

    constructor(data?: IBlacklistError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors7.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BlacklistError {
        data = typeof data === 'object' ? data : {};
        let result = new BlacklistError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

/** Blacklist model */
export interface IBlacklistError {
    message?: string;
    errors?: Errors7;

    [key: string]: any;
}

export class CategoryRequest implements ICategoryRequest {
    name?: TranslationRequest;
    parent_id?: number;
    is_final?: boolean;
    is_active?: boolean;
    example_answers?: TranslationRequest[];
    synonyms?: TranslationRequest[];

    [key: string]: any;

    constructor(data?: ICategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"] ? TranslationRequest.fromJS(_data["name"]) : <any>undefined;
            this.parent_id = _data["parent_id"];
            this.is_final = _data["is_final"];
            this.is_active = _data["is_active"];
            if (Array.isArray(_data["example_answers"])) {
                this.example_answers = [] as any;
                for (let item of _data["example_answers"])
                    this.example_answers!.push(TranslationRequest.fromJS(item));
            }
            if (Array.isArray(_data["synonyms"])) {
                this.synonyms = [] as any;
                for (let item of _data["synonyms"])
                    this.synonyms!.push(TranslationRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["parent_id"] = this.parent_id;
        data["is_final"] = this.is_final;
        data["is_active"] = this.is_active;
        if (Array.isArray(this.example_answers)) {
            data["example_answers"] = [];
            for (let item of this.example_answers)
                data["example_answers"].push(item.toJSON());
        }
        if (Array.isArray(this.synonyms)) {
            data["synonyms"] = [];
            for (let item of this.synonyms)
                data["synonyms"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICategoryRequest {
    name?: TranslationRequest;
    parent_id?: number;
    is_final?: boolean;
    is_active?: boolean;
    example_answers?: TranslationRequest[];
    synonyms?: TranslationRequest[];

    [key: string]: any;
}

export class CategoryDataResponse implements ICategoryDataResponse {
    data?: CategoryResponse;

    [key: string]: any;

    constructor(data?: ICategoryDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? CategoryResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CategoryDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICategoryDataResponse {
    data?: CategoryResponse;

    [key: string]: any;
}

export class CategoryResponse implements ICategoryResponse {
    id?: number;
    parent_id?: number;
    name?: string;
    is_final?: boolean;
    is_active?: boolean;
    order?: number;
    isSkillsExists?: boolean;
    example_answers?: any[];
    synonyms?: any[];
    children?: CategoryShortResponse[];

    [key: string]: any;

    constructor(data?: ICategoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.parent_id = _data["parent_id"];
            this.name = _data["name"];
            this.is_final = _data["is_final"];
            this.is_active = _data["is_active"];
            this.order = _data["order"];
            this.isSkillsExists = _data["isSkillsExists"];
            if (Array.isArray(_data["example_answers"])) {
                this.example_answers = [] as any;
                for (let item of _data["example_answers"])
                    this.example_answers!.push(item);
            }
            if (Array.isArray(_data["synonyms"])) {
                this.synonyms = [] as any;
                for (let item of _data["synonyms"])
                    this.synonyms!.push(item);
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(CategoryShortResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["parent_id"] = this.parent_id;
        data["name"] = this.name;
        data["is_final"] = this.is_final;
        data["is_active"] = this.is_active;
        data["order"] = this.order;
        data["isSkillsExists"] = this.isSkillsExists;
        if (Array.isArray(this.example_answers)) {
            data["example_answers"] = [];
            for (let item of this.example_answers)
                data["example_answers"].push(item);
        }
        if (Array.isArray(this.synonyms)) {
            data["synonyms"] = [];
            for (let item of this.synonyms)
                data["synonyms"].push(item);
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICategoryResponse {
    id?: number;
    parent_id?: number;
    name?: string;
    is_final?: boolean;
    is_active?: boolean;
    order?: number;
    isSkillsExists?: boolean;
    example_answers?: any[];
    synonyms?: any[];
    children?: CategoryShortResponse[];

    [key: string]: any;
}

export class CategoryShortResponse implements ICategoryShortResponse {
    id?: number;
    parent_id?: number;
    name?: string;
    is_final?: boolean;
    is_active?: boolean;
    order?: number;
    example_answers?: any[];
    synonyms?: any[];
    countSkills?: number;

    [key: string]: any;

    constructor(data?: ICategoryShortResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.parent_id = _data["parent_id"];
            this.name = _data["name"];
            this.is_final = _data["is_final"];
            this.is_active = _data["is_active"];
            this.order = _data["order"];
            if (Array.isArray(_data["example_answers"])) {
                this.example_answers = [] as any;
                for (let item of _data["example_answers"])
                    this.example_answers!.push(item);
            }
            if (Array.isArray(_data["synonyms"])) {
                this.synonyms = [] as any;
                for (let item of _data["synonyms"])
                    this.synonyms!.push(item);
            }
            this.countSkills = _data["countSkills"];
        }
    }

    static fromJS(data: any): CategoryShortResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryShortResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["parent_id"] = this.parent_id;
        data["name"] = this.name;
        data["is_final"] = this.is_final;
        data["is_active"] = this.is_active;
        data["order"] = this.order;
        if (Array.isArray(this.example_answers)) {
            data["example_answers"] = [];
            for (let item of this.example_answers)
                data["example_answers"].push(item);
        }
        if (Array.isArray(this.synonyms)) {
            data["synonyms"] = [];
            for (let item of this.synonyms)
                data["synonyms"].push(item);
        }
        data["countSkills"] = this.countSkills;
        return data;
    }
}

export interface ICategoryShortResponse {
    id?: number;
    parent_id?: number;
    name?: string;
    is_final?: boolean;
    is_active?: boolean;
    order?: number;
    example_answers?: any[];
    synonyms?: any[];
    countSkills?: number;

    [key: string]: any;
}

export class CategoryVeryShortResponse implements ICategoryVeryShortResponse {
    id?: number;
    name?: string;

    [key: string]: any;

    constructor(data?: ICategoryVeryShortResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CategoryVeryShortResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryVeryShortResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICategoryVeryShortResponse {
    id?: number;
    name?: string;

    [key: string]: any;
}

export class CategoryQuestionsDataResponse implements ICategoryQuestionsDataResponse {
    data?: CategoryQuestionsResponse;

    [key: string]: any;

    constructor(data?: ICategoryQuestionsDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? CategoryQuestionsResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CategoryQuestionsDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryQuestionsDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICategoryQuestionsDataResponse {
    data?: CategoryQuestionsResponse;

    [key: string]: any;
}

export class CategoryQuestionsResponse implements ICategoryQuestionsResponse {
    id?: number;
    name?: string;
    children?: CategoryQuestionsShortResponse[];
    questions?: QuestionResponse[];

    [key: string]: any;

    constructor(data?: ICategoryQuestionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(CategoryQuestionsShortResponse.fromJS(item));
            }
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(QuestionResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryQuestionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryQuestionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICategoryQuestionsResponse {
    id?: number;
    name?: string;
    children?: CategoryQuestionsShortResponse[];
    questions?: QuestionResponse[];

    [key: string]: any;
}

export class CategoryQuestionsShortResponse implements ICategoryQuestionsShortResponse {
    id?: number;
    name?: string;
    children?: any[];
    questions?: any[];

    [key: string]: any;

    constructor(data?: ICategoryQuestionsShortResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(item);
            }
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(item);
            }
        }
    }

    static fromJS(data: any): CategoryQuestionsShortResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryQuestionsShortResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item);
        }
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item);
        }
        return data;
    }
}

export interface ICategoryQuestionsShortResponse {
    id?: number;
    name?: string;
    children?: any[];
    questions?: any[];

    [key: string]: any;
}

/** Category model */
export class CategoryError implements ICategoryError {
    message?: string;
    errors?: Errors8;

    [key: string]: any;

    constructor(data?: ICategoryError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors8.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CategoryError {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

/** Category model */
export interface ICategoryError {
    message?: string;
    errors?: Errors8;

    [key: string]: any;
}

export class ChatRequest implements IChatRequest {
    user_2_id?: number;

    [key: string]: any;

    constructor(data?: IChatRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.user_2_id = _data["user_2_id"];
        }
    }

    static fromJS(data: any): ChatRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChatRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["user_2_id"] = this.user_2_id;
        return data;
    }
}

export interface IChatRequest {
    user_2_id?: number;

    [key: string]: any;
}

export class ChatUpdateRequest implements IChatUpdateRequest {
    title?: string;
    files?: ChatFilesUpdateRequest[];

    [key: string]: any;

    constructor(data?: IChatUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.title = _data["title"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(ChatFilesUpdateRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChatUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChatUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["title"] = this.title;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChatUpdateRequest {
    title?: string;
    files?: ChatFilesUpdateRequest[];

    [key: string]: any;
}

export class ChatFilesUpdateRequest implements IChatFilesUpdateRequest {
    file?: string;
    name?: string;
    size?: number;

    [key: string]: any;

    constructor(data?: IChatFilesUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.file = _data["file"];
            this.name = _data["name"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): ChatFilesUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChatFilesUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["file"] = this.file;
        data["name"] = this.name;
        data["size"] = this.size;
        return data;
    }
}

export interface IChatFilesUpdateRequest {
    file?: string;
    name?: string;
    size?: number;

    [key: string]: any;
}

export class ChatDataResponse implements IChatDataResponse {
    data?: ChatResponse;

    [key: string]: any;

    constructor(data?: IChatDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? ChatResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChatDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChatDataResponse {
    data?: ChatResponse;

    [key: string]: any;
}

export class ReactionNavigationAnchor implements IReactionNavigationAnchor {
    message_id?: string;
    created_at?: Date | undefined;

    [key: string]: any;

    constructor(data?: IReactionNavigationAnchor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message_id = _data["message_id"];
            this.created_at = _data["created_at"] ? new Date(_data["created_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReactionNavigationAnchor {
        data = typeof data === 'object' ? data : {};
        let result = new ReactionNavigationAnchor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message_id"] = this.message_id;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        return data;
    }
}

export interface IReactionNavigationAnchor {
    message_id?: string;
    created_at?: Date | undefined;

    [key: string]: any;
}

export class ReactionNavigationSummary implements IReactionNavigationSummary {
    has_unread_reactions?: boolean;
    unread_count?: number;
    anchors?: ReactionNavigationAnchor[];
    updated_at?: string | undefined;

    [key: string]: any;

    constructor(data?: IReactionNavigationSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.has_unread_reactions = _data["has_unread_reactions"];
            this.unread_count = _data["unread_count"];
            if (Array.isArray(_data["anchors"])) {
                this.anchors = [] as any;
                for (let item of _data["anchors"])
                    this.anchors!.push(ReactionNavigationAnchor.fromJS(item));
            }
            this.updated_at = _data["updated_at"];
        }
    }

    static fromJS(data: any): ReactionNavigationSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ReactionNavigationSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["has_unread_reactions"] = this.has_unread_reactions;
        data["unread_count"] = this.unread_count;
        if (Array.isArray(this.anchors)) {
            data["anchors"] = [];
            for (let item of this.anchors)
                data["anchors"].push(item.toJSON());
        }
        data["updated_at"] = this.updated_at;
        return data;
    }
}

export interface IReactionNavigationSummary {
    has_unread_reactions?: boolean;
    unread_count?: number;
    anchors?: ReactionNavigationAnchor[];
    updated_at?: string | undefined;

    [key: string]: any;
}

export class ReactionNavigationDataResponse implements IReactionNavigationDataResponse {
    data?: ReactionNavigationSummary;

    [key: string]: any;

    constructor(data?: IReactionNavigationDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? ReactionNavigationSummary.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReactionNavigationDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReactionNavigationDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReactionNavigationDataResponse {
    data?: ReactionNavigationSummary;

    [key: string]: any;
}

export class ReactionNavigationAckRequest implements IReactionNavigationAckRequest {
    message_id!: string;

    [key: string]: any;

    constructor(data?: IReactionNavigationAckRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message_id = _data["message_id"];
        }
    }

    static fromJS(data: any): ReactionNavigationAckRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReactionNavigationAckRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message_id"] = this.message_id;
        return data;
    }
}

export interface IReactionNavigationAckRequest {
    message_id: string;

    [key: string]: any;
}

export class ReactionNavigationAckResponse implements IReactionNavigationAckResponse {
    data?: ReactionNavigationSummary;

    [key: string]: any;

    constructor(data?: IReactionNavigationAckResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? ReactionNavigationSummary.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReactionNavigationAckResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReactionNavigationAckResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReactionNavigationAckResponse {
    data?: ReactionNavigationSummary;

    [key: string]: any;
}

export class ChatMessageSearchResult implements IChatMessageSearchResult {
    message_id?: string;
    chat_id?: number;
    message?: string;
    from_id?: number | undefined;
    user_info?: any | undefined;
    created_at?: Date | undefined;
    edited_at?: Date | undefined;

    [key: string]: any;

    constructor(data?: IChatMessageSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message_id = _data["message_id"];
            this.chat_id = _data["chat_id"];
            this.message = _data["message"];
            this.from_id = _data["from_id"];
            this.user_info = _data["user_info"];
            this.created_at = _data["created_at"] ? new Date(_data["created_at"].toString()) : <any>undefined;
            this.edited_at = _data["edited_at"] ? new Date(_data["edited_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatMessageSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message_id"] = this.message_id;
        data["chat_id"] = this.chat_id;
        data["message"] = this.message;
        data["from_id"] = this.from_id;
        data["user_info"] = this.user_info;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        data["edited_at"] = this.edited_at ? this.edited_at.toISOString() : <any>undefined;
        return data;
    }
}

export interface IChatMessageSearchResult {
    message_id?: string;
    chat_id?: number;
    message?: string;
    from_id?: number | undefined;
    user_info?: any | undefined;
    created_at?: Date | undefined;
    edited_at?: Date | undefined;

    [key: string]: any;
}

export class ChatMessageSearchMeta implements IChatMessageSearchMeta {
    /** Exact total when all matching results are already loaded */
    total?: number | undefined;
    has_more?: boolean;
    next_before_id?: string | undefined;
    query?: string;

    [key: string]: any;

    constructor(data?: IChatMessageSearchMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.total = _data["total"];
            this.has_more = _data["has_more"];
            this.next_before_id = _data["next_before_id"];
            this.query = _data["query"];
        }
    }

    static fromJS(data: any): ChatMessageSearchMeta {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageSearchMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["total"] = this.total;
        data["has_more"] = this.has_more;
        data["next_before_id"] = this.next_before_id;
        data["query"] = this.query;
        return data;
    }
}

export interface IChatMessageSearchMeta {
    /** Exact total when all matching results are already loaded */
    total?: number | undefined;
    has_more?: boolean;
    next_before_id?: string | undefined;
    query?: string;

    [key: string]: any;
}

export class ChatMessageSearchResponse implements IChatMessageSearchResponse {
    data?: ChatMessageSearchResult[];
    meta?: ChatMessageSearchMeta;

    [key: string]: any;

    constructor(data?: IChatMessageSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ChatMessageSearchResult.fromJS(item));
            }
            this.meta = _data["meta"] ? ChatMessageSearchMeta.fromJS(_data["meta"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatMessageSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChatMessageSearchResponse {
    data?: ChatMessageSearchResult[];
    meta?: ChatMessageSearchMeta;

    [key: string]: any;
}

export class ChatsDataResponse implements IChatsDataResponse {
    data?: ChatIndexResponse[];
    links?: Links;
    meta?: Meta3;

    [key: string]: any;

    constructor(data?: IChatsDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ChatIndexResponse.fromJS(item));
            }
            this.links = _data["links"] ? Links.fromJS(_data["links"]) : <any>undefined;
            this.meta = _data["meta"] ? Meta3.fromJS(_data["meta"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatsDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChatsDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["links"] = this.links ? this.links.toJSON() : <any>undefined;
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChatsDataResponse {
    data?: ChatIndexResponse[];
    links?: Links;
    meta?: Meta3;

    [key: string]: any;
}

export class ChatPresenceParticipantResponse implements IChatPresenceParticipantResponse {
    user_id?: number;
    chat_last_activity_at?: Date | undefined;

    [key: string]: any;

    constructor(data?: IChatPresenceParticipantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.user_id = _data["user_id"];
            this.chat_last_activity_at = _data["chat_last_activity_at"] ? new Date(_data["chat_last_activity_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatPresenceParticipantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChatPresenceParticipantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["user_id"] = this.user_id;
        data["chat_last_activity_at"] = this.chat_last_activity_at ? this.chat_last_activity_at.toISOString() : <any>undefined;
        return data;
    }
}

export interface IChatPresenceParticipantResponse {
    user_id?: number;
    chat_last_activity_at?: Date | undefined;

    [key: string]: any;
}

export class ChatPresenceChatResponse implements IChatPresenceChatResponse {
    id?: number;
    user_1_id?: number | undefined;
    user_2_id?: number | undefined;
    is_group?: boolean;
    participants?: ChatPresenceParticipantResponse[];

    [key: string]: any;

    constructor(data?: IChatPresenceChatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.user_1_id = _data["user_1_id"];
            this.user_2_id = _data["user_2_id"];
            this.is_group = _data["is_group"];
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(ChatPresenceParticipantResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChatPresenceChatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChatPresenceChatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["user_1_id"] = this.user_1_id;
        data["user_2_id"] = this.user_2_id;
        data["is_group"] = this.is_group;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChatPresenceChatResponse {
    id?: number;
    user_1_id?: number | undefined;
    user_2_id?: number | undefined;
    is_group?: boolean;
    participants?: ChatPresenceParticipantResponse[];

    [key: string]: any;
}

export class ChatPresenceChatsResponse implements IChatPresenceChatsResponse {
    data?: ChatPresenceChatResponse[];

    [key: string]: any;

    constructor(data?: IChatPresenceChatsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ChatPresenceChatResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChatPresenceChatsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChatPresenceChatsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChatPresenceChatsResponse {
    data?: ChatPresenceChatResponse[];

    [key: string]: any;
}

export class ChatResponse implements IChatResponse {
    id?: number;
    task_id?: number;
    reply_id?: number;
    offer_id?: number;
    title?: string | undefined;
    description?: string | undefined;
    user_1_id?: number;
    user_2_id?: number;
    user_1_qty_unread_messages?: number;
    user_2_qty_unread_messages?: number;
    user_1_last_message?: string;
    user_2_last_message?: string;
    user_1_last_message_at?: string;
    user_2_last_message_at?: string;
    last_message_id?: string | undefined;
    last_message_text?: string | undefined;
    last_message_type?: number | undefined;
    last_message_at?: string | undefined;
    last_message_user?: UserShortResponse;
    my_unread_count?: number | undefined;
    type?: string;
    is_archive?: boolean;
    is_blocked?: boolean;
    is_group?: boolean;
    members_count?: number | undefined;
    group_avatar?: FileResponse;
    updated_at?: string;
    task?: TaskShortResponse;
    reply?: ReplyResponse;
    offer?: OfferResponse;
    user_1?: UserShortResponse;
    user_2?: UserShortResponse;
    files?: FileResponse[];
    members?: ChatMemberResource[] | undefined;
    blacklists?: BlacklistResponse[];

    [key: string]: any;

    constructor(data?: IChatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.task_id = _data["task_id"];
            this.reply_id = _data["reply_id"];
            this.offer_id = _data["offer_id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.user_1_id = _data["user_1_id"];
            this.user_2_id = _data["user_2_id"];
            this.user_1_qty_unread_messages = _data["user_1_qty_unread_messages"];
            this.user_2_qty_unread_messages = _data["user_2_qty_unread_messages"];
            this.user_1_last_message = _data["user_1_last_message"];
            this.user_2_last_message = _data["user_2_last_message"];
            this.user_1_last_message_at = _data["user_1_last_message_at"];
            this.user_2_last_message_at = _data["user_2_last_message_at"];
            this.last_message_id = _data["last_message_id"];
            this.last_message_text = _data["last_message_text"];
            this.last_message_type = _data["last_message_type"];
            this.last_message_at = _data["last_message_at"];
            this.last_message_user = _data["last_message_user"] ? UserShortResponse.fromJS(_data["last_message_user"]) : <any>undefined;
            this.my_unread_count = _data["my_unread_count"];
            this.type = _data["type"];
            this.is_archive = _data["is_archive"];
            this.is_blocked = _data["is_blocked"];
            this.is_group = _data["is_group"];
            this.members_count = _data["members_count"];
            this.group_avatar = _data["group_avatar"] ? FileResponse.fromJS(_data["group_avatar"]) : <any>undefined;
            this.updated_at = _data["updated_at"];
            this.task = _data["task"] ? TaskShortResponse.fromJS(_data["task"]) : <any>undefined;
            this.reply = _data["reply"] ? ReplyResponse.fromJS(_data["reply"]) : <any>undefined;
            this.offer = _data["offer"] ? OfferResponse.fromJS(_data["offer"]) : <any>undefined;
            this.user_1 = _data["user_1"] ? UserShortResponse.fromJS(_data["user_1"]) : <any>undefined;
            this.user_2 = _data["user_2"] ? UserShortResponse.fromJS(_data["user_2"]) : <any>undefined;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileResponse.fromJS(item));
            }
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(ChatMemberResource.fromJS(item));
            }
            if (Array.isArray(_data["blacklists"])) {
                this.blacklists = [] as any;
                for (let item of _data["blacklists"])
                    this.blacklists!.push(BlacklistResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["task_id"] = this.task_id;
        data["reply_id"] = this.reply_id;
        data["offer_id"] = this.offer_id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["user_1_id"] = this.user_1_id;
        data["user_2_id"] = this.user_2_id;
        data["user_1_qty_unread_messages"] = this.user_1_qty_unread_messages;
        data["user_2_qty_unread_messages"] = this.user_2_qty_unread_messages;
        data["user_1_last_message"] = this.user_1_last_message;
        data["user_2_last_message"] = this.user_2_last_message;
        data["user_1_last_message_at"] = this.user_1_last_message_at;
        data["user_2_last_message_at"] = this.user_2_last_message_at;
        data["last_message_id"] = this.last_message_id;
        data["last_message_text"] = this.last_message_text;
        data["last_message_type"] = this.last_message_type;
        data["last_message_at"] = this.last_message_at;
        data["last_message_user"] = this.last_message_user ? this.last_message_user.toJSON() : <any>undefined;
        data["my_unread_count"] = this.my_unread_count;
        data["type"] = this.type;
        data["is_archive"] = this.is_archive;
        data["is_blocked"] = this.is_blocked;
        data["is_group"] = this.is_group;
        data["members_count"] = this.members_count;
        data["group_avatar"] = this.group_avatar ? this.group_avatar.toJSON() : <any>undefined;
        data["updated_at"] = this.updated_at;
        data["task"] = this.task ? this.task.toJSON() : <any>undefined;
        data["reply"] = this.reply ? this.reply.toJSON() : <any>undefined;
        data["offer"] = this.offer ? this.offer.toJSON() : <any>undefined;
        data["user_1"] = this.user_1 ? this.user_1.toJSON() : <any>undefined;
        data["user_2"] = this.user_2 ? this.user_2.toJSON() : <any>undefined;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        if (Array.isArray(this.blacklists)) {
            data["blacklists"] = [];
            for (let item of this.blacklists)
                data["blacklists"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChatResponse {
    id?: number;
    task_id?: number;
    reply_id?: number;
    offer_id?: number;
    title?: string | undefined;
    description?: string | undefined;
    user_1_id?: number;
    user_2_id?: number;
    user_1_qty_unread_messages?: number;
    user_2_qty_unread_messages?: number;
    user_1_last_message?: string;
    user_2_last_message?: string;
    user_1_last_message_at?: string;
    user_2_last_message_at?: string;
    last_message_id?: string | undefined;
    last_message_text?: string | undefined;
    last_message_type?: number | undefined;
    last_message_at?: string | undefined;
    last_message_user?: UserShortResponse;
    my_unread_count?: number | undefined;
    type?: string;
    is_archive?: boolean;
    is_blocked?: boolean;
    is_group?: boolean;
    members_count?: number | undefined;
    group_avatar?: FileResponse;
    updated_at?: string;
    task?: TaskShortResponse;
    reply?: ReplyResponse;
    offer?: OfferResponse;
    user_1?: UserShortResponse;
    user_2?: UserShortResponse;
    files?: FileResponse[];
    members?: ChatMemberResource[] | undefined;
    blacklists?: BlacklistResponse[];

    [key: string]: any;
}

export class ChatIndexResponse implements IChatIndexResponse {
    id?: number;
    reply_id?: number;
    title?: string | undefined;
    user_1_id?: number;
    user_2_id?: number;
    is_group?: boolean;
    members_count?: number | undefined;
    group_avatar?: FileResponse;
    user_1_qty_unread_messages?: number;
    user_2_qty_unread_messages?: number;
    user_1_last_message?: string;
    user_2_last_message?: string;
    user_1_last_message_at?: string;
    user_2_last_message_at?: string;
    last_message_id?: string | undefined;
    last_message_text?: string | undefined;
    last_message_type?: number | undefined;
    last_message_at?: string | undefined;
    last_message_user?: UserShortForChatResponse;
    my_unread_count?: number | undefined;
    type?: string;
    is_archive?: boolean;
    is_blocked?: boolean;
    has_unread_reactions?: boolean;
    reaction_navigation_unread_count?: number;
    reaction_navigation_updated_at?: string | undefined;
    updated_at?: string;
    task?: TaskShortForChatResponse;
    reply?: Reply;
    user_1?: UserShortForChatResponse;
    user_2?: UserShortForChatResponse;

    [key: string]: any;

    constructor(data?: IChatIndexResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.reply_id = _data["reply_id"];
            this.title = _data["title"];
            this.user_1_id = _data["user_1_id"];
            this.user_2_id = _data["user_2_id"];
            this.is_group = _data["is_group"];
            this.members_count = _data["members_count"];
            this.group_avatar = _data["group_avatar"] ? FileResponse.fromJS(_data["group_avatar"]) : <any>undefined;
            this.user_1_qty_unread_messages = _data["user_1_qty_unread_messages"];
            this.user_2_qty_unread_messages = _data["user_2_qty_unread_messages"];
            this.user_1_last_message = _data["user_1_last_message"];
            this.user_2_last_message = _data["user_2_last_message"];
            this.user_1_last_message_at = _data["user_1_last_message_at"];
            this.user_2_last_message_at = _data["user_2_last_message_at"];
            this.last_message_id = _data["last_message_id"];
            this.last_message_text = _data["last_message_text"];
            this.last_message_type = _data["last_message_type"];
            this.last_message_at = _data["last_message_at"];
            this.last_message_user = _data["last_message_user"] ? UserShortForChatResponse.fromJS(_data["last_message_user"]) : <any>undefined;
            this.my_unread_count = _data["my_unread_count"];
            this.type = _data["type"];
            this.is_archive = _data["is_archive"];
            this.is_blocked = _data["is_blocked"];
            this.has_unread_reactions = _data["has_unread_reactions"];
            this.reaction_navigation_unread_count = _data["reaction_navigation_unread_count"];
            this.reaction_navigation_updated_at = _data["reaction_navigation_updated_at"];
            this.updated_at = _data["updated_at"];
            this.task = _data["task"] ? TaskShortForChatResponse.fromJS(_data["task"]) : <any>undefined;
            this.reply = _data["reply"] ? Reply.fromJS(_data["reply"]) : <any>undefined;
            this.user_1 = _data["user_1"] ? UserShortForChatResponse.fromJS(_data["user_1"]) : <any>undefined;
            this.user_2 = _data["user_2"] ? UserShortForChatResponse.fromJS(_data["user_2"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatIndexResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChatIndexResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["reply_id"] = this.reply_id;
        data["title"] = this.title;
        data["user_1_id"] = this.user_1_id;
        data["user_2_id"] = this.user_2_id;
        data["is_group"] = this.is_group;
        data["members_count"] = this.members_count;
        data["group_avatar"] = this.group_avatar ? this.group_avatar.toJSON() : <any>undefined;
        data["user_1_qty_unread_messages"] = this.user_1_qty_unread_messages;
        data["user_2_qty_unread_messages"] = this.user_2_qty_unread_messages;
        data["user_1_last_message"] = this.user_1_last_message;
        data["user_2_last_message"] = this.user_2_last_message;
        data["user_1_last_message_at"] = this.user_1_last_message_at;
        data["user_2_last_message_at"] = this.user_2_last_message_at;
        data["last_message_id"] = this.last_message_id;
        data["last_message_text"] = this.last_message_text;
        data["last_message_type"] = this.last_message_type;
        data["last_message_at"] = this.last_message_at;
        data["last_message_user"] = this.last_message_user ? this.last_message_user.toJSON() : <any>undefined;
        data["my_unread_count"] = this.my_unread_count;
        data["type"] = this.type;
        data["is_archive"] = this.is_archive;
        data["is_blocked"] = this.is_blocked;
        data["has_unread_reactions"] = this.has_unread_reactions;
        data["reaction_navigation_unread_count"] = this.reaction_navigation_unread_count;
        data["reaction_navigation_updated_at"] = this.reaction_navigation_updated_at;
        data["updated_at"] = this.updated_at;
        data["task"] = this.task ? this.task.toJSON() : <any>undefined;
        data["reply"] = this.reply ? this.reply.toJSON() : <any>undefined;
        data["user_1"] = this.user_1 ? this.user_1.toJSON() : <any>undefined;
        data["user_2"] = this.user_2 ? this.user_2.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChatIndexResponse {
    id?: number;
    reply_id?: number;
    title?: string | undefined;
    user_1_id?: number;
    user_2_id?: number;
    is_group?: boolean;
    members_count?: number | undefined;
    group_avatar?: FileResponse;
    user_1_qty_unread_messages?: number;
    user_2_qty_unread_messages?: number;
    user_1_last_message?: string;
    user_2_last_message?: string;
    user_1_last_message_at?: string;
    user_2_last_message_at?: string;
    last_message_id?: string | undefined;
    last_message_text?: string | undefined;
    last_message_type?: number | undefined;
    last_message_at?: string | undefined;
    last_message_user?: UserShortForChatResponse;
    my_unread_count?: number | undefined;
    type?: string;
    is_archive?: boolean;
    is_blocked?: boolean;
    has_unread_reactions?: boolean;
    reaction_navigation_unread_count?: number;
    reaction_navigation_updated_at?: string | undefined;
    updated_at?: string;
    task?: TaskShortForChatResponse;
    reply?: Reply;
    user_1?: UserShortForChatResponse;
    user_2?: UserShortForChatResponse;

    [key: string]: any;
}

export class ChatError implements IChatError {
    message?: string;
    errors?: Errors9;

    [key: string]: any;

    constructor(data?: IChatError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors9.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatError {
        data = typeof data === 'object' ? data : {};
        let result = new ChatError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChatError {
    message?: string;
    errors?: Errors9;

    [key: string]: any;
}

export class ChatUpdateError implements IChatUpdateError {
    message?: string;
    errors?: Errors10;

    [key: string]: any;

    constructor(data?: IChatUpdateError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors10.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatUpdateError {
        data = typeof data === 'object' ? data : {};
        let result = new ChatUpdateError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChatUpdateError {
    message?: string;
    errors?: Errors10;

    [key: string]: any;
}

export class ChatMemberResource implements IChatMemberResource {
    id?: number;
    chat_id?: number;
    user_id?: number;
    role?: ChatMemberResourceRole;
    joined_at?: Date;
    left_at?: Date | undefined;
    last_read_at?: Date | undefined;
    unread_count?: number;
    muted_until?: Date | undefined;
    user?: UserShortForChatResponse;

    [key: string]: any;

    constructor(data?: IChatMemberResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.chat_id = _data["chat_id"];
            this.user_id = _data["user_id"];
            this.role = _data["role"];
            this.joined_at = _data["joined_at"] ? new Date(_data["joined_at"].toString()) : <any>undefined;
            this.left_at = _data["left_at"] ? new Date(_data["left_at"].toString()) : <any>undefined;
            this.last_read_at = _data["last_read_at"] ? new Date(_data["last_read_at"].toString()) : <any>undefined;
            this.unread_count = _data["unread_count"];
            this.muted_until = _data["muted_until"] ? new Date(_data["muted_until"].toString()) : <any>undefined;
            this.user = _data["user"] ? UserShortForChatResponse.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatMemberResource {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMemberResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["chat_id"] = this.chat_id;
        data["user_id"] = this.user_id;
        data["role"] = this.role;
        data["joined_at"] = this.joined_at ? this.joined_at.toISOString() : <any>undefined;
        data["left_at"] = this.left_at ? this.left_at.toISOString() : <any>undefined;
        data["last_read_at"] = this.last_read_at ? this.last_read_at.toISOString() : <any>undefined;
        data["unread_count"] = this.unread_count;
        data["muted_until"] = this.muted_until ? this.muted_until.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChatMemberResource {
    id?: number;
    chat_id?: number;
    user_id?: number;
    role?: ChatMemberResourceRole;
    joined_at?: Date;
    left_at?: Date | undefined;
    last_read_at?: Date | undefined;
    unread_count?: number;
    muted_until?: Date | undefined;
    user?: UserShortForChatResponse;

    [key: string]: any;
}

export class ChatInviteResource implements IChatInviteResource {
    id?: number;
    chat_id?: number;
    token?: string;
    created_by?: number;
    is_active?: boolean;
    uses_count?: number;
    share_url?: string;
    created_at?: Date;

    [key: string]: any;

    constructor(data?: IChatInviteResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.chat_id = _data["chat_id"];
            this.token = _data["token"];
            this.created_by = _data["created_by"];
            this.is_active = _data["is_active"];
            this.uses_count = _data["uses_count"];
            this.share_url = _data["share_url"];
            this.created_at = _data["created_at"] ? new Date(_data["created_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatInviteResource {
        data = typeof data === 'object' ? data : {};
        let result = new ChatInviteResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["chat_id"] = this.chat_id;
        data["token"] = this.token;
        data["created_by"] = this.created_by;
        data["is_active"] = this.is_active;
        data["uses_count"] = this.uses_count;
        data["share_url"] = this.share_url;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        return data;
    }
}

export interface IChatInviteResource {
    id?: number;
    chat_id?: number;
    token?: string;
    created_by?: number;
    is_active?: boolean;
    uses_count?: number;
    share_url?: string;
    created_at?: Date;

    [key: string]: any;
}

export class ChatInvitePreviewResource implements IChatInvitePreviewResource {
    id?: number;
    chat_id?: number;
    chat?: Chat;

    [key: string]: any;

    constructor(data?: IChatInvitePreviewResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.chat_id = _data["chat_id"];
            this.chat = _data["chat"] ? Chat.fromJS(_data["chat"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatInvitePreviewResource {
        data = typeof data === 'object' ? data : {};
        let result = new ChatInvitePreviewResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["chat_id"] = this.chat_id;
        data["chat"] = this.chat ? this.chat.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChatInvitePreviewResource {
    id?: number;
    chat_id?: number;
    chat?: Chat;

    [key: string]: any;
}

/** Chat model */
export class ChatNotificationSettingsResource implements IChatNotificationSettingsResource {
    chat_id?: number;
    muted_until?: Date | undefined;

    [key: string]: any;

    constructor(data?: IChatNotificationSettingsResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.chat_id = _data["chat_id"];
            this.muted_until = _data["muted_until"] ? new Date(_data["muted_until"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatNotificationSettingsResource {
        data = typeof data === 'object' ? data : {};
        let result = new ChatNotificationSettingsResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["chat_id"] = this.chat_id;
        data["muted_until"] = this.muted_until ? this.muted_until.toISOString() : <any>undefined;
        return data;
    }
}

/** Chat model */
export interface IChatNotificationSettingsResource {
    chat_id?: number;
    muted_until?: Date | undefined;

    [key: string]: any;
}

export class CommentRequest implements ICommentRequest {
    task_id?: number;
    parent_id?: number;
    text?: string;

    [key: string]: any;

    constructor(data?: ICommentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.task_id = _data["task_id"];
            this.parent_id = _data["parent_id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): CommentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CommentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["task_id"] = this.task_id;
        data["parent_id"] = this.parent_id;
        data["text"] = this.text;
        return data;
    }
}

export interface ICommentRequest {
    task_id?: number;
    parent_id?: number;
    text?: string;

    [key: string]: any;
}

export class CommentUpdateRequest implements ICommentUpdateRequest {
    text?: string;
    is_report?: boolean;

    [key: string]: any;

    constructor(data?: ICommentUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.text = _data["text"];
            this.is_report = _data["is_report"];
        }
    }

    static fromJS(data: any): CommentUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CommentUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["text"] = this.text;
        data["is_report"] = this.is_report;
        return data;
    }
}

export interface ICommentUpdateRequest {
    text?: string;
    is_report?: boolean;

    [key: string]: any;
}

export class CommentDataResponse implements ICommentDataResponse {
    data?: CommentResponse;

    [key: string]: any;

    constructor(data?: ICommentDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? CommentResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CommentDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CommentDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICommentDataResponse {
    data?: CommentResponse;

    [key: string]: any;
}

export class CommentsDataResponse implements ICommentsDataResponse {
    data?: CommentResponse[];

    [key: string]: any;

    constructor(data?: ICommentsDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CommentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommentsDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CommentsDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICommentsDataResponse {
    data?: CommentResponse[];

    [key: string]: any;
}

export class CommentResponse implements ICommentResponse {
    id?: number;
    parent_id?: number;
    text?: string;
    created_at?: string;
    children?: CommentShortResponse[];
    user?: UserShortForChatResponse;

    [key: string]: any;

    constructor(data?: ICommentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.parent_id = _data["parent_id"];
            this.text = _data["text"];
            this.created_at = _data["created_at"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(CommentShortResponse.fromJS(item));
            }
            this.user = _data["user"] ? UserShortForChatResponse.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CommentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CommentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["parent_id"] = this.parent_id;
        data["text"] = this.text;
        data["created_at"] = this.created_at;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICommentResponse {
    id?: number;
    parent_id?: number;
    text?: string;
    created_at?: string;
    children?: CommentShortResponse[];
    user?: UserShortForChatResponse;

    [key: string]: any;
}

export class CommentShortResponse implements ICommentShortResponse {
    id?: number;
    parent_id?: number;
    text?: string;
    created_at?: string;
    user?: UserShortForChatResponse;

    [key: string]: any;

    constructor(data?: ICommentShortResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.parent_id = _data["parent_id"];
            this.text = _data["text"];
            this.created_at = _data["created_at"];
            this.user = _data["user"] ? UserShortForChatResponse.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CommentShortResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CommentShortResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["parent_id"] = this.parent_id;
        data["text"] = this.text;
        data["created_at"] = this.created_at;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICommentShortResponse {
    id?: number;
    parent_id?: number;
    text?: string;
    created_at?: string;
    user?: UserShortForChatResponse;

    [key: string]: any;
}

export class CommentError implements ICommentError {
    message?: string;
    errors?: Errors11;

    [key: string]: any;

    constructor(data?: ICommentError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors11.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CommentError {
        data = typeof data === 'object' ? data : {};
        let result = new CommentError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICommentError {
    message?: string;
    errors?: Errors11;

    [key: string]: any;
}

/** Comment model */
export class CommentUpdateError implements ICommentUpdateError {
    message?: string;
    errors?: Errors12;

    [key: string]: any;

    constructor(data?: ICommentUpdateError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors12.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CommentUpdateError {
        data = typeof data === 'object' ? data : {};
        let result = new CommentUpdateError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

/** Comment model */
export interface ICommentUpdateError {
    message?: string;
    errors?: Errors12;

    [key: string]: any;
}

export class CoordinateRequest implements ICoordinateRequest {
    location?: Location;
    rate?: number;
    description?: string;
    /** 1 - for online, 2 - busy, 3 - offline */
    status?: number;
    front_camera_price?: number;
    is_allow_control_movement?: boolean;
    is_allow_front_camera?: boolean;
    is_allow_free_mode?: boolean;
    phone_model?: string;

    [key: string]: any;

    constructor(data?: ICoordinateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.rate = _data["rate"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.front_camera_price = _data["front_camera_price"];
            this.is_allow_control_movement = _data["is_allow_control_movement"];
            this.is_allow_front_camera = _data["is_allow_front_camera"];
            this.is_allow_free_mode = _data["is_allow_free_mode"];
            this.phone_model = _data["phone_model"];
        }
    }

    static fromJS(data: any): CoordinateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["rate"] = this.rate;
        data["description"] = this.description;
        data["status"] = this.status;
        data["front_camera_price"] = this.front_camera_price;
        data["is_allow_control_movement"] = this.is_allow_control_movement;
        data["is_allow_front_camera"] = this.is_allow_front_camera;
        data["is_allow_free_mode"] = this.is_allow_free_mode;
        data["phone_model"] = this.phone_model;
        return data;
    }
}

export interface ICoordinateRequest {
    location?: Location;
    rate?: number;
    description?: string;
    /** 1 - for online, 2 - busy, 3 - offline */
    status?: number;
    front_camera_price?: number;
    is_allow_control_movement?: boolean;
    is_allow_front_camera?: boolean;
    is_allow_free_mode?: boolean;
    phone_model?: string;

    [key: string]: any;
}

export class CoordinateUpdateRequest implements ICoordinateUpdateRequest {
    location?: Location;
    status?: number;

    [key: string]: any;

    constructor(data?: ICoordinateUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CoordinateUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinateUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface ICoordinateUpdateRequest {
    location?: Location;
    status?: number;

    [key: string]: any;
}

export class Location implements ILocation {
    type?: string;
    coordinates?: number[];

    [key: string]: any;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            if (Array.isArray(_data["coordinates"])) {
                this.coordinates = [] as any;
                for (let item of _data["coordinates"])
                    this.coordinates!.push(item);
            }
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item);
        }
        return data;
    }
}

export interface ILocation {
    type?: string;
    coordinates?: number[];

    [key: string]: any;
}

export class CoordinateDataResponse implements ICoordinateDataResponse {
    data?: CoordinateResponse;

    [key: string]: any;

    constructor(data?: ICoordinateDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? CoordinateResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CoordinateDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinateDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICoordinateDataResponse {
    data?: CoordinateResponse;

    [key: string]: any;
}

export class CoordinatesDataResponse implements ICoordinatesDataResponse {
    data?: CoordinateResponse[];

    [key: string]: any;

    constructor(data?: ICoordinatesDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CoordinateResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CoordinatesDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinatesDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICoordinatesDataResponse {
    data?: CoordinateResponse[];

    [key: string]: any;
}

export class CoordinatesMarkerShortResponse implements ICoordinatesMarkerShortResponse {
    data?: MarkerShortResource[];

    [key: string]: any;

    constructor(data?: ICoordinatesMarkerShortResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MarkerShortResource.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CoordinatesMarkerShortResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinatesMarkerShortResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICoordinatesMarkerShortResponse {
    data?: MarkerShortResource[];

    [key: string]: any;
}

export class CoordinateShortResponse implements ICoordinateShortResponse {
    _id?: string;

    [key: string]: any;

    constructor(data?: ICoordinateShortResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this._id = _data["_id"];
        }
    }

    static fromJS(data: any): CoordinateShortResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinateShortResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["_id"] = this._id;
        return data;
    }
}

export interface ICoordinateShortResponse {
    _id?: string;

    [key: string]: any;
}

export class AvatarResponse implements IAvatarResponse {
    id?: number;
    name?: string;
    surname?: string;
    avatar?: string;
    rating?: number;
    rating_total?: number;
    description?: string;
    official?: boolean;

    [key: string]: any;

    constructor(data?: IAvatarResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.avatar = _data["avatar"];
            this.rating = _data["rating"];
            this.rating_total = _data["rating_total"];
            this.description = _data["description"];
            this.official = _data["official"];
        }
    }

    static fromJS(data: any): AvatarResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AvatarResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["avatar"] = this.avatar;
        data["rating"] = this.rating;
        data["rating_total"] = this.rating_total;
        data["description"] = this.description;
        data["official"] = this.official;
        return data;
    }
}

export interface IAvatarResponse {
    id?: number;
    name?: string;
    surname?: string;
    avatar?: string;
    rating?: number;
    rating_total?: number;
    description?: string;
    official?: boolean;

    [key: string]: any;
}

export class PositionResponse implements IPositionResponse {
    latitude?: number;
    longitude?: number;

    [key: string]: any;

    constructor(data?: IPositionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): PositionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PositionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface IPositionResponse {
    latitude?: number;
    longitude?: number;

    [key: string]: any;
}

export class CoordinateRatesDataResponse implements ICoordinateRatesDataResponse {
    data?: CoordinateRatesResponse;

    [key: string]: any;

    constructor(data?: ICoordinateRatesDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? CoordinateRatesResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CoordinateRatesDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinateRatesDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICoordinateRatesDataResponse {
    data?: CoordinateRatesResponse;

    [key: string]: any;
}

/** Coordinate model */
export class CoordinateRatesResponse implements ICoordinateRatesResponse {
    min_rate?: number;
    max_rate?: number;

    [key: string]: any;

    constructor(data?: ICoordinateRatesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.min_rate = _data["min_rate"];
            this.max_rate = _data["max_rate"];
        }
    }

    static fromJS(data: any): CoordinateRatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinateRatesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["min_rate"] = this.min_rate;
        data["max_rate"] = this.max_rate;
        return data;
    }
}

/** Coordinate model */
export interface ICoordinateRatesResponse {
    min_rate?: number;
    max_rate?: number;

    [key: string]: any;
}

export class DraftRequest implements IDraftRequest {
    json?: any;

    [key: string]: any;

    constructor(data?: IDraftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.json = _data["json"];
        }
    }

    static fromJS(data: any): DraftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DraftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["json"] = this.json;
        return data;
    }
}

export interface IDraftRequest {
    json?: any;

    [key: string]: any;
}

export class DraftDataResponse implements IDraftDataResponse {
    data?: DraftResponse;

    [key: string]: any;

    constructor(data?: IDraftDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? DraftResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DraftDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DraftDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDraftDataResponse {
    data?: DraftResponse;

    [key: string]: any;
}

export class DraftsDataResponse implements IDraftsDataResponse {
    data?: DraftResponse[];

    [key: string]: any;

    constructor(data?: IDraftsDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DraftResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DraftsDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DraftsDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDraftsDataResponse {
    data?: DraftResponse[];

    [key: string]: any;
}

export class DraftResponse implements IDraftResponse {
    id?: number;
    user_id?: number;
    json?: any;
    draftFiles?: DraftFileResponse[];

    [key: string]: any;

    constructor(data?: IDraftResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.user_id = _data["user_id"];
            this.json = _data["json"];
            if (Array.isArray(_data["draftFiles"])) {
                this.draftFiles = [] as any;
                for (let item of _data["draftFiles"])
                    this.draftFiles!.push(DraftFileResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DraftResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DraftResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["user_id"] = this.user_id;
        data["json"] = this.json;
        if (Array.isArray(this.draftFiles)) {
            data["draftFiles"] = [];
            for (let item of this.draftFiles)
                data["draftFiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDraftResponse {
    id?: number;
    user_id?: number;
    json?: any;
    draftFiles?: DraftFileResponse[];

    [key: string]: any;
}

/** Draft model */
export class DraftError implements IDraftError {
    message?: string;
    errors?: Errors13;

    [key: string]: any;

    constructor(data?: IDraftError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors13.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DraftError {
        data = typeof data === 'object' ? data : {};
        let result = new DraftError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

/** Draft model */
export interface IDraftError {
    message?: string;
    errors?: Errors13;

    [key: string]: any;
}

/** DraftFile model */
export class DraftFileResponse implements IDraftFileResponse {
    id?: number;
    draft_id?: number;
    file_id?: number;
    question_id?: number;
    file?: FileResponse;
    question?: QuestionResponse;

    [key: string]: any;

    constructor(data?: IDraftFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.draft_id = _data["draft_id"];
            this.file_id = _data["file_id"];
            this.question_id = _data["question_id"];
            this.file = _data["file"] ? FileResponse.fromJS(_data["file"]) : <any>undefined;
            this.question = _data["question"] ? QuestionResponse.fromJS(_data["question"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DraftFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DraftFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["draft_id"] = this.draft_id;
        data["file_id"] = this.file_id;
        data["question_id"] = this.question_id;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["question"] = this.question ? this.question.toJSON() : <any>undefined;
        return data;
    }
}

/** DraftFile model */
export interface IDraftFileResponse {
    id?: number;
    draft_id?: number;
    file_id?: number;
    question_id?: number;
    file?: FileResponse;
    question?: QuestionResponse;

    [key: string]: any;
}

export class ExtraWorkRequest implements IExtraWorkRequest {
    reply_id?: number;
    price?: number;
    description?: string;
    files?: ExtraWorkFileRequest[];

    [key: string]: any;

    constructor(data?: IExtraWorkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.reply_id = _data["reply_id"];
            this.price = _data["price"];
            this.description = _data["description"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(ExtraWorkFileRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExtraWorkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraWorkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["reply_id"] = this.reply_id;
        data["price"] = this.price;
        data["description"] = this.description;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExtraWorkRequest {
    reply_id?: number;
    price?: number;
    description?: string;
    files?: ExtraWorkFileRequest[];

    [key: string]: any;
}

export class ExtraWorkFileRequest implements IExtraWorkFileRequest {
    file?: string;
    name?: string;
    size?: number;

    [key: string]: any;

    constructor(data?: IExtraWorkFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.file = _data["file"];
            this.name = _data["name"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): ExtraWorkFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraWorkFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["file"] = this.file;
        data["name"] = this.name;
        data["size"] = this.size;
        return data;
    }
}

export interface IExtraWorkFileRequest {
    file?: string;
    name?: string;
    size?: number;

    [key: string]: any;
}

export class ExtraWorkUpdateRequest implements IExtraWorkUpdateRequest {
    description?: string;

    [key: string]: any;

    constructor(data?: IExtraWorkUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ExtraWorkUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraWorkUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["description"] = this.description;
        return data;
    }
}

export interface IExtraWorkUpdateRequest {
    description?: string;

    [key: string]: any;
}

export class ExtraWorkRejectRequest implements IExtraWorkRejectRequest {
    reason_rejection?: string;

    [key: string]: any;

    constructor(data?: IExtraWorkRejectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.reason_rejection = _data["reason_rejection"];
        }
    }

    static fromJS(data: any): ExtraWorkRejectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraWorkRejectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["reason_rejection"] = this.reason_rejection;
        return data;
    }
}

export interface IExtraWorkRejectRequest {
    reason_rejection?: string;

    [key: string]: any;
}

export class ExtraWorkOfferExtraPayRequest implements IExtraWorkOfferExtraPayRequest {
    extra_pay?: number;
    extra_pay_description?: string;

    [key: string]: any;

    constructor(data?: IExtraWorkOfferExtraPayRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.extra_pay = _data["extra_pay"];
            this.extra_pay_description = _data["extra_pay_description"];
        }
    }

    static fromJS(data: any): ExtraWorkOfferExtraPayRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraWorkOfferExtraPayRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["extra_pay"] = this.extra_pay;
        data["extra_pay_description"] = this.extra_pay_description;
        return data;
    }
}

export interface IExtraWorkOfferExtraPayRequest {
    extra_pay?: number;
    extra_pay_description?: string;

    [key: string]: any;
}

export class ExtraWorkAddResultsRequest implements IExtraWorkAddResultsRequest {
    result_description?: string | undefined;
    files?: ExtraWorkFileRequest[] | undefined;

    [key: string]: any;

    constructor(data?: IExtraWorkAddResultsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.result_description = _data["result_description"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(ExtraWorkFileRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExtraWorkAddResultsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraWorkAddResultsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["result_description"] = this.result_description;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExtraWorkAddResultsRequest {
    result_description?: string | undefined;
    files?: ExtraWorkFileRequest[] | undefined;

    [key: string]: any;
}

export class ExtraWorkDataResponse implements IExtraWorkDataResponse {
    data?: ExtraWorkResponse;

    [key: string]: any;

    constructor(data?: IExtraWorkDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? ExtraWorkResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExtraWorkDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraWorkDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExtraWorkDataResponse {
    data?: ExtraWorkResponse;

    [key: string]: any;
}

export class ExtraWorksDataResponse implements IExtraWorksDataResponse {
    data?: ExtraWorkResponse[];

    [key: string]: any;

    constructor(data?: IExtraWorksDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ExtraWorkResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExtraWorksDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraWorksDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExtraWorksDataResponse {
    data?: ExtraWorkResponse[];

    [key: string]: any;
}

export class ExtraWorkResponse implements IExtraWorkResponse {
    id?: number;
    reply_id?: number;
    owner_id?: number;
    status?: number;
    price?: number;
    extra_pay?: number;
    description?: string;
    result_description?: string;
    extra_pay_description?: string;
    reason_rejection?: string;
    files?: FileResponse[];
    results?: FileResponse[];

    [key: string]: any;

    constructor(data?: IExtraWorkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.reply_id = _data["reply_id"];
            this.owner_id = _data["owner_id"];
            this.status = _data["status"];
            this.price = _data["price"];
            this.extra_pay = _data["extra_pay"];
            this.description = _data["description"];
            this.result_description = _data["result_description"];
            this.extra_pay_description = _data["extra_pay_description"];
            this.reason_rejection = _data["reason_rejection"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileResponse.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FileResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExtraWorkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraWorkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["reply_id"] = this.reply_id;
        data["owner_id"] = this.owner_id;
        data["status"] = this.status;
        data["price"] = this.price;
        data["extra_pay"] = this.extra_pay;
        data["description"] = this.description;
        data["result_description"] = this.result_description;
        data["extra_pay_description"] = this.extra_pay_description;
        data["reason_rejection"] = this.reason_rejection;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExtraWorkResponse {
    id?: number;
    reply_id?: number;
    owner_id?: number;
    status?: number;
    price?: number;
    extra_pay?: number;
    description?: string;
    result_description?: string;
    extra_pay_description?: string;
    reason_rejection?: string;
    files?: FileResponse[];
    results?: FileResponse[];

    [key: string]: any;
}

export class ExtraWorkError implements IExtraWorkError {
    message?: string;
    errors?: Errors14;

    [key: string]: any;

    constructor(data?: IExtraWorkError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors14.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExtraWorkError {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraWorkError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExtraWorkError {
    message?: string;
    errors?: Errors14;

    [key: string]: any;
}

export class ExtraWorkAddResultsError implements IExtraWorkAddResultsError {
    message?: string;
    errors?: Errors15;

    [key: string]: any;

    constructor(data?: IExtraWorkAddResultsError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors15.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExtraWorkAddResultsError {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraWorkAddResultsError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExtraWorkAddResultsError {
    message?: string;
    errors?: Errors15;

    [key: string]: any;
}

export class ExtraWorkUpdateError implements IExtraWorkUpdateError {
    message?: string;
    errors?: Errors16;

    [key: string]: any;

    constructor(data?: IExtraWorkUpdateError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors16.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExtraWorkUpdateError {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraWorkUpdateError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExtraWorkUpdateError {
    message?: string;
    errors?: Errors16;

    [key: string]: any;
}

export class ExtraWorkRejectError implements IExtraWorkRejectError {
    message?: string;
    errors?: Errors17;

    [key: string]: any;

    constructor(data?: IExtraWorkRejectError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors17.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExtraWorkRejectError {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraWorkRejectError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExtraWorkRejectError {
    message?: string;
    errors?: Errors17;

    [key: string]: any;
}

/** ExtraWork model */
export class ExtraWorkOfferExtraPayError implements IExtraWorkOfferExtraPayError {
    message?: string;
    errors?: Errors18;

    [key: string]: any;

    constructor(data?: IExtraWorkOfferExtraPayError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors18.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExtraWorkOfferExtraPayError {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraWorkOfferExtraPayError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

/** ExtraWork model */
export interface IExtraWorkOfferExtraPayError {
    message?: string;
    errors?: Errors18;

    [key: string]: any;
}

export class FilesListFromDbRequest implements IFilesListFromDbRequest {
    path?: string;

    [key: string]: any;

    constructor(data?: IFilesListFromDbRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.path = _data["path"];
        }
    }

    static fromJS(data: any): FilesListFromDbRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FilesListFromDbRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["path"] = this.path;
        return data;
    }
}

export interface IFilesListFromDbRequest {
    path?: string;

    [key: string]: any;
}

export class FileRequest implements IFileRequest {
    path?: string;
    type?: string;
    file?: string;
    name?: string;
    size?: number;

    [key: string]: any;

    constructor(data?: IFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.path = _data["path"];
            this.type = _data["type"];
            this.file = _data["file"];
            this.name = _data["name"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): FileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["path"] = this.path;
        data["type"] = this.type;
        data["file"] = this.file;
        data["name"] = this.name;
        data["size"] = this.size;
        return data;
    }
}

export interface IFileRequest {
    path?: string;
    type?: string;
    file?: string;
    name?: string;
    size?: number;

    [key: string]: any;
}

export class FileFormdataRequest implements IFileFormdataRequest {
    path?: string;
    type?: string;
    file?: string;

    [key: string]: any;

    constructor(data?: IFileFormdataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.path = _data["path"];
            this.type = _data["type"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): FileFormdataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FileFormdataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["path"] = this.path;
        data["type"] = this.type;
        data["file"] = this.file;
        return data;
    }
}

export interface IFileFormdataRequest {
    path?: string;
    type?: string;
    file?: string;

    [key: string]: any;
}

export class FileDataResponse implements IFileDataResponse {
    data?: FileResponse;

    [key: string]: any;

    constructor(data?: IFileDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? FileResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFileDataResponse {
    data?: FileResponse;

    [key: string]: any;
}

export class FilesDataResponse implements IFilesDataResponse {
    data?: FileResponse[];

    [key: string]: any;

    constructor(data?: IFilesDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FileResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilesDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FilesDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilesDataResponse {
    data?: FileResponse[];

    [key: string]: any;
}

export class FileResponse implements IFileResponse {
    id?: number;
    user_id?: number;
    name?: string;
    description?: string;
    title?: string;
    type?: FileTypeResponse;
    path?: string;
    size?: number;
    width?: number | undefined;
    height?: number | undefined;
    s3name?: string;
    url?: string;
    origin?: FileShortResponse;
    resizes?: FileShortResponse[];
    user_actions?: UserActionsResource;

    [key: string]: any;

    constructor(data?: IFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.user_id = _data["user_id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.title = _data["title"];
            this.type = _data["type"] ? FileTypeResponse.fromJS(_data["type"]) : <any>undefined;
            this.path = _data["path"];
            this.size = _data["size"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.s3name = _data["s3name"];
            this.url = _data["url"];
            this.origin = _data["origin"] ? FileShortResponse.fromJS(_data["origin"]) : <any>undefined;
            if (Array.isArray(_data["resizes"])) {
                this.resizes = [] as any;
                for (let item of _data["resizes"])
                    this.resizes!.push(FileShortResponse.fromJS(item));
            }
            this.user_actions = _data["user_actions"] ? UserActionsResource.fromJS(_data["user_actions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["user_id"] = this.user_id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["title"] = this.title;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["path"] = this.path;
        data["size"] = this.size;
        data["width"] = this.width;
        data["height"] = this.height;
        data["s3name"] = this.s3name;
        data["url"] = this.url;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        if (Array.isArray(this.resizes)) {
            data["resizes"] = [];
            for (let item of this.resizes)
                data["resizes"].push(item.toJSON());
        }
        data["user_actions"] = this.user_actions ? this.user_actions.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFileResponse {
    id?: number;
    user_id?: number;
    name?: string;
    description?: string;
    title?: string;
    type?: FileTypeResponse;
    path?: string;
    size?: number;
    width?: number | undefined;
    height?: number | undefined;
    s3name?: string;
    url?: string;
    origin?: FileShortResponse;
    resizes?: FileShortResponse[];
    user_actions?: UserActionsResource;

    [key: string]: any;
}

export class FileShortResponse implements IFileShortResponse {
    id?: number;
    url?: string;
    width?: number | undefined;
    height?: number | undefined;

    [key: string]: any;

    constructor(data?: IFileShortResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.url = _data["url"];
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): FileShortResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileShortResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["url"] = this.url;
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    }
}

export interface IFileShortResponse {
    id?: number;
    url?: string;
    width?: number | undefined;
    height?: number | undefined;

    [key: string]: any;
}

export class FileListResponse implements IFileListResponse {
    list?: FileResponse[];
    size?: number;

    [key: string]: any;

    constructor(data?: IFileListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"])
                    this.list!.push(FileResponse.fromJS(item));
            }
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): FileListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        data["size"] = this.size;
        return data;
    }
}

export interface IFileListResponse {
    list?: FileResponse[];
    size?: number;

    [key: string]: any;
}

/** File model */
export class FileError implements IFileError {
    message?: string;
    errors?: Errors19;

    [key: string]: any;

    constructor(data?: IFileError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors19.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileError {
        data = typeof data === 'object' ? data : {};
        let result = new FileError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

/** File model */
export interface IFileError {
    message?: string;
    errors?: Errors19;

    [key: string]: any;
}

export class FileTypeResponse implements IFileTypeResponse {
    id?: number;
    name?: string;

    [key: string]: any;

    constructor(data?: IFileTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FileTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IFileTypeResponse {
    id?: number;
    name?: string;

    [key: string]: any;
}

export class FilterRequest implements IFilterRequest {
    category_id?: number;
    question_id?: number;
    text?: string;
    text_skill?: string;
    is_active?: boolean;
    answers?: FilterAnswers[];

    [key: string]: any;

    constructor(data?: IFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.category_id = _data["category_id"];
            this.question_id = _data["question_id"];
            this.text = _data["text"];
            this.text_skill = _data["text_skill"];
            this.is_active = _data["is_active"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(FilterAnswers.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["category_id"] = this.category_id;
        data["question_id"] = this.question_id;
        data["text"] = this.text;
        data["text_skill"] = this.text_skill;
        data["is_active"] = this.is_active;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterRequest {
    category_id?: number;
    question_id?: number;
    text?: string;
    text_skill?: string;
    is_active?: boolean;
    answers?: FilterAnswers[];

    [key: string]: any;
}

export class FilterDataResponse implements IFilterDataResponse {
    data?: FilterResponse;

    [key: string]: any;

    constructor(data?: IFilterDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? FilterResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FilterDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FilterDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFilterDataResponse {
    data?: FilterResponse;

    [key: string]: any;
}

export class FiltersDataResponse implements IFiltersDataResponse {
    data?: FilterResponse[];

    [key: string]: any;

    constructor(data?: IFiltersDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FilterResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FiltersDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FiltersDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFiltersDataResponse {
    data?: FilterResponse[];

    [key: string]: any;
}

export class FiltersShortDataResponse implements IFiltersShortDataResponse {
    data?: FilterShortResponse[];

    [key: string]: any;

    constructor(data?: IFiltersShortDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FilterShortResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FiltersShortDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FiltersShortDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFiltersShortDataResponse {
    data?: FilterShortResponse[];

    [key: string]: any;
}

export class FilterResponse implements IFilterResponse {
    id?: number;
    category_id?: number;
    question_id?: number;
    text?: string;
    answers?: FilterAnswers[];
    skill?: SkillResponse;

    [key: string]: any;

    constructor(data?: IFilterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.category_id = _data["category_id"];
            this.question_id = _data["question_id"];
            this.text = _data["text"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(FilterAnswers.fromJS(item));
            }
            this.skill = _data["skill"] ? SkillResponse.fromJS(_data["skill"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FilterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["category_id"] = this.category_id;
        data["question_id"] = this.question_id;
        data["text"] = this.text;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        data["skill"] = this.skill ? this.skill.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFilterResponse {
    id?: number;
    category_id?: number;
    question_id?: number;
    text?: string;
    answers?: FilterAnswers[];
    skill?: SkillResponse;

    [key: string]: any;
}

export class FilterShortResponse implements IFilterShortResponse {
    id?: number;
    category_id?: number;
    question_id?: number;
    text?: string;
    text_question?: string;
    text_skill?: string;
    answers?: FilterAnswers[];

    [key: string]: any;

    constructor(data?: IFilterShortResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.category_id = _data["category_id"];
            this.question_id = _data["question_id"];
            this.text = _data["text"];
            this.text_question = _data["text_question"];
            this.text_skill = _data["text_skill"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(FilterAnswers.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterShortResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FilterShortResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["category_id"] = this.category_id;
        data["question_id"] = this.question_id;
        data["text"] = this.text;
        data["text_question"] = this.text_question;
        data["text_skill"] = this.text_skill;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterShortResponse {
    id?: number;
    category_id?: number;
    question_id?: number;
    text?: string;
    text_question?: string;
    text_skill?: string;
    answers?: FilterAnswers[];

    [key: string]: any;
}

export class FilterAnswers implements IFilterAnswers {
    answer_id?: number;
    is_checked?: boolean;
    text?: string;

    [key: string]: any;

    constructor(data?: IFilterAnswers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.answer_id = _data["answer_id"];
            this.is_checked = _data["is_checked"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): FilterAnswers {
        data = typeof data === 'object' ? data : {};
        let result = new FilterAnswers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["answer_id"] = this.answer_id;
        data["is_checked"] = this.is_checked;
        data["text"] = this.text;
        return data;
    }
}

export interface IFilterAnswers {
    answer_id?: number;
    is_checked?: boolean;
    text?: string;

    [key: string]: any;
}

/** Filter model */
export class FilterError implements IFilterError {
    message?: string;
    errors?: Errors20;

    [key: string]: any;

    constructor(data?: IFilterError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors20.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FilterError {
        data = typeof data === 'object' ? data : {};
        let result = new FilterError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

/** Filter model */
export interface IFilterError {
    message?: string;
    errors?: Errors20;

    [key: string]: any;
}

export class MailRequest implements IMailRequest {
    /** Use type 1 for a support request or type 2 for a user removal request */
    type?: number;
    message?: string;
    topic?: string;
    email?: string;
    files?: MailFileRequest[];

    [key: string]: any;

    constructor(data?: IMailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.message = _data["message"];
            this.topic = _data["topic"];
            this.email = _data["email"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(MailFileRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["message"] = this.message;
        data["topic"] = this.topic;
        data["email"] = this.email;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMailRequest {
    /** Use type 1 for a support request or type 2 for a user removal request */
    type?: number;
    message?: string;
    topic?: string;
    email?: string;
    files?: MailFileRequest[];

    [key: string]: any;
}

export class MailFileRequest implements IMailFileRequest {
    file?: string;
    name?: string;
    size?: number;

    [key: string]: any;

    constructor(data?: IMailFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.file = _data["file"];
            this.name = _data["name"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): MailFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MailFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["file"] = this.file;
        data["name"] = this.name;
        data["size"] = this.size;
        return data;
    }
}

export interface IMailFileRequest {
    file?: string;
    name?: string;
    size?: number;

    [key: string]: any;
}

export class MailUnauthRequest implements IMailUnauthRequest {
    topic?: string;
    message?: string;
    email?: string;
    files?: MailFileRequest[];

    [key: string]: any;

    constructor(data?: IMailUnauthRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.topic = _data["topic"];
            this.message = _data["message"];
            this.email = _data["email"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(MailFileRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MailUnauthRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MailUnauthRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["topic"] = this.topic;
        data["message"] = this.message;
        data["email"] = this.email;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMailUnauthRequest {
    topic?: string;
    message?: string;
    email?: string;
    files?: MailFileRequest[];

    [key: string]: any;
}

export class MailUpdateRequest implements IMailUpdateRequest {
    is_done?: boolean;

    [key: string]: any;

    constructor(data?: IMailUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.is_done = _data["is_done"];
        }
    }

    static fromJS(data: any): MailUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MailUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["is_done"] = this.is_done;
        return data;
    }
}

export interface IMailUpdateRequest {
    is_done?: boolean;

    [key: string]: any;
}

export class MailDataResponse implements IMailDataResponse {
    data?: MailResponse;

    [key: string]: any;

    constructor(data?: IMailDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? MailResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MailDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MailDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMailDataResponse {
    data?: MailResponse;

    [key: string]: any;
}

export class MailsDataResponse implements IMailsDataResponse {
    data?: MailResponse[];

    [key: string]: any;

    constructor(data?: IMailsDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MailResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MailsDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MailsDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMailsDataResponse {
    data?: MailResponse[];

    [key: string]: any;
}

export class MailResponse implements IMailResponse {
    id?: number;
    user_id?: number;
    type?: number;
    subject?: string;
    body?: string;
    is_done?: boolean;
    created_at?: string;
    user?: User;

    [key: string]: any;

    constructor(data?: IMailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.user_id = _data["user_id"];
            this.type = _data["type"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.is_done = _data["is_done"];
            this.created_at = _data["created_at"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["user_id"] = this.user_id;
        data["type"] = this.type;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["is_done"] = this.is_done;
        data["created_at"] = this.created_at;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMailResponse {
    id?: number;
    user_id?: number;
    type?: number;
    subject?: string;
    body?: string;
    is_done?: boolean;
    created_at?: string;
    user?: User;

    [key: string]: any;
}

export class MailError implements IMailError {
    message?: string;
    errors?: Errors21;

    [key: string]: any;

    constructor(data?: IMailError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors21.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MailError {
        data = typeof data === 'object' ? data : {};
        let result = new MailError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMailError {
    message?: string;
    errors?: Errors21;

    [key: string]: any;
}

/** Mail model */
export class MailUpdateError implements IMailUpdateError {
    message?: string;
    errors?: Errors22;

    [key: string]: any;

    constructor(data?: IMailUpdateError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors22.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MailUpdateError {
        data = typeof data === 'object' ? data : {};
        let result = new MailUpdateError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

/** Mail model */
export interface IMailUpdateError {
    message?: string;
    errors?: Errors22;

    [key: string]: any;
}

export class NotificationRequest implements INotificationRequest {
    user_id?: number;
    chat_id?: number;
    type?: number;
    is_read?: boolean;
    message?: string;
    mention_ids?: number[];
    body_text?: string;
    title_text?: string;
    url?: string;
    icon?: string;
    html_data?: string;
    meta?: any;

    [key: string]: any;

    constructor(data?: INotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.user_id = _data["user_id"];
            this.chat_id = _data["chat_id"];
            this.type = _data["type"];
            this.is_read = _data["is_read"];
            this.message = _data["message"];
            if (Array.isArray(_data["mention_ids"])) {
                this.mention_ids = [] as any;
                for (let item of _data["mention_ids"])
                    this.mention_ids!.push(item);
            }
            this.body_text = _data["body_text"];
            this.title_text = _data["title_text"];
            this.url = _data["url"];
            this.icon = _data["icon"];
            this.html_data = _data["html_data"];
            this.meta = _data["meta"];
        }
    }

    static fromJS(data: any): NotificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["user_id"] = this.user_id;
        data["chat_id"] = this.chat_id;
        data["type"] = this.type;
        data["is_read"] = this.is_read;
        data["message"] = this.message;
        if (Array.isArray(this.mention_ids)) {
            data["mention_ids"] = [];
            for (let item of this.mention_ids)
                data["mention_ids"].push(item);
        }
        data["body_text"] = this.body_text;
        data["title_text"] = this.title_text;
        data["url"] = this.url;
        data["icon"] = this.icon;
        data["html_data"] = this.html_data;
        data["meta"] = this.meta;
        return data;
    }
}

export interface INotificationRequest {
    user_id?: number;
    chat_id?: number;
    type?: number;
    is_read?: boolean;
    message?: string;
    mention_ids?: number[];
    body_text?: string;
    title_text?: string;
    url?: string;
    icon?: string;
    html_data?: string;
    meta?: any;

    [key: string]: any;
}

export class NotificationUpdateRequest implements INotificationUpdateRequest {
    is_read?: boolean;

    [key: string]: any;

    constructor(data?: INotificationUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.is_read = _data["is_read"];
        }
    }

    static fromJS(data: any): NotificationUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["is_read"] = this.is_read;
        return data;
    }
}

export interface INotificationUpdateRequest {
    is_read?: boolean;

    [key: string]: any;
}

export class NotificationDataResponse implements INotificationDataResponse {
    data?: NotificationResponse;

    [key: string]: any;

    constructor(data?: INotificationDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? NotificationResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NotificationDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface INotificationDataResponse {
    data?: NotificationResponse;

    [key: string]: any;
}

export class NotificationsDataResponse implements INotificationsDataResponse {
    data?: NotificationIndexResource[];
    links?: Links2;
    meta?: Meta4;

    [key: string]: any;

    constructor(data?: INotificationsDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(NotificationIndexResource.fromJS(item));
            }
            this.links = _data["links"] ? Links2.fromJS(_data["links"]) : <any>undefined;
            this.meta = _data["meta"] ? Meta4.fromJS(_data["meta"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NotificationsDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationsDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["links"] = this.links ? this.links.toJSON() : <any>undefined;
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface INotificationsDataResponse {
    data?: NotificationIndexResource[];
    links?: Links2;
    meta?: Meta4;

    [key: string]: any;
}

export class NotificationResponse implements INotificationResponse {
    id?: number;
    user_id?: number;
    type?: number;
    is_read?: boolean;
    body?: any;
    created_at?: string;
    body_text?: string | undefined;
    title_text?: string | undefined;
    url?: string | undefined;
    icon?: string | undefined;
    html_data?: string | undefined;
    meta?: any | undefined;

    [key: string]: any;

    constructor(data?: INotificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.user_id = _data["user_id"];
            this.type = _data["type"];
            this.is_read = _data["is_read"];
            this.body = _data["body"];
            this.created_at = _data["created_at"];
            this.body_text = _data["body_text"];
            this.title_text = _data["title_text"];
            this.url = _data["url"];
            this.icon = _data["icon"];
            this.html_data = _data["html_data"];
            this.meta = _data["meta"];
        }
    }

    static fromJS(data: any): NotificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["user_id"] = this.user_id;
        data["type"] = this.type;
        data["is_read"] = this.is_read;
        data["body"] = this.body;
        data["created_at"] = this.created_at;
        data["body_text"] = this.body_text;
        data["title_text"] = this.title_text;
        data["url"] = this.url;
        data["icon"] = this.icon;
        data["html_data"] = this.html_data;
        data["meta"] = this.meta;
        return data;
    }
}

export interface INotificationResponse {
    id?: number;
    user_id?: number;
    type?: number;
    is_read?: boolean;
    body?: any;
    created_at?: string;
    body_text?: string | undefined;
    title_text?: string | undefined;
    url?: string | undefined;
    icon?: string | undefined;
    html_data?: string | undefined;
    meta?: any | undefined;

    [key: string]: any;
}

export class NotificationIndexResource implements INotificationIndexResource {
    id?: number;
    type?: number;
    is_read?: boolean;
    body?: any;
    created_at?: string;
    body_text?: string | undefined;
    title_text?: string | undefined;
    url?: string | undefined;
    icon?: string | undefined;
    html_data?: string | undefined;
    meta?: any | undefined;

    [key: string]: any;

    constructor(data?: INotificationIndexResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.type = _data["type"];
            this.is_read = _data["is_read"];
            this.body = _data["body"];
            this.created_at = _data["created_at"];
            this.body_text = _data["body_text"];
            this.title_text = _data["title_text"];
            this.url = _data["url"];
            this.icon = _data["icon"];
            this.html_data = _data["html_data"];
            this.meta = _data["meta"];
        }
    }

    static fromJS(data: any): NotificationIndexResource {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationIndexResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["type"] = this.type;
        data["is_read"] = this.is_read;
        data["body"] = this.body;
        data["created_at"] = this.created_at;
        data["body_text"] = this.body_text;
        data["title_text"] = this.title_text;
        data["url"] = this.url;
        data["icon"] = this.icon;
        data["html_data"] = this.html_data;
        data["meta"] = this.meta;
        return data;
    }
}

export interface INotificationIndexResource {
    id?: number;
    type?: number;
    is_read?: boolean;
    body?: any;
    created_at?: string;
    body_text?: string | undefined;
    title_text?: string | undefined;
    url?: string | undefined;
    icon?: string | undefined;
    html_data?: string | undefined;
    meta?: any | undefined;

    [key: string]: any;
}

export class NotificationError implements INotificationError {
    message?: string;
    errors?: Errors23;

    [key: string]: any;

    constructor(data?: INotificationError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors23.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NotificationError {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface INotificationError {
    message?: string;
    errors?: Errors23;

    [key: string]: any;
}

/** Notification model */
export class NotificationUpdateError implements INotificationUpdateError {
    message?: string;
    errors?: Errors24;

    [key: string]: any;

    constructor(data?: INotificationUpdateError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors24.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NotificationUpdateError {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationUpdateError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

/** Notification model */
export interface INotificationUpdateError {
    message?: string;
    errors?: Errors24;

    [key: string]: any;
}

export class Notification_Type_Comment implements INotification_Type_Comment {
    commentId?: string;
    taskId?: number;

    [key: string]: any;

    constructor(data?: INotification_Type_Comment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.commentId = _data["commentId"];
            this.taskId = _data["taskId"];
        }
    }

    static fromJS(data: any): Notification_Type_Comment {
        data = typeof data === 'object' ? data : {};
        let result = new Notification_Type_Comment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["commentId"] = this.commentId;
        data["taskId"] = this.taskId;
        return data;
    }
}

export interface INotification_Type_Comment {
    commentId?: string;
    taskId?: number;

    [key: string]: any;
}

export class Notification_Type_Subscription_Message implements INotification_Type_Subscription_Message {
    /** push has in body */
    url?: string;

    [key: string]: any;

    constructor(data?: INotification_Type_Subscription_Message) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): Notification_Type_Subscription_Message {
        data = typeof data === 'object' ? data : {};
        let result = new Notification_Type_Subscription_Message();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["url"] = this.url;
        return data;
    }
}

export interface INotification_Type_Subscription_Message {
    /** push has in body */
    url?: string;

    [key: string]: any;
}

export class Notification_Type_User_Actions_Like implements INotification_Type_User_Actions_Like {
    user_id?: number;
    user_name?: string;
    user_surname?: string;
    address?: string;
    likes_count?: string;
    content_id?: number;
    content_type?: string;
    content_target?: Notification_Type_User_Actions_LikeContent_target;

    [key: string]: any;

    constructor(data?: INotification_Type_User_Actions_Like) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.user_id = _data["user_id"];
            this.user_name = _data["user_name"];
            this.user_surname = _data["user_surname"];
            this.address = _data["address"];
            this.likes_count = _data["likes_count"];
            this.content_id = _data["content_id"];
            this.content_type = _data["content_type"];
            this.content_target = _data["content_target"];
        }
    }

    static fromJS(data: any): Notification_Type_User_Actions_Like {
        data = typeof data === 'object' ? data : {};
        let result = new Notification_Type_User_Actions_Like();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["user_id"] = this.user_id;
        data["user_name"] = this.user_name;
        data["user_surname"] = this.user_surname;
        data["address"] = this.address;
        data["likes_count"] = this.likes_count;
        data["content_id"] = this.content_id;
        data["content_type"] = this.content_type;
        data["content_target"] = this.content_target;
        return data;
    }
}

export interface INotification_Type_User_Actions_Like {
    user_id?: number;
    user_name?: string;
    user_surname?: string;
    address?: string;
    likes_count?: string;
    content_id?: number;
    content_type?: string;
    content_target?: Notification_Type_User_Actions_LikeContent_target;

    [key: string]: any;
}

export class Notification_Type_New_Subscriber implements INotification_Type_New_Subscriber {
    /** push has in title */
    name?: string;
    /** push has in title */
    surname?: string;
    user_id?: number;

    [key: string]: any;

    constructor(data?: INotification_Type_New_Subscriber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.user_id = _data["user_id"];
        }
    }

    static fromJS(data: any): Notification_Type_New_Subscriber {
        data = typeof data === 'object' ? data : {};
        let result = new Notification_Type_New_Subscriber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["user_id"] = this.user_id;
        return data;
    }
}

export interface INotification_Type_New_Subscriber {
    /** push has in title */
    name?: string;
    /** push has in title */
    surname?: string;
    user_id?: number;

    [key: string]: any;
}

export class Notification_Type_New_Content_Comment implements INotification_Type_New_Content_Comment {
    user_id?: number;
    user_name?: string;
    user_surname?: string;
    address?: string;
    content_id?: number;
    content_type?: string;
    content_target?: Notification_Type_New_Content_CommentContent_target;

    [key: string]: any;

    constructor(data?: INotification_Type_New_Content_Comment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.user_id = _data["user_id"];
            this.user_name = _data["user_name"];
            this.user_surname = _data["user_surname"];
            this.address = _data["address"];
            this.content_id = _data["content_id"];
            this.content_type = _data["content_type"];
            this.content_target = _data["content_target"];
        }
    }

    static fromJS(data: any): Notification_Type_New_Content_Comment {
        data = typeof data === 'object' ? data : {};
        let result = new Notification_Type_New_Content_Comment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["user_id"] = this.user_id;
        data["user_name"] = this.user_name;
        data["user_surname"] = this.user_surname;
        data["address"] = this.address;
        data["content_id"] = this.content_id;
        data["content_type"] = this.content_type;
        data["content_target"] = this.content_target;
        return data;
    }
}

export interface INotification_Type_New_Content_Comment {
    user_id?: number;
    user_name?: string;
    user_surname?: string;
    address?: string;
    content_id?: number;
    content_type?: string;
    content_target?: Notification_Type_New_Content_CommentContent_target;

    [key: string]: any;
}

export class Notification_Type_Comment_Answer implements INotification_Type_Comment_Answer {
    commentId?: string;
    taskId?: number;

    [key: string]: any;

    constructor(data?: INotification_Type_Comment_Answer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.commentId = _data["commentId"];
            this.taskId = _data["taskId"];
        }
    }

    static fromJS(data: any): Notification_Type_Comment_Answer {
        data = typeof data === 'object' ? data : {};
        let result = new Notification_Type_Comment_Answer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["commentId"] = this.commentId;
        data["taskId"] = this.taskId;
        return data;
    }
}

export interface INotification_Type_Comment_Answer {
    commentId?: string;
    taskId?: number;

    [key: string]: any;
}

export class Notification_Type_New_Content_Comment_Answer implements INotification_Type_New_Content_Comment_Answer {
    user_name?: string;
    user_surname?: string;
    content_id?: number;
    content_type?: string;
    content_target?: Notification_Type_New_Content_Comment_AnswerContent_target;
    comment_id?: number;
    parent_comment_id?: number;

    [key: string]: any;

    constructor(data?: INotification_Type_New_Content_Comment_Answer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.user_name = _data["user_name"];
            this.user_surname = _data["user_surname"];
            this.content_id = _data["content_id"];
            this.content_type = _data["content_type"];
            this.content_target = _data["content_target"];
            this.comment_id = _data["comment_id"];
            this.parent_comment_id = _data["parent_comment_id"];
        }
    }

    static fromJS(data: any): Notification_Type_New_Content_Comment_Answer {
        data = typeof data === 'object' ? data : {};
        let result = new Notification_Type_New_Content_Comment_Answer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["user_name"] = this.user_name;
        data["user_surname"] = this.user_surname;
        data["content_id"] = this.content_id;
        data["content_type"] = this.content_type;
        data["content_target"] = this.content_target;
        data["comment_id"] = this.comment_id;
        data["parent_comment_id"] = this.parent_comment_id;
        return data;
    }
}

export interface INotification_Type_New_Content_Comment_Answer {
    user_name?: string;
    user_surname?: string;
    content_id?: number;
    content_type?: string;
    content_target?: Notification_Type_New_Content_Comment_AnswerContent_target;
    comment_id?: number;
    parent_comment_id?: number;

    [key: string]: any;
}

export class OfferRequest implements IOfferRequest {
    task_id?: number;
    user_id?: number;
    text?: string;

    [key: string]: any;

    constructor(data?: IOfferRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.task_id = _data["task_id"];
            this.user_id = _data["user_id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): OfferRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OfferRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["task_id"] = this.task_id;
        data["user_id"] = this.user_id;
        data["text"] = this.text;
        return data;
    }
}

export interface IOfferRequest {
    task_id?: number;
    user_id?: number;
    text?: string;

    [key: string]: any;
}

export class OfferUpdateRequest implements IOfferUpdateRequest {
    text?: string;

    [key: string]: any;

    constructor(data?: IOfferUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): OfferUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OfferUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["text"] = this.text;
        return data;
    }
}

export interface IOfferUpdateRequest {
    text?: string;

    [key: string]: any;
}

export class OfferDataResponse implements IOfferDataResponse {
    data?: OfferResponse;

    [key: string]: any;

    constructor(data?: IOfferDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? OfferResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OfferDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OfferDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOfferDataResponse {
    data?: OfferResponse;

    [key: string]: any;
}

export class OffersDataResponse implements IOffersDataResponse {
    data?: OfferResponse[];

    [key: string]: any;

    constructor(data?: IOffersDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OfferResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OffersDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OffersDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOffersDataResponse {
    data?: OfferResponse[];

    [key: string]: any;
}

export class OfferResponse implements IOfferResponse {
    id?: number;
    task_id?: number;
    owner_id?: number;
    user_id?: number;
    status?: number;
    text?: string;

    [key: string]: any;

    constructor(data?: IOfferResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.task_id = _data["task_id"];
            this.owner_id = _data["owner_id"];
            this.user_id = _data["user_id"];
            this.status = _data["status"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): OfferResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OfferResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["task_id"] = this.task_id;
        data["owner_id"] = this.owner_id;
        data["user_id"] = this.user_id;
        data["status"] = this.status;
        data["text"] = this.text;
        return data;
    }
}

export interface IOfferResponse {
    id?: number;
    task_id?: number;
    owner_id?: number;
    user_id?: number;
    status?: number;
    text?: string;

    [key: string]: any;
}

/** Offer model */
export class OfferError implements IOfferError {
    message?: string;
    errors?: Errors25;

    [key: string]: any;

    constructor(data?: IOfferError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors25.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OfferError {
        data = typeof data === 'object' ? data : {};
        let result = new OfferError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

/** Offer model */
export interface IOfferError {
    message?: string;
    errors?: Errors25;

    [key: string]: any;
}

export class ProfileFileFormdataRequest implements IProfileFileFormdataRequest {
    file?: string;
    description?: string;

    [key: string]: any;

    constructor(data?: IProfileFileFormdataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.file = _data["file"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ProfileFileFormdataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileFileFormdataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["file"] = this.file;
        data["description"] = this.description;
        return data;
    }
}

export interface IProfileFileFormdataRequest {
    file?: string;
    description?: string;

    [key: string]: any;
}

export class ProfileFileRequest implements IProfileFileRequest {
    file?: string;
    description?: string;
    name?: string;
    size?: number;

    [key: string]: any;

    constructor(data?: IProfileFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.file = _data["file"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): ProfileFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["file"] = this.file;
        data["description"] = this.description;
        data["name"] = this.name;
        data["size"] = this.size;
        return data;
    }
}

export interface IProfileFileRequest {
    file?: string;
    description?: string;
    name?: string;
    size?: number;

    [key: string]: any;
}

export class ProfileFileUpdateRequest implements IProfileFileUpdateRequest {
    description?: string;
    title?: string;

    [key: string]: any;

    constructor(data?: IProfileFileUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.description = _data["description"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): ProfileFileUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileFileUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["description"] = this.description;
        data["title"] = this.title;
        return data;
    }
}

export interface IProfileFileUpdateRequest {
    description?: string;
    title?: string;

    [key: string]: any;
}

export class ProfileFileUpdateError implements IProfileFileUpdateError {
    message?: string;
    errors?: Errors26;

    [key: string]: any;

    constructor(data?: IProfileFileUpdateError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors26.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProfileFileUpdateError {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileFileUpdateError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProfileFileUpdateError {
    message?: string;
    errors?: Errors26;

    [key: string]: any;
}

/** ProfileFile Model */
export class ProfileFileError implements IProfileFileError {
    message?: string;
    errors?: Errors27;

    [key: string]: any;

    constructor(data?: IProfileFileError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors27.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProfileFileError {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileFileError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

/** ProfileFile Model */
export interface IProfileFileError {
    message?: string;
    errors?: Errors27;

    [key: string]: any;
}

export class QuestionRequest implements IQuestionRequest {
    category_id?: number;
    next_question_id?: number;
    is_skip_next_question_id?: number;
    text_question?: string;
    type_question?: string;
    is_start?: boolean;
    is_skip?: boolean;
    allow_my_answer?: boolean;
    type_my_answer?: number;
    can_add_files?: boolean;
    example_answers?: any[];
    type_values?: any[];
    answers?: AnswersRequest[];
    files?: QuestionFileRequest[];

    [key: string]: any;

    constructor(data?: IQuestionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.category_id = _data["category_id"];
            this.next_question_id = _data["next_question_id"];
            this.is_skip_next_question_id = _data["is_skip_next_question_id"];
            this.text_question = _data["text_question"];
            this.type_question = _data["type_question"];
            this.is_start = _data["is_start"];
            this.is_skip = _data["is_skip"];
            this.allow_my_answer = _data["allow_my_answer"];
            this.type_my_answer = _data["type_my_answer"];
            this.can_add_files = _data["can_add_files"];
            if (Array.isArray(_data["example_answers"])) {
                this.example_answers = [] as any;
                for (let item of _data["example_answers"])
                    this.example_answers!.push(item);
            }
            if (Array.isArray(_data["type_values"])) {
                this.type_values = [] as any;
                for (let item of _data["type_values"])
                    this.type_values!.push(item);
            }
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(AnswersRequest.fromJS(item));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(QuestionFileRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["category_id"] = this.category_id;
        data["next_question_id"] = this.next_question_id;
        data["is_skip_next_question_id"] = this.is_skip_next_question_id;
        data["text_question"] = this.text_question;
        data["type_question"] = this.type_question;
        data["is_start"] = this.is_start;
        data["is_skip"] = this.is_skip;
        data["allow_my_answer"] = this.allow_my_answer;
        data["type_my_answer"] = this.type_my_answer;
        data["can_add_files"] = this.can_add_files;
        if (Array.isArray(this.example_answers)) {
            data["example_answers"] = [];
            for (let item of this.example_answers)
                data["example_answers"].push(item);
        }
        if (Array.isArray(this.type_values)) {
            data["type_values"] = [];
            for (let item of this.type_values)
                data["type_values"].push(item);
        }
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuestionRequest {
    category_id?: number;
    next_question_id?: number;
    is_skip_next_question_id?: number;
    text_question?: string;
    type_question?: string;
    is_start?: boolean;
    is_skip?: boolean;
    allow_my_answer?: boolean;
    type_my_answer?: number;
    can_add_files?: boolean;
    example_answers?: any[];
    type_values?: any[];
    answers?: AnswersRequest[];
    files?: QuestionFileRequest[];

    [key: string]: any;
}

export class QuestionUpdateRequest implements IQuestionUpdateRequest {
    category_id?: number;
    next_question_id?: number;
    is_skip_next_question_id?: number;
    text_question?: string;
    type_question?: string;
    is_start?: boolean;
    is_skip?: boolean;
    allow_my_answer?: boolean;
    type_my_answer?: number;
    can_add_files?: boolean;
    example_answers?: any[];
    type_values?: any[];
    answers?: AnswersRequest[];
    files?: QuestionFileRequest[];
    deleted?: any[];
    deletedFiles?: any[];

    [key: string]: any;

    constructor(data?: IQuestionUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.category_id = _data["category_id"];
            this.next_question_id = _data["next_question_id"];
            this.is_skip_next_question_id = _data["is_skip_next_question_id"];
            this.text_question = _data["text_question"];
            this.type_question = _data["type_question"];
            this.is_start = _data["is_start"];
            this.is_skip = _data["is_skip"];
            this.allow_my_answer = _data["allow_my_answer"];
            this.type_my_answer = _data["type_my_answer"];
            this.can_add_files = _data["can_add_files"];
            if (Array.isArray(_data["example_answers"])) {
                this.example_answers = [] as any;
                for (let item of _data["example_answers"])
                    this.example_answers!.push(item);
            }
            if (Array.isArray(_data["type_values"])) {
                this.type_values = [] as any;
                for (let item of _data["type_values"])
                    this.type_values!.push(item);
            }
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(AnswersRequest.fromJS(item));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(QuestionFileRequest.fromJS(item));
            }
            if (Array.isArray(_data["deleted"])) {
                this.deleted = [] as any;
                for (let item of _data["deleted"])
                    this.deleted!.push(item);
            }
            if (Array.isArray(_data["deletedFiles"])) {
                this.deletedFiles = [] as any;
                for (let item of _data["deletedFiles"])
                    this.deletedFiles!.push(item);
            }
        }
    }

    static fromJS(data: any): QuestionUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["category_id"] = this.category_id;
        data["next_question_id"] = this.next_question_id;
        data["is_skip_next_question_id"] = this.is_skip_next_question_id;
        data["text_question"] = this.text_question;
        data["type_question"] = this.type_question;
        data["is_start"] = this.is_start;
        data["is_skip"] = this.is_skip;
        data["allow_my_answer"] = this.allow_my_answer;
        data["type_my_answer"] = this.type_my_answer;
        data["can_add_files"] = this.can_add_files;
        if (Array.isArray(this.example_answers)) {
            data["example_answers"] = [];
            for (let item of this.example_answers)
                data["example_answers"].push(item);
        }
        if (Array.isArray(this.type_values)) {
            data["type_values"] = [];
            for (let item of this.type_values)
                data["type_values"].push(item);
        }
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        if (Array.isArray(this.deleted)) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item);
        }
        if (Array.isArray(this.deletedFiles)) {
            data["deletedFiles"] = [];
            for (let item of this.deletedFiles)
                data["deletedFiles"].push(item);
        }
        return data;
    }
}

export interface IQuestionUpdateRequest {
    category_id?: number;
    next_question_id?: number;
    is_skip_next_question_id?: number;
    text_question?: string;
    type_question?: string;
    is_start?: boolean;
    is_skip?: boolean;
    allow_my_answer?: boolean;
    type_my_answer?: number;
    can_add_files?: boolean;
    example_answers?: any[];
    type_values?: any[];
    answers?: AnswersRequest[];
    files?: QuestionFileRequest[];
    deleted?: any[];
    deletedFiles?: any[];

    [key: string]: any;
}

export class QuestionDataResponse implements IQuestionDataResponse {
    data?: QuestionResponse;

    [key: string]: any;

    constructor(data?: IQuestionDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? QuestionResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QuestionDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IQuestionDataResponse {
    data?: QuestionResponse;

    [key: string]: any;
}

export class QuestionsDataResponse implements IQuestionsDataResponse {
    data?: QuestionResponse[];

    [key: string]: any;

    constructor(data?: IQuestionsDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QuestionResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionsDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionsDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuestionsDataResponse {
    data?: QuestionResponse[];

    [key: string]: any;
}

export class QuestionResponse implements IQuestionResponse {
    id?: number;
    category_id?: number;
    next_question_id?: number;
    is_skip_next_question_id?: number;
    text_question?: string;
    type_question?: string;
    is_start?: boolean;
    is_skip?: boolean;
    allow_my_answer?: boolean;
    type_my_answer?: number;
    can_add_files?: boolean;
    example_answers?: any[];
    type_values?: any[];
    answers?: AnswersResponse[];
    category?: CategoryShortResponse;
    next_question?: QuestionShortResponse;
    is_skip_next_question?: QuestionShortResponse;
    files?: FileResponse[];
    skill?: SkillResponse;

    [key: string]: any;

    constructor(data?: IQuestionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.category_id = _data["category_id"];
            this.next_question_id = _data["next_question_id"];
            this.is_skip_next_question_id = _data["is_skip_next_question_id"];
            this.text_question = _data["text_question"];
            this.type_question = _data["type_question"];
            this.is_start = _data["is_start"];
            this.is_skip = _data["is_skip"];
            this.allow_my_answer = _data["allow_my_answer"];
            this.type_my_answer = _data["type_my_answer"];
            this.can_add_files = _data["can_add_files"];
            if (Array.isArray(_data["example_answers"])) {
                this.example_answers = [] as any;
                for (let item of _data["example_answers"])
                    this.example_answers!.push(item);
            }
            if (Array.isArray(_data["type_values"])) {
                this.type_values = [] as any;
                for (let item of _data["type_values"])
                    this.type_values!.push(item);
            }
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(AnswersResponse.fromJS(item));
            }
            this.category = _data["category"] ? CategoryShortResponse.fromJS(_data["category"]) : <any>undefined;
            this.next_question = _data["next_question"] ? QuestionShortResponse.fromJS(_data["next_question"]) : <any>undefined;
            this.is_skip_next_question = _data["is_skip_next_question"] ? QuestionShortResponse.fromJS(_data["is_skip_next_question"]) : <any>undefined;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileResponse.fromJS(item));
            }
            this.skill = _data["skill"] ? SkillResponse.fromJS(_data["skill"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QuestionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["category_id"] = this.category_id;
        data["next_question_id"] = this.next_question_id;
        data["is_skip_next_question_id"] = this.is_skip_next_question_id;
        data["text_question"] = this.text_question;
        data["type_question"] = this.type_question;
        data["is_start"] = this.is_start;
        data["is_skip"] = this.is_skip;
        data["allow_my_answer"] = this.allow_my_answer;
        data["type_my_answer"] = this.type_my_answer;
        data["can_add_files"] = this.can_add_files;
        if (Array.isArray(this.example_answers)) {
            data["example_answers"] = [];
            for (let item of this.example_answers)
                data["example_answers"].push(item);
        }
        if (Array.isArray(this.type_values)) {
            data["type_values"] = [];
            for (let item of this.type_values)
                data["type_values"].push(item);
        }
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["next_question"] = this.next_question ? this.next_question.toJSON() : <any>undefined;
        data["is_skip_next_question"] = this.is_skip_next_question ? this.is_skip_next_question.toJSON() : <any>undefined;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["skill"] = this.skill ? this.skill.toJSON() : <any>undefined;
        return data;
    }
}

export interface IQuestionResponse {
    id?: number;
    category_id?: number;
    next_question_id?: number;
    is_skip_next_question_id?: number;
    text_question?: string;
    type_question?: string;
    is_start?: boolean;
    is_skip?: boolean;
    allow_my_answer?: boolean;
    type_my_answer?: number;
    can_add_files?: boolean;
    example_answers?: any[];
    type_values?: any[];
    answers?: AnswersResponse[];
    category?: CategoryShortResponse;
    next_question?: QuestionShortResponse;
    is_skip_next_question?: QuestionShortResponse;
    files?: FileResponse[];
    skill?: SkillResponse;

    [key: string]: any;
}

export class QuestionShortResponse implements IQuestionShortResponse {
    id?: number;
    category_id?: number;
    next_question_id?: number;
    is_skip_next_question_id?: number;
    text_question?: string;
    type_question?: string;
    is_start?: boolean;
    is_skip?: boolean;
    allow_my_answer?: boolean;
    can_add_files?: boolean;
    example_answers?: any[];
    type_values?: any[];

    [key: string]: any;

    constructor(data?: IQuestionShortResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.category_id = _data["category_id"];
            this.next_question_id = _data["next_question_id"];
            this.is_skip_next_question_id = _data["is_skip_next_question_id"];
            this.text_question = _data["text_question"];
            this.type_question = _data["type_question"];
            this.is_start = _data["is_start"];
            this.is_skip = _data["is_skip"];
            this.allow_my_answer = _data["allow_my_answer"];
            this.can_add_files = _data["can_add_files"];
            if (Array.isArray(_data["example_answers"])) {
                this.example_answers = [] as any;
                for (let item of _data["example_answers"])
                    this.example_answers!.push(item);
            }
            if (Array.isArray(_data["type_values"])) {
                this.type_values = [] as any;
                for (let item of _data["type_values"])
                    this.type_values!.push(item);
            }
        }
    }

    static fromJS(data: any): QuestionShortResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionShortResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["category_id"] = this.category_id;
        data["next_question_id"] = this.next_question_id;
        data["is_skip_next_question_id"] = this.is_skip_next_question_id;
        data["text_question"] = this.text_question;
        data["type_question"] = this.type_question;
        data["is_start"] = this.is_start;
        data["is_skip"] = this.is_skip;
        data["allow_my_answer"] = this.allow_my_answer;
        data["can_add_files"] = this.can_add_files;
        if (Array.isArray(this.example_answers)) {
            data["example_answers"] = [];
            for (let item of this.example_answers)
                data["example_answers"].push(item);
        }
        if (Array.isArray(this.type_values)) {
            data["type_values"] = [];
            for (let item of this.type_values)
                data["type_values"].push(item);
        }
        return data;
    }
}

export interface IQuestionShortResponse {
    id?: number;
    category_id?: number;
    next_question_id?: number;
    is_skip_next_question_id?: number;
    text_question?: string;
    type_question?: string;
    is_start?: boolean;
    is_skip?: boolean;
    allow_my_answer?: boolean;
    can_add_files?: boolean;
    example_answers?: any[];
    type_values?: any[];

    [key: string]: any;
}

/** Question model */
export class QuestionError implements IQuestionError {
    message?: string;
    errors?: Errors28;

    [key: string]: any;

    constructor(data?: IQuestionError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors28.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QuestionError {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

/** Question model */
export interface IQuestionError {
    message?: string;
    errors?: Errors28;

    [key: string]: any;
}

export class QuestionFileRequest implements IQuestionFileRequest {
    file?: string;
    name?: string;
    size?: number;

    [key: string]: any;

    constructor(data?: IQuestionFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.file = _data["file"];
            this.name = _data["name"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): QuestionFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["file"] = this.file;
        data["name"] = this.name;
        data["size"] = this.size;
        return data;
    }
}

export interface IQuestionFileRequest {
    file?: string;
    name?: string;
    size?: number;

    [key: string]: any;
}

/** QuestionFile model */
export class QuestionFileResponse implements IQuestionFileResponse {
    id?: number;
    task_id?: number;
    file_id?: number;

    [key: string]: any;

    constructor(data?: IQuestionFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.task_id = _data["task_id"];
            this.file_id = _data["file_id"];
        }
    }

    static fromJS(data: any): QuestionFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["task_id"] = this.task_id;
        data["file_id"] = this.file_id;
        return data;
    }
}

/** QuestionFile model */
export interface IQuestionFileResponse {
    id?: number;
    task_id?: number;
    file_id?: number;

    [key: string]: any;
}

export class RatingRequest implements IRatingRequest {
    user_id?: number;
    category_id?: number;
    avatar_order_id?: number;
    rating?: number;
    is_anonymous?: boolean;
    video_quality?: number;
    controls?: number;
    problems?: number;
    description?: string;
    app_description?: string;

    [key: string]: any;

    constructor(data?: IRatingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.user_id = _data["user_id"];
            this.category_id = _data["category_id"];
            this.avatar_order_id = _data["avatar_order_id"];
            this.rating = _data["rating"];
            this.is_anonymous = _data["is_anonymous"];
            this.video_quality = _data["video_quality"];
            this.controls = _data["controls"];
            this.problems = _data["problems"];
            this.description = _data["description"];
            this.app_description = _data["app_description"];
        }
    }

    static fromJS(data: any): RatingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RatingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["user_id"] = this.user_id;
        data["category_id"] = this.category_id;
        data["avatar_order_id"] = this.avatar_order_id;
        data["rating"] = this.rating;
        data["is_anonymous"] = this.is_anonymous;
        data["video_quality"] = this.video_quality;
        data["controls"] = this.controls;
        data["problems"] = this.problems;
        data["description"] = this.description;
        data["app_description"] = this.app_description;
        return data;
    }
}

export interface IRatingRequest {
    user_id?: number;
    category_id?: number;
    avatar_order_id?: number;
    rating?: number;
    is_anonymous?: boolean;
    video_quality?: number;
    controls?: number;
    problems?: number;
    description?: string;
    app_description?: string;

    [key: string]: any;
}

export class RatingUpdateRequest implements IRatingUpdateRequest {
    rating?: number;
    description?: string;
    app_description?: string;

    [key: string]: any;

    constructor(data?: IRatingUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.rating = _data["rating"];
            this.description = _data["description"];
            this.app_description = _data["app_description"];
        }
    }

    static fromJS(data: any): RatingUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RatingUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["rating"] = this.rating;
        data["description"] = this.description;
        data["app_description"] = this.app_description;
        return data;
    }
}

export interface IRatingUpdateRequest {
    rating?: number;
    description?: string;
    app_description?: string;

    [key: string]: any;
}

export class RatingDataResponse implements IRatingDataResponse {
    data?: RatingResponse;

    [key: string]: any;

    constructor(data?: IRatingDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? RatingResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RatingDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RatingDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRatingDataResponse {
    data?: RatingResponse;

    [key: string]: any;
}

export class RatingsDataResponse implements IRatingsDataResponse {
    data?: RatingResponse[];

    [key: string]: any;

    constructor(data?: IRatingsDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RatingResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RatingsDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RatingsDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRatingsDataResponse {
    data?: RatingResponse[];

    [key: string]: any;
}

export class RatingResponse implements IRatingResponse {
    id?: number;
    user_id?: number;
    user_id_from?: number;
    category_id?: number;
    avatar_order_id?: number;
    rating?: number;
    description?: string;
    app_description?: string;
    created_at?: string;
    user_from?: User_from;
    tags?: string[];

    [key: string]: any;

    constructor(data?: IRatingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.user_id = _data["user_id"];
            this.user_id_from = _data["user_id_from"];
            this.category_id = _data["category_id"];
            this.avatar_order_id = _data["avatar_order_id"];
            this.rating = _data["rating"];
            this.description = _data["description"];
            this.app_description = _data["app_description"];
            this.created_at = _data["created_at"];
            this.user_from = _data["user_from"] ? User_from.fromJS(_data["user_from"]) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): RatingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RatingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["user_id"] = this.user_id;
        data["user_id_from"] = this.user_id_from;
        data["category_id"] = this.category_id;
        data["avatar_order_id"] = this.avatar_order_id;
        data["rating"] = this.rating;
        data["description"] = this.description;
        data["app_description"] = this.app_description;
        data["created_at"] = this.created_at;
        data["user_from"] = this.user_from ? this.user_from.toJSON() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IRatingResponse {
    id?: number;
    user_id?: number;
    user_id_from?: number;
    category_id?: number;
    avatar_order_id?: number;
    rating?: number;
    description?: string;
    app_description?: string;
    created_at?: string;
    user_from?: User_from;
    tags?: string[];

    [key: string]: any;
}

/** Rating model */
export class RatingError implements IRatingError {
    message?: string;
    errors?: Errors29;

    [key: string]: any;

    constructor(data?: IRatingError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors29.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RatingError {
        data = typeof data === 'object' ? data : {};
        let result = new RatingError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

/** Rating model */
export interface IRatingError {
    message?: string;
    errors?: Errors29;

    [key: string]: any;
}

export class ReplyRequest implements IReplyRequest {
    task_id?: number;
    text?: string;
    price?: number;
    deadline_at?: string;

    [key: string]: any;

    constructor(data?: IReplyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.task_id = _data["task_id"];
            this.text = _data["text"];
            this.price = _data["price"];
            this.deadline_at = _data["deadline_at"];
        }
    }

    static fromJS(data: any): ReplyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReplyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["task_id"] = this.task_id;
        data["text"] = this.text;
        data["price"] = this.price;
        data["deadline_at"] = this.deadline_at;
        return data;
    }
}

export interface IReplyRequest {
    task_id?: number;
    text?: string;
    price?: number;
    deadline_at?: string;

    [key: string]: any;
}

export class ReplyUpdateRequest implements IReplyUpdateRequest {
    text?: string;
    price?: number;
    deadline_at?: string;

    [key: string]: any;

    constructor(data?: IReplyUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.text = _data["text"];
            this.price = _data["price"];
            this.deadline_at = _data["deadline_at"];
        }
    }

    static fromJS(data: any): ReplyUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReplyUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["text"] = this.text;
        data["price"] = this.price;
        data["deadline_at"] = this.deadline_at;
        return data;
    }
}

export interface IReplyUpdateRequest {
    text?: string;
    price?: number;
    deadline_at?: string;

    [key: string]: any;
}

export class DisputeDescriptionRequest implements IDisputeDescriptionRequest {
    dispute_description?: string;

    [key: string]: any;

    constructor(data?: IDisputeDescriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.dispute_description = _data["dispute_description"];
        }
    }

    static fromJS(data: any): DisputeDescriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DisputeDescriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["dispute_description"] = this.dispute_description;
        return data;
    }
}

export interface IDisputeDescriptionRequest {
    dispute_description?: string;

    [key: string]: any;
}

export class ReplyOfferRequest implements IReplyOfferRequest {
    task_id?: number;
    user_id?: number;

    [key: string]: any;

    constructor(data?: IReplyOfferRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.task_id = _data["task_id"];
            this.user_id = _data["user_id"];
        }
    }

    static fromJS(data: any): ReplyOfferRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReplyOfferRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["task_id"] = this.task_id;
        data["user_id"] = this.user_id;
        return data;
    }
}

export interface IReplyOfferRequest {
    task_id?: number;
    user_id?: number;

    [key: string]: any;
}

export class ReplyAcceptOfferRequest implements IReplyAcceptOfferRequest {
    text?: string;
    price?: number;
    deadline_at?: string;

    [key: string]: any;

    constructor(data?: IReplyAcceptOfferRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.text = _data["text"];
            this.price = _data["price"];
            this.deadline_at = _data["deadline_at"];
        }
    }

    static fromJS(data: any): ReplyAcceptOfferRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReplyAcceptOfferRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["text"] = this.text;
        data["price"] = this.price;
        data["deadline_at"] = this.deadline_at;
        return data;
    }
}

export interface IReplyAcceptOfferRequest {
    text?: string;
    price?: number;
    deadline_at?: string;

    [key: string]: any;
}

export class ReplyDataResponse implements IReplyDataResponse {
    data?: ReplyResponse;

    [key: string]: any;

    constructor(data?: IReplyDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? ReplyResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReplyDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReplyDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReplyDataResponse {
    data?: ReplyResponse;

    [key: string]: any;
}

export class RepliesDataResponse implements IRepliesDataResponse {
    data?: ReplyResponse[];

    [key: string]: any;

    constructor(data?: IRepliesDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ReplyResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RepliesDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RepliesDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRepliesDataResponse {
    data?: ReplyResponse[];

    [key: string]: any;
}

export class ReplyResponse implements IReplyResponse {
    id?: number;
    task_id?: number;
    chat_id?: number;
    user_id?: number;
    trusted_user_id?: number;
    disputed_user_id?: number;
    text?: string;
    price?: number;
    status?: number;
    qty_extra_work?: number;
    dispute_description?: string;
    dispute_resolve_result?: DisputeResolveResultResponse;
    deadline_at?: string;
    date_pending_at?: string;
    date_accept_or_reject_at?: string;
    cancel_resolve_dispute_at?: string;
    date_done_at?: string;
    user?: UserShortForReplyResponse;

    [key: string]: any;

    constructor(data?: IReplyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.task_id = _data["task_id"];
            this.chat_id = _data["chat_id"];
            this.user_id = _data["user_id"];
            this.trusted_user_id = _data["trusted_user_id"];
            this.disputed_user_id = _data["disputed_user_id"];
            this.text = _data["text"];
            this.price = _data["price"];
            this.status = _data["status"];
            this.qty_extra_work = _data["qty_extra_work"];
            this.dispute_description = _data["dispute_description"];
            this.dispute_resolve_result = _data["dispute_resolve_result"] ? DisputeResolveResultResponse.fromJS(_data["dispute_resolve_result"]) : <any>undefined;
            this.deadline_at = _data["deadline_at"];
            this.date_pending_at = _data["date_pending_at"];
            this.date_accept_or_reject_at = _data["date_accept_or_reject_at"];
            this.cancel_resolve_dispute_at = _data["cancel_resolve_dispute_at"];
            this.date_done_at = _data["date_done_at"];
            this.user = _data["user"] ? UserShortForReplyResponse.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReplyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReplyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["task_id"] = this.task_id;
        data["chat_id"] = this.chat_id;
        data["user_id"] = this.user_id;
        data["trusted_user_id"] = this.trusted_user_id;
        data["disputed_user_id"] = this.disputed_user_id;
        data["text"] = this.text;
        data["price"] = this.price;
        data["status"] = this.status;
        data["qty_extra_work"] = this.qty_extra_work;
        data["dispute_description"] = this.dispute_description;
        data["dispute_resolve_result"] = this.dispute_resolve_result ? this.dispute_resolve_result.toJSON() : <any>undefined;
        data["deadline_at"] = this.deadline_at;
        data["date_pending_at"] = this.date_pending_at;
        data["date_accept_or_reject_at"] = this.date_accept_or_reject_at;
        data["cancel_resolve_dispute_at"] = this.cancel_resolve_dispute_at;
        data["date_done_at"] = this.date_done_at;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReplyResponse {
    id?: number;
    task_id?: number;
    chat_id?: number;
    user_id?: number;
    trusted_user_id?: number;
    disputed_user_id?: number;
    text?: string;
    price?: number;
    status?: number;
    qty_extra_work?: number;
    dispute_description?: string;
    dispute_resolve_result?: DisputeResolveResultResponse;
    deadline_at?: string;
    date_pending_at?: string;
    date_accept_or_reject_at?: string;
    cancel_resolve_dispute_at?: string;
    date_done_at?: string;
    user?: UserShortForReplyResponse;

    [key: string]: any;
}

export class DisputeResolveResultResponse implements IDisputeResolveResultResponse {
    owner_percent?: number;
    owner_amount?: number;
    contractor_percent?: number;
    contractor_amount?: number;

    [key: string]: any;

    constructor(data?: IDisputeResolveResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.owner_percent = _data["owner_percent"];
            this.owner_amount = _data["owner_amount"];
            this.contractor_percent = _data["contractor_percent"];
            this.contractor_amount = _data["contractor_amount"];
        }
    }

    static fromJS(data: any): DisputeResolveResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DisputeResolveResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["owner_percent"] = this.owner_percent;
        data["owner_amount"] = this.owner_amount;
        data["contractor_percent"] = this.contractor_percent;
        data["contractor_amount"] = this.contractor_amount;
        return data;
    }
}

export interface IDisputeResolveResultResponse {
    owner_percent?: number;
    owner_amount?: number;
    contractor_percent?: number;
    contractor_amount?: number;

    [key: string]: any;
}

export class ReplyTaskDataResponse implements IReplyTaskDataResponse {
    data?: ReplyTaskResponse[];

    [key: string]: any;

    constructor(data?: IReplyTaskDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ReplyTaskResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReplyTaskDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReplyTaskDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReplyTaskDataResponse {
    data?: ReplyTaskResponse[];

    [key: string]: any;
}

export class ReplyOrReplyTaskDataResponse implements IReplyOrReplyTaskDataResponse {
    data?: ReplyResponse;

    [key: string]: any;

    constructor(data?: IReplyOrReplyTaskDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? ReplyResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReplyOrReplyTaskDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReplyOrReplyTaskDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReplyOrReplyTaskDataResponse {
    data?: ReplyResponse;

    [key: string]: any;
}

export class ReplyTaskResponse implements IReplyTaskResponse {
    id?: number;
    task_id?: number;
    text?: string;
    price?: number;
    status?: number;
    qty_extra_work?: number;
    dispute_description?: string;
    deadline_at?: string;
    date_pending_at?: string;
    date_accept_or_reject_at?: string;
    date_done_at?: string;
    user?: UserResponse;
    task?: TaskResponse;
    chat?: ChatResponse;

    [key: string]: any;

    constructor(data?: IReplyTaskResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.task_id = _data["task_id"];
            this.text = _data["text"];
            this.price = _data["price"];
            this.status = _data["status"];
            this.qty_extra_work = _data["qty_extra_work"];
            this.dispute_description = _data["dispute_description"];
            this.deadline_at = _data["deadline_at"];
            this.date_pending_at = _data["date_pending_at"];
            this.date_accept_or_reject_at = _data["date_accept_or_reject_at"];
            this.date_done_at = _data["date_done_at"];
            this.user = _data["user"] ? UserResponse.fromJS(_data["user"]) : <any>undefined;
            this.task = _data["task"] ? TaskResponse.fromJS(_data["task"]) : <any>undefined;
            this.chat = _data["chat"] ? ChatResponse.fromJS(_data["chat"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReplyTaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReplyTaskResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["task_id"] = this.task_id;
        data["text"] = this.text;
        data["price"] = this.price;
        data["status"] = this.status;
        data["qty_extra_work"] = this.qty_extra_work;
        data["dispute_description"] = this.dispute_description;
        data["deadline_at"] = this.deadline_at;
        data["date_pending_at"] = this.date_pending_at;
        data["date_accept_or_reject_at"] = this.date_accept_or_reject_at;
        data["date_done_at"] = this.date_done_at;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["task"] = this.task ? this.task.toJSON() : <any>undefined;
        data["chat"] = this.chat ? this.chat.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReplyTaskResponse {
    id?: number;
    task_id?: number;
    text?: string;
    price?: number;
    status?: number;
    qty_extra_work?: number;
    dispute_description?: string;
    deadline_at?: string;
    date_pending_at?: string;
    date_accept_or_reject_at?: string;
    date_done_at?: string;
    user?: UserResponse;
    task?: TaskResponse;
    chat?: ChatResponse;

    [key: string]: any;
}

export class ReplyTaskShortResponse implements IReplyTaskShortResponse {
    id?: number;
    price?: number;
    task?: Task;

    [key: string]: any;

    constructor(data?: IReplyTaskShortResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.price = _data["price"];
            this.task = _data["task"] ? Task.fromJS(_data["task"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReplyTaskShortResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReplyTaskShortResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["price"] = this.price;
        data["task"] = this.task ? this.task.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReplyTaskShortResponse {
    id?: number;
    price?: number;
    task?: Task;

    [key: string]: any;
}

export class ReplyTaskShortDataResponse implements IReplyTaskShortDataResponse {
    data?: ReplyTaskShortResponse[];

    [key: string]: any;

    constructor(data?: IReplyTaskShortDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ReplyTaskShortResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReplyTaskShortDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReplyTaskShortDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReplyTaskShortDataResponse {
    data?: ReplyTaskShortResponse[];

    [key: string]: any;
}

/** Reply model */
export class ReplyError implements IReplyError {
    message?: string;
    errors?: Errors30;

    [key: string]: any;

    constructor(data?: IReplyError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors30.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReplyError {
        data = typeof data === 'object' ? data : {};
        let result = new ReplyError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

/** Reply model */
export interface IReplyError {
    message?: string;
    errors?: Errors30;

    [key: string]: any;
}

export class ReportRequest implements IReportRequest {
    object_id?: string;
    /** 
 *         TYPE_TASK        = 1,
 *         TYPE_COMMENT     = 2,
 *         TYPE_MESSAGE     = 3,
 *         TYPE_OFFER       = 4,
 *         TYPE_REPLY       = 5,
 *         TYPE_EXTRA_WORK  = 6,
 *         TYPE_TASK_RESULT = 7,
 *         TYPE_USER        = 8,
 *         TYPE_RATING      = 9,
 *         TYPE_FILE = 10,
 *         TYPE_LIVE_STREAM = 11,
 *         TYPE_STREAM =  12,
 *         TYPE_CONTENT_COMMENT = 13 */
    type?: number;
    reason?: number;
    description?: string;

    [key: string]: any;

    constructor(data?: IReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.object_id = _data["object_id"];
            this.type = _data["type"];
            this.reason = _data["reason"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["object_id"] = this.object_id;
        data["type"] = this.type;
        data["reason"] = this.reason;
        data["description"] = this.description;
        return data;
    }
}

export interface IReportRequest {
    object_id?: string;
    /** 
 *         TYPE_TASK        = 1,
 *         TYPE_COMMENT     = 2,
 *         TYPE_MESSAGE     = 3,
 *         TYPE_OFFER       = 4,
 *         TYPE_REPLY       = 5,
 *         TYPE_EXTRA_WORK  = 6,
 *         TYPE_TASK_RESULT = 7,
 *         TYPE_USER        = 8,
 *         TYPE_RATING      = 9,
 *         TYPE_FILE = 10,
 *         TYPE_LIVE_STREAM = 11,
 *         TYPE_STREAM =  12,
 *         TYPE_CONTENT_COMMENT = 13 */
    type?: number;
    reason?: number;
    description?: string;

    [key: string]: any;
}

export class ReportUpdateRequest implements IReportUpdateRequest {
    description?: string;

    [key: string]: any;

    constructor(data?: IReportUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ReportUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReportUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["description"] = this.description;
        return data;
    }
}

export interface IReportUpdateRequest {
    description?: string;

    [key: string]: any;
}

export class ReportDataResponse implements IReportDataResponse {
    data?: ReportResponse;

    [key: string]: any;

    constructor(data?: IReportDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? ReportResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReportDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReportDataResponse {
    data?: ReportResponse;

    [key: string]: any;
}

export class ReportsDataResponse implements IReportsDataResponse {
    data?: ReportResponse[];

    [key: string]: any;

    constructor(data?: IReportsDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ReportResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportsDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportsDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReportsDataResponse {
    data?: ReportResponse[];

    [key: string]: any;
}

export class ReportResponse implements IReportResponse {
    id?: number;
    from_id?: number;
    to_id?: number;
    object_id?: string;
    type?: number;
    reason?: number;
    description?: string;

    [key: string]: any;

    constructor(data?: IReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.from_id = _data["from_id"];
            this.to_id = _data["to_id"];
            this.object_id = _data["object_id"];
            this.type = _data["type"];
            this.reason = _data["reason"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["from_id"] = this.from_id;
        data["to_id"] = this.to_id;
        data["object_id"] = this.object_id;
        data["type"] = this.type;
        data["reason"] = this.reason;
        data["description"] = this.description;
        return data;
    }
}

export interface IReportResponse {
    id?: number;
    from_id?: number;
    to_id?: number;
    object_id?: string;
    type?: number;
    reason?: number;
    description?: string;

    [key: string]: any;
}

export class ReportError implements IReportError {
    message?: string;
    errors?: Errors31;

    [key: string]: any;

    constructor(data?: IReportError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors31.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReportError {
        data = typeof data === 'object' ? data : {};
        let result = new ReportError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReportError {
    message?: string;
    errors?: Errors31;

    [key: string]: any;
}

/** Report model */
export class ReportUpdateError implements IReportUpdateError {
    message?: string;
    errors?: Errors32;

    [key: string]: any;

    constructor(data?: IReportUpdateError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors32.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReportUpdateError {
        data = typeof data === 'object' ? data : {};
        let result = new ReportUpdateError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

/** Report model */
export interface IReportUpdateError {
    message?: string;
    errors?: Errors32;

    [key: string]: any;
}

export class SkillRequest implements ISkillRequest {
    filter_id?: number;
    text?: string;
    is_active?: boolean;

    [key: string]: any;

    constructor(data?: ISkillRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.filter_id = _data["filter_id"];
            this.text = _data["text"];
            this.is_active = _data["is_active"];
        }
    }

    static fromJS(data: any): SkillRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkillRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["filter_id"] = this.filter_id;
        data["text"] = this.text;
        data["is_active"] = this.is_active;
        return data;
    }
}

export interface ISkillRequest {
    filter_id?: number;
    text?: string;
    is_active?: boolean;

    [key: string]: any;
}

export class SkillUpdateRequest implements ISkillUpdateRequest {
    id?: number;
    filter_id?: number;
    text?: string;
    is_active?: boolean;

    [key: string]: any;

    constructor(data?: ISkillUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.filter_id = _data["filter_id"];
            this.text = _data["text"];
            this.is_active = _data["is_active"];
        }
    }

    static fromJS(data: any): SkillUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkillUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["filter_id"] = this.filter_id;
        data["text"] = this.text;
        data["is_active"] = this.is_active;
        return data;
    }
}

export interface ISkillUpdateRequest {
    id?: number;
    filter_id?: number;
    text?: string;
    is_active?: boolean;

    [key: string]: any;
}

export class SkillsDataResponse implements ISkillsDataResponse {
    data?: SkillResponse[];

    [key: string]: any;

    constructor(data?: ISkillsDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkillResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SkillsDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SkillsDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISkillsDataResponse {
    data?: SkillResponse[];

    [key: string]: any;
}

export class SkillResponse implements ISkillResponse {
    id?: number;
    filter_id?: number;
    is_active?: boolean;
    text?: string;
    type_question?: string;
    filter?: FilterShortResponse;

    [key: string]: any;

    constructor(data?: ISkillResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.filter_id = _data["filter_id"];
            this.is_active = _data["is_active"];
            this.text = _data["text"];
            this.type_question = _data["type_question"];
            this.filter = _data["filter"] ? FilterShortResponse.fromJS(_data["filter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SkillResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SkillResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["filter_id"] = this.filter_id;
        data["is_active"] = this.is_active;
        data["text"] = this.text;
        data["type_question"] = this.type_question;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISkillResponse {
    id?: number;
    filter_id?: number;
    is_active?: boolean;
    text?: string;
    type_question?: string;
    filter?: FilterShortResponse;

    [key: string]: any;
}

/** Skill model */
export class SkillError implements ISkillError {
    message?: string;
    errors?: Errors33;

    [key: string]: any;

    constructor(data?: ISkillError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors33.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SkillError {
        data = typeof data === 'object' ? data : {};
        let result = new SkillError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

/** Skill model */
export interface ISkillError {
    message?: string;
    errors?: Errors33;

    [key: string]: any;
}

export class StatusResponse implements IStatusResponse {
    id?: number;
    name?: string;

    [key: string]: any;

    constructor(data?: IStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IStatusResponse {
    id?: number;
    name?: string;

    [key: string]: any;
}

export class TaskRequest implements ITaskRequest {
    category_id?: number;
    name?: string;
    description?: string;
    price?: number;
    deadline?: boolean;
    deadline_at?: string;
    answers?: TaskAnswerRequest[];
    files?: TaskFileRequest[];

    [key: string]: any;

    constructor(data?: ITaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.category_id = _data["category_id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.deadline = _data["deadline"];
            this.deadline_at = _data["deadline_at"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(TaskAnswerRequest.fromJS(item));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(TaskFileRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["category_id"] = this.category_id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        data["deadline"] = this.deadline;
        data["deadline_at"] = this.deadline_at;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaskRequest {
    category_id?: number;
    name?: string;
    description?: string;
    price?: number;
    deadline?: boolean;
    deadline_at?: string;
    answers?: TaskAnswerRequest[];
    files?: TaskFileRequest[];

    [key: string]: any;
}

export class IndexTasksFiltersRequest implements IIndexTasksFiltersRequest {
    /** Search in category_id. */
    categories_id?: number[];
    /** Status. null by default. */
    replyStatus?: number;
    /** Sorting column. Use 'id','name','created_at'. 'id' by default. */
    sort?: string;
    /** Sorting order. Use 'asc' or 'desc'. 'asc' by default. */
    order?: string;
    /** Rows count on the page. 10 rows by default. */
    countOnPage?: number;
    /** Page number. 1 by default. */
    page?: number;
    /** Search in 'value'. */
    search?: string;
    /** Search in answers_id. */
    answers_id?: number[];
    /** Search in deadline. */
    is_deadline?: boolean;
    /** Search in value. */
    search_value?: string;
    /** Search in min_value. */
    min_value?: number;
    /** Search in max_value. */
    max_value?: number;
    /** Search in min_price. */
    min_price?: number;
    /** Search in max_price. */
    max_price?: number;
    /** Search in '4-5' rating of users. */
    highRating?: boolean;
    /** Filter by my task. */
    isMy?: boolean;
    /** Status. null by default. */
    taskStatus?: number;
    /** Filter by my task. */
    myReplies?: boolean;

    [key: string]: any;

    constructor(data?: IIndexTasksFiltersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["categories_id"])) {
                this.categories_id = [] as any;
                for (let item of _data["categories_id"])
                    this.categories_id!.push(item);
            }
            this.replyStatus = _data["replyStatus"];
            this.sort = _data["sort"];
            this.order = _data["order"];
            this.countOnPage = _data["countOnPage"];
            this.page = _data["page"];
            this.search = _data["search"];
            if (Array.isArray(_data["answers_id"])) {
                this.answers_id = [] as any;
                for (let item of _data["answers_id"])
                    this.answers_id!.push(item);
            }
            this.is_deadline = _data["is_deadline"];
            this.search_value = _data["search_value"];
            this.min_value = _data["min_value"];
            this.max_value = _data["max_value"];
            this.min_price = _data["min_price"];
            this.max_price = _data["max_price"];
            this.highRating = _data["highRating"];
            this.isMy = _data["isMy"];
            this.taskStatus = _data["taskStatus"];
            this.myReplies = _data["myReplies"];
        }
    }

    static fromJS(data: any): IndexTasksFiltersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IndexTasksFiltersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.categories_id)) {
            data["categories_id"] = [];
            for (let item of this.categories_id)
                data["categories_id"].push(item);
        }
        data["replyStatus"] = this.replyStatus;
        data["sort"] = this.sort;
        data["order"] = this.order;
        data["countOnPage"] = this.countOnPage;
        data["page"] = this.page;
        data["search"] = this.search;
        if (Array.isArray(this.answers_id)) {
            data["answers_id"] = [];
            for (let item of this.answers_id)
                data["answers_id"].push(item);
        }
        data["is_deadline"] = this.is_deadline;
        data["search_value"] = this.search_value;
        data["min_value"] = this.min_value;
        data["max_value"] = this.max_value;
        data["min_price"] = this.min_price;
        data["max_price"] = this.max_price;
        data["highRating"] = this.highRating;
        data["isMy"] = this.isMy;
        data["taskStatus"] = this.taskStatus;
        data["myReplies"] = this.myReplies;
        return data;
    }
}

export interface IIndexTasksFiltersRequest {
    /** Search in category_id. */
    categories_id?: number[];
    /** Status. null by default. */
    replyStatus?: number;
    /** Sorting column. Use 'id','name','created_at'. 'id' by default. */
    sort?: string;
    /** Sorting order. Use 'asc' or 'desc'. 'asc' by default. */
    order?: string;
    /** Rows count on the page. 10 rows by default. */
    countOnPage?: number;
    /** Page number. 1 by default. */
    page?: number;
    /** Search in 'value'. */
    search?: string;
    /** Search in answers_id. */
    answers_id?: number[];
    /** Search in deadline. */
    is_deadline?: boolean;
    /** Search in value. */
    search_value?: string;
    /** Search in min_value. */
    min_value?: number;
    /** Search in max_value. */
    max_value?: number;
    /** Search in min_price. */
    min_price?: number;
    /** Search in max_price. */
    max_price?: number;
    /** Search in '4-5' rating of users. */
    highRating?: boolean;
    /** Filter by my task. */
    isMy?: boolean;
    /** Status. null by default. */
    taskStatus?: number;
    /** Filter by my task. */
    myReplies?: boolean;

    [key: string]: any;
}

export class TasksFiltersRequest implements ITasksFiltersRequest {
    category_id?: number;
    /** Sorting column. Use 'id','name','created_at'. 'id' by default. */
    sort?: string;
    /** Sorting order. Use 'asc' or 'desc'. 'asc' by default. */
    order?: string;
    /** Rows count on the page. 10 rows by default. */
    countOnPage?: number;
    /** Page number. 1 by default. */
    page?: number;
    /** Search in 'value'. */
    search?: string;
    /** Search in answers_id. */
    answers_id?: number[];
    /** Search in deadline. */
    is_deadline?: boolean;
    /** Search in min_value. */
    min_value?: number;
    /** Search in max_value. */
    max_value?: number;
    /** Search in min_price. */
    min_price?: number;
    /** Search in max_price. */
    max_price?: number;
    /** Search in '4-5' rating of users. */
    highRating?: boolean;

    [key: string]: any;

    constructor(data?: ITasksFiltersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.category_id = _data["category_id"];
            this.sort = _data["sort"];
            this.order = _data["order"];
            this.countOnPage = _data["countOnPage"];
            this.page = _data["page"];
            this.search = _data["search"];
            if (Array.isArray(_data["answers_id"])) {
                this.answers_id = [] as any;
                for (let item of _data["answers_id"])
                    this.answers_id!.push(item);
            }
            this.is_deadline = _data["is_deadline"];
            this.min_value = _data["min_value"];
            this.max_value = _data["max_value"];
            this.min_price = _data["min_price"];
            this.max_price = _data["max_price"];
            this.highRating = _data["highRating"];
        }
    }

    static fromJS(data: any): TasksFiltersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TasksFiltersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["category_id"] = this.category_id;
        data["sort"] = this.sort;
        data["order"] = this.order;
        data["countOnPage"] = this.countOnPage;
        data["page"] = this.page;
        data["search"] = this.search;
        if (Array.isArray(this.answers_id)) {
            data["answers_id"] = [];
            for (let item of this.answers_id)
                data["answers_id"].push(item);
        }
        data["is_deadline"] = this.is_deadline;
        data["min_value"] = this.min_value;
        data["max_value"] = this.max_value;
        data["min_price"] = this.min_price;
        data["max_price"] = this.max_price;
        data["highRating"] = this.highRating;
        return data;
    }
}

export interface ITasksFiltersRequest {
    category_id?: number;
    /** Sorting column. Use 'id','name','created_at'. 'id' by default. */
    sort?: string;
    /** Sorting order. Use 'asc' or 'desc'. 'asc' by default. */
    order?: string;
    /** Rows count on the page. 10 rows by default. */
    countOnPage?: number;
    /** Page number. 1 by default. */
    page?: number;
    /** Search in 'value'. */
    search?: string;
    /** Search in answers_id. */
    answers_id?: number[];
    /** Search in deadline. */
    is_deadline?: boolean;
    /** Search in min_value. */
    min_value?: number;
    /** Search in max_value. */
    max_value?: number;
    /** Search in min_price. */
    min_price?: number;
    /** Search in max_price. */
    max_price?: number;
    /** Search in '4-5' rating of users. */
    highRating?: boolean;

    [key: string]: any;
}

export class TaskUpdateRequest implements ITaskUpdateRequest {
    status_id?: number;
    name?: string;
    description?: string;
    price?: number;
    deadline?: boolean;
    deadline_at?: string;
    answers?: TaskAnswerUpdateRequest[];
    files?: TaskFileRequest[];
    deletedFiles?: any[];
    deletedAnswers?: any[];
    updateTaskFilesQuestion?: UpdateTaskFilesQuestionRequest[];

    [key: string]: any;

    constructor(data?: ITaskUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.status_id = _data["status_id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.deadline = _data["deadline"];
            this.deadline_at = _data["deadline_at"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(TaskAnswerUpdateRequest.fromJS(item));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(TaskFileRequest.fromJS(item));
            }
            if (Array.isArray(_data["deletedFiles"])) {
                this.deletedFiles = [] as any;
                for (let item of _data["deletedFiles"])
                    this.deletedFiles!.push(item);
            }
            if (Array.isArray(_data["deletedAnswers"])) {
                this.deletedAnswers = [] as any;
                for (let item of _data["deletedAnswers"])
                    this.deletedAnswers!.push(item);
            }
            if (Array.isArray(_data["updateTaskFilesQuestion"])) {
                this.updateTaskFilesQuestion = [] as any;
                for (let item of _data["updateTaskFilesQuestion"])
                    this.updateTaskFilesQuestion!.push(UpdateTaskFilesQuestionRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["status_id"] = this.status_id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        data["deadline"] = this.deadline;
        data["deadline_at"] = this.deadline_at;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        if (Array.isArray(this.deletedFiles)) {
            data["deletedFiles"] = [];
            for (let item of this.deletedFiles)
                data["deletedFiles"].push(item);
        }
        if (Array.isArray(this.deletedAnswers)) {
            data["deletedAnswers"] = [];
            for (let item of this.deletedAnswers)
                data["deletedAnswers"].push(item);
        }
        if (Array.isArray(this.updateTaskFilesQuestion)) {
            data["updateTaskFilesQuestion"] = [];
            for (let item of this.updateTaskFilesQuestion)
                data["updateTaskFilesQuestion"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaskUpdateRequest {
    status_id?: number;
    name?: string;
    description?: string;
    price?: number;
    deadline?: boolean;
    deadline_at?: string;
    answers?: TaskAnswerUpdateRequest[];
    files?: TaskFileRequest[];
    deletedFiles?: any[];
    deletedAnswers?: any[];
    updateTaskFilesQuestion?: UpdateTaskFilesQuestionRequest[];

    [key: string]: any;
}

export class TaskDataResponse implements ITaskDataResponse {
    data?: TaskResponse;

    [key: string]: any;

    constructor(data?: ITaskDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? TaskResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITaskDataResponse {
    data?: TaskResponse;

    [key: string]: any;
}

export class TasksDataResponse implements ITasksDataResponse {
    data?: TaskIndexResponse[];

    [key: string]: any;

    constructor(data?: ITasksDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TaskIndexResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TasksDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TasksDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITasksDataResponse {
    data?: TaskIndexResponse[];

    [key: string]: any;
}

export class TaskResponse implements ITaskResponse {
    id?: number;
    name?: string;
    description?: string;
    price?: number;
    deadline?: boolean;
    deadline_at?: string;
    published_at?: string;
    created_at?: string;
    category?: CategoryVeryShortResponse;
    status?: StatusResponse;
    owner?: UserShortForTaskResponse;
    answers?: TaskAnswerResponse[];
    taskFiles?: TaskFileResponse[];
    comments?: number;
    replies?: ReplyResponse[];
    tags?: string[];

    [key: string]: any;

    constructor(data?: ITaskResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.deadline = _data["deadline"];
            this.deadline_at = _data["deadline_at"];
            this.published_at = _data["published_at"];
            this.created_at = _data["created_at"];
            this.category = _data["category"] ? CategoryVeryShortResponse.fromJS(_data["category"]) : <any>undefined;
            this.status = _data["status"] ? StatusResponse.fromJS(_data["status"]) : <any>undefined;
            this.owner = _data["owner"] ? UserShortForTaskResponse.fromJS(_data["owner"]) : <any>undefined;
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(TaskAnswerResponse.fromJS(item));
            }
            if (Array.isArray(_data["taskFiles"])) {
                this.taskFiles = [] as any;
                for (let item of _data["taskFiles"])
                    this.taskFiles!.push(TaskFileResponse.fromJS(item));
            }
            this.comments = _data["comments"];
            if (Array.isArray(_data["replies"])) {
                this.replies = [] as any;
                for (let item of _data["replies"])
                    this.replies!.push(ReplyResponse.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): TaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        data["deadline"] = this.deadline;
        data["deadline_at"] = this.deadline_at;
        data["published_at"] = this.published_at;
        data["created_at"] = this.created_at;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        if (Array.isArray(this.taskFiles)) {
            data["taskFiles"] = [];
            for (let item of this.taskFiles)
                data["taskFiles"].push(item.toJSON());
        }
        data["comments"] = this.comments;
        if (Array.isArray(this.replies)) {
            data["replies"] = [];
            for (let item of this.replies)
                data["replies"].push(item.toJSON());
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface ITaskResponse {
    id?: number;
    name?: string;
    description?: string;
    price?: number;
    deadline?: boolean;
    deadline_at?: string;
    published_at?: string;
    created_at?: string;
    category?: CategoryVeryShortResponse;
    status?: StatusResponse;
    owner?: UserShortForTaskResponse;
    answers?: TaskAnswerResponse[];
    taskFiles?: TaskFileResponse[];
    comments?: number;
    replies?: ReplyResponse[];
    tags?: string[];

    [key: string]: any;
}

export class TaskIndexResponse implements ITaskIndexResponse {
    id?: number;
    status_id?: number;
    name?: string;
    description?: string;
    price?: number;
    deadline?: boolean;
    deadline_at?: string;
    published_at?: string;
    created_at?: string;
    disputed_replies?: Disputed_replies[];
    category?: CategoryVeryShortResponse;
    owner?: UserShortForTaskIndexResponse;

    [key: string]: any;

    constructor(data?: ITaskIndexResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.status_id = _data["status_id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.deadline = _data["deadline"];
            this.deadline_at = _data["deadline_at"];
            this.published_at = _data["published_at"];
            this.created_at = _data["created_at"];
            if (Array.isArray(_data["disputed_replies"])) {
                this.disputed_replies = [] as any;
                for (let item of _data["disputed_replies"])
                    this.disputed_replies!.push(Disputed_replies.fromJS(item));
            }
            this.category = _data["category"] ? CategoryVeryShortResponse.fromJS(_data["category"]) : <any>undefined;
            this.owner = _data["owner"] ? UserShortForTaskIndexResponse.fromJS(_data["owner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskIndexResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskIndexResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["status_id"] = this.status_id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        data["deadline"] = this.deadline;
        data["deadline_at"] = this.deadline_at;
        data["published_at"] = this.published_at;
        data["created_at"] = this.created_at;
        if (Array.isArray(this.disputed_replies)) {
            data["disputed_replies"] = [];
            for (let item of this.disputed_replies)
                data["disputed_replies"].push(item.toJSON());
        }
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITaskIndexResponse {
    id?: number;
    status_id?: number;
    name?: string;
    description?: string;
    price?: number;
    deadline?: boolean;
    deadline_at?: string;
    published_at?: string;
    created_at?: string;
    disputed_replies?: Disputed_replies[];
    category?: CategoryVeryShortResponse;
    owner?: UserShortForTaskIndexResponse;

    [key: string]: any;
}

export class TaskShortResponse implements ITaskShortResponse {
    id?: number;
    status_id?: number;
    owner_id?: number;
    name?: string;
    price?: number;
    description?: string;
    deadline_at?: string;
    deleted_at?: string;
    taskFiles?: TaskFileResponse[];
    tags?: string[];
    category?: CategoryShortResponse;
    status?: StatusResponse;

    [key: string]: any;

    constructor(data?: ITaskShortResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.status_id = _data["status_id"];
            this.owner_id = _data["owner_id"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.description = _data["description"];
            this.deadline_at = _data["deadline_at"];
            this.deleted_at = _data["deleted_at"];
            if (Array.isArray(_data["taskFiles"])) {
                this.taskFiles = [] as any;
                for (let item of _data["taskFiles"])
                    this.taskFiles!.push(TaskFileResponse.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.category = _data["category"] ? CategoryShortResponse.fromJS(_data["category"]) : <any>undefined;
            this.status = _data["status"] ? StatusResponse.fromJS(_data["status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskShortResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskShortResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["status_id"] = this.status_id;
        data["owner_id"] = this.owner_id;
        data["name"] = this.name;
        data["price"] = this.price;
        data["description"] = this.description;
        data["deadline_at"] = this.deadline_at;
        data["deleted_at"] = this.deleted_at;
        if (Array.isArray(this.taskFiles)) {
            data["taskFiles"] = [];
            for (let item of this.taskFiles)
                data["taskFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITaskShortResponse {
    id?: number;
    status_id?: number;
    owner_id?: number;
    name?: string;
    price?: number;
    description?: string;
    deadline_at?: string;
    deleted_at?: string;
    taskFiles?: TaskFileResponse[];
    tags?: string[];
    category?: CategoryShortResponse;
    status?: StatusResponse;

    [key: string]: any;
}

export class TaskShortForChatResponse implements ITaskShortForChatResponse {
    id?: number;
    owner_id?: number;
    status_id?: number;
    name?: string;
    deadline_at?: string;
    deleted_at?: string;
    category?: CategoryVeryShortResponse;

    [key: string]: any;

    constructor(data?: ITaskShortForChatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.owner_id = _data["owner_id"];
            this.status_id = _data["status_id"];
            this.name = _data["name"];
            this.deadline_at = _data["deadline_at"];
            this.deleted_at = _data["deleted_at"];
            this.category = _data["category"] ? CategoryVeryShortResponse.fromJS(_data["category"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskShortForChatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskShortForChatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["owner_id"] = this.owner_id;
        data["status_id"] = this.status_id;
        data["name"] = this.name;
        data["deadline_at"] = this.deadline_at;
        data["deleted_at"] = this.deleted_at;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITaskShortForChatResponse {
    id?: number;
    owner_id?: number;
    status_id?: number;
    name?: string;
    deadline_at?: string;
    deleted_at?: string;
    category?: CategoryVeryShortResponse;

    [key: string]: any;
}

/** Task model */
export class TaskError implements ITaskError {
    message?: string;
    errors?: Errors34;

    [key: string]: any;

    constructor(data?: ITaskError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors34.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskError {
        data = typeof data === 'object' ? data : {};
        let result = new TaskError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

/** Task model */
export interface ITaskError {
    message?: string;
    errors?: Errors34;

    [key: string]: any;
}

export class TaskAnswerRequest implements ITaskAnswerRequest {
    question_id?: number;
    answer_id?: number;
    type_value?: string;
    value?: string;
    min_value?: string;
    max_value?: string;
    answers_id?: any[];

    [key: string]: any;

    constructor(data?: ITaskAnswerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.question_id = _data["question_id"];
            this.answer_id = _data["answer_id"];
            this.type_value = _data["type_value"];
            this.value = _data["value"];
            this.min_value = _data["min_value"];
            this.max_value = _data["max_value"];
            if (Array.isArray(_data["answers_id"])) {
                this.answers_id = [] as any;
                for (let item of _data["answers_id"])
                    this.answers_id!.push(item);
            }
        }
    }

    static fromJS(data: any): TaskAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["question_id"] = this.question_id;
        data["answer_id"] = this.answer_id;
        data["type_value"] = this.type_value;
        data["value"] = this.value;
        data["min_value"] = this.min_value;
        data["max_value"] = this.max_value;
        if (Array.isArray(this.answers_id)) {
            data["answers_id"] = [];
            for (let item of this.answers_id)
                data["answers_id"].push(item);
        }
        return data;
    }
}

export interface ITaskAnswerRequest {
    question_id?: number;
    answer_id?: number;
    type_value?: string;
    value?: string;
    min_value?: string;
    max_value?: string;
    answers_id?: any[];

    [key: string]: any;
}

export class TaskAnswerUpdateRequest implements ITaskAnswerUpdateRequest {
    id?: number;
    question_id?: number;
    answer_id?: number;
    type_value?: string;
    value?: string;
    min_value?: string;
    max_value?: string;
    answers_id?: any[];

    [key: string]: any;

    constructor(data?: ITaskAnswerUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.question_id = _data["question_id"];
            this.answer_id = _data["answer_id"];
            this.type_value = _data["type_value"];
            this.value = _data["value"];
            this.min_value = _data["min_value"];
            this.max_value = _data["max_value"];
            if (Array.isArray(_data["answers_id"])) {
                this.answers_id = [] as any;
                for (let item of _data["answers_id"])
                    this.answers_id!.push(item);
            }
        }
    }

    static fromJS(data: any): TaskAnswerUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskAnswerUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["question_id"] = this.question_id;
        data["answer_id"] = this.answer_id;
        data["type_value"] = this.type_value;
        data["value"] = this.value;
        data["min_value"] = this.min_value;
        data["max_value"] = this.max_value;
        if (Array.isArray(this.answers_id)) {
            data["answers_id"] = [];
            for (let item of this.answers_id)
                data["answers_id"].push(item);
        }
        return data;
    }
}

export interface ITaskAnswerUpdateRequest {
    id?: number;
    question_id?: number;
    answer_id?: number;
    type_value?: string;
    value?: string;
    min_value?: string;
    max_value?: string;
    answers_id?: any[];

    [key: string]: any;
}

/** TaskAnswer model */
export class TaskAnswerResponse implements ITaskAnswerResponse {
    id?: number;
    task_id?: number;
    question_id?: number;
    answer_id?: number;
    type_value?: string;
    value?: string;
    min_value?: string;
    max_value?: string;
    answers_id?: any[];
    text_question?: string;
    type_question?: string;

    [key: string]: any;

    constructor(data?: ITaskAnswerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.task_id = _data["task_id"];
            this.question_id = _data["question_id"];
            this.answer_id = _data["answer_id"];
            this.type_value = _data["type_value"];
            this.value = _data["value"];
            this.min_value = _data["min_value"];
            this.max_value = _data["max_value"];
            if (Array.isArray(_data["answers_id"])) {
                this.answers_id = [] as any;
                for (let item of _data["answers_id"])
                    this.answers_id!.push(item);
            }
            this.text_question = _data["text_question"];
            this.type_question = _data["type_question"];
        }
    }

    static fromJS(data: any): TaskAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["task_id"] = this.task_id;
        data["question_id"] = this.question_id;
        data["answer_id"] = this.answer_id;
        data["type_value"] = this.type_value;
        data["value"] = this.value;
        data["min_value"] = this.min_value;
        data["max_value"] = this.max_value;
        if (Array.isArray(this.answers_id)) {
            data["answers_id"] = [];
            for (let item of this.answers_id)
                data["answers_id"].push(item);
        }
        data["text_question"] = this.text_question;
        data["type_question"] = this.type_question;
        return data;
    }
}

/** TaskAnswer model */
export interface ITaskAnswerResponse {
    id?: number;
    task_id?: number;
    question_id?: number;
    answer_id?: number;
    type_value?: string;
    value?: string;
    min_value?: string;
    max_value?: string;
    answers_id?: any[];
    text_question?: string;
    type_question?: string;

    [key: string]: any;
}

export class TaskFileFormdataRequest implements ITaskFileFormdataRequest {
    file?: string;
    question_id?: number;

    [key: string]: any;

    constructor(data?: ITaskFileFormdataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.file = _data["file"];
            this.question_id = _data["question_id"];
        }
    }

    static fromJS(data: any): TaskFileFormdataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskFileFormdataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["file"] = this.file;
        data["question_id"] = this.question_id;
        return data;
    }
}

export interface ITaskFileFormdataRequest {
    file?: string;
    question_id?: number;

    [key: string]: any;
}

export class TaskFileRequest implements ITaskFileRequest {
    file?: string;
    name?: string;
    size?: number;
    question_id?: number;

    [key: string]: any;

    constructor(data?: ITaskFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.file = _data["file"];
            this.name = _data["name"];
            this.size = _data["size"];
            this.question_id = _data["question_id"];
        }
    }

    static fromJS(data: any): TaskFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["file"] = this.file;
        data["name"] = this.name;
        data["size"] = this.size;
        data["question_id"] = this.question_id;
        return data;
    }
}

export interface ITaskFileRequest {
    file?: string;
    name?: string;
    size?: number;
    question_id?: number;

    [key: string]: any;
}

export class UpdateTaskFilesQuestionRequest implements IUpdateTaskFilesQuestionRequest {
    id?: number;
    question_id?: number;

    [key: string]: any;

    constructor(data?: IUpdateTaskFilesQuestionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.question_id = _data["question_id"];
        }
    }

    static fromJS(data: any): UpdateTaskFilesQuestionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaskFilesQuestionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["question_id"] = this.question_id;
        return data;
    }
}

export interface IUpdateTaskFilesQuestionRequest {
    id?: number;
    question_id?: number;

    [key: string]: any;
}

/** TaskFile model */
export class TaskFileResponse implements ITaskFileResponse {
    id?: number;
    task_id?: number;
    file_id?: number;
    question_id?: number;
    file?: FileResponse;
    question?: QuestionShortResponse;

    [key: string]: any;

    constructor(data?: ITaskFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.task_id = _data["task_id"];
            this.file_id = _data["file_id"];
            this.question_id = _data["question_id"];
            this.file = _data["file"] ? FileResponse.fromJS(_data["file"]) : <any>undefined;
            this.question = _data["question"] ? QuestionShortResponse.fromJS(_data["question"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["task_id"] = this.task_id;
        data["file_id"] = this.file_id;
        data["question_id"] = this.question_id;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["question"] = this.question ? this.question.toJSON() : <any>undefined;
        return data;
    }
}

/** TaskFile model */
export interface ITaskFileResponse {
    id?: number;
    task_id?: number;
    file_id?: number;
    question_id?: number;
    file?: FileResponse;
    question?: QuestionShortResponse;

    [key: string]: any;
}

export class TaskResultRequest implements ITaskResultRequest {
    task_id?: number;
    reply_id?: number;
    text?: string;
    description?: string;
    files?: TaskResultFileRequest[];

    [key: string]: any;

    constructor(data?: ITaskResultRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.task_id = _data["task_id"];
            this.reply_id = _data["reply_id"];
            this.text = _data["text"];
            this.description = _data["description"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(TaskResultFileRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskResultRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskResultRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["task_id"] = this.task_id;
        data["reply_id"] = this.reply_id;
        data["text"] = this.text;
        data["description"] = this.description;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaskResultRequest {
    task_id?: number;
    reply_id?: number;
    text?: string;
    description?: string;
    files?: TaskResultFileRequest[];

    [key: string]: any;
}

export class TaskResultFileRequest implements ITaskResultFileRequest {
    file?: string;
    name?: string;
    size?: number;

    [key: string]: any;

    constructor(data?: ITaskResultFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.file = _data["file"];
            this.name = _data["name"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): TaskResultFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskResultFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["file"] = this.file;
        data["name"] = this.name;
        data["size"] = this.size;
        return data;
    }
}

export interface ITaskResultFileRequest {
    file?: string;
    name?: string;
    size?: number;

    [key: string]: any;
}

export class TaskResultUpdateRequest implements ITaskResultUpdateRequest {
    text?: string;
    description?: string;
    files?: TaskResultFileRequest[];

    [key: string]: any;

    constructor(data?: ITaskResultUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.text = _data["text"];
            this.description = _data["description"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(TaskResultFileRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskResultUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskResultUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["text"] = this.text;
        data["description"] = this.description;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaskResultUpdateRequest {
    text?: string;
    description?: string;
    files?: TaskResultFileRequest[];

    [key: string]: any;
}

export class TaskResultDataResponse implements ITaskResultDataResponse {
    data?: TaskResultResponse;

    [key: string]: any;

    constructor(data?: ITaskResultDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? TaskResultResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskResultDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskResultDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITaskResultDataResponse {
    data?: TaskResultResponse;

    [key: string]: any;
}

export class TaskResultsDataResponse implements ITaskResultsDataResponse {
    data?: TaskResultResponse[];

    [key: string]: any;

    constructor(data?: ITaskResultsDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TaskResultResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskResultsDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskResultsDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaskResultsDataResponse {
    data?: TaskResultResponse[];

    [key: string]: any;
}

export class TaskResultResponse implements ITaskResultResponse {
    id?: number;
    task_id?: number;
    reply_id?: number;
    user_id?: number;
    text?: string;
    description?: string;
    files?: FileResponse[];

    [key: string]: any;

    constructor(data?: ITaskResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.task_id = _data["task_id"];
            this.reply_id = _data["reply_id"];
            this.user_id = _data["user_id"];
            this.text = _data["text"];
            this.description = _data["description"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["task_id"] = this.task_id;
        data["reply_id"] = this.reply_id;
        data["user_id"] = this.user_id;
        data["text"] = this.text;
        data["description"] = this.description;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaskResultResponse {
    id?: number;
    task_id?: number;
    reply_id?: number;
    user_id?: number;
    text?: string;
    description?: string;
    files?: FileResponse[];

    [key: string]: any;
}

/** TaskResult model */
export class TaskResultError implements ITaskResultError {
    message?: string;
    errors?: Errors35;

    [key: string]: any;

    constructor(data?: ITaskResultError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors35.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskResultError {
        data = typeof data === 'object' ? data : {};
        let result = new TaskResultError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

/** TaskResult model */
export interface ITaskResultError {
    message?: string;
    errors?: Errors35;

    [key: string]: any;
}

export class TranslationRequest implements ITranslationRequest {
    ru?: string;
    en?: string;
    pl?: string;

    [key: string]: any;

    constructor(data?: ITranslationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.ru = _data["ru"];
            this.en = _data["en"];
            this.pl = _data["pl"];
        }
    }

    static fromJS(data: any): TranslationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["ru"] = this.ru;
        data["en"] = this.en;
        data["pl"] = this.pl;
        return data;
    }
}

export interface ITranslationRequest {
    ru?: string;
    en?: string;
    pl?: string;

    [key: string]: any;
}

export class TranslationUpdateRequest implements ITranslationUpdateRequest {
    property1?: number;
    property2?: string;

    [key: string]: any;

    constructor(data?: ITranslationUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.property1 = _data["property1"];
            this.property2 = _data["property2"];
        }
    }

    static fromJS(data: any): TranslationUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["property1"] = this.property1;
        data["property2"] = this.property2;
        return data;
    }
}

export interface ITranslationUpdateRequest {
    property1?: number;
    property2?: string;

    [key: string]: any;
}

export class TranslationDataResponse implements ITranslationDataResponse {
    data?: TranslationResponse;

    [key: string]: any;

    constructor(data?: ITranslationDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? TranslationResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TranslationDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITranslationDataResponse {
    data?: TranslationResponse;

    [key: string]: any;
}

export class TranslationsDataResponse implements ITranslationsDataResponse {
    data?: TranslationResponse[];

    [key: string]: any;

    constructor(data?: ITranslationsDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TranslationResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TranslationsDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITranslationsDataResponse {
    data?: TranslationResponse[];

    [key: string]: any;
}

export class TranslationResponse implements ITranslationResponse {
    id?: number;

    [key: string]: any;

    constructor(data?: ITranslationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TranslationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ITranslationResponse {
    id?: number;

    [key: string]: any;
}

export class TranslationError implements ITranslationError {
    message?: string;
    errors?: Errors36;

    [key: string]: any;

    constructor(data?: ITranslationError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors36.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TranslationError {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITranslationError {
    message?: string;
    errors?: Errors36;

    [key: string]: any;
}

/** Translation model */
export class TranslationUpdateError implements ITranslationUpdateError {
    message?: string;
    errors?: Errors37;

    [key: string]: any;

    constructor(data?: ITranslationUpdateError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors37.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TranslationUpdateError {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationUpdateError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

/** Translation model */
export interface ITranslationUpdateError {
    message?: string;
    errors?: Errors37;

    [key: string]: any;
}

export class SendSmsRequest implements ISendSmsRequest {
    version?: string;
    login?: string;
    temp_token?: string;
    captcha?: string;
    key?: string;

    [key: string]: any;

    constructor(data?: ISendSmsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.version = _data["version"];
            this.login = _data["login"];
            this.temp_token = _data["temp_token"];
            this.captcha = _data["captcha"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): SendSmsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendSmsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["version"] = this.version;
        data["login"] = this.login;
        data["temp_token"] = this.temp_token;
        data["captcha"] = this.captcha;
        data["key"] = this.key;
        return data;
    }
}

export interface ISendSmsRequest {
    version?: string;
    login?: string;
    temp_token?: string;
    captcha?: string;
    key?: string;

    [key: string]: any;
}

export class LoginSmsRequest implements ILoginSmsRequest {
    code?: string;
    login?: string;

    [key: string]: any;

    constructor(data?: ILoginSmsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.code = _data["code"];
            this.login = _data["login"];
        }
    }

    static fromJS(data: any): LoginSmsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginSmsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["code"] = this.code;
        data["login"] = this.login;
        return data;
    }
}

export interface ILoginSmsRequest {
    code?: string;
    login?: string;

    [key: string]: any;
}

export class ChangePhoneRequest implements IChangePhoneRequest {
    code?: string;
    phone?: string;

    [key: string]: any;

    constructor(data?: IChangePhoneRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.code = _data["code"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): ChangePhoneRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePhoneRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["code"] = this.code;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IChangePhoneRequest {
    code?: string;
    phone?: string;

    [key: string]: any;
}

export class UserCreateRequest implements IUserCreateRequest {
    name?: string;
    surname?: string;
    middlename?: string;
    email?: string;
    phone?: string;
    password?: string;

    [key: string]: any;

    constructor(data?: IUserCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.middlename = _data["middlename"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): UserCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["middlename"] = this.middlename;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["password"] = this.password;
        return data;
    }
}

export interface IUserCreateRequest {
    name?: string;
    surname?: string;
    middlename?: string;
    email?: string;
    phone?: string;
    password?: string;

    [key: string]: any;
}

export class UserUpdateRequest implements IUserUpdateRequest {
    is_trusted?: boolean;
    is_open_for_proposals?: boolean;
    lang?: number;
    work_status?: string;
    name?: string;
    surname?: string;
    middlename?: string;
    birthday?: string;
    email?: string;
    description?: string;
    price?: number;
    rate?: number;
    avatar?: Avatar;
    skills?: SkillsRequest[];

    [key: string]: any;

    constructor(data?: IUserUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.is_trusted = _data["is_trusted"];
            this.is_open_for_proposals = _data["is_open_for_proposals"];
            this.lang = _data["lang"];
            this.work_status = _data["work_status"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.middlename = _data["middlename"];
            this.birthday = _data["birthday"];
            this.email = _data["email"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.rate = _data["rate"];
            this.avatar = _data["avatar"] ? Avatar.fromJS(_data["avatar"]) : <any>undefined;
            if (Array.isArray(_data["skills"])) {
                this.skills = [] as any;
                for (let item of _data["skills"])
                    this.skills!.push(SkillsRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["is_trusted"] = this.is_trusted;
        data["is_open_for_proposals"] = this.is_open_for_proposals;
        data["lang"] = this.lang;
        data["work_status"] = this.work_status;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["middlename"] = this.middlename;
        data["birthday"] = this.birthday;
        data["email"] = this.email;
        data["description"] = this.description;
        data["price"] = this.price;
        data["rate"] = this.rate;
        data["avatar"] = this.avatar ? this.avatar.toJSON() : <any>undefined;
        if (Array.isArray(this.skills)) {
            data["skills"] = [];
            for (let item of this.skills)
                data["skills"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserUpdateRequest {
    is_trusted?: boolean;
    is_open_for_proposals?: boolean;
    lang?: number;
    work_status?: string;
    name?: string;
    surname?: string;
    middlename?: string;
    birthday?: string;
    email?: string;
    description?: string;
    price?: number;
    rate?: number;
    avatar?: Avatar;
    skills?: SkillsRequest[];

    [key: string]: any;
}

export class SkillsRequest implements ISkillsRequest {
    category_id?: number;
    skills?: Skills[];

    [key: string]: any;

    constructor(data?: ISkillsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.category_id = _data["category_id"];
            if (Array.isArray(_data["skills"])) {
                this.skills = [] as any;
                for (let item of _data["skills"])
                    this.skills!.push(Skills.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SkillsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkillsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["category_id"] = this.category_id;
        if (Array.isArray(this.skills)) {
            data["skills"] = [];
            for (let item of this.skills)
                data["skills"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISkillsRequest {
    category_id?: number;
    skills?: Skills[];

    [key: string]: any;
}

export class UserDataResponse implements IUserDataResponse {
    data?: UserResponse;

    [key: string]: any;

    constructor(data?: IUserDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? UserResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserDataResponse {
    data?: UserResponse;

    [key: string]: any;
}

export class UserFilesDataResponse implements IUserFilesDataResponse {
    data?: UserFilesResponse[];
    meta?: Meta5;

    [key: string]: any;

    constructor(data?: IUserFilesDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserFilesResponse.fromJS(item));
            }
            this.meta = _data["meta"] ? Meta5.fromJS(_data["meta"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserFilesDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserFilesDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserFilesDataResponse {
    data?: UserFilesResponse[];
    meta?: Meta5;

    [key: string]: any;
}

export class UsersDataResponse implements IUsersDataResponse {
    data?: UserResponse[];
    meta?: Meta6;

    [key: string]: any;

    constructor(data?: IUsersDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserResponse.fromJS(item));
            }
            this.meta = _data["meta"] ? Meta6.fromJS(_data["meta"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UsersDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UsersDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUsersDataResponse {
    data?: UserResponse[];
    meta?: Meta6;

    [key: string]: any;
}

export class UserResponse implements IUserResponse {
    id?: number;
    avatar_id?: number;
    is_online?: boolean;
    is_trusted?: boolean;
    is_open_for_proposals?: boolean;
    rating?: number;
    work_status?: string;
    name?: string;
    surname?: string;
    middlename?: string;
    nickname?: string | undefined;
    email?: string;
    phone?: string;
    role?: string;
    description?: string;
    price?: number;
    rate?: number;
    skills?: SkillsRequest[];
    birthday?: string;
    offline_at?: string;
    avatar?: FileResponse;
    lang?: LangResponse;
    isSended?: boolean;
    isApproved?: boolean;
    onboardingErrors?: string[];
    onboardingGateway?: string;
    replyOnResolveDispute?: ReplyOnResolveDispute;
    blacklists?: BlacklistResponse[];
    bans?: BanShortResponse[];
    subscriptionsInfo?: SubscriptionsInfo;
    official?: boolean;

    [key: string]: any;

    constructor(data?: IUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.avatar_id = _data["avatar_id"];
            this.is_online = _data["is_online"];
            this.is_trusted = _data["is_trusted"];
            this.is_open_for_proposals = _data["is_open_for_proposals"];
            this.rating = _data["rating"];
            this.work_status = _data["work_status"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.middlename = _data["middlename"];
            this.nickname = _data["nickname"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.role = _data["role"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.rate = _data["rate"];
            if (Array.isArray(_data["skills"])) {
                this.skills = [] as any;
                for (let item of _data["skills"])
                    this.skills!.push(SkillsRequest.fromJS(item));
            }
            this.birthday = _data["birthday"];
            this.offline_at = _data["offline_at"];
            this.avatar = _data["avatar"] ? FileResponse.fromJS(_data["avatar"]) : <any>undefined;
            this.lang = _data["lang"] ? LangResponse.fromJS(_data["lang"]) : <any>undefined;
            this.isSended = _data["isSended"];
            this.isApproved = _data["isApproved"];
            if (Array.isArray(_data["onboardingErrors"])) {
                this.onboardingErrors = [] as any;
                for (let item of _data["onboardingErrors"])
                    this.onboardingErrors!.push(item);
            }
            this.onboardingGateway = _data["onboardingGateway"];
            this.replyOnResolveDispute = _data["replyOnResolveDispute"] ? ReplyOnResolveDispute.fromJS(_data["replyOnResolveDispute"]) : <any>undefined;
            if (Array.isArray(_data["blacklists"])) {
                this.blacklists = [] as any;
                for (let item of _data["blacklists"])
                    this.blacklists!.push(BlacklistResponse.fromJS(item));
            }
            if (Array.isArray(_data["bans"])) {
                this.bans = [] as any;
                for (let item of _data["bans"])
                    this.bans!.push(BanShortResponse.fromJS(item));
            }
            this.subscriptionsInfo = _data["subscriptionsInfo"] ? SubscriptionsInfo.fromJS(_data["subscriptionsInfo"]) : <any>undefined;
            this.official = _data["official"];
        }
    }

    static fromJS(data: any): UserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["avatar_id"] = this.avatar_id;
        data["is_online"] = this.is_online;
        data["is_trusted"] = this.is_trusted;
        data["is_open_for_proposals"] = this.is_open_for_proposals;
        data["rating"] = this.rating;
        data["work_status"] = this.work_status;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["middlename"] = this.middlename;
        data["nickname"] = this.nickname;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["role"] = this.role;
        data["description"] = this.description;
        data["price"] = this.price;
        data["rate"] = this.rate;
        if (Array.isArray(this.skills)) {
            data["skills"] = [];
            for (let item of this.skills)
                data["skills"].push(item.toJSON());
        }
        data["birthday"] = this.birthday;
        data["offline_at"] = this.offline_at;
        data["avatar"] = this.avatar ? this.avatar.toJSON() : <any>undefined;
        data["lang"] = this.lang ? this.lang.toJSON() : <any>undefined;
        data["isSended"] = this.isSended;
        data["isApproved"] = this.isApproved;
        if (Array.isArray(this.onboardingErrors)) {
            data["onboardingErrors"] = [];
            for (let item of this.onboardingErrors)
                data["onboardingErrors"].push(item);
        }
        data["onboardingGateway"] = this.onboardingGateway;
        data["replyOnResolveDispute"] = this.replyOnResolveDispute ? this.replyOnResolveDispute.toJSON() : <any>undefined;
        if (Array.isArray(this.blacklists)) {
            data["blacklists"] = [];
            for (let item of this.blacklists)
                data["blacklists"].push(item.toJSON());
        }
        if (Array.isArray(this.bans)) {
            data["bans"] = [];
            for (let item of this.bans)
                data["bans"].push(item.toJSON());
        }
        data["subscriptionsInfo"] = this.subscriptionsInfo ? this.subscriptionsInfo.toJSON() : <any>undefined;
        data["official"] = this.official;
        return data;
    }
}

export interface IUserResponse {
    id?: number;
    avatar_id?: number;
    is_online?: boolean;
    is_trusted?: boolean;
    is_open_for_proposals?: boolean;
    rating?: number;
    work_status?: string;
    name?: string;
    surname?: string;
    middlename?: string;
    nickname?: string | undefined;
    email?: string;
    phone?: string;
    role?: string;
    description?: string;
    price?: number;
    rate?: number;
    skills?: SkillsRequest[];
    birthday?: string;
    offline_at?: string;
    avatar?: FileResponse;
    lang?: LangResponse;
    isSended?: boolean;
    isApproved?: boolean;
    onboardingErrors?: string[];
    onboardingGateway?: string;
    replyOnResolveDispute?: ReplyOnResolveDispute;
    blacklists?: BlacklistResponse[];
    bans?: BanShortResponse[];
    subscriptionsInfo?: SubscriptionsInfo;
    official?: boolean;

    [key: string]: any;
}

export class UserShortResponse implements IUserShortResponse {
    id?: number;
    avatar_id?: number;
    is_online?: boolean;
    is_open_for_proposals?: boolean;
    rating?: number;
    work_status?: string;
    name?: string;
    surname?: string;
    middlename?: string;
    nickname?: string | undefined;
    email?: string;
    role?: string;
    description?: string;
    price?: number;
    skills?: SkillsRequest[];
    birthday?: string;
    offline_at?: string;
    chat_is_online?: boolean;
    chat_last_activity_at?: string | undefined;
    avatar?: FileResponse;
    deleted_at?: string;
    official?: boolean;

    [key: string]: any;

    constructor(data?: IUserShortResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.avatar_id = _data["avatar_id"];
            this.is_online = _data["is_online"];
            this.is_open_for_proposals = _data["is_open_for_proposals"];
            this.rating = _data["rating"];
            this.work_status = _data["work_status"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.middlename = _data["middlename"];
            this.nickname = _data["nickname"];
            this.email = _data["email"];
            this.role = _data["role"];
            this.description = _data["description"];
            this.price = _data["price"];
            if (Array.isArray(_data["skills"])) {
                this.skills = [] as any;
                for (let item of _data["skills"])
                    this.skills!.push(SkillsRequest.fromJS(item));
            }
            this.birthday = _data["birthday"];
            this.offline_at = _data["offline_at"];
            this.chat_is_online = _data["chat_is_online"];
            this.chat_last_activity_at = _data["chat_last_activity_at"];
            this.avatar = _data["avatar"] ? FileResponse.fromJS(_data["avatar"]) : <any>undefined;
            this.deleted_at = _data["deleted_at"];
            this.official = _data["official"];
        }
    }

    static fromJS(data: any): UserShortResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserShortResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["avatar_id"] = this.avatar_id;
        data["is_online"] = this.is_online;
        data["is_open_for_proposals"] = this.is_open_for_proposals;
        data["rating"] = this.rating;
        data["work_status"] = this.work_status;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["middlename"] = this.middlename;
        data["nickname"] = this.nickname;
        data["email"] = this.email;
        data["role"] = this.role;
        data["description"] = this.description;
        data["price"] = this.price;
        if (Array.isArray(this.skills)) {
            data["skills"] = [];
            for (let item of this.skills)
                data["skills"].push(item.toJSON());
        }
        data["birthday"] = this.birthday;
        data["offline_at"] = this.offline_at;
        data["chat_is_online"] = this.chat_is_online;
        data["chat_last_activity_at"] = this.chat_last_activity_at;
        data["avatar"] = this.avatar ? this.avatar.toJSON() : <any>undefined;
        data["deleted_at"] = this.deleted_at;
        data["official"] = this.official;
        return data;
    }
}

export interface IUserShortResponse {
    id?: number;
    avatar_id?: number;
    is_online?: boolean;
    is_open_for_proposals?: boolean;
    rating?: number;
    work_status?: string;
    name?: string;
    surname?: string;
    middlename?: string;
    nickname?: string | undefined;
    email?: string;
    role?: string;
    description?: string;
    price?: number;
    skills?: SkillsRequest[];
    birthday?: string;
    offline_at?: string;
    chat_is_online?: boolean;
    chat_last_activity_at?: string | undefined;
    avatar?: FileResponse;
    deleted_at?: string;
    official?: boolean;

    [key: string]: any;
}

export class UserShortForChatResponse implements IUserShortForChatResponse {
    id?: number;
    is_online?: boolean;
    chat_is_online?: boolean;
    name?: string;
    surname?: string;
    nickname?: string | undefined;
    chat_last_activity_at?: string | undefined;
    avatar?: FileResponse;
    official?: boolean;

    [key: string]: any;

    constructor(data?: IUserShortForChatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.is_online = _data["is_online"];
            this.chat_is_online = _data["chat_is_online"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.nickname = _data["nickname"];
            this.chat_last_activity_at = _data["chat_last_activity_at"];
            this.avatar = _data["avatar"] ? FileResponse.fromJS(_data["avatar"]) : <any>undefined;
            this.official = _data["official"];
        }
    }

    static fromJS(data: any): UserShortForChatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserShortForChatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["is_online"] = this.is_online;
        data["chat_is_online"] = this.chat_is_online;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["nickname"] = this.nickname;
        data["chat_last_activity_at"] = this.chat_last_activity_at;
        data["avatar"] = this.avatar ? this.avatar.toJSON() : <any>undefined;
        data["official"] = this.official;
        return data;
    }
}

export interface IUserShortForChatResponse {
    id?: number;
    is_online?: boolean;
    chat_is_online?: boolean;
    name?: string;
    surname?: string;
    nickname?: string | undefined;
    chat_last_activity_at?: string | undefined;
    avatar?: FileResponse;
    official?: boolean;

    [key: string]: any;
}

export class UserShortForTaskIndexResponse implements IUserShortForTaskIndexResponse {
    id?: number;
    is_online?: boolean;
    rating?: number;
    name?: string;
    surname?: string;
    nickname?: string | undefined;
    avatar?: FileResponse;
    official?: boolean;

    [key: string]: any;

    constructor(data?: IUserShortForTaskIndexResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.is_online = _data["is_online"];
            this.rating = _data["rating"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.nickname = _data["nickname"];
            this.avatar = _data["avatar"] ? FileResponse.fromJS(_data["avatar"]) : <any>undefined;
            this.official = _data["official"];
        }
    }

    static fromJS(data: any): UserShortForTaskIndexResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserShortForTaskIndexResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["is_online"] = this.is_online;
        data["rating"] = this.rating;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["nickname"] = this.nickname;
        data["avatar"] = this.avatar ? this.avatar.toJSON() : <any>undefined;
        data["official"] = this.official;
        return data;
    }
}

export interface IUserShortForTaskIndexResponse {
    id?: number;
    is_online?: boolean;
    rating?: number;
    name?: string;
    surname?: string;
    nickname?: string | undefined;
    avatar?: FileResponse;
    official?: boolean;

    [key: string]: any;
}

export class UserShortForTaskResponse implements IUserShortForTaskResponse {
    id?: number;
    is_online?: boolean;
    rating?: number;
    name?: string;
    surname?: string;
    nickname?: string | undefined;
    avatar?: FileResponse;
    blacklists?: BlacklistResponse[];
    official?: boolean;

    [key: string]: any;

    constructor(data?: IUserShortForTaskResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.is_online = _data["is_online"];
            this.rating = _data["rating"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.nickname = _data["nickname"];
            this.avatar = _data["avatar"] ? FileResponse.fromJS(_data["avatar"]) : <any>undefined;
            if (Array.isArray(_data["blacklists"])) {
                this.blacklists = [] as any;
                for (let item of _data["blacklists"])
                    this.blacklists!.push(BlacklistResponse.fromJS(item));
            }
            this.official = _data["official"];
        }
    }

    static fromJS(data: any): UserShortForTaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserShortForTaskResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["is_online"] = this.is_online;
        data["rating"] = this.rating;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["nickname"] = this.nickname;
        data["avatar"] = this.avatar ? this.avatar.toJSON() : <any>undefined;
        if (Array.isArray(this.blacklists)) {
            data["blacklists"] = [];
            for (let item of this.blacklists)
                data["blacklists"].push(item.toJSON());
        }
        data["official"] = this.official;
        return data;
    }
}

export interface IUserShortForTaskResponse {
    id?: number;
    is_online?: boolean;
    rating?: number;
    name?: string;
    surname?: string;
    nickname?: string | undefined;
    avatar?: FileResponse;
    blacklists?: BlacklistResponse[];
    official?: boolean;

    [key: string]: any;
}

export class UserShortForReplyResponse implements IUserShortForReplyResponse {
    id?: number;
    is_online?: boolean;
    rating?: number;
    name?: string;
    surname?: string;
    nickname?: string | undefined;
    avatar?: FileResponse;
    isSended?: number;
    isApproved?: number;
    onboardingErrors?: string[];
    official?: boolean;

    [key: string]: any;

    constructor(data?: IUserShortForReplyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.is_online = _data["is_online"];
            this.rating = _data["rating"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.nickname = _data["nickname"];
            this.avatar = _data["avatar"] ? FileResponse.fromJS(_data["avatar"]) : <any>undefined;
            this.isSended = _data["isSended"];
            this.isApproved = _data["isApproved"];
            if (Array.isArray(_data["onboardingErrors"])) {
                this.onboardingErrors = [] as any;
                for (let item of _data["onboardingErrors"])
                    this.onboardingErrors!.push(item);
            }
            this.official = _data["official"];
        }
    }

    static fromJS(data: any): UserShortForReplyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserShortForReplyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["is_online"] = this.is_online;
        data["rating"] = this.rating;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["nickname"] = this.nickname;
        data["avatar"] = this.avatar ? this.avatar.toJSON() : <any>undefined;
        data["isSended"] = this.isSended;
        data["isApproved"] = this.isApproved;
        if (Array.isArray(this.onboardingErrors)) {
            data["onboardingErrors"] = [];
            for (let item of this.onboardingErrors)
                data["onboardingErrors"].push(item);
        }
        data["official"] = this.official;
        return data;
    }
}

export interface IUserShortForReplyResponse {
    id?: number;
    is_online?: boolean;
    rating?: number;
    name?: string;
    surname?: string;
    nickname?: string | undefined;
    avatar?: FileResponse;
    isSended?: number;
    isApproved?: number;
    onboardingErrors?: string[];
    official?: boolean;

    [key: string]: any;
}

export class UserFilesResponse implements IUserFilesResponse {
    id?: number;
    is_online?: boolean;
    rating?: number;
    name?: string;
    surname?: string;
    nickname?: string | undefined;
    rate?: number;
    is_open_for_proposals?: boolean;
    avatar?: FileResponse;
    profileFiles?: FileResponse[];
    official?: boolean;

    [key: string]: any;

    constructor(data?: IUserFilesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.is_online = _data["is_online"];
            this.rating = _data["rating"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.nickname = _data["nickname"];
            this.rate = _data["rate"];
            this.is_open_for_proposals = _data["is_open_for_proposals"];
            this.avatar = _data["avatar"] ? FileResponse.fromJS(_data["avatar"]) : <any>undefined;
            if (Array.isArray(_data["profileFiles"])) {
                this.profileFiles = [] as any;
                for (let item of _data["profileFiles"])
                    this.profileFiles!.push(FileResponse.fromJS(item));
            }
            this.official = _data["official"];
        }
    }

    static fromJS(data: any): UserFilesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserFilesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["is_online"] = this.is_online;
        data["rating"] = this.rating;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["nickname"] = this.nickname;
        data["rate"] = this.rate;
        data["is_open_for_proposals"] = this.is_open_for_proposals;
        data["avatar"] = this.avatar ? this.avatar.toJSON() : <any>undefined;
        if (Array.isArray(this.profileFiles)) {
            data["profileFiles"] = [];
            for (let item of this.profileFiles)
                data["profileFiles"].push(item.toJSON());
        }
        data["official"] = this.official;
        return data;
    }
}

export interface IUserFilesResponse {
    id?: number;
    is_online?: boolean;
    rating?: number;
    name?: string;
    surname?: string;
    nickname?: string | undefined;
    rate?: number;
    is_open_for_proposals?: boolean;
    avatar?: FileResponse;
    profileFiles?: FileResponse[];
    official?: boolean;

    [key: string]: any;
}

export class SharedUserDataResponse implements ISharedUserDataResponse {
    rating?: number;
    name?: string;
    surname?: string;
    nickname?: string | undefined;
    avatar?: FileResponse;

    [key: string]: any;

    constructor(data?: ISharedUserDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.rating = _data["rating"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.nickname = _data["nickname"];
            this.avatar = _data["avatar"] ? FileResponse.fromJS(_data["avatar"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SharedUserDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SharedUserDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["rating"] = this.rating;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["nickname"] = this.nickname;
        data["avatar"] = this.avatar ? this.avatar.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISharedUserDataResponse {
    rating?: number;
    name?: string;
    surname?: string;
    nickname?: string | undefined;
    avatar?: FileResponse;

    [key: string]: any;
}

export class ProfileFilesGroupDataResponse implements IProfileFilesGroupDataResponse {
    pdf?: FileResponse[];
    image?: FileResponse[];
    audio?: FileResponse[];
    video?: FileResponse[];
    other?: FileResponse[];

    [key: string]: any;

    constructor(data?: IProfileFilesGroupDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["pdf"])) {
                this.pdf = [] as any;
                for (let item of _data["pdf"])
                    this.pdf!.push(FileResponse.fromJS(item));
            }
            if (Array.isArray(_data["image"])) {
                this.image = [] as any;
                for (let item of _data["image"])
                    this.image!.push(FileResponse.fromJS(item));
            }
            if (Array.isArray(_data["audio"])) {
                this.audio = [] as any;
                for (let item of _data["audio"])
                    this.audio!.push(FileResponse.fromJS(item));
            }
            if (Array.isArray(_data["video"])) {
                this.video = [] as any;
                for (let item of _data["video"])
                    this.video!.push(FileResponse.fromJS(item));
            }
            if (Array.isArray(_data["other"])) {
                this.other = [] as any;
                for (let item of _data["other"])
                    this.other!.push(FileResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfileFilesGroupDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileFilesGroupDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.pdf)) {
            data["pdf"] = [];
            for (let item of this.pdf)
                data["pdf"].push(item.toJSON());
        }
        if (Array.isArray(this.image)) {
            data["image"] = [];
            for (let item of this.image)
                data["image"].push(item.toJSON());
        }
        if (Array.isArray(this.audio)) {
            data["audio"] = [];
            for (let item of this.audio)
                data["audio"].push(item.toJSON());
        }
        if (Array.isArray(this.video)) {
            data["video"] = [];
            for (let item of this.video)
                data["video"].push(item.toJSON());
        }
        if (Array.isArray(this.other)) {
            data["other"] = [];
            for (let item of this.other)
                data["other"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProfileFilesGroupDataResponse {
    pdf?: FileResponse[];
    image?: FileResponse[];
    audio?: FileResponse[];
    video?: FileResponse[];
    other?: FileResponse[];

    [key: string]: any;
}

export class ProfileFullnessDataResponse implements IProfileFullnessDataResponse {
    data?: ProfileFullnessResponse;

    [key: string]: any;

    constructor(data?: IProfileFullnessDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? ProfileFullnessResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProfileFullnessDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileFullnessDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProfileFullnessDataResponse {
    data?: ProfileFullnessResponse;

    [key: string]: any;
}

export class ProfileFullnessResponse implements IProfileFullnessResponse {
    fio?: number;
    description?: number;
    avatar?: number;
    skills?: number;
    profileFiles?: number;
    total?: number;

    [key: string]: any;

    constructor(data?: IProfileFullnessResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.fio = _data["fio"];
            this.description = _data["description"];
            this.avatar = _data["avatar"];
            this.skills = _data["skills"];
            this.profileFiles = _data["profileFiles"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ProfileFullnessResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileFullnessResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["fio"] = this.fio;
        data["description"] = this.description;
        data["avatar"] = this.avatar;
        data["skills"] = this.skills;
        data["profileFiles"] = this.profileFiles;
        data["total"] = this.total;
        return data;
    }
}

export interface IProfileFullnessResponse {
    fio?: number;
    description?: number;
    avatar?: number;
    skills?: number;
    profileFiles?: number;
    total?: number;

    [key: string]: any;
}

export class SendSmsError implements ISendSmsError {
    message?: string;
    errors?: Errors38;

    [key: string]: any;

    constructor(data?: ISendSmsError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors38.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SendSmsError {
        data = typeof data === 'object' ? data : {};
        let result = new SendSmsError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISendSmsError {
    message?: string;
    errors?: Errors38;

    [key: string]: any;
}

export class LoginError implements ILoginError {
    message?: string;
    errors?: Errors39;

    [key: string]: any;

    constructor(data?: ILoginError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors39.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LoginError {
        data = typeof data === 'object' ? data : {};
        let result = new LoginError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILoginError {
    message?: string;
    errors?: Errors39;

    [key: string]: any;
}

export class LoginSmsError implements ILoginSmsError {
    message?: string;
    errors?: Errors40;

    [key: string]: any;

    constructor(data?: ILoginSmsError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors40.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LoginSmsError {
        data = typeof data === 'object' ? data : {};
        let result = new LoginSmsError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILoginSmsError {
    message?: string;
    errors?: Errors40;

    [key: string]: any;
}

export class RefreshError implements IRefreshError {
    message?: string;
    errors?: Errors41;

    [key: string]: any;

    constructor(data?: IRefreshError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors41.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RefreshError {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRefreshError {
    message?: string;
    errors?: Errors41;

    [key: string]: any;
}

export class UserCreateError implements IUserCreateError {
    message?: string;
    errors?: Errors42;

    [key: string]: any;

    constructor(data?: IUserCreateError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors42.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserCreateError {
        data = typeof data === 'object' ? data : {};
        let result = new UserCreateError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserCreateError {
    message?: string;
    errors?: Errors42;

    [key: string]: any;
}

export class UserUpdateError implements IUserUpdateError {
    message?: string;
    errors?: Errors43;

    [key: string]: any;

    constructor(data?: IUserUpdateError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors43.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserUpdateError {
        data = typeof data === 'object' ? data : {};
        let result = new UserUpdateError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserUpdateError {
    message?: string;
    errors?: Errors43;

    [key: string]: any;
}

export class ResetError implements IResetError {
    message?: string;
    errors?: Errors44;

    [key: string]: any;

    constructor(data?: IResetError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors44.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResetError {
        data = typeof data === 'object' ? data : {};
        let result = new ResetError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResetError {
    message?: string;
    errors?: Errors44;

    [key: string]: any;
}

export class RecoveryError implements IRecoveryError {
    message?: string;
    errors?: Errors45;

    [key: string]: any;

    constructor(data?: IRecoveryError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors45.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RecoveryError {
        data = typeof data === 'object' ? data : {};
        let result = new RecoveryError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRecoveryError {
    message?: string;
    errors?: Errors45;

    [key: string]: any;
}

/** User model */
export class ChangePasswordError implements IChangePasswordError {
    message?: string;
    errors?: Errors46;

    [key: string]: any;

    constructor(data?: IChangePasswordError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors46.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChangePasswordError {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

/** User model */
export interface IChangePasswordError {
    message?: string;
    errors?: Errors46;

    [key: string]: any;
}

export class UserActionsResource implements IUserActionsResource {
    my_reaction?: string;
    i_watched?: boolean;
    likes?: number;
    dislikes?: number;
    watches?: number;
    comments_count?: number;

    [key: string]: any;

    constructor(data?: IUserActionsResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.my_reaction = _data["my_reaction"];
            this.i_watched = _data["i_watched"];
            this.likes = _data["likes"];
            this.dislikes = _data["dislikes"];
            this.watches = _data["watches"];
            this.comments_count = _data["comments_count"];
        }
    }

    static fromJS(data: any): UserActionsResource {
        data = typeof data === 'object' ? data : {};
        let result = new UserActionsResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["my_reaction"] = this.my_reaction;
        data["i_watched"] = this.i_watched;
        data["likes"] = this.likes;
        data["dislikes"] = this.dislikes;
        data["watches"] = this.watches;
        data["comments_count"] = this.comments_count;
        return data;
    }
}

export interface IUserActionsResource {
    my_reaction?: string;
    i_watched?: boolean;
    likes?: number;
    dislikes?: number;
    watches?: number;
    comments_count?: number;

    [key: string]: any;
}

export class UserDeviceRequest implements IUserDeviceRequest {
    token?: string;
    /** 1 - default, 2 - for apple voip, 3 - for apple location */
    type?: number;
    name?: string;

    [key: string]: any;

    constructor(data?: IUserDeviceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.token = _data["token"];
            this.type = _data["type"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UserDeviceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserDeviceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["token"] = this.token;
        data["type"] = this.type;
        data["name"] = this.name;
        return data;
    }
}

export interface IUserDeviceRequest {
    token?: string;
    /** 1 - default, 2 - for apple voip, 3 - for apple location */
    type?: number;
    name?: string;

    [key: string]: any;
}

export class UserDeviceUpdateRequest implements IUserDeviceUpdateRequest {
    token?: string;
    type?: number;
    name?: string;

    [key: string]: any;

    constructor(data?: IUserDeviceUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.token = _data["token"];
            this.type = _data["type"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UserDeviceUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserDeviceUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["token"] = this.token;
        data["type"] = this.type;
        data["name"] = this.name;
        return data;
    }
}

export interface IUserDeviceUpdateRequest {
    token?: string;
    type?: number;
    name?: string;

    [key: string]: any;
}

export class UserDeviceDataResponse implements IUserDeviceDataResponse {
    data?: UserDeviceResponse;

    [key: string]: any;

    constructor(data?: IUserDeviceDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? UserDeviceResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserDeviceDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserDeviceDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserDeviceDataResponse {
    data?: UserDeviceResponse;

    [key: string]: any;
}

export class UserDevicesDataResponse implements IUserDevicesDataResponse {
    data?: UserDeviceResponse[];

    [key: string]: any;

    constructor(data?: IUserDevicesDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserDeviceResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDevicesDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserDevicesDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserDevicesDataResponse {
    data?: UserDeviceResponse[];

    [key: string]: any;
}

export class UserDeviceResponse implements IUserDeviceResponse {
    id?: number;
    user_id?: number;
    token?: string;
    type?: number;
    name?: string;

    [key: string]: any;

    constructor(data?: IUserDeviceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.user_id = _data["user_id"];
            this.token = _data["token"];
            this.type = _data["type"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UserDeviceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserDeviceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["user_id"] = this.user_id;
        data["token"] = this.token;
        data["type"] = this.type;
        data["name"] = this.name;
        return data;
    }
}

export interface IUserDeviceResponse {
    id?: number;
    user_id?: number;
    token?: string;
    type?: number;
    name?: string;

    [key: string]: any;
}

export class UserDeviceError implements IUserDeviceError {
    message?: string;
    errors?: Errors47;

    [key: string]: any;

    constructor(data?: IUserDeviceError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors47.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserDeviceError {
        data = typeof data === 'object' ? data : {};
        let result = new UserDeviceError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserDeviceError {
    message?: string;
    errors?: Errors47;

    [key: string]: any;
}

/** UserDevice model */
export class UserDeviceUpdateError implements IUserDeviceUpdateError {
    message?: string;
    errors?: Errors48;

    [key: string]: any;

    constructor(data?: IUserDeviceUpdateError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors48.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserDeviceUpdateError {
        data = typeof data === 'object' ? data : {};
        let result = new UserDeviceUpdateError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

/** UserDevice model */
export interface IUserDeviceUpdateError {
    message?: string;
    errors?: Errors48;

    [key: string]: any;
}

export class UserSolanaWalletResponse implements IUserSolanaWalletResponse {
    id!: number;
    wallet_address!: string;
    status!: UserSolanaWalletResponseStatus;
    verified_at!: Date;
    created_at!: Date;
    updated_at!: Date;

    [key: string]: any;

    constructor(data?: IUserSolanaWalletResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.wallet_address = _data["wallet_address"];
            this.status = _data["status"];
            this.verified_at = _data["verified_at"] ? new Date(_data["verified_at"].toString()) : <any>undefined;
            this.created_at = _data["created_at"] ? new Date(_data["created_at"].toString()) : <any>undefined;
            this.updated_at = _data["updated_at"] ? new Date(_data["updated_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserSolanaWalletResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserSolanaWalletResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["wallet_address"] = this.wallet_address;
        data["status"] = this.status;
        data["verified_at"] = this.verified_at ? this.verified_at.toISOString() : <any>undefined;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        data["updated_at"] = this.updated_at ? this.updated_at.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserSolanaWalletResponse {
    id: number;
    wallet_address: string;
    status: UserSolanaWalletResponseStatus;
    verified_at: Date;
    created_at: Date;
    updated_at: Date;

    [key: string]: any;
}

export class SolanaWalletDataResponse implements ISolanaWalletDataResponse {
    data?: UserSolanaWalletResponse;

    [key: string]: any;

    constructor(data?: ISolanaWalletDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? UserSolanaWalletResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SolanaWalletDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SolanaWalletDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISolanaWalletDataResponse {
    data?: UserSolanaWalletResponse;

    [key: string]: any;
}

export class SolanaWalletLinkChallengeRequest implements ISolanaWalletLinkChallengeRequest {
    wallet_address!: string;

    [key: string]: any;

    constructor(data?: ISolanaWalletLinkChallengeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.wallet_address = _data["wallet_address"];
        }
    }

    static fromJS(data: any): SolanaWalletLinkChallengeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SolanaWalletLinkChallengeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["wallet_address"] = this.wallet_address;
        return data;
    }
}

export interface ISolanaWalletLinkChallengeRequest {
    wallet_address: string;

    [key: string]: any;
}

export class SolanaWalletLinkVerifyRequest implements ISolanaWalletLinkVerifyRequest {
    wallet_address!: string;
    challenge_id!: string;
    signature_base64!: string;

    [key: string]: any;

    constructor(data?: ISolanaWalletLinkVerifyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.wallet_address = _data["wallet_address"];
            this.challenge_id = _data["challenge_id"];
            this.signature_base64 = _data["signature_base64"];
        }
    }

    static fromJS(data: any): SolanaWalletLinkVerifyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SolanaWalletLinkVerifyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["wallet_address"] = this.wallet_address;
        data["challenge_id"] = this.challenge_id;
        data["signature_base64"] = this.signature_base64;
        return data;
    }
}

export interface ISolanaWalletLinkVerifyRequest {
    wallet_address: string;
    challenge_id: string;
    signature_base64: string;

    [key: string]: any;
}

export class SolanaWalletOwnershipChallengeResponse implements ISolanaWalletOwnershipChallengeResponse {
    id!: string;
    wallet_address!: string;
    message!: string;
    expires_at!: Date;

    [key: string]: any;

    constructor(data?: ISolanaWalletOwnershipChallengeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.wallet_address = _data["wallet_address"];
            this.message = _data["message"];
            this.expires_at = _data["expires_at"] ? new Date(_data["expires_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SolanaWalletOwnershipChallengeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SolanaWalletOwnershipChallengeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["wallet_address"] = this.wallet_address;
        data["message"] = this.message;
        data["expires_at"] = this.expires_at ? this.expires_at.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISolanaWalletOwnershipChallengeResponse {
    id: string;
    wallet_address: string;
    message: string;
    expires_at: Date;

    [key: string]: any;
}

export class SolanaWalletOwnershipChallengeDataResponse implements ISolanaWalletOwnershipChallengeDataResponse {
    data!: SolanaWalletOwnershipChallengeResponse;

    [key: string]: any;

    constructor(data?: ISolanaWalletOwnershipChallengeDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = new SolanaWalletOwnershipChallengeResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? SolanaWalletOwnershipChallengeResponse.fromJS(_data["data"]) : new SolanaWalletOwnershipChallengeResponse();
        }
    }

    static fromJS(data: any): SolanaWalletOwnershipChallengeDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SolanaWalletOwnershipChallengeDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISolanaWalletOwnershipChallengeDataResponse {
    data: SolanaWalletOwnershipChallengeResponse;

    [key: string]: any;
}

export class PjmBalanceResponse implements IPjmBalanceResponse {
    wallet_address!: string;
    mint_address!: string;
    amount_base_units!: string;
    spendable_amount_base_units!: string;
    decimals!: number;
    free_transfer_limit!: number;
    free_transfers_remaining!: number;

    [key: string]: any;

    constructor(data?: IPjmBalanceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.wallet_address = _data["wallet_address"];
            this.mint_address = _data["mint_address"];
            this.amount_base_units = _data["amount_base_units"];
            this.spendable_amount_base_units = _data["spendable_amount_base_units"];
            this.decimals = _data["decimals"];
            this.free_transfer_limit = _data["free_transfer_limit"];
            this.free_transfers_remaining = _data["free_transfers_remaining"];
        }
    }

    static fromJS(data: any): PjmBalanceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PjmBalanceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["wallet_address"] = this.wallet_address;
        data["mint_address"] = this.mint_address;
        data["amount_base_units"] = this.amount_base_units;
        data["spendable_amount_base_units"] = this.spendable_amount_base_units;
        data["decimals"] = this.decimals;
        data["free_transfer_limit"] = this.free_transfer_limit;
        data["free_transfers_remaining"] = this.free_transfers_remaining;
        return data;
    }
}

export interface IPjmBalanceResponse {
    wallet_address: string;
    mint_address: string;
    amount_base_units: string;
    spendable_amount_base_units: string;
    decimals: number;
    free_transfer_limit: number;
    free_transfers_remaining: number;

    [key: string]: any;
}

export class PjmBalanceDataResponse implements IPjmBalanceDataResponse {
    data!: PjmBalanceResponse;

    [key: string]: any;

    constructor(data?: IPjmBalanceDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = new PjmBalanceResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? PjmBalanceResponse.fromJS(_data["data"]) : new PjmBalanceResponse();
        }
    }

    static fromJS(data: any): PjmBalanceDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PjmBalanceDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPjmBalanceDataResponse {
    data: PjmBalanceResponse;

    [key: string]: any;
}

export class Body implements IBody {
    version?: string;
    type?: string;
    token?: string;
    email?: string;
    phone?: string;
    password?: string;

    [key: string]: any;

    constructor(data?: IBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.version = _data["version"];
            this.type = _data["type"];
            this.token = _data["token"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): Body {
        data = typeof data === 'object' ? data : {};
        let result = new Body();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["version"] = this.version;
        data["type"] = this.type;
        data["token"] = this.token;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["password"] = this.password;
        return data;
    }
}

export interface IBody {
    version?: string;
    type?: string;
    token?: string;
    email?: string;
    phone?: string;
    password?: string;

    [key: string]: any;
}

export class Body2 implements IBody2 {
    refresh_token?: string;

    [key: string]: any;

    constructor(data?: IBody2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.refresh_token = _data["refresh_token"];
        }
    }

    static fromJS(data: any): Body2 {
        data = typeof data === 'object' ? data : {};
        let result = new Body2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["refresh_token"] = this.refresh_token;
        return data;
    }
}

export interface IBody2 {
    refresh_token?: string;

    [key: string]: any;
}

export class Body3 implements IBody3 {
    accountSid?: string;
    smsSid?: string;
    smsStatus?: string;

    [key: string]: any;

    constructor(data?: IBody3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.accountSid = _data["AccountSid"];
            this.smsSid = _data["SmsSid"];
            this.smsStatus = _data["SmsStatus"];
        }
    }

    static fromJS(data: any): Body3 {
        data = typeof data === 'object' ? data : {};
        let result = new Body3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["AccountSid"] = this.accountSid;
        data["SmsSid"] = this.smsSid;
        data["SmsStatus"] = this.smsStatus;
        return data;
    }
}

export interface IBody3 {
    accountSid?: string;
    smsSid?: string;
    smsStatus?: string;

    [key: string]: any;
}

export class Body4 implements IBody4 {
    /** Group chat title */
    title!: string;
    /** Group chat description */
    description?: string;
    /** Array of user IDs to add as members */
    user_ids?: number[];

    [key: string]: any;

    constructor(data?: IBody4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.title = _data["title"];
            this.description = _data["description"];
            if (Array.isArray(_data["user_ids"])) {
                this.user_ids = [] as any;
                for (let item of _data["user_ids"])
                    this.user_ids!.push(item);
            }
        }
    }

    static fromJS(data: any): Body4 {
        data = typeof data === 'object' ? data : {};
        let result = new Body4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["title"] = this.title;
        data["description"] = this.description;
        if (Array.isArray(this.user_ids)) {
            data["user_ids"] = [];
            for (let item of this.user_ids)
                data["user_ids"].push(item);
        }
        return data;
    }
}

export interface IBody4 {
    /** Group chat title */
    title: string;
    /** Group chat description */
    description?: string;
    /** Array of user IDs to add as members */
    user_ids?: number[];

    [key: string]: any;
}

export class Body5 implements IBody5 {
    /** Array of user IDs to add as members */
    user_ids!: number[];

    [key: string]: any;

    constructor(data?: IBody5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user_ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["user_ids"])) {
                this.user_ids = [] as any;
                for (let item of _data["user_ids"])
                    this.user_ids!.push(item);
            }
        }
    }

    static fromJS(data: any): Body5 {
        data = typeof data === 'object' ? data : {};
        let result = new Body5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.user_ids)) {
            data["user_ids"] = [];
            for (let item of this.user_ids)
                data["user_ids"].push(item);
        }
        return data;
    }
}

export interface IBody5 {
    /** Array of user IDs to add as members */
    user_ids: number[];

    [key: string]: any;
}

export class Body6 implements IBody6 {
    /** New role for the member */
    role!: Body6Role;

    [key: string]: any;

    constructor(data?: IBody6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): Body6 {
        data = typeof data === 'object' ? data : {};
        let result = new Body6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["role"] = this.role;
        return data;
    }
}

export interface IBody6 {
    /** New role for the member */
    role: Body6Role;

    [key: string]: any;
}

export class Body7 implements IBody7 {
    /** Group chat title */
    title?: string;
    /** Group chat description */
    description?: string;
    /** Avatar file ID */
    avatar_file_id?: number;

    [key: string]: any;

    constructor(data?: IBody7) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.title = _data["title"];
            this.description = _data["description"];
            this.avatar_file_id = _data["avatar_file_id"];
        }
    }

    static fromJS(data: any): Body7 {
        data = typeof data === 'object' ? data : {};
        let result = new Body7();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["title"] = this.title;
        data["description"] = this.description;
        data["avatar_file_id"] = this.avatar_file_id;
        return data;
    }
}

export interface IBody7 {
    /** Group chat title */
    title?: string;
    /** Group chat description */
    description?: string;
    /** Avatar file ID */
    avatar_file_id?: number;

    [key: string]: any;
}

export class Body8 implements IBody8 {
    secret!: string;
    user_id?: number | undefined;

    [key: string]: any;

    constructor(data?: IBody8) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.secret = _data["secret"];
            this.user_id = _data["user_id"];
        }
    }

    static fromJS(data: any): Body8 {
        data = typeof data === 'object' ? data : {};
        let result = new Body8();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["secret"] = this.secret;
        data["user_id"] = this.user_id;
        return data;
    }
}

export interface IBody8 {
    secret: string;
    user_id?: number | undefined;

    [key: string]: any;
}

export class Body9 implements IBody9 {
    /** S3 object key/name of uploaded avatar */
    s3name!: string;

    [key: string]: any;

    constructor(data?: IBody9) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.s3name = _data["s3name"];
        }
    }

    static fromJS(data: any): Body9 {
        data = typeof data === 'object' ? data : {};
        let result = new Body9();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["s3name"] = this.s3name;
        return data;
    }
}

export interface IBody9 {
    /** S3 object key/name of uploaded avatar */
    s3name: string;

    [key: string]: any;
}

export enum Scope {
    Me = "me",
    Everyone = "everyone",
}

export class FileRequestBody implements IFileRequestBody {
    files?: FileRequest[];

    [key: string]: any;

    constructor(data?: IFileRequestBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileRequestBody {
        data = typeof data === 'object' ? data : {};
        let result = new FileRequestBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFileRequestBody {
    files?: FileRequest[];

    [key: string]: any;
}

export class Body10 implements IBody10 {
    client_guid!: string;

    [key: string]: any;

    constructor(data?: IBody10) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.client_guid = _data["client_guid"];
        }
    }

    static fromJS(data: any): Body10 {
        data = typeof data === 'object' ? data : {};
        let result = new Body10();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["client_guid"] = this.client_guid;
        return data;
    }
}

export interface IBody10 {
    client_guid: string;

    [key: string]: any;
}

export class Body11 implements IBody11 {
    client_guid?: string;
    s3name?: string;

    [key: string]: any;

    constructor(data?: IBody11) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.client_guid = _data["client_guid"];
            this.s3name = _data["s3name"];
        }
    }

    static fromJS(data: any): Body11 {
        data = typeof data === 'object' ? data : {};
        let result = new Body11();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["client_guid"] = this.client_guid;
        data["s3name"] = this.s3name;
        return data;
    }
}

export interface IBody11 {
    client_guid?: string;
    s3name?: string;

    [key: string]: any;
}

export class ProfileFileRequestBody implements IProfileFileRequestBody {
    files?: ProfileFileRequest[];

    [key: string]: any;

    constructor(data?: IProfileFileRequestBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(ProfileFileRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfileFileRequestBody {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileFileRequestBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProfileFileRequestBody {
    files?: ProfileFileRequest[];

    [key: string]: any;
}

export enum Locale {
    Ru = "ru",
    En = "en",
    Pl = "pl",
}

export class QuestionsByIdsRequest implements IQuestionsByIdsRequest {
    ids?: number[];

    [key: string]: any;

    constructor(data?: IQuestionsByIdsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): QuestionsByIdsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionsByIdsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IQuestionsByIdsRequest {
    ids?: number[];

    [key: string]: any;
}

export class Body12 implements IBody12 {
    code?: string;
    phone?: string;
    password?: string;

    [key: string]: any;

    constructor(data?: IBody12) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.code = _data["code"];
            this.phone = _data["phone"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): Body12 {
        data = typeof data === 'object' ? data : {};
        let result = new Body12();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["code"] = this.code;
        data["phone"] = this.phone;
        data["password"] = this.password;
        return data;
    }
}

export interface IBody12 {
    code?: string;
    phone?: string;
    password?: string;

    [key: string]: any;
}

export class Body13 implements IBody13 {
    password?: string;
    c_password?: string;

    [key: string]: any;

    constructor(data?: IBody13) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.password = _data["password"];
            this.c_password = _data["c_password"];
        }
    }

    static fromJS(data: any): Body13 {
        data = typeof data === 'object' ? data : {};
        let result = new Body13();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["password"] = this.password;
        data["c_password"] = this.c_password;
        return data;
    }
}

export interface IBody13 {
    password?: string;
    c_password?: string;

    [key: string]: any;
}

export class Body14 implements IBody14 {
    secret?: string;
    is_online?: boolean;

    [key: string]: any;

    constructor(data?: IBody14) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.secret = _data["secret"];
            this.is_online = _data["is_online"];
        }
    }

    static fromJS(data: any): Body14 {
        data = typeof data === 'object' ? data : {};
        let result = new Body14();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["secret"] = this.secret;
        data["is_online"] = this.is_online;
        return data;
    }
}

export interface IBody14 {
    secret?: string;
    is_online?: boolean;

    [key: string]: any;
}

export class Body15 implements IBody15 {
    secret!: string;
    is_online!: boolean;
    last_activity_at?: Date | undefined;

    [key: string]: any;

    constructor(data?: IBody15) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.secret = _data["secret"];
            this.is_online = _data["is_online"];
            this.last_activity_at = _data["last_activity_at"] ? new Date(_data["last_activity_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Body15 {
        data = typeof data === 'object' ? data : {};
        let result = new Body15();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["secret"] = this.secret;
        data["is_online"] = this.is_online;
        data["last_activity_at"] = this.last_activity_at ? this.last_activity_at.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBody15 {
    secret: string;
    is_online: boolean;
    last_activity_at?: Date | undefined;

    [key: string]: any;
}

export class Body16 implements IBody16 {
    nickname!: string;

    [key: string]: any;

    constructor(data?: IBody16) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.nickname = _data["nickname"];
        }
    }

    static fromJS(data: any): Body16 {
        data = typeof data === 'object' ? data : {};
        let result = new Body16();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["nickname"] = this.nickname;
        return data;
    }
}

export interface IBody16 {
    nickname: string;

    [key: string]: any;
}

export class Body17 implements IBody17 {
    text?: string;

    [key: string]: any;

    constructor(data?: IBody17) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): Body17 {
        data = typeof data === 'object' ? data : {};
        let result = new Body17();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["text"] = this.text;
        return data;
    }
}

export interface IBody17 {
    text?: string;

    [key: string]: any;
}

export class CategoriesDataResponse implements ICategoriesDataResponse {
    data?: CategoryResponse[];

    [key: string]: any;

    constructor(data?: ICategoriesDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CategoryResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoriesDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CategoriesDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICategoriesDataResponse {
    data?: CategoryResponse[];

    [key: string]: any;
}

export class CategoriesShortDataResponse implements ICategoriesShortDataResponse {
    data?: CategoryShortResponse[];

    [key: string]: any;

    constructor(data?: ICategoriesShortDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CategoryShortResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoriesShortDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CategoriesShortDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICategoriesShortDataResponse {
    data?: CategoryShortResponse[];

    [key: string]: any;
}

export class CategoriesDataResponse2 implements ICategoriesDataResponse2 {
    data?: CategoryShortResponse[];

    [key: string]: any;

    constructor(data?: ICategoriesDataResponse2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CategoryShortResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoriesDataResponse2 {
        data = typeof data === 'object' ? data : {};
        let result = new CategoriesDataResponse2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICategoriesDataResponse2 {
    data?: CategoryShortResponse[];

    [key: string]: any;
}

export class Anonymous implements IAnonymous {
    message?: string;
    added?: number[];

    [key: string]: any;

    constructor(data?: IAnonymous) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            if (Array.isArray(_data["added"])) {
                this.added = [] as any;
                for (let item of _data["added"])
                    this.added!.push(item);
            }
        }
    }

    static fromJS(data: any): Anonymous {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        if (Array.isArray(this.added)) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item);
        }
        return data;
    }
}

export interface IAnonymous {
    message?: string;
    added?: number[];

    [key: string]: any;
}

export class QtyUnreadMessages implements IQtyUnreadMessages {
    connects?: number;
    inProgress?: number;
    done?: number;

    [key: string]: any;

    constructor(data?: IQtyUnreadMessages) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.connects = _data["connects"];
            this.inProgress = _data["inProgress"];
            this.done = _data["done"];
        }
    }

    static fromJS(data: any): QtyUnreadMessages {
        data = typeof data === 'object' ? data : {};
        let result = new QtyUnreadMessages();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["connects"] = this.connects;
        data["inProgress"] = this.inProgress;
        data["done"] = this.done;
        return data;
    }
}

export interface IQtyUnreadMessages {
    connects?: number;
    inProgress?: number;
    done?: number;

    [key: string]: any;
}

export class FilesStringDataResponse implements IFilesStringDataResponse {
    data?: string[];

    [key: string]: any;

    constructor(data?: IFilesStringDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
        }
    }

    static fromJS(data: any): FilesStringDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FilesStringDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        return data;
    }
}

export interface IFilesStringDataResponse {
    data?: string[];

    [key: string]: any;
}

export class Anonymous2 implements IAnonymous2 {
    ok?: boolean;

    [key: string]: any;

    constructor(data?: IAnonymous2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): Anonymous2 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["ok"] = this.ok;
        return data;
    }
}

export interface IAnonymous2 {
    ok?: boolean;

    [key: string]: any;
}

export class Anonymous3 implements IAnonymous3 {
    status?: string;
    client_guid?: string | undefined;
    s3name?: string | undefined;
    file_id?: number | undefined;
    completed_at?: string | undefined;
    file?: FileResponse;

    [key: string]: any;

    constructor(data?: IAnonymous3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.status = _data["status"];
            this.client_guid = _data["client_guid"];
            this.s3name = _data["s3name"];
            this.file_id = _data["file_id"];
            this.completed_at = _data["completed_at"];
            this.file = _data["file"] ? FileResponse.fromJS(_data["file"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Anonymous3 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["status"] = this.status;
        data["client_guid"] = this.client_guid;
        data["s3name"] = this.s3name;
        data["file_id"] = this.file_id;
        data["completed_at"] = this.completed_at;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAnonymous3 {
    status?: string;
    client_guid?: string | undefined;
    s3name?: string | undefined;
    file_id?: number | undefined;
    completed_at?: string | undefined;
    file?: FileResponse;

    [key: string]: any;
}

export class FileTypeDataResponse implements IFileTypeDataResponse {
    data?: FileTypeResponse[];

    [key: string]: any;

    constructor(data?: IFileTypeDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FileTypeResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileTypeDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileTypeDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFileTypeDataResponse {
    data?: FileTypeResponse[];

    [key: string]: any;
}

export class Anonymous4 implements IAnonymous4 {
    object?: string;
    created?: number;
    url?: string;

    [key: string]: any;

    constructor(data?: IAnonymous4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.object = _data["object"];
            this.created = _data["created"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): Anonymous4 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["object"] = this.object;
        data["created"] = this.created;
        data["url"] = this.url;
        return data;
    }
}

export interface IAnonymous4 {
    object?: string;
    created?: number;
    url?: string;

    [key: string]: any;
}

export class Anonymous5 implements IAnonymous5 {
    suggestions?: Suggestions[];

    [key: string]: any;

    constructor(data?: IAnonymous5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["suggestions"])) {
                this.suggestions = [] as any;
                for (let item of _data["suggestions"])
                    this.suggestions!.push(Suggestions.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Anonymous5 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.suggestions)) {
            data["suggestions"] = [];
            for (let item of this.suggestions)
                data["suggestions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAnonymous5 {
    suggestions?: Suggestions[];

    [key: string]: any;
}

export class Anonymous6 implements IAnonymous6 {
    data?: ContentCommentResource;

    [key: string]: any;

    constructor(data?: IAnonymous6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? ContentCommentResource.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Anonymous6 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAnonymous6 {
    data?: ContentCommentResource;

    [key: string]: any;
}

export class Anonymous7 implements IAnonymous7 {
    data?: UserMinimalResource;

    [key: string]: any;

    constructor(data?: IAnonymous7) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? UserMinimalResource.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Anonymous7 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous7();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAnonymous7 {
    data?: UserMinimalResource;

    [key: string]: any;
}

export class Anonymous8 implements IAnonymous8 {
    available?: boolean;

    [key: string]: any;

    constructor(data?: IAnonymous8) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.available = _data["available"];
        }
    }

    static fromJS(data: any): Anonymous8 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous8();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["available"] = this.available;
        return data;
    }
}

export interface IAnonymous8 {
    available?: boolean;

    [key: string]: any;
}

export class Anonymous9 implements IAnonymous9 {
    data?: UserMinimalResource;

    [key: string]: any;

    constructor(data?: IAnonymous9) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? UserMinimalResource.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Anonymous9 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous9();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAnonymous9 {
    data?: UserMinimalResource;

    [key: string]: any;
}

export class Anonymous10 implements IAnonymous10 {
    message?: string;

    [key: string]: any;

    constructor(data?: IAnonymous10) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): Anonymous10 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous10();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        return data;
    }
}

export interface IAnonymous10 {
    message?: string;

    [key: string]: any;
}

export class Anonymous11 implements IAnonymous11 {
    message?: string;
    errors?: Errors49;

    [key: string]: any;

    constructor(data?: IAnonymous11) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.errors = _data["errors"] ? Errors49.fromJS(_data["errors"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Anonymous11 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous11();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAnonymous11 {
    message?: string;
    errors?: Errors49;

    [key: string]: any;
}

export class Anonymous12 implements IAnonymous12 {
    video_id?: number;

    [key: string]: any;

    constructor(data?: IAnonymous12) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.video_id = _data["video_id"];
        }
    }

    static fromJS(data: any): Anonymous12 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous12();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["video_id"] = this.video_id;
        return data;
    }
}

export interface IAnonymous12 {
    video_id?: number;

    [key: string]: any;
}

export class Anonymous13 implements IAnonymous13 {
    data?: ContentCommentResource;

    [key: string]: any;

    constructor(data?: IAnonymous13) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? ContentCommentResource.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Anonymous13 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous13();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAnonymous13 {
    data?: ContentCommentResource;

    [key: string]: any;
}

export class Anonymous14 implements IAnonymous14 {
    video_id?: number;

    [key: string]: any;

    constructor(data?: IAnonymous14) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.video_id = _data["video_id"];
        }
    }

    static fromJS(data: any): Anonymous14 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous14();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["video_id"] = this.video_id;
        return data;
    }
}

export interface IAnonymous14 {
    video_id?: number;

    [key: string]: any;
}

export class Anonymous15 implements IAnonymous15 {
    message?: string;
    video_id?: number;

    [key: string]: any;

    constructor(data?: IAnonymous15) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.video_id = _data["video_id"];
        }
    }

    static fromJS(data: any): Anonymous15 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous15();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["video_id"] = this.video_id;
        return data;
    }
}

export interface IAnonymous15 {
    message?: string;
    video_id?: number;

    [key: string]: any;
}

export class Data implements IData {
    chat_id?: number;
    messages?: ChatForwardedMessage[];
    created_count?: number;
    chat_preview?: any | undefined;

    [key: string]: any;

    constructor(data?: IData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.chat_id = _data["chat_id"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(ChatForwardedMessage.fromJS(item));
            }
            this.created_count = _data["created_count"];
            this.chat_preview = _data["chat_preview"];
        }
    }

    static fromJS(data: any): Data {
        data = typeof data === 'object' ? data : {};
        let result = new Data();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["chat_id"] = this.chat_id;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        data["created_count"] = this.created_count;
        data["chat_preview"] = this.chat_preview;
        return data;
    }
}

export interface IData {
    chat_id?: number;
    messages?: ChatForwardedMessage[];
    created_count?: number;
    chat_preview?: any | undefined;

    [key: string]: any;
}

export class Chat_preview implements IChat_preview {
    last_message_id?: string | undefined;
    last_message_text?: string | undefined;
    last_message_type?: number | undefined;
    last_message_at?: Date | undefined;
    last_message_user?: UserShortForChatResponse;
    user_1_last_message?: string | undefined;
    user_1_last_message_at?: Date | undefined;
    user_2_last_message?: string | undefined;
    user_2_last_message_at?: Date | undefined;

    [key: string]: any;

    constructor(data?: IChat_preview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.last_message_id = _data["last_message_id"];
            this.last_message_text = _data["last_message_text"];
            this.last_message_type = _data["last_message_type"];
            this.last_message_at = _data["last_message_at"] ? new Date(_data["last_message_at"].toString()) : <any>undefined;
            this.last_message_user = _data["last_message_user"] ? UserShortForChatResponse.fromJS(_data["last_message_user"]) : <any>undefined;
            this.user_1_last_message = _data["user_1_last_message"];
            this.user_1_last_message_at = _data["user_1_last_message_at"] ? new Date(_data["user_1_last_message_at"].toString()) : <any>undefined;
            this.user_2_last_message = _data["user_2_last_message"];
            this.user_2_last_message_at = _data["user_2_last_message_at"] ? new Date(_data["user_2_last_message_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Chat_preview {
        data = typeof data === 'object' ? data : {};
        let result = new Chat_preview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["last_message_id"] = this.last_message_id;
        data["last_message_text"] = this.last_message_text;
        data["last_message_type"] = this.last_message_type;
        data["last_message_at"] = this.last_message_at ? this.last_message_at.toISOString() : <any>undefined;
        data["last_message_user"] = this.last_message_user ? this.last_message_user.toJSON() : <any>undefined;
        data["user_1_last_message"] = this.user_1_last_message;
        data["user_1_last_message_at"] = this.user_1_last_message_at ? this.user_1_last_message_at.toISOString() : <any>undefined;
        data["user_2_last_message"] = this.user_2_last_message;
        data["user_2_last_message_at"] = this.user_2_last_message_at ? this.user_2_last_message_at.toISOString() : <any>undefined;
        return data;
    }
}

export interface IChat_preview {
    last_message_id?: string | undefined;
    last_message_text?: string | undefined;
    last_message_type?: number | undefined;
    last_message_at?: Date | undefined;
    last_message_user?: UserShortForChatResponse;
    user_1_last_message?: string | undefined;
    user_1_last_message_at?: Date | undefined;
    user_2_last_message?: string | undefined;
    user_2_last_message_at?: Date | undefined;

    [key: string]: any;
}

export enum ChatDeleteMessagesRequestScope {
    Me = "me",
    Everyone = "everyone",
}

export class Errors implements IErrors {
    title?: string[];

    [key: string]: any;

    constructor(data?: IErrors) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["title"])) {
                this.title = [] as any;
                for (let item of _data["title"])
                    this.title!.push(item);
            }
        }
    }

    static fromJS(data: any): Errors {
        data = typeof data === 'object' ? data : {};
        let result = new Errors();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.title)) {
            data["title"] = [];
            for (let item of this.title)
                data["title"].push(item);
        }
        return data;
    }
}

export interface IErrors {
    title?: string[];

    [key: string]: any;
}

export class Link implements ILink {
    object?: string;
    created?: number;
    expires_at?: number;
    url?: string;

    [key: string]: any;

    constructor(data?: ILink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.object = _data["object"];
            this.created = _data["created"];
            this.expires_at = _data["expires_at"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): Link {
        data = typeof data === 'object' ? data : {};
        let result = new Link();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["object"] = this.object;
        data["created"] = this.created;
        data["expires_at"] = this.expires_at;
        data["url"] = this.url;
        return data;
    }
}

export interface ILink {
    object?: string;
    created?: number;
    expires_at?: number;
    url?: string;

    [key: string]: any;
}

export enum ContentActionRequestContent_type {
    Video = "video",
    File = "file",
    Comment = "comment",
}

export enum ContentActionRequestAction {
    Like = "like",
    Dislike = "dislike",
    Watch = "watch",
    Remove_like = "remove_like",
    Remove_dislike = "remove_dislike",
}

export enum ContentCommentRequestContent_type {
    Video = "video",
    File = "file",
}

export class Errors2 implements IErrors2 {
    user_ids?: string[];
    body_text_key?: string[];
    title_text_key?: string[];
    url?: string[];

    [key: string]: any;

    constructor(data?: IErrors2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["user_ids"])) {
                this.user_ids = [] as any;
                for (let item of _data["user_ids"])
                    this.user_ids!.push(item);
            }
            if (Array.isArray(_data["body_text_key"])) {
                this.body_text_key = [] as any;
                for (let item of _data["body_text_key"])
                    this.body_text_key!.push(item);
            }
            if (Array.isArray(_data["title_text_key"])) {
                this.title_text_key = [] as any;
                for (let item of _data["title_text_key"])
                    this.title_text_key!.push(item);
            }
            if (Array.isArray(_data["url"])) {
                this.url = [] as any;
                for (let item of _data["url"])
                    this.url!.push(item);
            }
        }
    }

    static fromJS(data: any): Errors2 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.user_ids)) {
            data["user_ids"] = [];
            for (let item of this.user_ids)
                data["user_ids"].push(item);
        }
        if (Array.isArray(this.body_text_key)) {
            data["body_text_key"] = [];
            for (let item of this.body_text_key)
                data["body_text_key"].push(item);
        }
        if (Array.isArray(this.title_text_key)) {
            data["title_text_key"] = [];
            for (let item of this.title_text_key)
                data["title_text_key"].push(item);
        }
        if (Array.isArray(this.url)) {
            data["url"] = [];
            for (let item of this.url)
                data["url"].push(item);
        }
        return data;
    }
}

export interface IErrors2 {
    user_ids?: string[];
    body_text_key?: string[];
    title_text_key?: string[];
    url?: string[];

    [key: string]: any;
}

export enum SetUserPushSettingsRequestPushType {
    Others = "others",
    Streams = "streams",
    Chats = "chats",
}

export enum StoreUserLocationRequestSource {
    Ip = "ip",
    Gps = "gps",
}

export enum UpdateVideoLocationRequestLocation_source {
    Gps = "gps",
    Ip = "ip",
}

export enum UserContentSubscriptionRequestSubscription_type {
    Streaming_radius = "streaming_radius",
    Streamer_id = "streamer_id",
}

export enum UserContentSubscriptionRequestAction {
    Subscribe = "subscribe",
    Unsubscribe = "unsubscribe",
}

export class Meta implements IMeta {
    total?: number;
    offset?: number;
    limit?: number;

    [key: string]: any;

    constructor(data?: IMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): Meta {
        data = typeof data === 'object' ? data : {};
        let result = new Meta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IMeta {
    total?: number;
    offset?: number;
    limit?: number;

    [key: string]: any;
}

export enum StreamExtendedResourceLocation_source {
    Gps = "gps",
    Ip = "ip",
}

export class Meta2 implements IMeta2 {
    total?: number;
    offset?: number;
    count?: number;

    [key: string]: any;

    constructor(data?: IMeta2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): Meta2 {
        data = typeof data === 'object' ? data : {};
        let result = new Meta2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["count"] = this.count;
        return data;
    }
}

export interface IMeta2 {
    total?: number;
    offset?: number;
    count?: number;

    [key: string]: any;
}

export enum WalletTransactionResponseDirection {
    Incoming = "incoming",
    Outgoing = "outgoing",
}

export enum WalletTransactionResponseStatus {
    Prepared = "prepared",
    Submitted = "submitted",
    Finalized = "finalized",
    Failed = "failed",
    Expired = "expired",
}

export enum WalletTransferPaymentIntentResponseSolana_cluster {
    Devnet = "devnet",
    Testnet = "testnet",
    MainnetBeta = "mainnet-beta",
    Localnet = "localnet",
}

export enum WorldStreamResourceLocation_source {
    Gps = "gps",
    Ip = "ip",
}

export class My_actions implements IMy_actions {
    my_reaction?: string | undefined;
    i_watched?: boolean;
    i_subscribed?: boolean;

    [key: string]: any;

    constructor(data?: IMy_actions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.my_reaction = _data["my_reaction"];
            this.i_watched = _data["i_watched"];
            this.i_subscribed = _data["i_subscribed"];
        }
    }

    static fromJS(data: any): My_actions {
        data = typeof data === 'object' ? data : {};
        let result = new My_actions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["my_reaction"] = this.my_reaction;
        data["i_watched"] = this.i_watched;
        data["i_subscribed"] = this.i_subscribed;
        return data;
    }
}

export interface IMy_actions {
    my_reaction?: string | undefined;
    i_watched?: boolean;
    i_subscribed?: boolean;

    [key: string]: any;
}

export class Errors3 implements IErrors3 {
    property?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["property"])) {
                this.property = [] as any;
                for (let item of _data["property"])
                    this.property!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors3 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.property)) {
            data["property"] = [];
            for (let item of this.property)
                data["property"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors3 {
    property?: Validation[];

    [key: string]: any;
}

export class Errors4 implements IErrors4 {
    property?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["property"])) {
                this.property = [] as any;
                for (let item of _data["property"])
                    this.property!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors4 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.property)) {
            data["property"] = [];
            for (let item of this.property)
                data["property"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors4 {
    property?: Validation[];

    [key: string]: any;
}

export class Errors5 implements IErrors5 {
    date?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["date"])) {
                this.date = [] as any;
                for (let item of _data["date"])
                    this.date!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors5 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.date)) {
            data["date"] = [];
            for (let item of this.date)
                data["date"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors5 {
    date?: Validation[];

    [key: string]: any;
}

export class Errors6 implements IErrors6 {
    date?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["date"])) {
                this.date = [] as any;
                for (let item of _data["date"])
                    this.date!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors6 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.date)) {
            data["date"] = [];
            for (let item of this.date)
                data["date"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors6 {
    date?: Validation[];

    [key: string]: any;
}

export class Errors7 implements IErrors7 {
    to_id?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors7) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["to_id"])) {
                this.to_id = [] as any;
                for (let item of _data["to_id"])
                    this.to_id!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors7 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors7();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.to_id)) {
            data["to_id"] = [];
            for (let item of this.to_id)
                data["to_id"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors7 {
    to_id?: Validation[];

    [key: string]: any;
}

export class Errors8 implements IErrors8 {
    name?: Validation[];
    is_final?: Validation[];
    is_active?: Validation[];
    example_answers?: Validation[];
    synonyms?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors8) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["name"])) {
                this.name = [] as any;
                for (let item of _data["name"])
                    this.name!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["is_final"])) {
                this.is_final = [] as any;
                for (let item of _data["is_final"])
                    this.is_final!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["is_active"])) {
                this.is_active = [] as any;
                for (let item of _data["is_active"])
                    this.is_active!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["example_answers"])) {
                this.example_answers = [] as any;
                for (let item of _data["example_answers"])
                    this.example_answers!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["synonyms"])) {
                this.synonyms = [] as any;
                for (let item of _data["synonyms"])
                    this.synonyms!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors8 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors8();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.name)) {
            data["name"] = [];
            for (let item of this.name)
                data["name"].push(item.toJSON());
        }
        if (Array.isArray(this.is_final)) {
            data["is_final"] = [];
            for (let item of this.is_final)
                data["is_final"].push(item.toJSON());
        }
        if (Array.isArray(this.is_active)) {
            data["is_active"] = [];
            for (let item of this.is_active)
                data["is_active"].push(item.toJSON());
        }
        if (Array.isArray(this.example_answers)) {
            data["example_answers"] = [];
            for (let item of this.example_answers)
                data["example_answers"].push(item.toJSON());
        }
        if (Array.isArray(this.synonyms)) {
            data["synonyms"] = [];
            for (let item of this.synonyms)
                data["synonyms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors8 {
    name?: Validation[];
    is_final?: Validation[];
    is_active?: Validation[];
    example_answers?: Validation[];
    synonyms?: Validation[];

    [key: string]: any;
}

export class Links implements ILinks {
    first?: string;
    last?: string;
    prev?: string | undefined;
    next?: string | undefined;

    [key: string]: any;

    constructor(data?: ILinks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.first = _data["first"];
            this.last = _data["last"];
            this.prev = _data["prev"];
            this.next = _data["next"];
        }
    }

    static fromJS(data: any): Links {
        data = typeof data === 'object' ? data : {};
        let result = new Links();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["first"] = this.first;
        data["last"] = this.last;
        data["prev"] = this.prev;
        data["next"] = this.next;
        return data;
    }
}

export interface ILinks {
    first?: string;
    last?: string;
    prev?: string | undefined;
    next?: string | undefined;

    [key: string]: any;
}

export class Meta3 implements IMeta3 {
    current_page?: number;
    from?: number;
    last_page?: number;
    path?: string;
    per_page?: number;
    to?: number;
    total?: number;
    links?: Links3[];

    [key: string]: any;

    constructor(data?: IMeta3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.current_page = _data["current_page"];
            this.from = _data["from"];
            this.last_page = _data["last_page"];
            this.path = _data["path"];
            this.per_page = _data["per_page"];
            this.to = _data["to"];
            this.total = _data["total"];
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(Links3.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Meta3 {
        data = typeof data === 'object' ? data : {};
        let result = new Meta3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["current_page"] = this.current_page;
        data["from"] = this.from;
        data["last_page"] = this.last_page;
        data["path"] = this.path;
        data["per_page"] = this.per_page;
        data["to"] = this.to;
        data["total"] = this.total;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMeta3 {
    current_page?: number;
    from?: number;
    last_page?: number;
    path?: string;
    per_page?: number;
    to?: number;
    total?: number;
    links?: Links3[];

    [key: string]: any;
}

export class Reply implements IReply {
    status?: number;
    user?: User2;

    [key: string]: any;

    constructor(data?: IReply) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.status = _data["status"];
            this.user = _data["user"] ? User2.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Reply {
        data = typeof data === 'object' ? data : {};
        let result = new Reply();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["status"] = this.status;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReply {
    status?: number;
    user?: User2;

    [key: string]: any;
}

export class Errors9 implements IErrors9 {
    task_id?: Validation[];
    user_1_id?: Validation[];
    user_2_id?: Validation[];
    title?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors9) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["task_id"])) {
                this.task_id = [] as any;
                for (let item of _data["task_id"])
                    this.task_id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["user_1_id"])) {
                this.user_1_id = [] as any;
                for (let item of _data["user_1_id"])
                    this.user_1_id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["user_2_id"])) {
                this.user_2_id = [] as any;
                for (let item of _data["user_2_id"])
                    this.user_2_id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["title"])) {
                this.title = [] as any;
                for (let item of _data["title"])
                    this.title!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors9 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors9();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.task_id)) {
            data["task_id"] = [];
            for (let item of this.task_id)
                data["task_id"].push(item.toJSON());
        }
        if (Array.isArray(this.user_1_id)) {
            data["user_1_id"] = [];
            for (let item of this.user_1_id)
                data["user_1_id"].push(item.toJSON());
        }
        if (Array.isArray(this.user_2_id)) {
            data["user_2_id"] = [];
            for (let item of this.user_2_id)
                data["user_2_id"].push(item.toJSON());
        }
        if (Array.isArray(this.title)) {
            data["title"] = [];
            for (let item of this.title)
                data["title"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors9 {
    task_id?: Validation[];
    user_1_id?: Validation[];
    user_2_id?: Validation[];
    title?: Validation[];

    [key: string]: any;
}

export class Errors10 implements IErrors10 {
    title?: Validation[];
    filesStarFile?: FilesStarFile[];

    [key: string]: any;

    constructor(data?: IErrors10) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["title"])) {
                this.title = [] as any;
                for (let item of _data["title"])
                    this.title!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["files.*.file"])) {
                this.filesStarFile = [] as any;
                for (let item of _data["files.*.file"])
                    this.filesStarFile!.push(item);
            }
        }
    }

    static fromJS(data: any): Errors10 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors10();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.title)) {
            data["title"] = [];
            for (let item of this.title)
                data["title"].push(item.toJSON());
        }
        if (Array.isArray(this.filesStarFile)) {
            data["files.*.file"] = [];
            for (let item of this.filesStarFile)
                data["files.*.file"].push(item);
        }
        return data;
    }
}

export interface IErrors10 {
    title?: Validation[];
    filesStarFile?: FilesStarFile[];

    [key: string]: any;
}

export enum ChatMemberResourceRole {
    Owner = "owner",
    Admin = "admin",
    Member = "member",
}

export class Chat implements IChat {
    id?: number;
    title?: string;
    description?: string | undefined;
    members_count?: number;
    group_avatar?: FileResponse;

    [key: string]: any;

    constructor(data?: IChat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.members_count = _data["members_count"];
            this.group_avatar = _data["group_avatar"] ? FileResponse.fromJS(_data["group_avatar"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Chat {
        data = typeof data === 'object' ? data : {};
        let result = new Chat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["members_count"] = this.members_count;
        data["group_avatar"] = this.group_avatar ? this.group_avatar.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChat {
    id?: number;
    title?: string;
    description?: string | undefined;
    members_count?: number;
    group_avatar?: FileResponse;

    [key: string]: any;
}

export class Errors11 implements IErrors11 {
    task_id?: Validation[];
    parent_id?: Validation[];
    text?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors11) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["task_id"])) {
                this.task_id = [] as any;
                for (let item of _data["task_id"])
                    this.task_id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["parent_id"])) {
                this.parent_id = [] as any;
                for (let item of _data["parent_id"])
                    this.parent_id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["text"])) {
                this.text = [] as any;
                for (let item of _data["text"])
                    this.text!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors11 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors11();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.task_id)) {
            data["task_id"] = [];
            for (let item of this.task_id)
                data["task_id"].push(item.toJSON());
        }
        if (Array.isArray(this.parent_id)) {
            data["parent_id"] = [];
            for (let item of this.parent_id)
                data["parent_id"].push(item.toJSON());
        }
        if (Array.isArray(this.text)) {
            data["text"] = [];
            for (let item of this.text)
                data["text"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors11 {
    task_id?: Validation[];
    parent_id?: Validation[];
    text?: Validation[];

    [key: string]: any;
}

export class Errors12 implements IErrors12 {
    text?: Validation[];
    is_report?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors12) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["text"])) {
                this.text = [] as any;
                for (let item of _data["text"])
                    this.text!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["is_report"])) {
                this.is_report = [] as any;
                for (let item of _data["is_report"])
                    this.is_report!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors12 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors12();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.text)) {
            data["text"] = [];
            for (let item of this.text)
                data["text"].push(item.toJSON());
        }
        if (Array.isArray(this.is_report)) {
            data["is_report"] = [];
            for (let item of this.is_report)
                data["is_report"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors12 {
    text?: Validation[];
    is_report?: Validation[];

    [key: string]: any;
}

export class Errors13 implements IErrors13 {
    json?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors13) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["json"])) {
                this.json = [] as any;
                for (let item of _data["json"])
                    this.json!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors13 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors13();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.json)) {
            data["json"] = [];
            for (let item of this.json)
                data["json"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors13 {
    json?: Validation[];

    [key: string]: any;
}

export class Errors14 implements IErrors14 {
    reply_id?: Validation[];
    description?: Validation[];
    filesStar?: FilesStar[];

    [key: string]: any;

    constructor(data?: IErrors14) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["reply_id"])) {
                this.reply_id = [] as any;
                for (let item of _data["reply_id"])
                    this.reply_id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["description"])) {
                this.description = [] as any;
                for (let item of _data["description"])
                    this.description!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["files.*"])) {
                this.filesStar = [] as any;
                for (let item of _data["files.*"])
                    this.filesStar!.push(item);
            }
        }
    }

    static fromJS(data: any): Errors14 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors14();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.reply_id)) {
            data["reply_id"] = [];
            for (let item of this.reply_id)
                data["reply_id"].push(item.toJSON());
        }
        if (Array.isArray(this.description)) {
            data["description"] = [];
            for (let item of this.description)
                data["description"].push(item.toJSON());
        }
        if (Array.isArray(this.filesStar)) {
            data["files.*"] = [];
            for (let item of this.filesStar)
                data["files.*"].push(item);
        }
        return data;
    }
}

export interface IErrors14 {
    reply_id?: Validation[];
    description?: Validation[];
    filesStar?: FilesStar[];

    [key: string]: any;
}

export class Errors15 implements IErrors15 {
    filesStar?: FilesStar2[];

    [key: string]: any;

    constructor(data?: IErrors15) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["files.*"])) {
                this.filesStar = [] as any;
                for (let item of _data["files.*"])
                    this.filesStar!.push(item);
            }
        }
    }

    static fromJS(data: any): Errors15 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors15();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.filesStar)) {
            data["files.*"] = [];
            for (let item of this.filesStar)
                data["files.*"].push(item);
        }
        return data;
    }
}

export interface IErrors15 {
    filesStar?: FilesStar2[];

    [key: string]: any;
}

export class Errors16 implements IErrors16 {
    description?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors16) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["description"])) {
                this.description = [] as any;
                for (let item of _data["description"])
                    this.description!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors16 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors16();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.description)) {
            data["description"] = [];
            for (let item of this.description)
                data["description"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors16 {
    description?: Validation[];

    [key: string]: any;
}

export class Errors17 implements IErrors17 {
    reason_rejection?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors17) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["reason_rejection"])) {
                this.reason_rejection = [] as any;
                for (let item of _data["reason_rejection"])
                    this.reason_rejection!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors17 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors17();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.reason_rejection)) {
            data["reason_rejection"] = [];
            for (let item of this.reason_rejection)
                data["reason_rejection"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors17 {
    reason_rejection?: Validation[];

    [key: string]: any;
}

export class Errors18 implements IErrors18 {
    price?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors18) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["price"])) {
                this.price = [] as any;
                for (let item of _data["price"])
                    this.price!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors18 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors18();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.price)) {
            data["price"] = [];
            for (let item of this.price)
                data["price"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors18 {
    price?: Validation[];

    [key: string]: any;
}

export class Errors19 implements IErrors19 {
    files?: ValidationMax[];
    filesStarPath?: ValidationMax[];
    filesStarType?: Validation[];
    filesStarFile?: ValidationMax[];

    [key: string]: any;

    constructor(data?: IErrors19) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(ValidationMax.fromJS(item));
            }
            if (Array.isArray(_data["files.*.path"])) {
                this.filesStarPath = [] as any;
                for (let item of _data["files.*.path"])
                    this.filesStarPath!.push(ValidationMax.fromJS(item));
            }
            if (Array.isArray(_data["files.*.type"])) {
                this.filesStarType = [] as any;
                for (let item of _data["files.*.type"])
                    this.filesStarType!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["files.*.file"])) {
                this.filesStarFile = [] as any;
                for (let item of _data["files.*.file"])
                    this.filesStarFile!.push(ValidationMax.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors19 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors19();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        if (Array.isArray(this.filesStarPath)) {
            data["files.*.path"] = [];
            for (let item of this.filesStarPath)
                data["files.*.path"].push(item.toJSON());
        }
        if (Array.isArray(this.filesStarType)) {
            data["files.*.type"] = [];
            for (let item of this.filesStarType)
                data["files.*.type"].push(item.toJSON());
        }
        if (Array.isArray(this.filesStarFile)) {
            data["files.*.file"] = [];
            for (let item of this.filesStarFile)
                data["files.*.file"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors19 {
    files?: ValidationMax[];
    filesStarPath?: ValidationMax[];
    filesStarType?: Validation[];
    filesStarFile?: ValidationMax[];

    [key: string]: any;
}

export class Errors20 implements IErrors20 {
    category_id?: Validation[];
    question_id?: Validation[];
    text?: Validation[];
    answers?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors20) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["category_id"])) {
                this.category_id = [] as any;
                for (let item of _data["category_id"])
                    this.category_id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["question_id"])) {
                this.question_id = [] as any;
                for (let item of _data["question_id"])
                    this.question_id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["text"])) {
                this.text = [] as any;
                for (let item of _data["text"])
                    this.text!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors20 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors20();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.category_id)) {
            data["category_id"] = [];
            for (let item of this.category_id)
                data["category_id"].push(item.toJSON());
        }
        if (Array.isArray(this.question_id)) {
            data["question_id"] = [];
            for (let item of this.question_id)
                data["question_id"].push(item.toJSON());
        }
        if (Array.isArray(this.text)) {
            data["text"] = [];
            for (let item of this.text)
                data["text"].push(item.toJSON());
        }
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors20 {
    category_id?: Validation[];
    question_id?: Validation[];
    text?: Validation[];
    answers?: Validation[];

    [key: string]: any;
}

export class User implements IUser {
    name?: string;
    surname?: string;

    [key: string]: any;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.surname = _data["surname"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["surname"] = this.surname;
        return data;
    }
}

export interface IUser {
    name?: string;
    surname?: string;

    [key: string]: any;
}

export class Errors21 implements IErrors21 {
    type?: Validation[];
    body?: Validation[];
    email?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors21) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["type"])) {
                this.type = [] as any;
                for (let item of _data["type"])
                    this.type!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["body"])) {
                this.body = [] as any;
                for (let item of _data["body"])
                    this.body!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["email"])) {
                this.email = [] as any;
                for (let item of _data["email"])
                    this.email!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors21 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors21();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.type)) {
            data["type"] = [];
            for (let item of this.type)
                data["type"].push(item.toJSON());
        }
        if (Array.isArray(this.body)) {
            data["body"] = [];
            for (let item of this.body)
                data["body"].push(item.toJSON());
        }
        if (Array.isArray(this.email)) {
            data["email"] = [];
            for (let item of this.email)
                data["email"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors21 {
    type?: Validation[];
    body?: Validation[];
    email?: Validation[];

    [key: string]: any;
}

export class Errors22 implements IErrors22 {
    is_done?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors22) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["is_done"])) {
                this.is_done = [] as any;
                for (let item of _data["is_done"])
                    this.is_done!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors22 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors22();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.is_done)) {
            data["is_done"] = [];
            for (let item of this.is_done)
                data["is_done"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors22 {
    is_done?: Validation[];

    [key: string]: any;
}

export class Links2 implements ILinks2 {
    first?: string;
    last?: string;
    prev?: string | undefined;
    next?: string | undefined;

    [key: string]: any;

    constructor(data?: ILinks2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.first = _data["first"];
            this.last = _data["last"];
            this.prev = _data["prev"];
            this.next = _data["next"];
        }
    }

    static fromJS(data: any): Links2 {
        data = typeof data === 'object' ? data : {};
        let result = new Links2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["first"] = this.first;
        data["last"] = this.last;
        data["prev"] = this.prev;
        data["next"] = this.next;
        return data;
    }
}

export interface ILinks2 {
    first?: string;
    last?: string;
    prev?: string | undefined;
    next?: string | undefined;

    [key: string]: any;
}

export class Meta4 implements IMeta4 {
    current_page?: number;
    from?: number;
    last_page?: number;
    path?: string;
    per_page?: number;
    to?: number;
    total?: number;
    links?: Links4[];

    [key: string]: any;

    constructor(data?: IMeta4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.current_page = _data["current_page"];
            this.from = _data["from"];
            this.last_page = _data["last_page"];
            this.path = _data["path"];
            this.per_page = _data["per_page"];
            this.to = _data["to"];
            this.total = _data["total"];
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(Links4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Meta4 {
        data = typeof data === 'object' ? data : {};
        let result = new Meta4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["current_page"] = this.current_page;
        data["from"] = this.from;
        data["last_page"] = this.last_page;
        data["path"] = this.path;
        data["per_page"] = this.per_page;
        data["to"] = this.to;
        data["total"] = this.total;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMeta4 {
    current_page?: number;
    from?: number;
    last_page?: number;
    path?: string;
    per_page?: number;
    to?: number;
    total?: number;
    links?: Links4[];

    [key: string]: any;
}

export class Errors23 implements IErrors23 {
    user_id?: Validation[];
    type?: Validation[];
    is_read?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors23) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["user_id"])) {
                this.user_id = [] as any;
                for (let item of _data["user_id"])
                    this.user_id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["type"])) {
                this.type = [] as any;
                for (let item of _data["type"])
                    this.type!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["is_read"])) {
                this.is_read = [] as any;
                for (let item of _data["is_read"])
                    this.is_read!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors23 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors23();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.user_id)) {
            data["user_id"] = [];
            for (let item of this.user_id)
                data["user_id"].push(item.toJSON());
        }
        if (Array.isArray(this.type)) {
            data["type"] = [];
            for (let item of this.type)
                data["type"].push(item.toJSON());
        }
        if (Array.isArray(this.is_read)) {
            data["is_read"] = [];
            for (let item of this.is_read)
                data["is_read"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors23 {
    user_id?: Validation[];
    type?: Validation[];
    is_read?: Validation[];

    [key: string]: any;
}

export class Errors24 implements IErrors24 {
    is_read?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors24) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["is_read"])) {
                this.is_read = [] as any;
                for (let item of _data["is_read"])
                    this.is_read!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors24 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors24();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.is_read)) {
            data["is_read"] = [];
            for (let item of this.is_read)
                data["is_read"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors24 {
    is_read?: Validation[];

    [key: string]: any;
}

export enum Notification_Type_User_Actions_LikeContent_target {
    Video = "video",
    File = "file",
    Avatar = "avatar",
}

export enum Notification_Type_New_Content_CommentContent_target {
    Video = "video",
    File = "file",
    Avatar = "avatar",
}

export enum Notification_Type_New_Content_Comment_AnswerContent_target {
    Video = "video",
    File = "file",
    Avatar = "avatar",
}

export class Errors25 implements IErrors25 {
    task_id?: Validation[];
    text?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors25) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["task_id"])) {
                this.task_id = [] as any;
                for (let item of _data["task_id"])
                    this.task_id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["text"])) {
                this.text = [] as any;
                for (let item of _data["text"])
                    this.text!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors25 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors25();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.task_id)) {
            data["task_id"] = [];
            for (let item of this.task_id)
                data["task_id"].push(item.toJSON());
        }
        if (Array.isArray(this.text)) {
            data["text"] = [];
            for (let item of this.text)
                data["text"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors25 {
    task_id?: Validation[];
    text?: Validation[];

    [key: string]: any;
}

export class Errors26 implements IErrors26 {
    description?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors26) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["description"])) {
                this.description = [] as any;
                for (let item of _data["description"])
                    this.description!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors26 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors26();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.description)) {
            data["description"] = [];
            for (let item of this.description)
                data["description"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors26 {
    description?: Validation[];

    [key: string]: any;
}

export class Errors27 implements IErrors27 {
    files?: ValidationMax[];
    filesStarFile?: FilesStarFile2[];
    filesStarDescription?: ValidationMax[];

    [key: string]: any;

    constructor(data?: IErrors27) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(ValidationMax.fromJS(item));
            }
            if (Array.isArray(_data["files.*.file"])) {
                this.filesStarFile = [] as any;
                for (let item of _data["files.*.file"])
                    this.filesStarFile!.push(item);
            }
            if (Array.isArray(_data["files.*.description"])) {
                this.filesStarDescription = [] as any;
                for (let item of _data["files.*.description"])
                    this.filesStarDescription!.push(ValidationMax.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors27 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors27();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        if (Array.isArray(this.filesStarFile)) {
            data["files.*.file"] = [];
            for (let item of this.filesStarFile)
                data["files.*.file"].push(item);
        }
        if (Array.isArray(this.filesStarDescription)) {
            data["files.*.description"] = [];
            for (let item of this.filesStarDescription)
                data["files.*.description"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors27 {
    files?: ValidationMax[];
    filesStarFile?: FilesStarFile2[];
    filesStarDescription?: ValidationMax[];

    [key: string]: any;
}

export class Errors28 implements IErrors28 {
    category_id?: Validation[];
    next_question_id?: Validation[];
    is_skip_next_question_id?: Validation[];
    text_question?: Validation[];
    type_question?: Validation[];
    is_start?: Validation[];
    is_skip?: Validation[];
    example_answers?: Validation[];
    type_values?: Validation[];
    answers?: Validation[];
    answersStarText_answer?: ValidationValues[];
    filesStar?: FilesStar3[];

    [key: string]: any;

    constructor(data?: IErrors28) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["category_id"])) {
                this.category_id = [] as any;
                for (let item of _data["category_id"])
                    this.category_id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["next_question_id"])) {
                this.next_question_id = [] as any;
                for (let item of _data["next_question_id"])
                    this.next_question_id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["is_skip_next_question_id"])) {
                this.is_skip_next_question_id = [] as any;
                for (let item of _data["is_skip_next_question_id"])
                    this.is_skip_next_question_id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["text_question"])) {
                this.text_question = [] as any;
                for (let item of _data["text_question"])
                    this.text_question!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["type_question"])) {
                this.type_question = [] as any;
                for (let item of _data["type_question"])
                    this.type_question!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["is_start"])) {
                this.is_start = [] as any;
                for (let item of _data["is_start"])
                    this.is_start!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["is_skip"])) {
                this.is_skip = [] as any;
                for (let item of _data["is_skip"])
                    this.is_skip!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["example_answers"])) {
                this.example_answers = [] as any;
                for (let item of _data["example_answers"])
                    this.example_answers!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["type_values"])) {
                this.type_values = [] as any;
                for (let item of _data["type_values"])
                    this.type_values!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["answers.*.text_answer"])) {
                this.answersStarText_answer = [] as any;
                for (let item of _data["answers.*.text_answer"])
                    this.answersStarText_answer!.push(ValidationValues.fromJS(item));
            }
            if (Array.isArray(_data["files.*"])) {
                this.filesStar = [] as any;
                for (let item of _data["files.*"])
                    this.filesStar!.push(item);
            }
        }
    }

    static fromJS(data: any): Errors28 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors28();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.category_id)) {
            data["category_id"] = [];
            for (let item of this.category_id)
                data["category_id"].push(item.toJSON());
        }
        if (Array.isArray(this.next_question_id)) {
            data["next_question_id"] = [];
            for (let item of this.next_question_id)
                data["next_question_id"].push(item.toJSON());
        }
        if (Array.isArray(this.is_skip_next_question_id)) {
            data["is_skip_next_question_id"] = [];
            for (let item of this.is_skip_next_question_id)
                data["is_skip_next_question_id"].push(item.toJSON());
        }
        if (Array.isArray(this.text_question)) {
            data["text_question"] = [];
            for (let item of this.text_question)
                data["text_question"].push(item.toJSON());
        }
        if (Array.isArray(this.type_question)) {
            data["type_question"] = [];
            for (let item of this.type_question)
                data["type_question"].push(item.toJSON());
        }
        if (Array.isArray(this.is_start)) {
            data["is_start"] = [];
            for (let item of this.is_start)
                data["is_start"].push(item.toJSON());
        }
        if (Array.isArray(this.is_skip)) {
            data["is_skip"] = [];
            for (let item of this.is_skip)
                data["is_skip"].push(item.toJSON());
        }
        if (Array.isArray(this.example_answers)) {
            data["example_answers"] = [];
            for (let item of this.example_answers)
                data["example_answers"].push(item.toJSON());
        }
        if (Array.isArray(this.type_values)) {
            data["type_values"] = [];
            for (let item of this.type_values)
                data["type_values"].push(item.toJSON());
        }
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        if (Array.isArray(this.answersStarText_answer)) {
            data["answers.*.text_answer"] = [];
            for (let item of this.answersStarText_answer)
                data["answers.*.text_answer"].push(item.toJSON());
        }
        if (Array.isArray(this.filesStar)) {
            data["files.*"] = [];
            for (let item of this.filesStar)
                data["files.*"].push(item);
        }
        return data;
    }
}

export interface IErrors28 {
    category_id?: Validation[];
    next_question_id?: Validation[];
    is_skip_next_question_id?: Validation[];
    text_question?: Validation[];
    type_question?: Validation[];
    is_start?: Validation[];
    is_skip?: Validation[];
    example_answers?: Validation[];
    type_values?: Validation[];
    answers?: Validation[];
    answersStarText_answer?: ValidationValues[];
    filesStar?: FilesStar3[];

    [key: string]: any;
}

export class User_from implements IUser_from {
    name?: string;
    surname?: string;
    avatar?: FileResponse;
    official?: boolean;

    [key: string]: any;

    constructor(data?: IUser_from) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.avatar = _data["avatar"] ? FileResponse.fromJS(_data["avatar"]) : <any>undefined;
            this.official = _data["official"];
        }
    }

    static fromJS(data: any): User_from {
        data = typeof data === 'object' ? data : {};
        let result = new User_from();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["avatar"] = this.avatar ? this.avatar.toJSON() : <any>undefined;
        data["official"] = this.official;
        return data;
    }
}

export interface IUser_from {
    name?: string;
    surname?: string;
    avatar?: FileResponse;
    official?: boolean;

    [key: string]: any;
}

export class Errors29 implements IErrors29 {
    user_id?: Validation[];
    rating?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors29) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["user_id"])) {
                this.user_id = [] as any;
                for (let item of _data["user_id"])
                    this.user_id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["rating"])) {
                this.rating = [] as any;
                for (let item of _data["rating"])
                    this.rating!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors29 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors29();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.user_id)) {
            data["user_id"] = [];
            for (let item of this.user_id)
                data["user_id"].push(item.toJSON());
        }
        if (Array.isArray(this.rating)) {
            data["rating"] = [];
            for (let item of this.rating)
                data["rating"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors29 {
    user_id?: Validation[];
    rating?: Validation[];

    [key: string]: any;
}

export class Task implements ITask {
    name?: string;

    [key: string]: any;

    constructor(data?: ITask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Task {
        data = typeof data === 'object' ? data : {};
        let result = new Task();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        return data;
    }
}

export interface ITask {
    name?: string;

    [key: string]: any;
}

export class Errors30 implements IErrors30 {
    task_id?: Validation[];
    text?: Validation[];
    price?: Validation[];
    deadline_at?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors30) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["task_id"])) {
                this.task_id = [] as any;
                for (let item of _data["task_id"])
                    this.task_id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["text"])) {
                this.text = [] as any;
                for (let item of _data["text"])
                    this.text!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["price"])) {
                this.price = [] as any;
                for (let item of _data["price"])
                    this.price!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["deadline_at"])) {
                this.deadline_at = [] as any;
                for (let item of _data["deadline_at"])
                    this.deadline_at!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors30 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors30();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.task_id)) {
            data["task_id"] = [];
            for (let item of this.task_id)
                data["task_id"].push(item.toJSON());
        }
        if (Array.isArray(this.text)) {
            data["text"] = [];
            for (let item of this.text)
                data["text"].push(item.toJSON());
        }
        if (Array.isArray(this.price)) {
            data["price"] = [];
            for (let item of this.price)
                data["price"].push(item.toJSON());
        }
        if (Array.isArray(this.deadline_at)) {
            data["deadline_at"] = [];
            for (let item of this.deadline_at)
                data["deadline_at"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors30 {
    task_id?: Validation[];
    text?: Validation[];
    price?: Validation[];
    deadline_at?: Validation[];

    [key: string]: any;
}

export class Errors31 implements IErrors31 {
    description?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors31) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["description"])) {
                this.description = [] as any;
                for (let item of _data["description"])
                    this.description!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors31 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors31();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.description)) {
            data["description"] = [];
            for (let item of this.description)
                data["description"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors31 {
    description?: Validation[];

    [key: string]: any;
}

export class Errors32 implements IErrors32 {
    description?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["description"])) {
                this.description = [] as any;
                for (let item of _data["description"])
                    this.description!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors32 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.description)) {
            data["description"] = [];
            for (let item of this.description)
                data["description"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors32 {
    description?: Validation[];

    [key: string]: any;
}

export class Errors33 implements IErrors33 {
    id?: Validation[];
    filter_id?: Validation[];
    text?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors33) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["id"])) {
                this.id = [] as any;
                for (let item of _data["id"])
                    this.id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["filter_id"])) {
                this.filter_id = [] as any;
                for (let item of _data["filter_id"])
                    this.filter_id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["text"])) {
                this.text = [] as any;
                for (let item of _data["text"])
                    this.text!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors33 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors33();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.id)) {
            data["id"] = [];
            for (let item of this.id)
                data["id"].push(item.toJSON());
        }
        if (Array.isArray(this.filter_id)) {
            data["filter_id"] = [];
            for (let item of this.filter_id)
                data["filter_id"].push(item.toJSON());
        }
        if (Array.isArray(this.text)) {
            data["text"] = [];
            for (let item of this.text)
                data["text"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors33 {
    id?: Validation[];
    filter_id?: Validation[];
    text?: Validation[];

    [key: string]: any;
}

export class Disputed_replies implements IDisputed_replies {
    id?: number;
    price?: number;

    [key: string]: any;

    constructor(data?: IDisputed_replies) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): Disputed_replies {
        data = typeof data === 'object' ? data : {};
        let result = new Disputed_replies();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["price"] = this.price;
        return data;
    }
}

export interface IDisputed_replies {
    id?: number;
    price?: number;

    [key: string]: any;
}

export class Errors34 implements IErrors34 {
    category_id?: Validation[];
    name?: Validation[];
    description?: Validation[];
    price?: Validation[];
    filesStarFile?: FilesStarFile3[];

    [key: string]: any;

    constructor(data?: IErrors34) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["category_id"])) {
                this.category_id = [] as any;
                for (let item of _data["category_id"])
                    this.category_id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["name"])) {
                this.name = [] as any;
                for (let item of _data["name"])
                    this.name!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["description"])) {
                this.description = [] as any;
                for (let item of _data["description"])
                    this.description!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["price"])) {
                this.price = [] as any;
                for (let item of _data["price"])
                    this.price!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["files.*.file"])) {
                this.filesStarFile = [] as any;
                for (let item of _data["files.*.file"])
                    this.filesStarFile!.push(item);
            }
        }
    }

    static fromJS(data: any): Errors34 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors34();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.category_id)) {
            data["category_id"] = [];
            for (let item of this.category_id)
                data["category_id"].push(item.toJSON());
        }
        if (Array.isArray(this.name)) {
            data["name"] = [];
            for (let item of this.name)
                data["name"].push(item.toJSON());
        }
        if (Array.isArray(this.description)) {
            data["description"] = [];
            for (let item of this.description)
                data["description"].push(item.toJSON());
        }
        if (Array.isArray(this.price)) {
            data["price"] = [];
            for (let item of this.price)
                data["price"].push(item.toJSON());
        }
        if (Array.isArray(this.filesStarFile)) {
            data["files.*.file"] = [];
            for (let item of this.filesStarFile)
                data["files.*.file"].push(item);
        }
        return data;
    }
}

export interface IErrors34 {
    category_id?: Validation[];
    name?: Validation[];
    description?: Validation[];
    price?: Validation[];
    filesStarFile?: FilesStarFile3[];

    [key: string]: any;
}

export class Errors35 implements IErrors35 {
    task_id?: Validation[];
    reply_id?: Validation[];
    filesStar?: FilesStar4[];

    [key: string]: any;

    constructor(data?: IErrors35) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["task_id"])) {
                this.task_id = [] as any;
                for (let item of _data["task_id"])
                    this.task_id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["reply_id"])) {
                this.reply_id = [] as any;
                for (let item of _data["reply_id"])
                    this.reply_id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["files.*"])) {
                this.filesStar = [] as any;
                for (let item of _data["files.*"])
                    this.filesStar!.push(item);
            }
        }
    }

    static fromJS(data: any): Errors35 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors35();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.task_id)) {
            data["task_id"] = [];
            for (let item of this.task_id)
                data["task_id"].push(item.toJSON());
        }
        if (Array.isArray(this.reply_id)) {
            data["reply_id"] = [];
            for (let item of this.reply_id)
                data["reply_id"].push(item.toJSON());
        }
        if (Array.isArray(this.filesStar)) {
            data["files.*"] = [];
            for (let item of this.filesStar)
                data["files.*"].push(item);
        }
        return data;
    }
}

export interface IErrors35 {
    task_id?: Validation[];
    reply_id?: Validation[];
    filesStar?: FilesStar4[];

    [key: string]: any;
}

export class Errors36 implements IErrors36 {
    property?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors36) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["property"])) {
                this.property = [] as any;
                for (let item of _data["property"])
                    this.property!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors36 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors36();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.property)) {
            data["property"] = [];
            for (let item of this.property)
                data["property"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors36 {
    property?: Validation[];

    [key: string]: any;
}

export class Errors37 implements IErrors37 {
    property?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors37) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["property"])) {
                this.property = [] as any;
                for (let item of _data["property"])
                    this.property!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors37 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors37();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.property)) {
            data["property"] = [];
            for (let item of this.property)
                data["property"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors37 {
    property?: Validation[];

    [key: string]: any;
}

export class Avatar implements IAvatar {
    file?: string;
    name?: string;
    size?: number;

    [key: string]: any;

    constructor(data?: IAvatar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.file = _data["file"];
            this.name = _data["name"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): Avatar {
        data = typeof data === 'object' ? data : {};
        let result = new Avatar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["file"] = this.file;
        data["name"] = this.name;
        data["size"] = this.size;
        return data;
    }
}

export interface IAvatar {
    file?: string;
    name?: string;
    size?: number;

    [key: string]: any;
}

export class Skills implements ISkills {
    skill_id?: number;
    question_id?: number;
    answers?: number[];
    answer_id?: number;
    value?: string;
    min_value?: number;
    max_value?: number;

    [key: string]: any;

    constructor(data?: ISkills) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.skill_id = _data["skill_id"];
            this.question_id = _data["question_id"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(item);
            }
            this.answer_id = _data["answer_id"];
            this.value = _data["value"];
            this.min_value = _data["min_value"];
            this.max_value = _data["max_value"];
        }
    }

    static fromJS(data: any): Skills {
        data = typeof data === 'object' ? data : {};
        let result = new Skills();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["skill_id"] = this.skill_id;
        data["question_id"] = this.question_id;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item);
        }
        data["answer_id"] = this.answer_id;
        data["value"] = this.value;
        data["min_value"] = this.min_value;
        data["max_value"] = this.max_value;
        return data;
    }
}

export interface ISkills {
    skill_id?: number;
    question_id?: number;
    answers?: number[];
    answer_id?: number;
    value?: string;
    min_value?: number;
    max_value?: number;

    [key: string]: any;
}

export class Meta5 implements IMeta5 {
    total?: number;

    [key: string]: any;

    constructor(data?: IMeta5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): Meta5 {
        data = typeof data === 'object' ? data : {};
        let result = new Meta5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IMeta5 {
    total?: number;

    [key: string]: any;
}

export class Meta6 implements IMeta6 {
    total?: number;

    [key: string]: any;

    constructor(data?: IMeta6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): Meta6 {
        data = typeof data === 'object' ? data : {};
        let result = new Meta6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IMeta6 {
    total?: number;

    [key: string]: any;
}

export class ReplyOnResolveDispute implements IReplyOnResolveDispute {
    taskId?: number;
    hasReplyOnResolveDispute?: boolean;

    [key: string]: any;

    constructor(data?: IReplyOnResolveDispute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.taskId = _data["taskId"];
            this.hasReplyOnResolveDispute = _data["hasReplyOnResolveDispute"];
        }
    }

    static fromJS(data: any): ReplyOnResolveDispute {
        data = typeof data === 'object' ? data : {};
        let result = new ReplyOnResolveDispute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["taskId"] = this.taskId;
        data["hasReplyOnResolveDispute"] = this.hasReplyOnResolveDispute;
        return data;
    }
}

export interface IReplyOnResolveDispute {
    taskId?: number;
    hasReplyOnResolveDispute?: boolean;

    [key: string]: any;
}

export class Errors38 implements IErrors38 {
    phone?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors38) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["phone"])) {
                this.phone = [] as any;
                for (let item of _data["phone"])
                    this.phone!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors38 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors38();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.phone)) {
            data["phone"] = [];
            for (let item of this.phone)
                data["phone"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors38 {
    phone?: Validation[];

    [key: string]: any;
}

export class Errors39 implements IErrors39 {
    phone?: Validation[];
    password?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors39) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["phone"])) {
                this.phone = [] as any;
                for (let item of _data["phone"])
                    this.phone!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["password"])) {
                this.password = [] as any;
                for (let item of _data["password"])
                    this.password!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors39 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors39();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.phone)) {
            data["phone"] = [];
            for (let item of this.phone)
                data["phone"].push(item.toJSON());
        }
        if (Array.isArray(this.password)) {
            data["password"] = [];
            for (let item of this.password)
                data["password"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors39 {
    phone?: Validation[];
    password?: Validation[];

    [key: string]: any;
}

export class Errors40 implements IErrors40 {
    code?: Validation[];
    phone?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors40) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["code"])) {
                this.code = [] as any;
                for (let item of _data["code"])
                    this.code!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["phone"])) {
                this.phone = [] as any;
                for (let item of _data["phone"])
                    this.phone!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors40 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors40();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.code)) {
            data["code"] = [];
            for (let item of this.code)
                data["code"].push(item.toJSON());
        }
        if (Array.isArray(this.phone)) {
            data["phone"] = [];
            for (let item of this.phone)
                data["phone"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors40 {
    code?: Validation[];
    phone?: Validation[];

    [key: string]: any;
}

export class Errors41 implements IErrors41 {
    refresh_token?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors41) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["refresh_token"])) {
                this.refresh_token = [] as any;
                for (let item of _data["refresh_token"])
                    this.refresh_token!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors41 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors41();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.refresh_token)) {
            data["refresh_token"] = [];
            for (let item of this.refresh_token)
                data["refresh_token"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors41 {
    refresh_token?: Validation[];

    [key: string]: any;
}

export class Errors42 implements IErrors42 {
    name?: Validation[];
    surname?: Validation[];
    middlename?: Validation[];
    email?: Validation[];
    phone?: Validation[];
    password?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors42) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["name"])) {
                this.name = [] as any;
                for (let item of _data["name"])
                    this.name!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["surname"])) {
                this.surname = [] as any;
                for (let item of _data["surname"])
                    this.surname!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["middlename"])) {
                this.middlename = [] as any;
                for (let item of _data["middlename"])
                    this.middlename!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["email"])) {
                this.email = [] as any;
                for (let item of _data["email"])
                    this.email!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["phone"])) {
                this.phone = [] as any;
                for (let item of _data["phone"])
                    this.phone!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["password"])) {
                this.password = [] as any;
                for (let item of _data["password"])
                    this.password!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors42 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors42();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.name)) {
            data["name"] = [];
            for (let item of this.name)
                data["name"].push(item.toJSON());
        }
        if (Array.isArray(this.surname)) {
            data["surname"] = [];
            for (let item of this.surname)
                data["surname"].push(item.toJSON());
        }
        if (Array.isArray(this.middlename)) {
            data["middlename"] = [];
            for (let item of this.middlename)
                data["middlename"].push(item.toJSON());
        }
        if (Array.isArray(this.email)) {
            data["email"] = [];
            for (let item of this.email)
                data["email"].push(item.toJSON());
        }
        if (Array.isArray(this.phone)) {
            data["phone"] = [];
            for (let item of this.phone)
                data["phone"].push(item.toJSON());
        }
        if (Array.isArray(this.password)) {
            data["password"] = [];
            for (let item of this.password)
                data["password"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors42 {
    name?: Validation[];
    surname?: Validation[];
    middlename?: Validation[];
    email?: Validation[];
    phone?: Validation[];
    password?: Validation[];

    [key: string]: any;
}

export class Errors43 implements IErrors43 {
    name?: Validation[];
    surname?: Validation[];
    middlename?: Validation[];
    phone?: Validation[];
    avatar?: Avatar2[];
    skillsStarSkillsStarCategory_id?: Validation[];
    skillsStarSkillsStarSkill_id?: Validation[];
    skillsStarSkillsStarFilter_id?: Validation[];
    skillsStarSkillsStarQuestion_id?: Validation[];
    skillsStarSkillsStarAnswers?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors43) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["name"])) {
                this.name = [] as any;
                for (let item of _data["name"])
                    this.name!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["surname"])) {
                this.surname = [] as any;
                for (let item of _data["surname"])
                    this.surname!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["middlename"])) {
                this.middlename = [] as any;
                for (let item of _data["middlename"])
                    this.middlename!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["phone"])) {
                this.phone = [] as any;
                for (let item of _data["phone"])
                    this.phone!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["avatar"])) {
                this.avatar = [] as any;
                for (let item of _data["avatar"])
                    this.avatar!.push(item);
            }
            if (Array.isArray(_data["skills.*.skills.*.category_id"])) {
                this.skillsStarSkillsStarCategory_id = [] as any;
                for (let item of _data["skills.*.skills.*.category_id"])
                    this.skillsStarSkillsStarCategory_id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["skills.*.skills.*.skill_id"])) {
                this.skillsStarSkillsStarSkill_id = [] as any;
                for (let item of _data["skills.*.skills.*.skill_id"])
                    this.skillsStarSkillsStarSkill_id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["skills.*.skills.*.filter_id"])) {
                this.skillsStarSkillsStarFilter_id = [] as any;
                for (let item of _data["skills.*.skills.*.filter_id"])
                    this.skillsStarSkillsStarFilter_id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["skills.*.skills.*.question_id"])) {
                this.skillsStarSkillsStarQuestion_id = [] as any;
                for (let item of _data["skills.*.skills.*.question_id"])
                    this.skillsStarSkillsStarQuestion_id!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["skills.*.skills.*.answers"])) {
                this.skillsStarSkillsStarAnswers = [] as any;
                for (let item of _data["skills.*.skills.*.answers"])
                    this.skillsStarSkillsStarAnswers!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors43 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors43();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.name)) {
            data["name"] = [];
            for (let item of this.name)
                data["name"].push(item.toJSON());
        }
        if (Array.isArray(this.surname)) {
            data["surname"] = [];
            for (let item of this.surname)
                data["surname"].push(item.toJSON());
        }
        if (Array.isArray(this.middlename)) {
            data["middlename"] = [];
            for (let item of this.middlename)
                data["middlename"].push(item.toJSON());
        }
        if (Array.isArray(this.phone)) {
            data["phone"] = [];
            for (let item of this.phone)
                data["phone"].push(item.toJSON());
        }
        if (Array.isArray(this.avatar)) {
            data["avatar"] = [];
            for (let item of this.avatar)
                data["avatar"].push(item);
        }
        if (Array.isArray(this.skillsStarSkillsStarCategory_id)) {
            data["skills.*.skills.*.category_id"] = [];
            for (let item of this.skillsStarSkillsStarCategory_id)
                data["skills.*.skills.*.category_id"].push(item.toJSON());
        }
        if (Array.isArray(this.skillsStarSkillsStarSkill_id)) {
            data["skills.*.skills.*.skill_id"] = [];
            for (let item of this.skillsStarSkillsStarSkill_id)
                data["skills.*.skills.*.skill_id"].push(item.toJSON());
        }
        if (Array.isArray(this.skillsStarSkillsStarFilter_id)) {
            data["skills.*.skills.*.filter_id"] = [];
            for (let item of this.skillsStarSkillsStarFilter_id)
                data["skills.*.skills.*.filter_id"].push(item.toJSON());
        }
        if (Array.isArray(this.skillsStarSkillsStarQuestion_id)) {
            data["skills.*.skills.*.question_id"] = [];
            for (let item of this.skillsStarSkillsStarQuestion_id)
                data["skills.*.skills.*.question_id"].push(item.toJSON());
        }
        if (Array.isArray(this.skillsStarSkillsStarAnswers)) {
            data["skills.*.skills.*.answers"] = [];
            for (let item of this.skillsStarSkillsStarAnswers)
                data["skills.*.skills.*.answers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors43 {
    name?: Validation[];
    surname?: Validation[];
    middlename?: Validation[];
    phone?: Validation[];
    avatar?: Avatar2[];
    skillsStarSkillsStarCategory_id?: Validation[];
    skillsStarSkillsStarSkill_id?: Validation[];
    skillsStarSkillsStarFilter_id?: Validation[];
    skillsStarSkillsStarQuestion_id?: Validation[];
    skillsStarSkillsStarAnswers?: Validation[];

    [key: string]: any;
}

export class Errors44 implements IErrors44 {
    code?: Validation[];
    phone?: Validation[];
    password?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors44) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["code"])) {
                this.code = [] as any;
                for (let item of _data["code"])
                    this.code!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["phone"])) {
                this.phone = [] as any;
                for (let item of _data["phone"])
                    this.phone!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["password"])) {
                this.password = [] as any;
                for (let item of _data["password"])
                    this.password!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors44 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors44();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.code)) {
            data["code"] = [];
            for (let item of this.code)
                data["code"].push(item.toJSON());
        }
        if (Array.isArray(this.phone)) {
            data["phone"] = [];
            for (let item of this.phone)
                data["phone"].push(item.toJSON());
        }
        if (Array.isArray(this.password)) {
            data["password"] = [];
            for (let item of this.password)
                data["password"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors44 {
    code?: Validation[];
    phone?: Validation[];
    password?: Validation[];

    [key: string]: any;
}

export class Errors45 implements IErrors45 {
    phone?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors45) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["phone"])) {
                this.phone = [] as any;
                for (let item of _data["phone"])
                    this.phone!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors45 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors45();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.phone)) {
            data["phone"] = [];
            for (let item of this.phone)
                data["phone"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors45 {
    phone?: Validation[];

    [key: string]: any;
}

export class Errors46 implements IErrors46 {
    password?: Validation[];
    c_password?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors46) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["password"])) {
                this.password = [] as any;
                for (let item of _data["password"])
                    this.password!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["c_password"])) {
                this.c_password = [] as any;
                for (let item of _data["c_password"])
                    this.c_password!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors46 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors46();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.password)) {
            data["password"] = [];
            for (let item of this.password)
                data["password"].push(item.toJSON());
        }
        if (Array.isArray(this.c_password)) {
            data["c_password"] = [];
            for (let item of this.c_password)
                data["c_password"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors46 {
    password?: Validation[];
    c_password?: Validation[];

    [key: string]: any;
}

export class Errors47 implements IErrors47 {
    token?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors47) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["token"])) {
                this.token = [] as any;
                for (let item of _data["token"])
                    this.token!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors47 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors47();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.token)) {
            data["token"] = [];
            for (let item of this.token)
                data["token"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors47 {
    token?: Validation[];

    [key: string]: any;
}

export class Errors48 implements IErrors48 {
    token?: Validation[];

    [key: string]: any;

    constructor(data?: IErrors48) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["token"])) {
                this.token = [] as any;
                for (let item of _data["token"])
                    this.token!.push(Validation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Errors48 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors48();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.token)) {
            data["token"] = [];
            for (let item of this.token)
                data["token"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrors48 {
    token?: Validation[];

    [key: string]: any;
}

export enum UserSolanaWalletResponseStatus {
    Active = "active",
    Replaced = "replaced",
}

export enum Body6Role {
    Admin = "admin",
    Member = "member",
}

export class Suggestions implements ISuggestions {
    placePrediction?: PlacePrediction;

    [key: string]: any;

    constructor(data?: ISuggestions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.placePrediction = _data["placePrediction"] ? PlacePrediction.fromJS(_data["placePrediction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Suggestions {
        data = typeof data === 'object' ? data : {};
        let result = new Suggestions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["placePrediction"] = this.placePrediction ? this.placePrediction.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISuggestions {
    placePrediction?: PlacePrediction;

    [key: string]: any;
}

export class Errors49 implements IErrors49 {
    nickname?: string[];

    [key: string]: any;

    constructor(data?: IErrors49) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["nickname"])) {
                this.nickname = [] as any;
                for (let item of _data["nickname"])
                    this.nickname!.push(item);
            }
        }
    }

    static fromJS(data: any): Errors49 {
        data = typeof data === 'object' ? data : {};
        let result = new Errors49();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.nickname)) {
            data["nickname"] = [];
            for (let item of this.nickname)
                data["nickname"].push(item);
        }
        return data;
    }
}

export interface IErrors49 {
    nickname?: string[];

    [key: string]: any;
}

export class Links3 implements ILinks3 {
    url?: string | undefined;
    label?: string;
    active?: boolean;

    [key: string]: any;

    constructor(data?: ILinks3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.url = _data["url"];
            this.label = _data["label"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): Links3 {
        data = typeof data === 'object' ? data : {};
        let result = new Links3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["url"] = this.url;
        data["label"] = this.label;
        data["active"] = this.active;
        return data;
    }
}

export interface ILinks3 {
    url?: string | undefined;
    label?: string;
    active?: boolean;

    [key: string]: any;
}

export class User2 implements IUser2 {
    id?: number;

    [key: string]: any;

    constructor(data?: IUser2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): User2 {
        data = typeof data === 'object' ? data : {};
        let result = new User2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IUser2 {
    id?: number;

    [key: string]: any;
}

export class FilesStarFile implements IFilesStarFile {

    [key: string]: any;

    constructor(data?: IFilesStarFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): FilesStarFile {
        data = typeof data === 'object' ? data : {};
        let result = new FilesStarFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IFilesStarFile {

    [key: string]: any;
}

export class FilesStar implements IFilesStar {

    [key: string]: any;

    constructor(data?: IFilesStar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): FilesStar {
        data = typeof data === 'object' ? data : {};
        let result = new FilesStar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IFilesStar {

    [key: string]: any;
}

export class FilesStar2 implements IFilesStar2 {

    [key: string]: any;

    constructor(data?: IFilesStar2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): FilesStar2 {
        data = typeof data === 'object' ? data : {};
        let result = new FilesStar2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IFilesStar2 {

    [key: string]: any;
}

export class Links4 implements ILinks4 {
    url?: string | undefined;
    label?: string;
    active?: boolean;

    [key: string]: any;

    constructor(data?: ILinks4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.url = _data["url"];
            this.label = _data["label"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): Links4 {
        data = typeof data === 'object' ? data : {};
        let result = new Links4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["url"] = this.url;
        data["label"] = this.label;
        data["active"] = this.active;
        return data;
    }
}

export interface ILinks4 {
    url?: string | undefined;
    label?: string;
    active?: boolean;

    [key: string]: any;
}

export class FilesStarFile2 implements IFilesStarFile2 {

    [key: string]: any;

    constructor(data?: IFilesStarFile2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): FilesStarFile2 {
        data = typeof data === 'object' ? data : {};
        let result = new FilesStarFile2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IFilesStarFile2 {

    [key: string]: any;
}

export class FilesStar3 implements IFilesStar3 {

    [key: string]: any;

    constructor(data?: IFilesStar3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): FilesStar3 {
        data = typeof data === 'object' ? data : {};
        let result = new FilesStar3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IFilesStar3 {

    [key: string]: any;
}

export class FilesStarFile3 implements IFilesStarFile3 {

    [key: string]: any;

    constructor(data?: IFilesStarFile3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): FilesStarFile3 {
        data = typeof data === 'object' ? data : {};
        let result = new FilesStarFile3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IFilesStarFile3 {

    [key: string]: any;
}

export class FilesStar4 implements IFilesStar4 {

    [key: string]: any;

    constructor(data?: IFilesStar4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): FilesStar4 {
        data = typeof data === 'object' ? data : {};
        let result = new FilesStar4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IFilesStar4 {

    [key: string]: any;
}

export class Avatar2 implements IAvatar2 {

    [key: string]: any;

    constructor(data?: IAvatar2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): Avatar2 {
        data = typeof data === 'object' ? data : {};
        let result = new Avatar2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IAvatar2 {

    [key: string]: any;
}

export class PlacePrediction implements IPlacePrediction {
    text?: Text;
    placeId?: string;

    [key: string]: any;

    constructor(data?: IPlacePrediction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.text = _data["text"] ? Text.fromJS(_data["text"]) : <any>undefined;
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): PlacePrediction {
        data = typeof data === 'object' ? data : {};
        let result = new PlacePrediction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["text"] = this.text ? this.text.toJSON() : <any>undefined;
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface IPlacePrediction {
    text?: Text;
    placeId?: string;

    [key: string]: any;
}

export class Text implements IText {
    text?: string;

    [key: string]: any;

    constructor(data?: IText) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): Text {
        data = typeof data === 'object' ? data : {};
        let result = new Text();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["text"] = this.text;
        return data;
    }
}

export interface IText {
    text?: string;

    [key: string]: any;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    return _observableThrow(new ApiException(message, status, response, headers, result));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else if (typeof FileReader !== 'undefined') {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        } else {
            observer.next(blob);
            observer.complete();
        }
    });
}